import * as i0 from '@angular/core';
import { NgModule, Injectable, Component, Input, signal, HostBinding, Directive, ContentChildren, HostListener, EventEmitter, forwardRef, ElementRef, Optional, Output, ViewChild, ViewChildren, Pipe, Inject, ContentChild, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, InjectionToken, ChangeDetectionStrategy, ViewEncapsulation, Host } from '@angular/core';
import * as i1$5 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i5$3 from '@angular/material/tree';
import { MatTreeModule, MatTreeNestedDataSource } from '@angular/material/tree';
import * as i1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import * as i2$1 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i5$1 from '@angular/material/badge';
import { MatBadgeModule } from '@angular/material/badge';
import * as i8 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i9 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i10 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i1$7 from '@angular/material/dialog';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import * as i2$2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i3$3 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i14 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import * as i4 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i1$2 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i2$3 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule, MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import * as i3 from '@angular/material/radio';
import { MatRadioModule } from '@angular/material/radio';
import * as i5 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import * as i3$6 from '@angular/material/sidenav';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import * as i3$4 from '@angular/material/tabs';
import { MatTabsModule, MAT_TABS_CONFIG } from '@angular/material/tabs';
import * as i2$4 from '@angular/material/toolbar';
import { MatToolbarModule } from '@angular/material/toolbar';
import * as i16 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i1$4 from '@angular/material/paginator';
import { MatPaginatorModule, MAT_PAGINATOR_DEFAULT_OPTIONS } from '@angular/material/paginator';
import * as i17 from '@angular/material/sort';
import { MatSortModule, MatSort } from '@angular/material/sort';
import * as i18 from '@angular/material/table';
import { MatTableModule, MatTableDataSource, MatTable } from '@angular/material/table';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import * as i4$1 from '@angular/material/form-field';
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import * as i5$2 from '@angular/material/divider';
import { MatDividerModule } from '@angular/material/divider';
import { CdkTableModule } from '@angular/cdk/table';
import * as i1$3 from '@angular/cdk/scrolling';
import { ScrollingModule, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import * as i3$2 from '@angular/material/core';
import { MatNativeDateModule, MatRippleModule, DateAdapter, MAT_DATE_LOCALE, MatOption } from '@angular/material/core';
import * as i4$2 from '@angular/material/expansion';
import { MatExpansionModule, MAT_EXPANSION_PANEL_DEFAULT_OPTIONS } from '@angular/material/expansion';
import * as i3$1 from '@angular/forms';
import { ReactiveFormsModule, FormsModule, UntypedFormGroup, FormControl, Validators, NG_VALUE_ACCESSOR, FormArray, UntypedFormControl } from '@angular/forms';
import * as i19 from '@angular/cdk/drag-drop';
import { DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import * as i1$8 from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
import * as i2 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import { Subject, interval, takeUntil, filter, BehaviorSubject, defer, of } from 'rxjs';
import * as i1$1 from '@angular/router';
import { NavigationEnd, NavigationStart, RouterModule } from '@angular/router';
import { query, style, group, animate, trigger, transition, state } from '@angular/animations';
import { SelectionModel } from '@angular/cdk/collections';
import { filter as filter$1, distinctUntilChanged, catchError, share, startWith, pairwise, debounceTime } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { isMoment } from 'moment';
import OverlayScrollbars from 'overlayscrollbars';
import * as i1$6 from '@angular/platform-browser';
import * as i2$5 from '@angular/cdk/layout';
import { Breakpoints } from '@angular/cdk/layout';
import { NestedTreeControl } from '@angular/cdk/tree';
import * as i3$5 from '@angular/cdk/bidi';

const modules$3 = [
    CdkTableModule,
    ScrollingModule,
    MatAutocompleteModule,
    MatTreeModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatBadgeModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatListModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatStepperModule,
    MatDividerModule,
    MatRippleModule,
    ReactiveFormsModule,
    MatMomentDateModule,
    DragDropModule,
    OverlayModule
];
/** <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { MaterialModule } from '@michelin/theme';</code>
 */
class MaterialModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: MaterialModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: MaterialModule, imports: [CdkTableModule,
            ScrollingModule,
            MatAutocompleteModule,
            MatTreeModule,
            MatButtonModule,
            MatButtonToggleModule,
            MatCardModule,
            MatBadgeModule,
            MatCheckboxModule,
            MatChipsModule,
            MatDatepickerModule,
            MatDialogModule,
            MatGridListModule,
            MatIconModule,
            MatInputModule,
            MatFormFieldModule,
            MatListModule,
            MatMenuModule,
            MatProgressBarModule,
            MatProgressSpinnerModule,
            MatRadioModule,
            MatSelectModule,
            MatSlideToggleModule,
            MatSliderModule,
            MatSidenavModule,
            MatSnackBarModule,
            MatTabsModule,
            MatToolbarModule,
            MatTooltipModule,
            MatPaginatorModule,
            MatSortModule,
            MatTableModule,
            MatNativeDateModule,
            MatExpansionModule,
            MatStepperModule,
            MatDividerModule,
            MatRippleModule,
            ReactiveFormsModule,
            MatMomentDateModule,
            DragDropModule,
            OverlayModule], exports: [CdkTableModule,
            ScrollingModule,
            MatAutocompleteModule,
            MatTreeModule,
            MatButtonModule,
            MatButtonToggleModule,
            MatCardModule,
            MatBadgeModule,
            MatCheckboxModule,
            MatChipsModule,
            MatDatepickerModule,
            MatDialogModule,
            MatGridListModule,
            MatIconModule,
            MatInputModule,
            MatFormFieldModule,
            MatListModule,
            MatMenuModule,
            MatProgressBarModule,
            MatProgressSpinnerModule,
            MatRadioModule,
            MatSelectModule,
            MatSlideToggleModule,
            MatSliderModule,
            MatSidenavModule,
            MatSnackBarModule,
            MatTabsModule,
            MatToolbarModule,
            MatTooltipModule,
            MatPaginatorModule,
            MatSortModule,
            MatTableModule,
            MatNativeDateModule,
            MatExpansionModule,
            MatStepperModule,
            MatDividerModule,
            MatRippleModule,
            ReactiveFormsModule,
            MatMomentDateModule,
            DragDropModule,
            OverlayModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: MaterialModule, providers: [
            { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 10000 } },
            { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
            { provide: MAT_TABS_CONFIG, useValue: { animationDuration: '0ms' } },
            {
                provide: MAT_EXPANSION_PANEL_DEFAULT_OPTIONS,
                useValue: {
                    expandedHeight: '56px',
                    collapsedHeight: '56px'
                }
            },
            { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
            { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always' } },
            { provide: MAT_PAGINATOR_DEFAULT_OPTIONS, useValue: { formFieldAppearance: 'fill' } }
        ], imports: [modules$3, CdkTableModule,
            ScrollingModule,
            MatAutocompleteModule,
            MatTreeModule,
            MatButtonModule,
            MatButtonToggleModule,
            MatCardModule,
            MatBadgeModule,
            MatCheckboxModule,
            MatChipsModule,
            MatDatepickerModule,
            MatDialogModule,
            MatGridListModule,
            MatIconModule,
            MatInputModule,
            MatFormFieldModule,
            MatListModule,
            MatMenuModule,
            MatProgressBarModule,
            MatProgressSpinnerModule,
            MatRadioModule,
            MatSelectModule,
            MatSlideToggleModule,
            MatSliderModule,
            MatSidenavModule,
            MatSnackBarModule,
            MatTabsModule,
            MatToolbarModule,
            MatTooltipModule,
            MatPaginatorModule,
            MatSortModule,
            MatTableModule,
            MatNativeDateModule,
            MatExpansionModule,
            MatStepperModule,
            MatDividerModule,
            MatRippleModule,
            ReactiveFormsModule,
            MatMomentDateModule,
            DragDropModule,
            OverlayModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: MaterialModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: modules$3,
                    exports: modules$3,
                    providers: [
                        { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 10000 } },
                        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
                        { provide: MAT_TABS_CONFIG, useValue: { animationDuration: '0ms' } },
                        {
                            provide: MAT_EXPANSION_PANEL_DEFAULT_OPTIONS,
                            useValue: {
                                expandedHeight: '56px',
                                collapsedHeight: '56px'
                            }
                        },
                        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
                        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always' } },
                        { provide: MAT_PAGINATOR_DEFAULT_OPTIONS, useValue: { formFieldAppearance: 'fill' } }
                    ]
                }]
        }] });

var AlertType;
(function (AlertType) {
    AlertType["classical"] = "classical";
    AlertType["success"] = "success";
    AlertType["strong"] = "strong";
    AlertType["critical"] = "critical";
    AlertType["clear"] = "clear";
})(AlertType || (AlertType = {}));

/**
 * Alert service
 */
class AlertService {
    constructor() {
        this.show = new Subject();
        this.hide = new Subject();
    }
    /**
     * Show an alert describe using associated model
     *
     * @param alert
     */
    showAlert(alert) {
        this.show.next(alert);
    }
    /**
     * Detect new alert display using observables
     *
     * @returns
     */
    receiveShowAlert() {
        return this.show.asObservable();
    }
    /**
     * Hide an alert after delay
     *
     * @param timestamp
     */
    hideAlert(timestamp) {
        this.hide.next(timestamp);
    }
    /**
     * Detect new alert hiding using observables
     *
     * @returns
     */
    receiveHideAlert() {
        return this.hide.asObservable();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: AlertService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: AlertService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: AlertService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Component to manage alerts.
 *
 * <b>Requirements: </b>
 *
 * - Add the alert center component on this *layout component* : `<mic-alert-center></mic-alert-center>`
 *
 * <b>On business component: </b>
 * - Add the `AlertService` on the constructor of your component.
 * - Use `showAlert` method from this service to display an alert.
 */
class AlertComponent {
    constructor(alertService) {
        this.alertService = alertService;
    }
    ngOnInit() {
        this.icon = this.getAlertIcon();
    }
    /**
     * Get alert icon from alert type
     *
     * @returns
     */
    getAlertIcon() {
        switch (this.alert.type) {
            case AlertType.success:
                return 'done';
            case AlertType.strong:
                return 'error_outline';
            case AlertType.critical:
                return 'priority_high';
            case AlertType.classical:
            case AlertType.clear:
            default:
                return 'notifications';
        }
    }
    hideAlert() {
        this.alertService.hideAlert(this.alert.timestamp);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: AlertComponent, deps: [{ token: AlertService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: AlertComponent, selector: "mic-alert", inputs: { alert: "alert" }, ngImport: i0, template: "@if (alert) {\n<mat-card class=\"alert mat-elevation-z2\" [ngClass]=\"'alert-' + alert.type\">\n  <div class=\"flex flex-row items-center gap-x-3\">\n    <mat-icon>{{ icon }}</mat-icon>\n    <div class=\"flex-1\">\n      @if (alert.title) {\n      <strong>{{ alert.title }}</strong>\n      }\n      <div [ngClass]=\"{ 'alert-small': alert.title }\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n    <div class=\"flex-none\">\n      <button mat-icon-button (click)=\"hideAlert()\"><mat-icon>close</mat-icon></button>\n    </div>\n  </div>\n</mat-card>\n}\n", styles: [":host{margin-top:15px}.alert{width:100%;animation-name:fade-in;animation-fill-mode:both;animation-duration:.2s}.alert .alert-small{font-size:12px}@keyframes fade-in{0%{opacity:0}to{opacity:1}}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: i1.MatIconButton, selector: "button[mat-icon-button]", exportAs: ["matButton"] }, { kind: "component", type: i2$1.MatCard, selector: "mat-card", inputs: ["appearance"], exportAs: ["matCard"] }, { kind: "component", type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: AlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-alert', template: "@if (alert) {\n<mat-card class=\"alert mat-elevation-z2\" [ngClass]=\"'alert-' + alert.type\">\n  <div class=\"flex flex-row items-center gap-x-3\">\n    <mat-icon>{{ icon }}</mat-icon>\n    <div class=\"flex-1\">\n      @if (alert.title) {\n      <strong>{{ alert.title }}</strong>\n      }\n      <div [ngClass]=\"{ 'alert-small': alert.title }\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n    <div class=\"flex-none\">\n      <button mat-icon-button (click)=\"hideAlert()\"><mat-icon>close</mat-icon></button>\n    </div>\n  </div>\n</mat-card>\n}\n", styles: [":host{margin-top:15px}.alert{width:100%;animation-name:fade-in;animation-fill-mode:both;animation-duration:.2s}.alert .alert-small{font-size:12px}@keyframes fade-in{0%{opacity:0}to{opacity:1}}\n"] }]
        }], ctorParameters: () => [{ type: AlertService }], propDecorators: { alert: [{
                type: Input
            }] } });

// Default hide delay
const defaultHideDelay = 8;
/**
 * Component use as alert container
 */
class AlertCenterComponent {
    constructor(alertService) {
        this.alertService = alertService;
        /**
         * Delay to hide alert in seconds (default value is **8 sec**)
         */
        this.hideDelay = defaultHideDelay;
        /**
         * Hide all types of alerts after the delay (including errors alerts)
         */
        this.hideAll = false;
        /**
         * List of visible alerts
         */
        this.visibleAlerts = signal([]);
        /**
         * Complete list of alerts
         */
        this.alerts = [];
    }
    ngOnInit() {
        // Manage alerts display
        this.showSubscription = this.alertService.receiveShowAlert().subscribe((alert) => {
            this.alerts.push({ ...alert, timestamp: alert.timestamp || new Date().getTime() });
            this.setAlertVisibility();
        });
        // Manage alerts hiding
        this.hideSubscription = this.alertService.receiveHideAlert().subscribe((timestamp) => {
            this.alerts = this.alerts.filter((alert) => alert.timestamp !== timestamp);
            this.setAlertVisibility();
        });
        this.scheduler = setInterval(() => this.setAlertVisibility(), 50);
    }
    ngOnDestroy() {
        this.showSubscription.unsubscribe();
        this.hideSubscription.unsubscribe();
        clearInterval(this.scheduler);
    }
    /**
     * Store displayed alerts in a dedicated scope variable
     */
    setAlertVisibility() {
        this.visibleAlerts.set(this.alerts.filter((alert) => this.isAlertVisible(alert)).reverse());
    }
    /**
     * Is an alert visible
     *
     * Critical & strong alerts are always visible
     * Others are hide when delay is outdated
     *
     * @param alert
     * @returns
     */
    isAlertVisible(alert) {
        const isRecentAlert = new Date().getTime() - alert.timestamp < this.hideDelay * 1000;
        const isCriticalAlert = [AlertType.strong, AlertType.critical].includes(alert.type);
        return isRecentAlert || (isCriticalAlert && !this.hideAll);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: AlertCenterComponent, deps: [{ token: AlertService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: AlertCenterComponent, selector: "mic-alert-center", inputs: { hideDelay: "hideDelay", hideAll: "hideAll" }, ngImport: i0, template: "<div class=\"flex flex-col justify-end alert-center\">\n  @for (alert of visibleAlerts(); track alert) {\n  <mic-alert [alert]=\"alert\">{{ alert.content }}</mic-alert>\n  }\n</div>\n", styles: [".alert-center{position:fixed;bottom:20px;right:60px;width:calc(100vw - 100px);max-width:700px;z-index:1001}\n"], dependencies: [{ kind: "component", type: AlertComponent, selector: "mic-alert", inputs: ["alert"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: AlertCenterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-alert-center', template: "<div class=\"flex flex-col justify-end alert-center\">\n  @for (alert of visibleAlerts(); track alert) {\n  <mic-alert [alert]=\"alert\">{{ alert.content }}</mic-alert>\n  }\n</div>\n", styles: [".alert-center{position:fixed;bottom:20px;right:60px;width:calc(100vw - 100px);max-width:700px;z-index:1001}\n"] }]
        }], ctorParameters: () => [{ type: AlertService }], propDecorators: { hideDelay: [{
                type: Input
            }], hideAll: [{
                type: Input
            }] } });

const imports$m = [CommonModule, MaterialModule];
const providers$2 = [AlertService];
const components$f = [AlertComponent, AlertCenterComponent];
/**
 *
 * <b>Requirements: </b>
 *
 * - Import the following module : <code>import { AlertModule } from '@michelin/theme';</code>
 */
class AlertModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: AlertModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: AlertModule, declarations: [AlertComponent, AlertCenterComponent], imports: [CommonModule, MaterialModule], exports: [AlertComponent, AlertCenterComponent, CommonModule, MaterialModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: AlertModule, providers: providers$2, imports: [imports$m, CommonModule, MaterialModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: AlertModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$m,
                    providers: providers$2,
                    declarations: [...components$f],
                    exports: [...components$f, ...imports$m]
                }]
        }] });

class BreadcrumbLinkComponent {
    constructor(router) {
        this.router = router;
        this.class = 'mic-breadcrumb-link';
    }
    click() {
        if (!this.disabled) {
            this.router.navigate([this.link]);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: BreadcrumbLinkComponent, deps: [{ token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: BreadcrumbLinkComponent, selector: "mic-breadcrumb-link", inputs: { icon: "icon", label: "label", ariaLabel: "ariaLabel", disabled: "disabled", link: "link", separator: "separator", active: "active" }, host: { properties: { "class": "this.class" } }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: BreadcrumbLinkComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'mic-breadcrumb-link',
                    template: ''
                }]
        }], ctorParameters: () => [{ type: i1$1.Router }], propDecorators: { icon: [{
                type: Input
            }], label: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], disabled: [{
                type: Input
            }], link: [{
                type: Input
            }], separator: [{
                type: Input
            }], active: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });

/* eslint-disable @angular-eslint/directive-selector */
/**
 * Directive to apply color on Link
 */
class LinkDirective {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: LinkDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: LinkDirective, selector: "a", inputs: { color: "color" }, host: { properties: { "attr.color": "this.color" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: LinkDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'a' }]
        }], propDecorators: { color: [{
                type: HostBinding,
                args: ['attr.color']
            }, {
                type: Input
            }] } });

class LinkComponent {
    constructor(router, el, renderer) {
        this.router = router;
        this.el = el;
        this.renderer = renderer;
        /**
         * Link target (default _self)
         */
        this.target = '_self';
        /**
         * Icon position: 'left' or 'right' (default right)
         */
        this.iconPosition = 'right';
        /**
         * Title with target="_blank": New tab (default langage: en)
         */
        this.titleNewWindow = 'New tab';
    }
    ngOnInit() {
        this.title = this.getTitle();
        this.tabIndex = this.getTabIndex();
        this.renderer.removeAttribute(this.el.nativeElement, 'tabindex');
    }
    ngOnChanges(changes) {
        if (changes.ariaLabel || changes.label || changes.target || changes.active || changes.disabled) {
            this.ngOnInit();
        }
    }
    /**
     * Determine the link title regarding target and ariaLabel
     */
    getTitle() {
        if (this.target === '_blank') {
            if (this.ariaLabel) {
                return `${this.ariaLabel}: ${this.titleNewWindow}`;
            }
            return `${this.label}: ${this.titleNewWindow}`;
        }
        else if (this.ariaLabel) {
            return this.ariaLabel;
        }
        return this.label;
    }
    /**
     * Determine the tab index form disabled and active attribute
     */
    getTabIndex() {
        if (this.disabled || this.active) {
            return -1;
        }
        return 0;
    }
    onClick() {
        if (!this.disabled && this.routerLink) {
            this.router.navigate([this.routerLink]);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: LinkComponent, deps: [{ token: i1$1.Router }, { token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: LinkComponent, selector: "mic-link", inputs: { id: "id", href: "href", target: "target", label: "label", ariaLabel: "ariaLabel", color: "color", icon: "icon", iconPosition: "iconPosition", rel: "rel", routerLink: "routerLink", disabled: "disabled", active: "active", titleNewWindow: "titleNewWindow" }, usesOnChanges: true, ngImport: i0, template: "@if (href) {\n<a\n  id=\"{{ id }}\"\n  [href]=\"href\"\n  [target]=\"target\"\n  [class]=\"color\"\n  [title]=\"title\"\n  [rel]=\"rel\"\n  [ngClass]=\"{ disabled: disabled, icon: icon, active: active }\"\n  [tabindex]=\"tabIndex\"\n>\n  <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n</a>\n} @else {\n<a\n  id=\"{{ id }}\"\n  [target]=\"target\"\n  [class]=\"color\"\n  [title]=\"title\"\n  [rel]=\"rel\"\n  [ngClass]=\"{ disabled: disabled, icon: icon, active: active }\"\n  (click)=\"onClick()\"\n  (keydown.enter)=\"onClick()\"\n  [tabindex]=\"tabIndex\"\n>\n  <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n</a>\n}\n\n<ng-template #contentTemplate>\n  @if (icon) {\n  <ng-container *ngTemplateOutlet=\"iconTemplate\"></ng-container>\n  } @else {\n  <ng-container *ngTemplateOutlet=\"labelTemplate\"></ng-container>\n  }\n</ng-template>\n\n<ng-template #iconTemplate>\n  @if (label) { @if (iconPosition === 'left') {\n  <mat-icon class=\"mic-icon-link\" [fontIcon]=\"icon\"></mat-icon>\n  <span class=\"mic-space-link\">&nbsp;</span>\n  <p class=\"mic-label-link\">{{ label }}</p>\n  } @if (iconPosition === 'right') {\n  <p class=\"mic-label-link\">{{ label }}</p>\n  <span class=\"mic-space-link\">&nbsp;</span>\n  <mat-icon class=\"mic-icon-link\" [fontIcon]=\"icon\"></mat-icon>\n  } } @else {\n  <ng-container *ngTemplateOutlet=\"iconOnly\"></ng-container>\n  }\n</ng-template>\n\n<ng-template #labelTemplate>\n  @if (label) {\n  <p class=\"mic-label-link\">{{ label }}</p>\n  } @else {\n  <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n  }\n</ng-template>\n\n<ng-template #iconOnly>\n  <mat-icon class=\"mic-icon-link\" [fontIcon]=\"icon\" [attr.aria-label]=\"ariaLabel\" aria-hidden=\"false\"></mat-icon>\n</ng-template>\n\n<ng-template #content>\n  <ng-content></ng-content>\n</ng-template>\n", styles: [":host a{display:flex;width:max-content;align-items:center}:host .mic-label-link{margin:0}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: LinkDirective, selector: "a", inputs: ["color"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: LinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-link', template: "@if (href) {\n<a\n  id=\"{{ id }}\"\n  [href]=\"href\"\n  [target]=\"target\"\n  [class]=\"color\"\n  [title]=\"title\"\n  [rel]=\"rel\"\n  [ngClass]=\"{ disabled: disabled, icon: icon, active: active }\"\n  [tabindex]=\"tabIndex\"\n>\n  <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n</a>\n} @else {\n<a\n  id=\"{{ id }}\"\n  [target]=\"target\"\n  [class]=\"color\"\n  [title]=\"title\"\n  [rel]=\"rel\"\n  [ngClass]=\"{ disabled: disabled, icon: icon, active: active }\"\n  (click)=\"onClick()\"\n  (keydown.enter)=\"onClick()\"\n  [tabindex]=\"tabIndex\"\n>\n  <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n</a>\n}\n\n<ng-template #contentTemplate>\n  @if (icon) {\n  <ng-container *ngTemplateOutlet=\"iconTemplate\"></ng-container>\n  } @else {\n  <ng-container *ngTemplateOutlet=\"labelTemplate\"></ng-container>\n  }\n</ng-template>\n\n<ng-template #iconTemplate>\n  @if (label) { @if (iconPosition === 'left') {\n  <mat-icon class=\"mic-icon-link\" [fontIcon]=\"icon\"></mat-icon>\n  <span class=\"mic-space-link\">&nbsp;</span>\n  <p class=\"mic-label-link\">{{ label }}</p>\n  } @if (iconPosition === 'right') {\n  <p class=\"mic-label-link\">{{ label }}</p>\n  <span class=\"mic-space-link\">&nbsp;</span>\n  <mat-icon class=\"mic-icon-link\" [fontIcon]=\"icon\"></mat-icon>\n  } } @else {\n  <ng-container *ngTemplateOutlet=\"iconOnly\"></ng-container>\n  }\n</ng-template>\n\n<ng-template #labelTemplate>\n  @if (label) {\n  <p class=\"mic-label-link\">{{ label }}</p>\n  } @else {\n  <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n  }\n</ng-template>\n\n<ng-template #iconOnly>\n  <mat-icon class=\"mic-icon-link\" [fontIcon]=\"icon\" [attr.aria-label]=\"ariaLabel\" aria-hidden=\"false\"></mat-icon>\n</ng-template>\n\n<ng-template #content>\n  <ng-content></ng-content>\n</ng-template>\n", styles: [":host a{display:flex;width:max-content;align-items:center}:host .mic-label-link{margin:0}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.Router }, { type: i0.ElementRef }, { type: i0.Renderer2 }], propDecorators: { id: [{
                type: Input
            }], href: [{
                type: Input
            }], target: [{
                type: Input
            }], label: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], color: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconPosition: [{
                type: Input
            }], rel: [{
                type: Input
            }], routerLink: [{
                type: Input
            }], disabled: [{
                type: Input
            }], active: [{
                type: Input
            }], titleNewWindow: [{
                type: Input
            }] } });

/**
 * Component to manage breadcrumbs and sub navigation.
 */
class BreadcrumbComponent {
    constructor(router) {
        this.router = router;
        this.hidden = [];
    }
    ngAfterContentInit() {
        this.links.forEach((item, index) => {
            // Manage separator for items
            if (index + 1 < this.links.length) {
                item.separator = true;
            }
        });
        const arr = this.links.toArray();
        if (this.limit && this.limit < arr.length) {
            this.before = arr.slice(0, 1);
            this.hidden = arr.slice(1, arr.length - this.limit + 1);
            this.after = arr.slice(-this.limit + 1);
        }
        this.links.last.active = true;
    }
    click(link) {
        if (!link.disabled) {
            this.router.navigate([link.link]);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: BreadcrumbComponent, deps: [{ token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: BreadcrumbComponent, selector: "mic-breadcrumb", inputs: { limit: "limit" }, queries: [{ propertyName: "links", predicate: BreadcrumbLinkComponent }], ngImport: i0, template: "<nav aria-label=\"Breadcrumb\" class=\"flex flex-row flex-wrap items-center gap-x-2-5\">\n  @if (hidden.length > 0 && limit > 1) {\n  <ol>\n    @for (link of before; track link) {\n    <ng-container [ngTemplateOutlet]=\"simpleLink\" [ngTemplateOutletContext]=\"{ link: link }\"></ng-container>\n    }\n    <button [matMenuTriggerFor]=\"menu\" class=\"mic-breadcrumb-more\">\n      <mat-icon fontIcon=\"more_horiz\"></mat-icon>\n    </button>\n    <mat-icon class=\"mic-breadcrumb-separator\" fontIcon=\"keyboard_arrow_right\"></mat-icon>\n    @for (link of after; track link) {\n    <ng-container [ngTemplateOutlet]=\"simpleLink\" [ngTemplateOutletContext]=\"{ link: link }\"></ng-container>\n    }\n  </ol>\n  } @else {\n  <ol>\n    @for (link of links; track link) {\n    <ng-container [ngTemplateOutlet]=\"simpleLink\" [ngTemplateOutletContext]=\"{ link: link }\"></ng-container>\n    }\n  </ol>\n  }\n</nav>\n<ng-template #simpleLink let-link=\"link\">\n  <li class=\"mic-breadcrumb-link flex flex-row items-center gap-x-1-5\">\n    <mic-link\n      [label]=\"link.label\"\n      [ariaLabel]=\"link.ariaLabel\"\n      [icon]=\"link.icon\"\n      iconPosition=\"left\"\n      [routerLink]=\"link.link\"\n      [disabled]=\"link.disabled\"\n      [active]=\"link.active\"\n      [attr.aria-current]=\"link.active ? 'page' : ''\"\n    ></mic-link>\n    @if (link.separator) {\n    <mat-icon class=\"mic-breadcrumb-separator\" fontIcon=\"keyboard_arrow_right\"></mat-icon>\n    }\n  </li>\n</ng-template>\n<mat-menu #menu=\"matMenu\">\n  @for (link of hidden; track link) {\n  <button [disabled]=\"link.disabled\" (click)=\"click(link)\" mat-menu-item>\n    @if (link.icon) {\n    <mat-icon>{{ link.icon }}</mat-icon>\n    }\n    <span>{{ link.label }}</span>\n  </button>\n  }\n</mat-menu>\n", styles: [":host{margin:4px 0}.mic-breadcrumb-more{cursor:pointer;height:16px;padding:0 4px;border-radius:4px;border:0px;display:flex;place-items:center}\n"], dependencies: [{ kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i4.MatMenu, selector: "mat-menu", inputs: ["backdropClass", "aria-label", "aria-labelledby", "aria-describedby", "xPosition", "yPosition", "overlapTrigger", "hasBackdrop", "class", "classList"], outputs: ["closed", "close"], exportAs: ["matMenu"] }, { kind: "component", type: i4.MatMenuItem, selector: "[mat-menu-item]", inputs: ["role", "disabled", "disableRipple"], exportAs: ["matMenuItem"] }, { kind: "directive", type: i4.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", inputs: ["mat-menu-trigger-for", "matMenuTriggerFor", "matMenuTriggerData", "matMenuTriggerRestoreFocus"], outputs: ["menuOpened", "onMenuOpen", "menuClosed", "onMenuClose"], exportAs: ["matMenuTrigger"] }, { kind: "component", type: LinkComponent, selector: "mic-link", inputs: ["id", "href", "target", "label", "ariaLabel", "color", "icon", "iconPosition", "rel", "routerLink", "disabled", "active", "titleNewWindow"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: BreadcrumbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-breadcrumb', template: "<nav aria-label=\"Breadcrumb\" class=\"flex flex-row flex-wrap items-center gap-x-2-5\">\n  @if (hidden.length > 0 && limit > 1) {\n  <ol>\n    @for (link of before; track link) {\n    <ng-container [ngTemplateOutlet]=\"simpleLink\" [ngTemplateOutletContext]=\"{ link: link }\"></ng-container>\n    }\n    <button [matMenuTriggerFor]=\"menu\" class=\"mic-breadcrumb-more\">\n      <mat-icon fontIcon=\"more_horiz\"></mat-icon>\n    </button>\n    <mat-icon class=\"mic-breadcrumb-separator\" fontIcon=\"keyboard_arrow_right\"></mat-icon>\n    @for (link of after; track link) {\n    <ng-container [ngTemplateOutlet]=\"simpleLink\" [ngTemplateOutletContext]=\"{ link: link }\"></ng-container>\n    }\n  </ol>\n  } @else {\n  <ol>\n    @for (link of links; track link) {\n    <ng-container [ngTemplateOutlet]=\"simpleLink\" [ngTemplateOutletContext]=\"{ link: link }\"></ng-container>\n    }\n  </ol>\n  }\n</nav>\n<ng-template #simpleLink let-link=\"link\">\n  <li class=\"mic-breadcrumb-link flex flex-row items-center gap-x-1-5\">\n    <mic-link\n      [label]=\"link.label\"\n      [ariaLabel]=\"link.ariaLabel\"\n      [icon]=\"link.icon\"\n      iconPosition=\"left\"\n      [routerLink]=\"link.link\"\n      [disabled]=\"link.disabled\"\n      [active]=\"link.active\"\n      [attr.aria-current]=\"link.active ? 'page' : ''\"\n    ></mic-link>\n    @if (link.separator) {\n    <mat-icon class=\"mic-breadcrumb-separator\" fontIcon=\"keyboard_arrow_right\"></mat-icon>\n    }\n  </li>\n</ng-template>\n<mat-menu #menu=\"matMenu\">\n  @for (link of hidden; track link) {\n  <button [disabled]=\"link.disabled\" (click)=\"click(link)\" mat-menu-item>\n    @if (link.icon) {\n    <mat-icon>{{ link.icon }}</mat-icon>\n    }\n    <span>{{ link.label }}</span>\n  </button>\n  }\n</mat-menu>\n", styles: [":host{margin:4px 0}.mic-breadcrumb-more{cursor:pointer;height:16px;padding:0 4px;border-radius:4px;border:0px;display:flex;place-items:center}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.Router }], propDecorators: { limit: [{
                type: Input
            }], links: [{
                type: ContentChildren,
                args: [BreadcrumbLinkComponent]
            }] } });

const imports$l = [CommonModule, MaterialModule];
const declarations$7 = [LinkComponent, LinkDirective];
class LinkModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: LinkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: LinkModule, declarations: [LinkComponent, LinkDirective], imports: [CommonModule, MaterialModule], exports: [LinkComponent, LinkDirective, CommonModule, MaterialModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: LinkModule, imports: [imports$l, CommonModule, MaterialModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: LinkModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$l,
                    declarations: declarations$7,
                    exports: [...declarations$7, ...imports$l]
                }]
        }] });

const imports$k = [CommonModule, MaterialModule, FormsModule, LinkModule];
const components$e = [BreadcrumbComponent, BreadcrumbLinkComponent];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { BreadcrumbModule } from '@michelin/theme';</code>
 */
class BreadcrumbModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: BreadcrumbModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: BreadcrumbModule, declarations: [BreadcrumbComponent, BreadcrumbLinkComponent], imports: [CommonModule, MaterialModule, FormsModule, LinkModule], exports: [BreadcrumbComponent, BreadcrumbLinkComponent, CommonModule, MaterialModule, FormsModule, LinkModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: BreadcrumbModule, imports: [imports$k, CommonModule, MaterialModule, FormsModule, LinkModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: BreadcrumbModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$k,
                    declarations: [...components$e],
                    exports: [...components$e, ...imports$k]
                }]
        }] });

const translateXzero = 'translateX(0%)';
const easeOut = '.5s ease-out';
const left = [
    query(':enter, :leave', style({ 'transform-style': 'preserve-3d' }), { optional: true }),
    group([
        query(':enter', [style({ transform: 'translateX(-100%)' }), animate(easeOut, style({ transform: translateXzero }))], {
            optional: true
        }),
        query(':leave', [style({ transform: translateXzero }), animate(easeOut, style({ transform: 'translateX(100%)' }))], {
            optional: true
        })
    ])
];
const right = [
    query(':enter, :leave', style({}), { optional: true }),
    group([
        query(':enter', [style({ transform: 'translateX(100%)' }), animate(easeOut, style({ transform: translateXzero }))], {
            optional: true
        }),
        query(':leave', [style({ transform: translateXzero }), animate(easeOut, style({ transform: 'translateX(-100%)' }))], {
            optional: true
        })
    ])
];
const carouselAnimation = [trigger('slideInOut', [transition(':increment', right), transition(':decrement', left)])];

/**
 * Component for image carousel
 */
class CarouselComponent {
    constructor() {
        /**
         * Manage the autoplay of the carouse
         */
        this.autoPlay = false;
        /**
         * The amount of time to delay between automatically cycling an image
         */
        this.interval = 5000;
        this.ariaRpleDescription = 'carousel';
        this.id = new Date().getTime().toString();
        this.currentIndex = signal(0);
        this.stopPlay = new Subject();
    }
    ngOnInit() {
        this.observable = interval(this.interval);
        if (this.autoPlay) {
            this.setInterval();
        }
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    setInterval() {
        this.subscription = this.observable.pipe(takeUntil(this.stopPlay)).subscribe(() => {
            this.setIndex(this.currentIndex() + 1, false);
        });
    }
    setIndex(index, resetInterval = true) {
        this.currentIndex.set(index);
        if (this.currentIndex() >= this.images.length) {
            this.currentIndex.set(0);
        }
        if (this.currentIndex() < 0) {
            this.currentIndex.set(this.images.length - 1);
        }
        if (resetInterval && this.subscription && !this.subscription.closed) {
            this.stopPlay.next();
            this.setInterval();
        }
    }
    toggleAutoPlay() {
        if (this.subscription.closed) {
            this.setInterval();
        }
        else {
            this.stopPlay.next();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: CarouselComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: CarouselComponent, selector: "mic-carousel", inputs: { images: "images", autoPlay: "autoPlay", interval: "interval" }, host: { properties: { "attr.aria-roledescription": "this.ariaRpleDescription" } }, ngImport: i0, template: "<div\n  id=\"carousel-items-{{ id }}\"\n  class=\"mic-carousel\"\n  [@slideInOut]=\"currentIndex()\"\n  [attr.aria-live]=\"!autoPlay ? 'polite' : subscription.closed ? 'polite' : 'off'\"\n>\n  @for (image of images; track image; let i = $index) { @if (i === currentIndex()) {\n  <div\n    id=\"carousel-items-{{ id }}-{{ i + 1 }}\"\n    class=\"slide\"\n    role=\"tabpanel\"\n    aria-roledescription=\"slide\"\n    attr.aria-label=\"{{ i + 1 }} of {{ images.length }}\"\n  >\n    <img [src]=\"image.url\" alt=\"\" />\n    @if (image.description) {\n    <div class=\"description\">{{ image.description }}</div>\n    }\n  </div>\n  } }\n</div>\n<button\n  type=\"button\"\n  mat-mini-fab\n  color=\"primary\"\n  (click)=\"setIndex(currentIndex() - 1)\"\n  class=\"button-left\"\n  aria-label=\"Previous slide\"\n  aria-controls=\"carousel-items\"\n>\n  <mat-icon>chevron_left</mat-icon>\n</button>\n<button\n  type=\"button\"\n  mat-mini-fab\n  color=\"primary\"\n  (click)=\"setIndex(currentIndex() + 1)\"\n  class=\"button-right\"\n  aria-label=\"Next slide\"\n  aria-controls=\"carousel-items\"\n>\n  <mat-icon>chevron_right</mat-icon>\n</button>\n<div class=\"flex flex-row justify-center mt-1\">\n  @if (autoPlay) {\n  <button\n    type=\"button\"\n    mat-icon-button\n    color=\"primary\"\n    (click)=\"toggleAutoPlay()\"\n    attr.aria-label=\"{{ subscription.closed ? 'Start' : 'Stop' }} automatic slide show\"\n  >\n    @if (!subscription.closed) {\n    <mat-icon>pause</mat-icon>\n    } @if (subscription.closed) {\n    <mat-icon>play_arrow</mat-icon>\n    }\n  </button>\n  }\n  <mat-radio-group role=\"tablist\" aria-label=\"Slides\" [ngModel]=\"currentIndex()\" (ngModelChange)=\"setIndex($event)\">\n    @for (img of images; track img; let i = $index) {\n    <mat-radio-button\n      type=\"button\"\n      role=\"tab\"\n      [value]=\"i\"\n      [attr.aria-label]=\"'Slide ' + (i + 1)\"\n      [attr.aria-selected]=\"i === currentIndex()\"\n      attr.aria-controls=\"carousel-items-{{ i + 1 }}\"\n    ></mat-radio-button>\n    }\n  </mat-radio-group>\n</div>\n", styles: [":host{width:100%;height:500px;position:relative}@media (max-width: 640px){:host{height:250px}}:host .mic-carousel{position:relative;height:calc(100% - 40px);overflow:hidden}:host .mic-carousel .slide{position:absolute;inset:0;height:100%;width:100%}:host .mic-carousel .slide img{display:block;object-fit:cover;height:100%;width:100%}:host .mic-carousel .slide .description{position:absolute;bottom:0;width:100%;padding:10px 0;text-align:center;opacity:.95}.button-left,.button-right{position:absolute;top:50%;margin-top:-20px}.button-left.button-left,.button-right.button-left{left:20px}.button-left.button-right,.button-right.button-right{right:20px}\n"], dependencies: [{ kind: "component", type: i1.MatIconButton, selector: "button[mat-icon-button]", exportAs: ["matButton"] }, { kind: "component", type: i1.MatMiniFabButton, selector: "button[mat-mini-fab]", exportAs: ["matButton"] }, { kind: "component", type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i3.MatRadioGroup, selector: "mat-radio-group", inputs: ["color", "name", "labelPosition", "value", "selected", "disabled", "required"], outputs: ["change"], exportAs: ["matRadioGroup"] }, { kind: "component", type: i3.MatRadioButton, selector: "mat-radio-button", inputs: ["id", "name", "aria-label", "aria-labelledby", "aria-describedby", "disableRipple", "tabIndex", "checked", "value", "labelPosition", "disabled", "required", "color"], outputs: ["change"], exportAs: ["matRadioButton"] }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], animations: carouselAnimation }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: CarouselComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-carousel', animations: carouselAnimation, template: "<div\n  id=\"carousel-items-{{ id }}\"\n  class=\"mic-carousel\"\n  [@slideInOut]=\"currentIndex()\"\n  [attr.aria-live]=\"!autoPlay ? 'polite' : subscription.closed ? 'polite' : 'off'\"\n>\n  @for (image of images; track image; let i = $index) { @if (i === currentIndex()) {\n  <div\n    id=\"carousel-items-{{ id }}-{{ i + 1 }}\"\n    class=\"slide\"\n    role=\"tabpanel\"\n    aria-roledescription=\"slide\"\n    attr.aria-label=\"{{ i + 1 }} of {{ images.length }}\"\n  >\n    <img [src]=\"image.url\" alt=\"\" />\n    @if (image.description) {\n    <div class=\"description\">{{ image.description }}</div>\n    }\n  </div>\n  } }\n</div>\n<button\n  type=\"button\"\n  mat-mini-fab\n  color=\"primary\"\n  (click)=\"setIndex(currentIndex() - 1)\"\n  class=\"button-left\"\n  aria-label=\"Previous slide\"\n  aria-controls=\"carousel-items\"\n>\n  <mat-icon>chevron_left</mat-icon>\n</button>\n<button\n  type=\"button\"\n  mat-mini-fab\n  color=\"primary\"\n  (click)=\"setIndex(currentIndex() + 1)\"\n  class=\"button-right\"\n  aria-label=\"Next slide\"\n  aria-controls=\"carousel-items\"\n>\n  <mat-icon>chevron_right</mat-icon>\n</button>\n<div class=\"flex flex-row justify-center mt-1\">\n  @if (autoPlay) {\n  <button\n    type=\"button\"\n    mat-icon-button\n    color=\"primary\"\n    (click)=\"toggleAutoPlay()\"\n    attr.aria-label=\"{{ subscription.closed ? 'Start' : 'Stop' }} automatic slide show\"\n  >\n    @if (!subscription.closed) {\n    <mat-icon>pause</mat-icon>\n    } @if (subscription.closed) {\n    <mat-icon>play_arrow</mat-icon>\n    }\n  </button>\n  }\n  <mat-radio-group role=\"tablist\" aria-label=\"Slides\" [ngModel]=\"currentIndex()\" (ngModelChange)=\"setIndex($event)\">\n    @for (img of images; track img; let i = $index) {\n    <mat-radio-button\n      type=\"button\"\n      role=\"tab\"\n      [value]=\"i\"\n      [attr.aria-label]=\"'Slide ' + (i + 1)\"\n      [attr.aria-selected]=\"i === currentIndex()\"\n      attr.aria-controls=\"carousel-items-{{ i + 1 }}\"\n    ></mat-radio-button>\n    }\n  </mat-radio-group>\n</div>\n", styles: [":host{width:100%;height:500px;position:relative}@media (max-width: 640px){:host{height:250px}}:host .mic-carousel{position:relative;height:calc(100% - 40px);overflow:hidden}:host .mic-carousel .slide{position:absolute;inset:0;height:100%;width:100%}:host .mic-carousel .slide img{display:block;object-fit:cover;height:100%;width:100%}:host .mic-carousel .slide .description{position:absolute;bottom:0;width:100%;padding:10px 0;text-align:center;opacity:.95}.button-left,.button-right{position:absolute;top:50%;margin-top:-20px}.button-left.button-left,.button-right.button-left{left:20px}.button-left.button-right,.button-right.button-right{right:20px}\n"] }]
        }], propDecorators: { images: [{
                type: Input
            }], autoPlay: [{
                type: Input
            }], interval: [{
                type: Input
            }], ariaRpleDescription: [{
                type: HostBinding,
                args: ['attr.aria-roledescription']
            }] } });

const imports$j = [CommonModule, MatButtonModule, MatIconModule, MatRadioModule, FormsModule];
const components$d = [CarouselComponent];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { CarouselModule } from '@michelin/theme';</code>
 */
class CarouselModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: CarouselModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: CarouselModule, declarations: [CarouselComponent], imports: [CommonModule, MatButtonModule, MatIconModule, MatRadioModule, FormsModule], exports: [CarouselComponent, CommonModule, MatButtonModule, MatIconModule, MatRadioModule, FormsModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: CarouselModule, imports: [imports$j, CommonModule, MatButtonModule, MatIconModule, MatRadioModule, FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: CarouselModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$j,
                    declarations: [...components$d],
                    exports: [...components$d, ...imports$j]
                }]
        }] });

/**
 * Image model for carousel
 */
class Image {
}

const DEFAULT_PAGESIZE = 10;
const DEFAULT_PAGESIZE_OPTIONS = [5, 10, 50, 100];
/**
 * Define pagination opions
 */
class PaginationOption {
}
/**
 * Paginator configuration model
 */
class PaginatorConfig {
}
/**
 * Storage options
 */
class StorageOption {
}
/**
 * Storage configuration model
 */
class StorageConfig {
    /**
     * Get pagination store state from a storage configuration
     *
     * In the case of query parameter storage, you need to give activated route
     *
     * @param storage
     * @param route
     * @returns
     */
    static getState(storage, route) {
        const params = StorageConfig.manageParams(storage, route);
        if (params) {
            const extraFilters = storage.options?.keys
                ? Object.keys(params)
                    .filter((value) => storage.options.keys.indexOf(value) >= 0)
                    .reduce((p, key) => {
                    p[key] = params[key] !== '' ? params[key] : null;
                    return p;
                }, {})
                : null;
            return {
                extraFilters,
                page: params.page ? parseInt(params.page) : 1,
                limit: params.limit ? parseInt(params.limit) : null,
                sort: params.sort
            };
        }
        return {};
    }
    static manageParams(storage, route) {
        let params = null;
        if (storage && storage.type instanceof Storage) {
            if (!storage.options?.prefix) {
                throw new Error('Missing options.prefix to save state in localstorage or sessionstorage');
            }
            else {
                params = JSON.parse(storage.type.getItem(`${storage.options.prefix}state`)) || {};
            }
        }
        if (storage && storage.type === 'query') {
            if (!route) {
                throw new Error('Missing route parameter on StorageConfig.getState');
            }
            else {
                params = StorageConfig.removePrefix(storage.options?.prefix, route.snapshot.queryParams);
            }
        }
        return params;
    }
    /**
     * Store pagination state with a storage configuration
     *
     * In the case of query parameter storage, you need to give router
     *
     * @param storage
     * @param filters
     * @param router
     */
    static storeState(storage, filters, router) {
        if (storage) {
            // Get extra filters associated to desired keys
            const extraFilters = StorageConfig.getExtraFilters(storage, filters);
            let state = {
                ...extraFilters
            };
            if (storage.options?.paginator) {
                state = {
                    ...extraFilters,
                    page: filters.page,
                    limit: filters.limit,
                    sort: filters.sort
                };
            }
            if (storage.type instanceof Storage) {
                if (!storage.options?.prefix) {
                    throw new Error('Missing options.prefix to save state in localstorage or sessionstorage');
                }
                else {
                    storage.type.setItem(`${storage.options.prefix}state`, JSON.stringify(state));
                }
            }
            if (storage.type === 'query') {
                router.navigate([], {
                    queryParams: StorageConfig.addPrefix(storage.options?.prefix, state),
                    queryParamsHandling: 'merge',
                    replaceUrl: true
                });
            }
        }
    }
    static getExtraFilters(storage, filters) {
        return storage.options?.keys
            ? Object.keys(filters?.extraFilters || {})
                .filter((value) => storage.options.keys.indexOf(value) >= 0)
                .reduce((params, key) => {
                let value = filters.extraFilters[key];
                // Manage case of dates
                if (isMoment(value)) {
                    // Convert to timestamp
                    value = value.format();
                }
                if (value instanceof Date) {
                    // Convert to timestamp
                    value = value.getTime();
                }
                // Manage case of dates
                if (value instanceof Array) {
                    // Convert to timestamp
                    value = value.join(',');
                }
                params[key] = value !== '' ? value : null;
                return params;
            }, {})
            : {};
    }
    /**
     * Remove prefix on each stored keys
     *
     * @param prefix
     * @param params
     * @returns
     */
    static removePrefix(prefix, params) {
        return Object.keys(params).reduce((p, key) => {
            p[key.replace(prefix, '')] = params[key];
            return p;
        }, {});
    }
    /**
     * Add prefix on each stored keys
     *
     * @param prefix
     * @param params
     * @returns
     */
    static addPrefix(prefix, params) {
        return Object.keys(params).reduce((p, key) => {
            p[(prefix || '') + key] = params[key];
            return p;
        }, {});
    }
}
/**
 * Paginator filters
 */
class PaginatorFilters {
    constructor({ limit, page, sort, extraFilters }) {
        this.limit = limit;
        this.page = page;
        this.sort = sort;
        this.extraFilters = extraFilters;
    }
    /**
     * Apply extra filters on the model
     *
     * @param extraFilters
     */
    patchExtraFilters(extraFilters) {
        this.extraFilters = { ...this.extraFilters, ...extraFilters };
    }
    /**
     * Retrieve all pagination parameters as Angular Http parameters
     *
     * @returns
     */
    toHttpParams() {
        let params = new HttpParams();
        params = params.appendAll({
            limit: this.limit,
            page: this.page
        });
        if (this.sort) {
            params = params.append('sort', this.sort);
        }
        if (this.extraFilters) {
            const keys = Object.keys(this.extraFilters);
            keys.forEach((key) => {
                if (this.extraFilters[key]) {
                    params = params.append(key, this.extraFilters[key].toString());
                }
            });
        }
        return params;
    }
}
class PaginatorFormGroup extends UntypedFormGroup {
    constructor(init, extraFilters = {}) {
        super({
            limit: new FormControl(init.limit || DEFAULT_PAGESIZE),
            page: new FormControl(init.page || 1),
            sort: new FormControl(init.sort || null),
            extraFilters: new FormControl(extraFilters)
        });
    }
}

const scrollAnimationDelay$1 = 100;
const scrollAnimationType$1 = 'linear';
const panelActiveItemSelector = '.mat-active';
/**
 * Directive based on overlayscrollbars to customize overflow through a dedicated directive
 *
 */
class ScrollBarDirective {
    handleKeyboardEvent(event) {
        const element = this.element.nativeElement;
        if (element.classList.contains('mat-select-options-wrapper')) {
            const active = document.querySelector(panelActiveItemSelector);
            if (active && this.scroll) {
                // Scroll is necessary if the active item is not completly visible
                // Distinction is necessary for keyboard event (ArrowDown vs ArrowUp)
                const scrollY = this.scroll.scroll().position.y;
                const needScroll = event.key === 'ArrowDown' ? element.offsetHeight < active.offsetTop + active.offsetHeight : active.offsetTop < scrollY;
                if (needScroll) {
                    // Scroll with animation
                    this.scroll.scroll({ y: active.offsetTop }, scrollAnimationDelay$1, scrollAnimationType$1);
                }
                active.focus();
            }
        }
    }
    /**
     * For print mode
     * Overlayscrollbar need to be disabled
     */
    onBeforePrint() {
        this.destroyScrollbar();
    }
    /**
     * For display mode
     * Overlayscrollbar need to be enabled
     */
    onAfterPrint() {
        this.createScrollbar();
    }
    constructor(element, router) {
        this.element = element;
        this.router = router;
        /**
         * Options for the scrollbar
         */
        this.micScrollBarOptions = {
            scrollbars: { autoHide: 'move' }
        };
    }
    /**
     * Create a scrollbar using lib overlayscrollbars
     */
    createScrollbar() {
        this.scroll = OverlayScrollbars(this.element.nativeElement, this.micScrollBarOptions);
    }
    /**
     * Destroy the current scrollbar if exists
     */
    destroyScrollbar() {
        if (OverlayScrollbars.valid(this.scroll)) {
            this.scroll.destroy();
        }
    }
    /**
     * Create scrollbar when dom is ready
     */
    ngAfterViewInit() {
        this.createScrollbar();
    }
    /**
     * Delete scrollbar instance
     */
    ngOnDestroy() {
        this.destroyScrollbar();
        // Destroy router sub if exists
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }
    /**
     * Init route detection to force reset scroll bar
     */
    initRouteDetection() {
        this.routerSubscription = this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((_) => {
            this.scroll.scroll(0);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ScrollBarDirective, deps: [{ token: i0.ElementRef }, { token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: ScrollBarDirective, selector: "[micScrollBar]", inputs: { micScrollBar: "micScrollBar", micScrollBarOptions: "micScrollBarOptions" }, host: { listeners: { "keyup": "handleKeyboardEvent($event)", "window:beforeprint": "onBeforePrint()", "window:afterprint": "onAfterPrint()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ScrollBarDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[micScrollBar]' }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$1.Router }], propDecorators: { micScrollBar: [{
                type: Input
            }], micScrollBarOptions: [{
                type: Input
            }], handleKeyboardEvent: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }], onBeforePrint: [{
                type: HostListener,
                args: ['window:beforeprint']
            }], onAfterPrint: [{
                type: HostListener,
                args: ['window:afterprint']
            }] } });

class AbstractScrollbarDirective {
    constructor() {
        this.opened = false;
        this.scrollAnimationDelay = 100;
        this.scrollAnimationType = 'linear';
        this.panelActiveItemSelector = `.mat-active`;
    }
    handleKeyboardEvent(event) {
        if (this.opened) {
            const active = document.querySelector(`${this.panelSelector} ${this.panelActiveItemSelector}`);
            if (active && this.scroll) {
                const element = document.querySelector(this.panelSelector);
                // Scroll is necessary if the active item is not completly visible
                // Distinction is necessary for keyboard event (ArrowDown vs ArrowUp)
                const scrollY = this.scroll.scroll().position.y;
                const needScroll = event.key === 'ArrowDown' ? element.offsetHeight < active.offsetTop + active.offsetHeight : active.offsetTop < scrollY;
                if (needScroll) {
                    // Scroll with animation
                    this.scroll.scroll({ y: active.offsetTop }, this.scrollAnimationDelay, this.scrollAnimationType);
                }
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: AbstractScrollbarDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: AbstractScrollbarDirective, host: { listeners: { "keyup": "handleKeyboardEvent($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: AbstractScrollbarDirective, decorators: [{
            type: Directive
        }], propDecorators: { handleKeyboardEvent: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }] } });

/* eslint-disable @angular-eslint/directive-selector */
const panelClass = 'mic-select-panel';
class ScrollBarSelectDirective extends AbstractScrollbarDirective {
    constructor(element) {
        super();
        this.panelSelector = `.${panelClass}`;
        this.element = element;
        this.element.panelClass = panelClass;
    }
    ngOnInit() {
        this.subscription = this.element.openedChange.subscribe((opened) => {
            this.opened = opened;
            if (opened) {
                const element = document.querySelector(this.panelSelector);
                if (navigator.userAgent.indexOf('WebKit') !== -1) {
                    element.style.height = 'fit-content';
                }
                else {
                    element.style.height = '-moz-fit-content';
                }
                const active = element.querySelector(this.panelActiveItemSelector);
                this.scroll = OverlayScrollbars(element, {});
                // Scroll to the active item
                if (active && element.offsetHeight < active.offsetTop + active.offsetHeight) {
                    this.scroll.scroll({ y: active.offsetTop }, this.scrollAnimationDelay, this.scrollAnimationType);
                }
            }
            else if (OverlayScrollbars.valid(this.scroll)) {
                this.scroll.destroy();
            }
        });
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ScrollBarSelectDirective, deps: [{ token: i5.MatSelect }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: ScrollBarSelectDirective, selector: "mat-select", usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ScrollBarSelectDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'mat-select' }]
        }], ctorParameters: () => [{ type: i5.MatSelect }] });

const defaultDiameter = 60;
const defaultStrokeWidth = 5;
/**
 * Component to display spinner
 */
class SpinnerComponent {
    constructor() {
        /**
         * Stroke with (default: 5px)
         */
        this.strokeWidth = defaultStrokeWidth;
        /**
         * Diameter (default: 60px)
         */
        this.diameter = defaultDiameter;
        /**
         * Progress spinner mode
         * Input must be one of these values: determinate, indeterminate, buffer, query, defaults to 'determinate'.
         */
        this.mode = 'indeterminate';
        /**
         * Show percentage (default value true)
         */
        this.showPercentage = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: SpinnerComponent, selector: "mic-spinner", inputs: { color: "color", strokeWidth: "strokeWidth", diameter: "diameter", mode: "mode", value: "value", ariaLabel: "ariaLabel", showPercentage: "showPercentage" }, ngImport: i0, template: "<div class=\"grid items-center\">\n  <mat-progress-spinner\n    class=\"first-grid\"\n    [mode]=\"mode\"\n    [color]=\"color\"\n    [strokeWidth]=\"strokeWidth\"\n    [diameter]=\"diameter\"\n    [value]=\"value\"\n    [ariaLabel]=\"ariaLabel\"\n  ></mat-progress-spinner>\n  @if (mode !== 'indeterminate' && showPercentage) {\n  <h6 class=\"percentage\" [ngClass]=\"diameter >= 60 ? 'first-grid' : ''\">\n    {{ value + '%' }}\n  </h6>\n  }\n</div>\n", styles: [":host{height:100%;min-height:100%;min-width:100%;width:100%;flex-direction:row;box-sizing:border-box;display:flex;place-content:center;align-items:center;padding:10px 0}.percentage{margin-top:0;text-align:center}.first-grid{grid-row:1;grid-column:1}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: i2$3.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "mode", "value", "diameter", "strokeWidth"], exportAs: ["matProgressSpinner"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-spinner', template: "<div class=\"grid items-center\">\n  <mat-progress-spinner\n    class=\"first-grid\"\n    [mode]=\"mode\"\n    [color]=\"color\"\n    [strokeWidth]=\"strokeWidth\"\n    [diameter]=\"diameter\"\n    [value]=\"value\"\n    [ariaLabel]=\"ariaLabel\"\n  ></mat-progress-spinner>\n  @if (mode !== 'indeterminate' && showPercentage) {\n  <h6 class=\"percentage\" [ngClass]=\"diameter >= 60 ? 'first-grid' : ''\">\n    {{ value + '%' }}\n  </h6>\n  }\n</div>\n", styles: [":host{height:100%;min-height:100%;min-width:100%;width:100%;flex-direction:row;box-sizing:border-box;display:flex;place-content:center;align-items:center;padding:10px 0}.percentage{margin-top:0;text-align:center}.first-grid{grid-row:1;grid-column:1}\n"] }]
        }], propDecorators: { color: [{
                type: Input
            }], strokeWidth: [{
                type: Input
            }], diameter: [{
                type: Input
            }], mode: [{
                type: Input
            }], value: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], showPercentage: [{
                type: Input
            }] } });

/**
 * Component to display spinner in front of content
 */
class SpinnerOverlayComponent {
    constructor(el) {
        this.el = el;
        this.overlayHeight = signal(100);
        this.overlayTop = signal(100);
        this.onChange = () => {
            const wh = window.innerHeight;
            const elRect = this.el.nativeElement.getBoundingClientRect();
            if (elRect.top > wh || elRect.bottom < 0) {
                return;
            }
            if (elRect.top <= 0) {
                this.overlayTop.set(-elRect.top);
                this.overlayHeight.set(wh);
            }
            else {
                this.overlayTop.set(0);
                this.overlayHeight.set(wh - elRect.top);
            }
            if (elRect.bottom < wh) {
                this.overlayHeight.set(elRect.bottom);
            }
        };
    }
    ngAfterContentChecked() {
        if (this.loading) {
            this.onChange();
        }
    }
    ngOnChanges() {
        if (this.loading) {
            this.onChange();
            window.addEventListener('resize', this.onChange);
        }
        else {
            window.removeEventListener('resize', this.onChange);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SpinnerOverlayComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: SpinnerOverlayComponent, selector: "mic-spinner-overlay", inputs: { loading: "loading", color: "color", diameter: "diameter", disableSpinner: "disableSpinner", ariaLabel: "ariaLabel" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"loader\">\n  <div [class.loading]=\"loading\">\n    <ng-content></ng-content>\n  </div>\n  @if (loading && !disableSpinner) {\n  <div class=\"loader-overlay\" [style.height.px]=\"overlayHeight()\" [style.top.px]=\"overlayTop()\">\n    <div class=\"container-spinner\">\n      <mic-spinner [diameter]=\"diameter || 60\" [color]=\"color || 'primary'\" [ariaLabel]=\"ariaLabel\"></mic-spinner>\n    </div>\n  </div>\n  }\n</div>\n", styles: [".loader{position:relative;transition:opacity .3s ease}.loader .loading{transition:opacity 1s ease;opacity:.3}.loader .loading ::ng-deep .table-empty{display:none}.loader .loader-overlay{position:absolute;width:100%;max-height:100%;top:0;left:0;overflow:visible}.loader .container-spinner{display:flex;justify-content:center;align-items:center;height:100%}\n"], dependencies: [{ kind: "component", type: SpinnerComponent, selector: "mic-spinner", inputs: ["color", "strokeWidth", "diameter", "mode", "value", "ariaLabel", "showPercentage"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SpinnerOverlayComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-spinner-overlay', template: "<div class=\"loader\">\n  <div [class.loading]=\"loading\">\n    <ng-content></ng-content>\n  </div>\n  @if (loading && !disableSpinner) {\n  <div class=\"loader-overlay\" [style.height.px]=\"overlayHeight()\" [style.top.px]=\"overlayTop()\">\n    <div class=\"container-spinner\">\n      <mic-spinner [diameter]=\"diameter || 60\" [color]=\"color || 'primary'\" [ariaLabel]=\"ariaLabel\"></mic-spinner>\n    </div>\n  </div>\n  }\n</div>\n", styles: [".loader{position:relative;transition:opacity .3s ease}.loader .loading{transition:opacity 1s ease;opacity:.3}.loader .loading ::ng-deep .table-empty{display:none}.loader .loader-overlay{position:absolute;width:100%;max-height:100%;top:0;left:0;overflow:visible}.loader .container-spinner{display:flex;justify-content:center;align-items:center;height:100%}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { loading: [{
                type: Input
            }], color: [{
                type: Input
            }], diameter: [{
                type: Input
            }], disableSpinner: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }] } });

/**
 * Component to display progress bars
 */
class ProgressbarComponent {
    constructor() {
        /**
         * Progress bar mode
         * Input must be one of these values: determinate, indeterminate, buffer, query, defaults to 'determinate'.
         */
        this.mode = 'indeterminate';
        /**
         * Show percentage (default value true)
         */
        this.showPercentage = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ProgressbarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: ProgressbarComponent, selector: "mic-progress-bar", inputs: { color: "color", mode: "mode", value: "value", ariaLabel: "ariaLabel", showPercentage: "showPercentage" }, ngImport: i0, template: "<mat-progress-bar [mode]=\"mode\" [color]=\"color\" [value]=\"value\" [ariaLabel]=\"ariaLabel\"></mat-progress-bar>\n@if (mode !== 'indeterminate' && showPercentage) {\n<h6 class=\"percentage\" [class]=\"color ? color : 'primary'\">{{ value + '%' }}</h6>\n}\n", styles: [":host{height:100%;min-height:100%;min-width:100%;width:100%;flex-direction:row;box-sizing:border-box;display:flex;place-content:center;align-items:center;padding:10px 0}:host.wide .mat-mdc-progress-bar{height:16px;border-radius:8px}:host.wide ::ng-deep .mdc-linear-progress__bar-inner{border-top-width:16px}:host.wide ::ng-deep .mdc-linear-progress__buffer,:host.wide ::ng-deep .mdc-linear-progress__bar{margin:0;height:16px}:host.wide .percentage{width:10%;text-align:center}:host:not(.wide){flex-direction:column;align-items:baseline}:host:not(.wide) .percentage{text-align:left}:host .percentage{margin:0!important}\n"], dependencies: [{ kind: "component", type: i1$2.MatProgressBar, selector: "mat-progress-bar", inputs: ["color", "value", "bufferValue", "mode"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ProgressbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-progress-bar', template: "<mat-progress-bar [mode]=\"mode\" [color]=\"color\" [value]=\"value\" [ariaLabel]=\"ariaLabel\"></mat-progress-bar>\n@if (mode !== 'indeterminate' && showPercentage) {\n<h6 class=\"percentage\" [class]=\"color ? color : 'primary'\">{{ value + '%' }}</h6>\n}\n", styles: [":host{height:100%;min-height:100%;min-width:100%;width:100%;flex-direction:row;box-sizing:border-box;display:flex;place-content:center;align-items:center;padding:10px 0}:host.wide .mat-mdc-progress-bar{height:16px;border-radius:8px}:host.wide ::ng-deep .mdc-linear-progress__bar-inner{border-top-width:16px}:host.wide ::ng-deep .mdc-linear-progress__buffer,:host.wide ::ng-deep .mdc-linear-progress__bar{margin:0;height:16px}:host.wide .percentage{width:10%;text-align:center}:host:not(.wide){flex-direction:column;align-items:baseline}:host:not(.wide) .percentage{text-align:left}:host .percentage{margin:0!important}\n"] }]
        }], propDecorators: { color: [{
                type: Input
            }], mode: [{
                type: Input
            }], value: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], showPercentage: [{
                type: Input
            }] } });

/**
 * Component to manage dropdown with a search input
 *
 * This component support server side pagnation
 */
class DropdownComponent {
    constructor(cd, sd, differs, 
    // required parameters should be placed first
    controlContainer) {
        this.cd = cd;
        this.sd = sd;
        this.differs = differs;
        this.controlContainer = controlContainer;
        /**
         * Pagination index
         */
        this.pageIndex = signal(0);
        /**
         * Is the list loading for the first time
         */
        this.firstLoading = true;
        /**
         * Value to manage all checkbox
         * This value is exclude from result
         */
        this.allValue = '#ALL#';
        /**
         * Form control to manage the search input
         */
        this.search = new FormControl('', [Validators.maxLength(30)]);
        /**
         * Associate control for ControlValueAccessor
         */
        this.control = new FormControl(null);
        /**
         * Filter data used to display dropdown options
         */
        this.searchData = [];
        /**
         * Show content is used to manage transclusion on dropdown
         */
        this.showContent = false;
        /**
         * Loading subject used during data fetching
         */
        this.loadingSubject = new BehaviorSubject(true);
        this.dataSourceSubject = new BehaviorSubject(null);
        /**
         * Put your data with this attribute
         *
         * Alternative : use fetcher
         */
        this.data = [];
        /**
         * Input placeholder
         */
        this.placeholder = '';
        /**
         * Is the input required
         */
        this.required = false;
        /**
         * Whether the form field should reserve space for one line of hint/error text (default) or to have the spacing grow from 0px as needed based on the size of the hint/error content.
         *
         * Note that when using dynamic sizing, layout shifts will occur when hint/error text changes.
         */
        this.subscriptSizing = 'fixed';
        /**
         * Event trigger when the dropdown is opened or closed
         */
        this.openedChange = new EventEmitter();
        /**
         * Method to compare items
         *
         * @param i
         * @param j
         * @returns
         */
        this.compareWith = (i, j) => i === j;
        // @typescript-eslint/explicit-function-return-type
        this.onChange = (_) => {
            /*onChange*/
        };
        this.onTouch = () => {
            /*onTouch */
        };
    }
    get pageSize() {
        // @typescript-eslint/prefer-nullish-coalescing
        return this.paginator?.pageSize ?? DEFAULT_PAGESIZE;
    }
    /**
     * Get the parent control using input or control container
     */
    // @typescript-eslint/explicit-function-return-type
    get parentControl() {
        if (this.controlContainer !== undefined && this.formControlName !== undefined && this.formControl === undefined) {
            return this.controlContainer.control?.get(this.formControlName);
        }
        return this.formControl;
    }
    ngOnInit() {
        this.dataDiffer = this.differs.find([]).create();
        this.selection = new SelectionModel(true, [], true, this.compareWith);
        this.showContent = this.content?.nativeElement.innerHTML !== undefined && this.content?.nativeElement.innerHTML.trim() !== '';
        // Inherit required validators from parent control
        if (this.parentControl?.hasValidator(Validators.required)) {
            this.control.addValidators(Validators.required);
            this.required = true;
        }
        if (this.fetcher) {
            this.retreiveDataUsingFetcher();
        }
        else {
            this.loadingSubject.next(false);
        }
        this.initSearchField();
    }
    /**
     * Do check
     * Detect touched on the formControl
     *
     * @returns
     */
    ngDoCheck() {
        // Detect data change using differs
        const dataChanges = this.dataDiffer.diff(this.data);
        if (dataChanges) {
            this.updateDataAndSelection();
        }
        if (this.control.touched) {
            return;
        }
        if (this.parentControl && this.parentControl.touched) {
            this.control.markAsTouched();
        }
    }
    ngOnChanges(changes) {
        if (Object.prototype.hasOwnProperty.call(changes, 'filters') && this.fetcher) {
            this.pageIndex.set(0);
            this.search.reset(null, { emitEvent: false });
            this.loadData({ ...this.filters, search: this.search.value });
        }
    }
    ngAfterViewInit() {
        if (this.cdkVirtualScrollViewPort) {
            this.sdSubscription = this.sd
                .scrolled()
                .pipe(filter$1((scrollable) => this.cdkVirtualScrollViewPort === scrollable))
                .subscribe(() => {
                this.checkOptions();
            });
        }
        if (this.fetcher) {
            this.paginatorRef?.page.subscribe(({ pageIndex }) => {
                this.pageIndex.set(pageIndex);
                this.loadData({ ...this.filters, search: this.search.value });
            });
        }
    }
    ngOnDestroy() {
        if (this.sdSubscription) {
            this.sdSubscription.unsubscribe();
        }
        if (this.dataSubscr) {
            this.dataSubscr.unsubscribe();
        }
        if (this.dataTotalSubscr) {
            this.dataTotalSubscr.unsubscribe();
        }
    }
    /**
     * Update search data when data input change
     * Selection should be updated too
     */
    updateDataAndSelection() {
        this.searchData = this.data.slice();
        const selection = this.selection.selected;
        this.selection.clear();
        this.data
            .filter((dataElement) => selection.some((selectedElement) => this.compareWith(dataElement, selectedElement)))
            .forEach((selectedDataElement) => this.selection.select(selectedDataElement));
    }
    retreiveDataUsingFetcher() {
        let isFirstLoad = true;
        this.dataTotalSubscr = defer(() => this.dataSourceSubject).subscribe((res) => {
            this.searchData = res ? res.items : [];
            if (isFirstLoad && this.searchData.length > 0) {
                isFirstLoad = false;
                const selectedValue = this.formControl?.value;
                // on first load add selected value if not found
                if (selectedValue &&
                    !Array.isArray(selectedValue) &&
                    this.searchData.findIndex((data) => this.getAttribute(data) === this.getAttribute(selectedValue)) === -1) {
                    this.searchData.push(selectedValue);
                }
            }
            this.dataTotalSize = res ? res.count : 0;
            this.checkOptions();
        });
        this.loadData(this.filters);
    }
    initSearchField() {
        this.search.valueChanges.pipe(distinctUntilChanged()).subscribe((value) => {
            if (!this.firstLoading) {
                if (this.fetcher) {
                    this.pageIndex.set(0);
                    this.loadData({ ...this.filters, search: value });
                }
                else {
                    this.searchData = this.data.filter((item) => this.isActive(item, value));
                    if (this.virtualScroll) {
                        this.cdkVirtualScrollViewPort?.scrollToIndex(0);
                        this.cdkVirtualScrollViewPort?.checkViewportSize();
                    }
                    this.checkOptions();
                }
                // Manage all filter
                if (this.allSelected) {
                    if (this.getValuesExceptAllSelector().length !== this.searchData.length) {
                        this.allSelected.deselect();
                    }
                    else {
                        this.allSelected.select();
                    }
                }
            }
            this.firstLoading = false;
        });
    }
    /**
     * Method triggered when the dropdown is opened
     * Reset the search input
     */
    opened(opened) {
        this.search.setValue('');
        if (opened) {
            // Set focus on the search input
            setTimeout(() => {
                if (this.searchInput) {
                    this.searchInput.nativeElement.focus();
                }
            }, 200);
        }
        this.openedChange.emit(opened);
    }
    /**
     * Check if a checkbox is selected
     * Usefull with paginated dropdown
     */
    checkOptions() {
        this.cd.detectChanges();
        this.options?.forEach((option) => {
            const selected = this.selection.selected.find((sel) => this.compareWith(sel, option.value)) !== undefined;
            if (selected && !option.selected) {
                option.select();
            }
            else if (!selected && option.selected) {
                option.deselect();
            }
        });
    }
    /**
     * Return selection except value use to checkall option
     *
     * @returns
     */
    getValuesExceptAllSelector() {
        return this.selection.selected.filter((value) => value !== this.allValue);
    }
    /**
     * Update selected values based on parameter
     */
    updateSelection(values) {
        if (values.length) {
            this.selection.select(...values);
        }
        else {
            this.selection.clear();
        }
        this.checkOptions();
        this.onChange(this.multiple ? this.getValuesExceptAllSelector() : this.selection.selected[0]);
    }
    /**
     * In the case of multiple selection
     * Trigger the change detection on formcontrol with the selected value
     */
    onSelectionChange(change, index) {
        if (!change.isUserInput) {
            return;
        }
        if (!this.multiple) {
            this.selection.clear();
        }
        const value = this.selection.selected.find((item) => this.compareWith(item, change.source.value));
        this.selection.toggle(value ?? change.source.value);
        if (this.multiple) {
            if (this.allSelected && (this.allSelected.selected || this.selection.selected.length === this.searchData.length)) {
                this.selection.toggle(this.allValue);
            }
            this.control.patchValue(this.selection.selected, {
                emitEvent: false,
                onlySelf: true,
                emitViewToModelChange: false
            });
        }
        this.onChange(this.multiple ? this.getValuesExceptAllSelector() : this.selection.selected[0]);
        if (this.multiple) {
            setTimeout(() => {
                this.options.get(index + (this.multiple && this.allSelected ? 1 : 0)).focus();
            }, 300);
        }
    }
    /**
     * Virtual scroll open triggered
     */
    foropen() {
        this.cdkVirtualScrollViewPort?.scrollToIndex(5);
    }
    /**
     *  Check if an item is active based on a search parameter
     */
    isActive(item, value) {
        if (!item) {
            return false;
        }
        if (this.attribute) {
            /** if this.attribute is a function, use it for comparison  */
            const attributeValue = getAttributeForObject(item, this.attribute);
            const attributeValueString = typeof attributeValue === 'string' ? attributeValue : null;
            if (attributeValueString !== null) {
                return attributeValueString.toLowerCase().includes(value.toLowerCase());
            }
        }
        return item.toString().toLowerCase().includes(value.toString().toLowerCase());
    }
    /**
     * Return length of data set
     * Usefull for virtual scrolling
     */
    getLength() {
        if (this.allLabel && this.searchData.length > 1 && this.multiple) {
            return this.searchData.length + 1;
        }
        return this.searchData.length;
    }
    /**
     * Construction of the placeholder based on the selected data
     */
    getSelectTriggerLabel() {
        if (this.multiple && this.allLabel && this.data && this.getValuesExceptAllSelector().length === this.data.length) {
            return this.allLabel;
        }
        return this.getValuesExceptAllSelector()
            .map((selected) => {
            if (this.attribute && selected) {
                return getAttributeForObject(selected, this.attribute);
            }
            return selected || this.nullLabel;
        })
            .sort()
            .join(', ');
    }
    /**
     * If the objects handled are different from a character string,
     * it is possible to target the right attribute with this method
     */
    getAttribute(element) {
        if (this.attribute) {
            const value = getAttributeForObject(element, this.attribute);
            if (typeof value === 'string') {
                return value;
            }
        }
        return element;
    }
    /**
     * When the user first interacts with the form control, the control is considered to have the status touched, which is useful for styling.
     * In order to report to the parent form that the control was touched, we need to use a callback registered using the registerOnToched method
     */
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    /**
     * When a form value changes due to user input, we need to report the value back to the parent form.
     * This is done by calling a callback, that was initially registered with the control using the registerOnChange method
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * This method is called by the Forms module to write a value into a form control
     */
    writeValue(value) {
        if (!value) {
            this.selection.clear();
            this.control.reset();
        }
        else {
            const selection = Array.isArray(value) ? value : [value];
            this.selection.setSelection(...selection);
            if (this.isAllChecked()) {
                this.selection.toggle(this.allValue);
            }
            this.control.setValue(this.selection.selected, { onlySelf: true });
            this.checkOptions();
        }
    }
    /**
     * adds a clear button when one value is selected and
     * expecting to clear selection
     */
    clearSelection(matSelect) {
        this.updateSelection([]);
        this.control.reset();
        matSelect.close();
    }
    /**
     * Form controls can be enabled and disabled using the Forms API.
     * This state can be transmitted to the form control via the setDisabledState method
     */
    setDisabledState(disabled) {
        if (disabled) {
            this.control.disable();
        }
        else {
            this.control.enable();
        }
    }
    /**
     * Check if all values are selected
     *
     * @returns
     */
    isAllChecked() {
        return this.selection && this.searchData.length && this.selection.selected.length === this.searchData.length;
    }
    /**
     * Update the selection when all checkbox status change
     */
    toggleAll(event) {
        if (event.isUserInput) {
            if (this.allSelected?.selected) {
                this.updateSelection([this.allValue, ...this.searchData]);
            }
            else {
                this.updateSelection([]);
            }
        }
    }
    /**
     * Load data using fetcher
     * Pagination and search field are passed in parameters
     */
    loadData(extraFilters) {
        if (typeof this.fetcher !== 'function') {
            return;
        }
        if (this.dataSubscr) {
            this.dataSubscr.unsubscribe();
        }
        this.loadingSubject.next(true);
        const filters = new PaginatorFilters({ page: this.pageIndex() + 1, limit: this.pageSize, extraFilters });
        this.dataSubscr = this.fetcher(filters)
            .pipe(catchError(() => {
            this.loadingSubject.next(false);
            return of({ items: [], count: 0 });
        }))
            .subscribe((res) => {
            this.loadingSubject.next(false);
            this.dataSourceSubject.next({ items: res.items, count: res.count });
        });
    }
    /**
     * Manage keyboard actions on search input
     *
     * @param event
     */
    onSearchKeydown(event) {
        if (event.key === 'Tab') {
            event.stopPropagation();
            if (this.options && this.options.first) {
                this.options.first.focus();
            }
        }
        // Specific test to manage space in the search input
        // By default, space key is disable inside a mat-select
        if (event.code === 'Space') {
            event.preventDefault();
            event.stopPropagation();
            this.search.setValue(`${this.search.value} `);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: DropdownComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i1$3.ScrollDispatcher }, { token: i0.IterableDiffers }, { token: i3$1.ControlContainer, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: DropdownComponent, selector: "mic-dropdown-search", inputs: { data: "data", label: "label", appearance: "appearance", color: "color", loaderConfig: "loaderConfig", virtualScroll: "virtualScroll", floatLabel: "floatLabel", attribute: "attribute", placeholder: "placeholder", emptyPlaceholder: "emptyPlaceholder", searchPlaceholder: "searchPlaceholder", required: "required", requiredLabel: "requiredLabel", nullLabel: "nullLabel", allLabel: "allLabel", multiple: "multiple", limitSelection: "limitSelection", paginator: "paginator", filters: "filters", fetcher: "fetcher", subscriptSizing: "subscriptSizing", formControl: "formControl", formControlName: "formControlName", compareWith: "compareWith" }, outputs: { openedChange: "openedChange" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DropdownComponent),
                multi: true
            }
        ], viewQueries: [{ propertyName: "cdkVirtualScrollViewPort", first: true, predicate: CdkVirtualScrollViewport, descendants: true }, { propertyName: "searchInput", first: true, predicate: ["searchInput"], descendants: true, static: true }, { propertyName: "allSelected", first: true, predicate: ["allSelected"], descendants: true }, { propertyName: "content", first: true, predicate: ["content"], descendants: true, read: ElementRef, static: true }, { propertyName: "paginatorRef", first: true, predicate: ["paginator"], descendants: true, static: true }, { propertyName: "options", predicate: MatOption, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"grid grid-cols-1 grid-rows-1\">\n  <div #content (click)=\"select.open()\" (keydown.enter)=\"select.open()\" tabindex=\"0\">\n    <ng-content></ng-content>\n  </div>\n  <mat-form-field\n    class=\"cols-span-1 rows-span-1\"\n    [class.mat-select-hidden]=\"showContent\"\n    [class.select-arrow]=\"loaderConfig?.loading && loaderConfig?.type === 'spinner'\"\n    [color]=\"color\"\n    [appearance]=\"appearance\"\n    [floatLabel]=\"floatLabel\"\n    [subscriptSizing]=\"subscriptSizing\"\n  >\n    <mat-label>{{ label }}</mat-label>\n    <mat-select\n      #select\n      [required]=\"required\"\n      [multiple]=\"multiple\"\n      [formControl]=\"control\"\n      [compareWith]=\"compareWith\"\n      [placeholder]=\"getSelectTriggerLabel() || placeholder\"\n      (openedChange)=\"opened($event)\"\n    >\n      <mat-select-trigger>\n        <span>{{ getSelectTriggerLabel() }}</span>\n      </mat-select-trigger>\n      <div class=\"flex flex-row\">\n        <div class=\"flex flex-row w-1on6\">\n          <div class=\"mat-select-checked flex flex-col ml-2 gap-1\">\n            @if (selection.selected.length && multiple) {\n            <button mat-icon-button class=\"mic-icon-button-medium\" mat-icon-button (click)=\"updateSelection([])\">\n              @if (selection.selected.length) {\n              <mat-icon\n                aria-hidden=\"false\"\n                [matBadge]=\"getValuesExceptAllSelector().length\"\n                [matBadgeHidden]=\"limitSelection && limitSelection > 0\"\n                matBadgeSize=\"small\"\n                matBadgeColor=\"primary\"\n                aria-hidden=\"false\"\n                [matBadgeDescription]=\"'selected items'\"\n                >indeterminate_check_box</mat-icon\n              >\n              }\n            </button>\n            } @else {\n            <button mat-icon-button class=\"mic-icon-button-medium\" type=\"button\" (click)=\"clearSelection(select)\">\n              <mat-icon>clear</mat-icon>\n            </button>\n            } @if (multiple) {\n            <small>\n              @if (selection.selected.length && limitSelection) {\n              {{ selection.selected.length }}/{{ limitSelection }}\n              }\n            </small>\n            }\n          </div>\n        </div>\n        <mat-form-field class=\"flex-1 mic-dropdown-search\" [color]=\"color\">\n          <input\n            #searchInput\n            matInput\n            type=\"text\"\n            [placeholder]=\"searchPlaceholder\"\n            (keydown)=\"onSearchKeydown($event)\"\n            [formControl]=\"search\"\n            autocomplete=\"off\"\n          />\n          <mat-icon matSuffix>search</mat-icon>\n        </mat-form-field>\n        <div class=\"w-1on6\"></div>\n      </div>\n      <mic-spinner-overlay color=\"primary\" [diameter]=\"50\" [loading]=\"(loadingSubject | async) === true\">\n        <div>\n          @if (!virtualScroll) {\n          <div class=\"mat-select-options-wrapper\" [class.paginated]=\"dataTotalSize && dataTotalSize - 1 > pageSize && fetcher\" micScrollBar>\n            @if (searchData?.length === 0) {\n            <div class=\"mat-select-empty-placeholder\">\n              {{ emptyPlaceholder }}\n            </div>\n            } @if (multiple && !fetcher && searchData?.length > 0) {\n            <mat-option #allSelected [value]=\"allValue\" (onSelectionChange)=\"toggleAll($event)\">\n              {{ allLabel }}\n            </mat-option>\n            } @for (element of searchData; track element; let i = $index) {\n            <mat-option\n              #option\n              (onSelectionChange)=\"onSelectionChange($event, i)\"\n              [value]=\"element\"\n              [disabled]=\"limitSelection && limitSelection <= selection.selected.length && !option.selected\"\n            >\n              @if (element) {\n              {{ getAttribute(element) }}\n              } @if (!element && !multiple) {\n              {{ nullLabel }}\n              }\n            </mat-option>\n            }\n          </div>\n          }\n        </div>\n        @if (virtualScroll) { @if (searchData?.length === 0) {\n        <div #options class=\"mat-select-options-wrapper\">\n          <div class=\"mat-select-empty-placeholder\">\n            {{ emptyPlaceholder }}\n          </div>\n        </div>\n        }\n        <cdk-virtual-scroll-viewport\n          [itemSize]=\"48\"\n          [style.height.px]=\"getLength() <= 3 ? getLength() * 50 : 4 * 50\"\n          class=\"virtual-scroll-viewport\"\n        >\n          @if (multiple && !fetcher && searchData?.length > 0) {\n          <mat-option #allSelected [value]=\"allValue\" (onSelectionChange)=\"toggleAll($event)\">\n            {{ allLabel }}\n          </mat-option>\n          }\n          <mat-option\n            #option\n            (onSelectionChange)=\"onSelectionChange($event, i)\"\n            *cdkVirtualFor=\"let element of searchData; let i = index\"\n            [value]=\"element\"\n            [disabled]=\"limitSelection <= selection.selected.length && !option.selected\"\n            [class.mat-active]=\"!element && !multiple && !control.value\"\n          >\n            @if (element) {\n            {{ getAttribute(element) }}\n            } @if (!element && !multiple) {\n            {{ nullLabel }}\n            }\n          </mat-option>\n        </cdk-virtual-scroll-viewport>\n        }\n      </mic-spinner-overlay>\n      <div [class.hidden]=\"dataTotalSize - 1 < pageSize || !fetcher\">\n        <mat-paginator #paginator [hidePageSize]=\"true\" [length]=\"dataTotalSize\" [pageIndex]=\"pageIndex()\" [pageSize]=\"pageSize\">\n        </mat-paginator>\n      </div>\n    </mat-select>\n    <mat-error>{{ requiredLabel }}</mat-error>\n  </mat-form-field>\n  @if (loaderConfig?.loading && loaderConfig?.type === 'progress-bar' && !showContent) {\n  <div class=\"progress-bar cols-span-1 rows-span-1\" [class.outline]=\"appearance === 'outline'\">\n    <mic-progress-bar\n      [class.outline]=\"appearance === 'outline'\"\n      color=\"accent\"\n      [showPercentage]=\"false\"\n      [mode]=\"loaderConfig?.value || loaderConfig?.value === 0 ? 'determinate' : 'indeterminate'\"\n      [value]=\"loaderConfig?.value\"\n    ></mic-progress-bar>\n  </div>\n  } @if (loaderConfig?.loading && loaderConfig?.type === 'spinner' && !showContent) {\n  <div class=\"cols-span-1 rows-span-1 spinner\">\n    <mic-spinner\n      [diameter]=\"20\"\n      [strokeWidth]=\"3\"\n      color=\"accent\"\n      [mode]=\"loaderConfig?.value || loaderConfig?.value === 0 ? 'determinate' : 'indeterminate'\"\n      [value]=\"loaderConfig?.value\"\n    ></mic-spinner>\n  </div>\n  }\n</div>\n", styles: [".mat-icon.mic-icon-link{vertical-align:sub;font-size:18px;width:auto;height:auto}.mic-elevation-1{box-shadow:0 4px 8px #6666661f}.mic-elevation-2{box-shadow:0 8px 16px #66666629}.mic-elevation-3{box-shadow:0 16px 32px #6663}.mic-elevation-4{box-shadow:0 32px 64px #66666652}:host.min-w .mat-mdc-form-field{min-width:270px}:host ::ng-deep .mat-mdc-select-arrow-wrapper{margin-right:10px}.mic-dropdown-search{background-color:transparent}.mic-dropdown-search ::ng-deep .mat-mdc-form-field-subscript-wrapper{height:0px}.mic-dropdown-search ::ng-deep .mat-mdc-text-field-wrapper,.mic-dropdown-search .mat-mdc-form-field-flex{max-height:40px}.mic-dropdown-search ::ng-deep .mdc-text-field--no-label:not(.mdc-text-field--outlined):not(.mdc-text-field--textarea) .mat-mdc-form-field-infix{padding-top:8px}.mic-dropdown-search ::ng-deep .mat-mdc-form-field-icon-suffix>.mat-icon{padding-top:0}::ng-deep .mdc-menu-surface.mat-mdc-select-panel{padding-bottom:0;box-shadow:0 4px 8px #6666661f}.mat-select-options-wrapper{max-height:170px;overflow:hidden}.mat-select-options-wrapper.paginated{max-height:146px}.mat-select-hidden{height:0px;overflow:hidden}.select-arrow ::ng-deep .mat-mdc-select-arrow{display:none}.mat-select-checked .mat-icon{font-size:19px;height:19px;width:19px;line-height:19px}.mat-select-checked small{text-align:center;font-size:.6rem;margin-top:-10px;line-height:13px;height:13px}.mat-select-empty-placeholder{height:50px;line-height:50px;text-align:center}::ng-deep .mat-mdc-paginator-container,::ng-deep .mat-mdc-paginator{min-height:50px}.progress-bar{overflow:hidden;display:flex;height:4px;margin-top:-5px}.progress-bar.outline{border-bottom-left-radius:5px;border-bottom-right-radius:5px}.progress-bar mic-progress-bar{padding:0 1px 0 0}.progress-bar mic-progress-bar.outline{padding:0 2px 0 1px}.spinner{padding:0 10px 0 0;margin-top:-55px}.spinner mic-spinner{align-items:end;flex-direction:column}\n"], dependencies: [{ kind: "directive", type: i1$3.CdkFixedSizeVirtualScroll, selector: "cdk-virtual-scroll-viewport[itemSize]", inputs: ["itemSize", "minBufferPx", "maxBufferPx"] }, { kind: "directive", type: i1$3.CdkVirtualForOf, selector: "[cdkVirtualFor][cdkVirtualForOf]", inputs: ["cdkVirtualForOf", "cdkVirtualForTrackBy", "cdkVirtualForTemplate", "cdkVirtualForTemplateCacheSize"] }, { kind: "component", type: i1$3.CdkVirtualScrollViewport, selector: "cdk-virtual-scroll-viewport", inputs: ["orientation", "appendOnly"], outputs: ["scrolledIndexChange"] }, { kind: "component", type: i3$2.MatOption, selector: "mat-option", inputs: ["value", "id", "disabled"], outputs: ["onSelectionChange"], exportAs: ["matOption"] }, { kind: "component", type: i1.MatIconButton, selector: "button[mat-icon-button]", exportAs: ["matButton"] }, { kind: "directive", type: i5$1.MatBadge, selector: "[matBadge]", inputs: ["matBadgeColor", "matBadgeOverlap", "matBadgeDisabled", "matBadgePosition", "matBadge", "matBadgeDescription", "matBadgeSize", "matBadgeHidden"] }, { kind: "component", type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i3$3.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i4$1.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i4$1.MatLabel, selector: "mat-label" }, { kind: "directive", type: i4$1.MatError, selector: "mat-error, [matError]", inputs: ["id"] }, { kind: "directive", type: i4$1.MatSuffix, selector: "[matSuffix], [matIconSuffix], [matTextSuffix]", inputs: ["matTextSuffix"] }, { kind: "component", type: i5.MatSelect, selector: "mat-select", inputs: ["aria-describedby", "panelClass", "disabled", "disableRipple", "tabIndex", "hideSingleSelectionIndicator", "placeholder", "required", "multiple", "disableOptionCentering", "compareWith", "value", "aria-label", "aria-labelledby", "errorStateMatcher", "typeaheadDebounceInterval", "sortComparator", "id", "panelWidth"], outputs: ["openedChange", "opened", "closed", "selectionChange", "valueChange"], exportAs: ["matSelect"] }, { kind: "directive", type: i5.MatSelectTrigger, selector: "mat-select-trigger" }, { kind: "component", type: i1$4.MatPaginator, selector: "mat-paginator", inputs: ["color", "pageIndex", "length", "pageSize", "pageSizeOptions", "hidePageSize", "showFirstLastButtons", "selectConfig", "disabled"], outputs: ["page"], exportAs: ["matPaginator"] }, { kind: "directive", type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i3$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: ScrollBarDirective, selector: "[micScrollBar]", inputs: ["micScrollBar", "micScrollBarOptions"] }, { kind: "directive", type: ScrollBarSelectDirective, selector: "mat-select" }, { kind: "component", type: SpinnerComponent, selector: "mic-spinner", inputs: ["color", "strokeWidth", "diameter", "mode", "value", "ariaLabel", "showPercentage"] }, { kind: "component", type: SpinnerOverlayComponent, selector: "mic-spinner-overlay", inputs: ["loading", "color", "diameter", "disableSpinner", "ariaLabel"] }, { kind: "component", type: ProgressbarComponent, selector: "mic-progress-bar", inputs: ["color", "mode", "value", "ariaLabel", "showPercentage"] }, { kind: "pipe", type: i2.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: DropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-dropdown-search', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => DropdownComponent),
                            multi: true
                        }
                    ], template: "<div class=\"grid grid-cols-1 grid-rows-1\">\n  <div #content (click)=\"select.open()\" (keydown.enter)=\"select.open()\" tabindex=\"0\">\n    <ng-content></ng-content>\n  </div>\n  <mat-form-field\n    class=\"cols-span-1 rows-span-1\"\n    [class.mat-select-hidden]=\"showContent\"\n    [class.select-arrow]=\"loaderConfig?.loading && loaderConfig?.type === 'spinner'\"\n    [color]=\"color\"\n    [appearance]=\"appearance\"\n    [floatLabel]=\"floatLabel\"\n    [subscriptSizing]=\"subscriptSizing\"\n  >\n    <mat-label>{{ label }}</mat-label>\n    <mat-select\n      #select\n      [required]=\"required\"\n      [multiple]=\"multiple\"\n      [formControl]=\"control\"\n      [compareWith]=\"compareWith\"\n      [placeholder]=\"getSelectTriggerLabel() || placeholder\"\n      (openedChange)=\"opened($event)\"\n    >\n      <mat-select-trigger>\n        <span>{{ getSelectTriggerLabel() }}</span>\n      </mat-select-trigger>\n      <div class=\"flex flex-row\">\n        <div class=\"flex flex-row w-1on6\">\n          <div class=\"mat-select-checked flex flex-col ml-2 gap-1\">\n            @if (selection.selected.length && multiple) {\n            <button mat-icon-button class=\"mic-icon-button-medium\" mat-icon-button (click)=\"updateSelection([])\">\n              @if (selection.selected.length) {\n              <mat-icon\n                aria-hidden=\"false\"\n                [matBadge]=\"getValuesExceptAllSelector().length\"\n                [matBadgeHidden]=\"limitSelection && limitSelection > 0\"\n                matBadgeSize=\"small\"\n                matBadgeColor=\"primary\"\n                aria-hidden=\"false\"\n                [matBadgeDescription]=\"'selected items'\"\n                >indeterminate_check_box</mat-icon\n              >\n              }\n            </button>\n            } @else {\n            <button mat-icon-button class=\"mic-icon-button-medium\" type=\"button\" (click)=\"clearSelection(select)\">\n              <mat-icon>clear</mat-icon>\n            </button>\n            } @if (multiple) {\n            <small>\n              @if (selection.selected.length && limitSelection) {\n              {{ selection.selected.length }}/{{ limitSelection }}\n              }\n            </small>\n            }\n          </div>\n        </div>\n        <mat-form-field class=\"flex-1 mic-dropdown-search\" [color]=\"color\">\n          <input\n            #searchInput\n            matInput\n            type=\"text\"\n            [placeholder]=\"searchPlaceholder\"\n            (keydown)=\"onSearchKeydown($event)\"\n            [formControl]=\"search\"\n            autocomplete=\"off\"\n          />\n          <mat-icon matSuffix>search</mat-icon>\n        </mat-form-field>\n        <div class=\"w-1on6\"></div>\n      </div>\n      <mic-spinner-overlay color=\"primary\" [diameter]=\"50\" [loading]=\"(loadingSubject | async) === true\">\n        <div>\n          @if (!virtualScroll) {\n          <div class=\"mat-select-options-wrapper\" [class.paginated]=\"dataTotalSize && dataTotalSize - 1 > pageSize && fetcher\" micScrollBar>\n            @if (searchData?.length === 0) {\n            <div class=\"mat-select-empty-placeholder\">\n              {{ emptyPlaceholder }}\n            </div>\n            } @if (multiple && !fetcher && searchData?.length > 0) {\n            <mat-option #allSelected [value]=\"allValue\" (onSelectionChange)=\"toggleAll($event)\">\n              {{ allLabel }}\n            </mat-option>\n            } @for (element of searchData; track element; let i = $index) {\n            <mat-option\n              #option\n              (onSelectionChange)=\"onSelectionChange($event, i)\"\n              [value]=\"element\"\n              [disabled]=\"limitSelection && limitSelection <= selection.selected.length && !option.selected\"\n            >\n              @if (element) {\n              {{ getAttribute(element) }}\n              } @if (!element && !multiple) {\n              {{ nullLabel }}\n              }\n            </mat-option>\n            }\n          </div>\n          }\n        </div>\n        @if (virtualScroll) { @if (searchData?.length === 0) {\n        <div #options class=\"mat-select-options-wrapper\">\n          <div class=\"mat-select-empty-placeholder\">\n            {{ emptyPlaceholder }}\n          </div>\n        </div>\n        }\n        <cdk-virtual-scroll-viewport\n          [itemSize]=\"48\"\n          [style.height.px]=\"getLength() <= 3 ? getLength() * 50 : 4 * 50\"\n          class=\"virtual-scroll-viewport\"\n        >\n          @if (multiple && !fetcher && searchData?.length > 0) {\n          <mat-option #allSelected [value]=\"allValue\" (onSelectionChange)=\"toggleAll($event)\">\n            {{ allLabel }}\n          </mat-option>\n          }\n          <mat-option\n            #option\n            (onSelectionChange)=\"onSelectionChange($event, i)\"\n            *cdkVirtualFor=\"let element of searchData; let i = index\"\n            [value]=\"element\"\n            [disabled]=\"limitSelection <= selection.selected.length && !option.selected\"\n            [class.mat-active]=\"!element && !multiple && !control.value\"\n          >\n            @if (element) {\n            {{ getAttribute(element) }}\n            } @if (!element && !multiple) {\n            {{ nullLabel }}\n            }\n          </mat-option>\n        </cdk-virtual-scroll-viewport>\n        }\n      </mic-spinner-overlay>\n      <div [class.hidden]=\"dataTotalSize - 1 < pageSize || !fetcher\">\n        <mat-paginator #paginator [hidePageSize]=\"true\" [length]=\"dataTotalSize\" [pageIndex]=\"pageIndex()\" [pageSize]=\"pageSize\">\n        </mat-paginator>\n      </div>\n    </mat-select>\n    <mat-error>{{ requiredLabel }}</mat-error>\n  </mat-form-field>\n  @if (loaderConfig?.loading && loaderConfig?.type === 'progress-bar' && !showContent) {\n  <div class=\"progress-bar cols-span-1 rows-span-1\" [class.outline]=\"appearance === 'outline'\">\n    <mic-progress-bar\n      [class.outline]=\"appearance === 'outline'\"\n      color=\"accent\"\n      [showPercentage]=\"false\"\n      [mode]=\"loaderConfig?.value || loaderConfig?.value === 0 ? 'determinate' : 'indeterminate'\"\n      [value]=\"loaderConfig?.value\"\n    ></mic-progress-bar>\n  </div>\n  } @if (loaderConfig?.loading && loaderConfig?.type === 'spinner' && !showContent) {\n  <div class=\"cols-span-1 rows-span-1 spinner\">\n    <mic-spinner\n      [diameter]=\"20\"\n      [strokeWidth]=\"3\"\n      color=\"accent\"\n      [mode]=\"loaderConfig?.value || loaderConfig?.value === 0 ? 'determinate' : 'indeterminate'\"\n      [value]=\"loaderConfig?.value\"\n    ></mic-spinner>\n  </div>\n  }\n</div>\n", styles: [".mat-icon.mic-icon-link{vertical-align:sub;font-size:18px;width:auto;height:auto}.mic-elevation-1{box-shadow:0 4px 8px #6666661f}.mic-elevation-2{box-shadow:0 8px 16px #66666629}.mic-elevation-3{box-shadow:0 16px 32px #6663}.mic-elevation-4{box-shadow:0 32px 64px #66666652}:host.min-w .mat-mdc-form-field{min-width:270px}:host ::ng-deep .mat-mdc-select-arrow-wrapper{margin-right:10px}.mic-dropdown-search{background-color:transparent}.mic-dropdown-search ::ng-deep .mat-mdc-form-field-subscript-wrapper{height:0px}.mic-dropdown-search ::ng-deep .mat-mdc-text-field-wrapper,.mic-dropdown-search .mat-mdc-form-field-flex{max-height:40px}.mic-dropdown-search ::ng-deep .mdc-text-field--no-label:not(.mdc-text-field--outlined):not(.mdc-text-field--textarea) .mat-mdc-form-field-infix{padding-top:8px}.mic-dropdown-search ::ng-deep .mat-mdc-form-field-icon-suffix>.mat-icon{padding-top:0}::ng-deep .mdc-menu-surface.mat-mdc-select-panel{padding-bottom:0;box-shadow:0 4px 8px #6666661f}.mat-select-options-wrapper{max-height:170px;overflow:hidden}.mat-select-options-wrapper.paginated{max-height:146px}.mat-select-hidden{height:0px;overflow:hidden}.select-arrow ::ng-deep .mat-mdc-select-arrow{display:none}.mat-select-checked .mat-icon{font-size:19px;height:19px;width:19px;line-height:19px}.mat-select-checked small{text-align:center;font-size:.6rem;margin-top:-10px;line-height:13px;height:13px}.mat-select-empty-placeholder{height:50px;line-height:50px;text-align:center}::ng-deep .mat-mdc-paginator-container,::ng-deep .mat-mdc-paginator{min-height:50px}.progress-bar{overflow:hidden;display:flex;height:4px;margin-top:-5px}.progress-bar.outline{border-bottom-left-radius:5px;border-bottom-right-radius:5px}.progress-bar mic-progress-bar{padding:0 1px 0 0}.progress-bar mic-progress-bar.outline{padding:0 2px 0 1px}.spinner{padding:0 10px 0 0;margin-top:-55px}.spinner mic-spinner{align-items:end;flex-direction:column}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i1$3.ScrollDispatcher }, { type: i0.IterableDiffers }, { type: i3$1.ControlContainer, decorators: [{
                    type: Optional
                }] }], propDecorators: { data: [{
                type: Input
            }], label: [{
                type: Input
            }], appearance: [{
                type: Input
            }], color: [{
                type: Input
            }], loaderConfig: [{
                type: Input
            }], virtualScroll: [{
                type: Input
            }], floatLabel: [{
                type: Input
            }], attribute: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], emptyPlaceholder: [{
                type: Input
            }], searchPlaceholder: [{
                type: Input
            }], required: [{
                type: Input
            }], requiredLabel: [{
                type: Input
            }], nullLabel: [{
                type: Input
            }], allLabel: [{
                type: Input
            }], multiple: [{
                type: Input
            }], limitSelection: [{
                type: Input
            }], paginator: [{
                type: Input
            }], filters: [{
                type: Input
            }], fetcher: [{
                type: Input
            }], subscriptSizing: [{
                type: Input
            }], openedChange: [{
                type: Output
            }], cdkVirtualScrollViewPort: [{
                type: ViewChild,
                args: [CdkVirtualScrollViewport, { static: false }]
            }], searchInput: [{
                type: ViewChild,
                args: ['searchInput', { static: true }]
            }], options: [{
                type: ViewChildren,
                args: [MatOption]
            }], allSelected: [{
                type: ViewChild,
                args: ['allSelected']
            }], content: [{
                type: ViewChild,
                args: ['content', { read: ElementRef, static: true }]
            }], paginatorRef: [{
                type: ViewChild,
                args: ['paginator', { static: true }]
            }], formControl: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], compareWith: [{
                type: Input
            }] } });
function getAttributeForObject(item, attribute) {
    if (attribute && typeof attribute === 'function') {
        return attribute(item) ?? undefined;
    }
    else {
        const attributeIndex = Object.keys(item).indexOf(attribute);
        if (attributeIndex !== -1) {
            const attributeEntryValue = Object.entries(item)[attributeIndex];
            const attributeValue = attributeEntryValue[1];
            if (typeof attributeValue === 'string') {
                return attributeValue;
            }
            return Object.prototype.toString.call(attributeValue);
        }
        return undefined;
    }
}

const scrollAnimationDelay = 300;
const scrollAnimationType = 'linear';
const scrollClass = '.os-host';
/**
 * Directive to trigger a scroll to top
 */
class ScrollBarBacktotopDirective {
    constructor(element) {
        this.element = element;
    }
    backToTop() {
        const parentElement = this.element.nativeElement.closest(scrollClass);
        const scroll = OverlayScrollbars(parentElement);
        scroll.scroll({ y: 0 }, scrollAnimationDelay, scrollAnimationType);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ScrollBarBacktotopDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: ScrollBarBacktotopDirective, selector: "[micBackToTop]", inputs: { micBackToTop: "micBackToTop" }, host: { listeners: { "click": "backToTop()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ScrollBarBacktotopDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[micBackToTop]' }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { micBackToTop: [{
                type: Input
            }], backToTop: [{
                type: HostListener,
                args: ['click']
            }] } });

/* eslint-disable @angular-eslint/directive-selector */
class ScrollBarAutocompleteDirective extends AbstractScrollbarDirective {
    constructor(element) {
        super();
        this.panelSelector = '.mat-mdc-autocomplete-panel';
        this.element = element;
    }
    ngOnInit() {
        this.element.autoActiveFirstOption = false;
        this.subscriptions = [
            this.element.opened.subscribe((opened) => {
                this.opened = opened;
                const element = document.querySelector(this.panelSelector);
                const active = element.querySelector(this.panelActiveItemSelector);
                if (navigator.userAgent.indexOf('WebKit') !== -1) {
                    element.style.height = 'fit-content';
                }
                else {
                    element.style.height = '-moz-fit-content';
                }
                this.scroll = OverlayScrollbars(element, {});
                if (active) {
                    this.scroll.scroll({ y: active.offsetTop }, this.scrollAnimationDelay, this.scrollAnimationType);
                }
            }),
            this.element.closed.subscribe(() => {
                if (OverlayScrollbars.valid(this.scroll)) {
                    this.scroll.destroy();
                }
            })
        ];
    }
    ngOnDestroy() {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ScrollBarAutocompleteDirective, deps: [{ token: i1$5.MatAutocomplete }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: ScrollBarAutocompleteDirective, selector: "mat-autocomplete", usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ScrollBarAutocompleteDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'mat-autocomplete' }]
        }], ctorParameters: () => [{ type: i1$5.MatAutocomplete }] });

const imports$i = [CommonModule];
const directives$1 = [ScrollBarDirective, ScrollBarSelectDirective, ScrollBarAutocompleteDirective, ScrollBarBacktotopDirective];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { ScrollbarModule } from '@michelin/theme';</code>
 */
class ScrollbarModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ScrollbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: ScrollbarModule, declarations: [ScrollBarDirective, ScrollBarSelectDirective, ScrollBarAutocompleteDirective, ScrollBarBacktotopDirective], imports: [CommonModule], exports: [ScrollBarDirective, ScrollBarSelectDirective, ScrollBarAutocompleteDirective, ScrollBarBacktotopDirective, CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ScrollbarModule, imports: [imports$i, CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ScrollbarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$i,
                    declarations: [...directives$1],
                    exports: [...directives$1, ...imports$i]
                }]
        }] });

class LoaderDirective {
    constructor(templateRef, viewContainerRef) {
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
        /**
         * Type of loader : spinner or progressbar
         */
        this.type = 'spinner';
        /**
         * Stroke with (default: 5px)
         */
        this.strokeWidth = 5;
        /**
         * Spinner diameter (default: 60px)
         */
        this.diameter = 60;
        /**
         * Expose observable result through an output method
         */
        this.resolvedObs = new EventEmitter();
    }
    ngOnInit() {
        this.initView();
    }
    ngOnChanges(changes) {
        if (changes.micLoaderObs && !changes.micLoaderObs.isFirstChange()) {
            this.initView();
        }
    }
    ngOnDestroy() {
        this.destroyView();
    }
    initView() {
        this.destroyView();
        if (this.type === 'progress-bar') {
            this.component = this.viewContainerRef.createComponent(ProgressbarComponent);
            this.component.instance.color = this.color;
            this.component.location.nativeElement.setAttribute('class', this.class);
        }
        else {
            this.component = this.viewContainerRef.createComponent(SpinnerComponent);
            this.component.instance.strokeWidth = this.strokeWidth;
            this.component.instance.color = this.color;
            this.component.instance.diameter = this.diameter;
        }
        if (this.micLoaderObs) {
            this.subscription = this.micLoaderObs
                .pipe(share(), catchError((e) => {
                this.destroyView();
                return e;
            }))
                .subscribe((result) => {
                this.destroyView();
                this.resolvedObs.emit(result);
                this.viewContainerRef.createEmbeddedView(this.templateRef, { result });
            });
        }
        else {
            this.destroyView();
        }
    }
    destroyView() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.component) {
            this.component.destroy();
        }
        else {
            this.viewContainerRef.clear();
        }
        if (this.viewContainerRef.get(0)) {
            this.viewContainerRef.remove(0);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: LoaderDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: LoaderDirective, selector: "[micLoaderObs]", inputs: { color: "color", type: "type", strokeWidth: "strokeWidth", diameter: "diameter", micLoaderObs: "micLoaderObs", class: "class" }, outputs: { resolvedObs: "resolvedObs" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: LoaderDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[micLoaderObs]'
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }], propDecorators: { color: [{
                type: Input
            }], type: [{
                type: Input
            }], strokeWidth: [{
                type: Input
            }], diameter: [{
                type: Input
            }], micLoaderObs: [{
                type: Input
            }], class: [{
                type: Input
            }], resolvedObs: [{
                type: Output
            }] } });

/* eslint-disable @angular-eslint/directive-selector */
/**
 * Component to display spinner inside a button
 */
class SpinnerButtonDirective {
    constructor(matButton, viewContainerRef, renderer) {
        this.matButton = matButton;
        this.viewContainerRef = viewContainerRef;
        this.renderer = renderer;
    }
    ngOnChanges(changes) {
        if (!changes.loading) {
            return;
        }
        if (changes.loading.currentValue) {
            this.matButton._elementRef.nativeElement.classList.add('mic-button-loading');
            this.matButton.disabled = true;
            this.createSpinner();
        }
        else if (!changes.loading.firstChange) {
            this.matButton._elementRef.nativeElement.classList.remove('mic-button-loading');
            this.matButton.disabled = this.disabled;
            this.destroySpinner();
        }
    }
    createSpinner() {
        if (!this.spinner) {
            this.spinner = this.viewContainerRef.createComponent(MatProgressSpinner);
            this.spinner.instance.color = this.color;
            this.spinner.instance.diameter = 20;
            this.spinner.instance.mode = 'indeterminate';
            this.renderer.appendChild(this.matButton._elementRef.nativeElement, this.spinner.instance._elementRef.nativeElement);
        }
    }
    destroySpinner() {
        if (this.spinner) {
            this.spinner.destroy();
            this.spinner = null;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SpinnerButtonDirective, deps: [{ token: i1.MatButton }, { token: i0.ViewContainerRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: SpinnerButtonDirective, selector: "button[mat-button][loading], button[mat-raised-button][loading], button[mat-icon-button][loading],\n             button[mat-fab][loading], button[mat-mini-fab][loading], button[mat-stroked-button][loading],\n             button[mat-flat-button][loading]", inputs: { loading: "loading", disabled: "disabled", color: "color" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SpinnerButtonDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: `button[mat-button][loading], button[mat-raised-button][loading], button[mat-icon-button][loading],
             button[mat-fab][loading], button[mat-mini-fab][loading], button[mat-stroked-button][loading],
             button[mat-flat-button][loading]`
                }]
        }], ctorParameters: () => [{ type: i1.MatButton }, { type: i0.ViewContainerRef }, { type: i0.Renderer2 }], propDecorators: { loading: [{
                type: Input
            }], disabled: [{
                type: Input
            }], color: [{
                type: Input
            }] } });

/**
 * Component to skeleton loader
 */
class SkeletonComponent {
    constructor() {
        /**
         * Amination for the skeleton loader
         */
        this.animation = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SkeletonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: SkeletonComponent, selector: "mic-skeleton-loader", inputs: { appearance: "appearance", animation: "animation", ariaLabel: "ariaLabel" }, ngImport: i0, template: "<span\n  class=\"skeleton-loader\"\n  role=\"progressbar\"\n  [ngClass]=\"{\n    image: appearance === 'image',\n    circle: appearance === 'circle',\n    progress: animation\n  }\"\n  [ariaLabel]=\"ariaLabel\"\n>\n</span>\n", styles: [".skeleton-loader{box-sizing:border-box;overflow:hidden;position:relative;border-radius:4px;width:100%;height:20px;display:inline-block;margin-bottom:10px;will-change:transform}.skeleton-loader:after,.skeleton-loader:before{box-sizing:border-box}.skeleton-loader.circle{width:40px;height:40px;margin:5px;border-radius:50%}.skeleton-loader.image{height:150px;text-align:center}.skeleton-loader.image:after{font-family:Material Icons;content:\"\\e3f4\";font-size:150px}.skeleton-loader.progress{transform:translateZ(0)}.skeleton-loader.progress:after,.skeleton-loader.progress:before{box-sizing:border-box}.skeleton-loader.progress:before{animation:progress 2s ease-in-out infinite;background-size:200px 100%;background-image:linear-gradient(90deg,#fff0,#fff9,#fff0);position:absolute;z-index:1;top:0;left:0;width:200px;height:100%;content:\"\"}@keyframes progress{0%{transform:translate3d(-200px,0,0)}to{transform:translate3d(calc(200px + 100vw),0,0)}}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SkeletonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-skeleton-loader', template: "<span\n  class=\"skeleton-loader\"\n  role=\"progressbar\"\n  [ngClass]=\"{\n    image: appearance === 'image',\n    circle: appearance === 'circle',\n    progress: animation\n  }\"\n  [ariaLabel]=\"ariaLabel\"\n>\n</span>\n", styles: [".skeleton-loader{box-sizing:border-box;overflow:hidden;position:relative;border-radius:4px;width:100%;height:20px;display:inline-block;margin-bottom:10px;will-change:transform}.skeleton-loader:after,.skeleton-loader:before{box-sizing:border-box}.skeleton-loader.circle{width:40px;height:40px;margin:5px;border-radius:50%}.skeleton-loader.image{height:150px;text-align:center}.skeleton-loader.image:after{font-family:Material Icons;content:\"\\e3f4\";font-size:150px}.skeleton-loader.progress{transform:translateZ(0)}.skeleton-loader.progress:after,.skeleton-loader.progress:before{box-sizing:border-box}.skeleton-loader.progress:before{animation:progress 2s ease-in-out infinite;background-size:200px 100%;background-image:linear-gradient(90deg,#fff0,#fff9,#fff0);position:absolute;z-index:1;top:0;left:0;width:200px;height:100%;content:\"\"}@keyframes progress{0%{transform:translate3d(-200px,0,0)}to{transform:translate3d(calc(200px + 100vw),0,0)}}\n"] }]
        }], propDecorators: { appearance: [{
                type: Input
            }], animation: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }] } });

const imports$h = [CommonModule, MaterialModule];
const declarations$6 = [
    LoaderDirective,
    SkeletonComponent,
    SpinnerComponent,
    SpinnerOverlayComponent,
    SpinnerButtonDirective,
    ProgressbarComponent
];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { LoaderModule } from '@michelin/theme';</code>
 */
class LoaderModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: LoaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: LoaderModule, declarations: [LoaderDirective,
            SkeletonComponent,
            SpinnerComponent,
            SpinnerOverlayComponent,
            SpinnerButtonDirective,
            ProgressbarComponent], imports: [CommonModule, MaterialModule], exports: [LoaderDirective,
            SkeletonComponent,
            SpinnerComponent,
            SpinnerOverlayComponent,
            SpinnerButtonDirective,
            ProgressbarComponent, CommonModule, MaterialModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: LoaderModule, imports: [imports$h, CommonModule, MaterialModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: LoaderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$h,
                    declarations: declarations$6,
                    exports: [...declarations$6, ...imports$h]
                }]
        }] });

const imports$g = [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, ScrollbarModule, LoaderModule];
const components$c = [DropdownComponent];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { DropdownModule } from '@michelin/theme';</code>
 */
class DropdownModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: DropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: DropdownModule, declarations: [DropdownComponent], imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, ScrollbarModule, LoaderModule], exports: [DropdownComponent, CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, ScrollbarModule, LoaderModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: DropdownModule, imports: [imports$g, CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, ScrollbarModule, LoaderModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: DropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$g,
                    declarations: [...components$c],
                    exports: [...components$c, ...imports$g]
                }]
        }] });

/**
 * Component to manage empty states.
 */
class EmptyStateComponent {
    constructor() {
        /**
         * Method triggered when the button is clicked
         */
        this.result = new EventEmitter();
    }
    /**
     * On button click
     */
    onButtonClick() {
        this.result.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: EmptyStateComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: EmptyStateComponent, selector: "mic-empty-state", inputs: { icon: "icon", image: "image", title: "title", subtitle: "subtitle", button: "button" }, outputs: { result: "result" }, ngImport: i0, template: "<div class=\"flex flex-col h-fit gap-4\">\n  @if (icon) {\n  <div class=\"flex flex-col items-center\">\n    <mat-icon class=\"empty-state-icon\">{{ icon }}</mat-icon>\n  </div>\n  } @if (image) {\n  <div class=\"flex flex-col items-center h-fit mb-2\">\n    <img [src]=\"image\" [alt]=\"title ? title : null\" />\n  </div>\n  }\n  <div>\n    @if (title) {\n    <div class=\"flex flex-row justify-center\">\n      <strong>{{ title }}</strong>\n    </div>\n    } @if (subtitle) {\n    <div class=\"subtitle flex flex-row justify-center\">\n      {{ subtitle }}\n    </div>\n    }\n  </div>\n  @if (button) {\n  <div class=\"flex flex-col items-center\">\n    <button mat-flat-button color=\"primary\" (click)=\"onButtonClick()\">{{ button }}</button>\n  </div>\n  }\n</div>\n", styles: [":host{display:block}.empty-state-icon{font-size:50px;width:50px;height:45px}img{max-height:200px}\n"], dependencies: [{ kind: "component", type: i1.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", exportAs: ["matButton"] }, { kind: "component", type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: EmptyStateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-empty-state', template: "<div class=\"flex flex-col h-fit gap-4\">\n  @if (icon) {\n  <div class=\"flex flex-col items-center\">\n    <mat-icon class=\"empty-state-icon\">{{ icon }}</mat-icon>\n  </div>\n  } @if (image) {\n  <div class=\"flex flex-col items-center h-fit mb-2\">\n    <img [src]=\"image\" [alt]=\"title ? title : null\" />\n  </div>\n  }\n  <div>\n    @if (title) {\n    <div class=\"flex flex-row justify-center\">\n      <strong>{{ title }}</strong>\n    </div>\n    } @if (subtitle) {\n    <div class=\"subtitle flex flex-row justify-center\">\n      {{ subtitle }}\n    </div>\n    }\n  </div>\n  @if (button) {\n  <div class=\"flex flex-col items-center\">\n    <button mat-flat-button color=\"primary\" (click)=\"onButtonClick()\">{{ button }}</button>\n  </div>\n  }\n</div>\n", styles: [":host{display:block}.empty-state-icon{font-size:50px;width:50px;height:45px}img{max-height:200px}\n"] }]
        }], propDecorators: { icon: [{
                type: Input
            }], image: [{
                type: Input
            }], title: [{
                type: Input
            }], subtitle: [{
                type: Input
            }], button: [{
                type: Input
            }], result: [{
                type: Output
            }] } });

const imports$f = [CommonModule, MaterialModule];
const declarations$5 = [EmptyStateComponent];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { EmptyStateModule } from '@michelin/theme';</code>
 */
class EmptyStateModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: EmptyStateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: EmptyStateModule, declarations: [EmptyStateComponent], imports: [CommonModule, MaterialModule], exports: [EmptyStateComponent, CommonModule, MaterialModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: EmptyStateModule, imports: [imports$f, CommonModule, MaterialModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: EmptyStateModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [imports$f],
                    declarations: declarations$5,
                    exports: [...declarations$5, ...imports$f]
                }]
        }] });

/**
 * This component allow to manage navbar links
 *
 * It's possible to use link tree to get sub menu
 */
class NavbarLinkComponent {
    constructor() {
        /**
         * Force alignment to the right (default = false)
         */
        this.alignRight = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarLinkComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: NavbarLinkComponent, selector: "mic-navbar-link", inputs: { icon: "icon", link: "link", label: "label", alignRight: "alignRight" }, queries: [{ propertyName: "children", predicate: i0.forwardRef(() => NavbarLinkComponent) }], ngImport: i0, template: ``, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarLinkComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'mic-navbar-link',
                    template: ``
                }]
        }], propDecorators: { icon: [{
                type: Input
            }], link: [{
                type: Input
            }], label: [{
                type: Input
            }], alignRight: [{
                type: Input
            }], children: [{
                type: ContentChildren,
                args: [forwardRef(() => NavbarLinkComponent)]
            }] } });

/**
 * Component to display an icon
 */
class IconComponent {
    constructor() {
        this.class = 'mic-icon';
    }
    ngOnChanges() {
        if (typeof this.icon === 'string') {
            this.key = this.icon;
            this.type = 'material';
        }
        if (typeof this.icon === 'object') {
            this.key = this.icon.key;
            this.type = this.icon.type;
            this.fontSet = this.icon.fontSet;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: IconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: IconComponent, selector: "mic-icon", inputs: { icon: "icon", fontSet: "fontSet", ariaLabel: "ariaLabel", decorative: "decorative" }, host: { properties: { "class": "this.class" } }, usesOnChanges: true, ngImport: i0, template: "@if (type === 'svg') {\n<mat-icon [svgIcon]=\"key\" [fontSet]=\"fontSet\"></mat-icon>\n} @if (type === 'material') {\n<mat-icon [fontIcon]=\"key\" [fontSet]=\"fontSet\"></mat-icon>\n}\n", styles: [".mat-icon.mic-icon-link{vertical-align:sub;font-size:18px;width:auto;height:auto}:host{display:flex}:host.xs .mat-icon{font-size:12px;height:12px;width:12px;line-height:12px}:host.s .mat-icon{font-size:16px;height:16px;width:16px;line-height:16px}:host.sm .mat-icon{font-size:20px;height:20px;width:20px;line-height:20px}:host.m .mat-icon{font-size:32px;height:32px;width:32px;line-height:32px}:host.l .mat-icon{font-size:40px;height:40px;width:40px;line-height:40px}:host.xl .mat-icon{font-size:48px;height:48px;width:48px;line-height:48px}:host.xxl .mat-icon{font-size:56px;height:56px;width:56px;line-height:56px}:host.xxxl .mat-icon{font-size:64px;height:64px;width:64px;line-height:64px}@media (max-width: 5000px){:host.xl-xs .mat-icon{font-size:12px;height:12px;width:12px;line-height:12px}:host.xl-s .mat-icon{font-size:16px;height:16px;width:16px;line-height:16px}:host.xl-sm .mat-icon{font-size:20px;height:20px;width:20px;line-height:20px}:host.xl-m .mat-icon{font-size:32px;height:32px;width:32px;line-height:32px}:host.xl-l .mat-icon{font-size:40px;height:40px;width:40px;line-height:40px}:host.xl-xl .mat-icon{font-size:48px;height:48px;width:48px;line-height:48px}:host.xl-xxl .mat-icon{font-size:56px;height:56px;width:56px;line-height:56px}:host.xl-xxxl .mat-icon{font-size:64px;height:64px;width:64px;line-height:64px}}@media (max-width: 1919px){:host.lg-xs .mat-icon{font-size:12px;height:12px;width:12px;line-height:12px}:host.lg-s .mat-icon{font-size:16px;height:16px;width:16px;line-height:16px}:host.lg-sm .mat-icon{font-size:20px;height:20px;width:20px;line-height:20px}:host.lg-m .mat-icon{font-size:32px;height:32px;width:32px;line-height:32px}:host.lg-l .mat-icon{font-size:40px;height:40px;width:40px;line-height:40px}:host.lg-xl .mat-icon{font-size:48px;height:48px;width:48px;line-height:48px}:host.lg-xxl .mat-icon{font-size:56px;height:56px;width:56px;line-height:56px}:host.lg-xxxl .mat-icon{font-size:64px;height:64px;width:64px;line-height:64px}}@media (max-width: 1279px){:host.md-xs .mat-icon{font-size:12px;height:12px;width:12px;line-height:12px}:host.md-s .mat-icon{font-size:16px;height:16px;width:16px;line-height:16px}:host.md-sm .mat-icon{font-size:20px;height:20px;width:20px;line-height:20px}:host.md-m .mat-icon{font-size:32px;height:32px;width:32px;line-height:32px}:host.md-l .mat-icon{font-size:40px;height:40px;width:40px;line-height:40px}:host.md-xl .mat-icon{font-size:48px;height:48px;width:48px;line-height:48px}:host.md-xxl .mat-icon{font-size:56px;height:56px;width:56px;line-height:56px}:host.md-xxxl .mat-icon{font-size:64px;height:64px;width:64px;line-height:64px}}@media (max-width: 959px){:host.sm-xs .mat-icon{font-size:12px;height:12px;width:12px;line-height:12px}:host.sm-s .mat-icon{font-size:16px;height:16px;width:16px;line-height:16px}:host.sm-sm .mat-icon{font-size:20px;height:20px;width:20px;line-height:20px}:host.sm-m .mat-icon{font-size:32px;height:32px;width:32px;line-height:32px}:host.sm-l .mat-icon{font-size:40px;height:40px;width:40px;line-height:40px}:host.sm-xl .mat-icon{font-size:48px;height:48px;width:48px;line-height:48px}:host.sm-xxl .mat-icon{font-size:56px;height:56px;width:56px;line-height:56px}:host.sm-xxxl .mat-icon{font-size:64px;height:64px;width:64px;line-height:64px}}@media (max-width: 599px){:host.xs-xs .mat-icon{font-size:12px;height:12px;width:12px;line-height:12px}:host.xs-s .mat-icon{font-size:16px;height:16px;width:16px;line-height:16px}:host.xs-sm .mat-icon{font-size:20px;height:20px;width:20px;line-height:20px}:host.xs-m .mat-icon{font-size:32px;height:32px;width:32px;line-height:32px}:host.xs-l .mat-icon{font-size:40px;height:40px;width:40px;line-height:40px}:host.xs-xl .mat-icon{font-size:48px;height:48px;width:48px;line-height:48px}:host.xs-xxl .mat-icon{font-size:56px;height:56px;width:56px;line-height:56px}:host.xs-xxxl .mat-icon{font-size:64px;height:64px;width:64px;line-height:64px}}\n"], dependencies: [{ kind: "component", type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-icon', template: "@if (type === 'svg') {\n<mat-icon [svgIcon]=\"key\" [fontSet]=\"fontSet\"></mat-icon>\n} @if (type === 'material') {\n<mat-icon [fontIcon]=\"key\" [fontSet]=\"fontSet\"></mat-icon>\n}\n", styles: [".mat-icon.mic-icon-link{vertical-align:sub;font-size:18px;width:auto;height:auto}:host{display:flex}:host.xs .mat-icon{font-size:12px;height:12px;width:12px;line-height:12px}:host.s .mat-icon{font-size:16px;height:16px;width:16px;line-height:16px}:host.sm .mat-icon{font-size:20px;height:20px;width:20px;line-height:20px}:host.m .mat-icon{font-size:32px;height:32px;width:32px;line-height:32px}:host.l .mat-icon{font-size:40px;height:40px;width:40px;line-height:40px}:host.xl .mat-icon{font-size:48px;height:48px;width:48px;line-height:48px}:host.xxl .mat-icon{font-size:56px;height:56px;width:56px;line-height:56px}:host.xxxl .mat-icon{font-size:64px;height:64px;width:64px;line-height:64px}@media (max-width: 5000px){:host.xl-xs .mat-icon{font-size:12px;height:12px;width:12px;line-height:12px}:host.xl-s .mat-icon{font-size:16px;height:16px;width:16px;line-height:16px}:host.xl-sm .mat-icon{font-size:20px;height:20px;width:20px;line-height:20px}:host.xl-m .mat-icon{font-size:32px;height:32px;width:32px;line-height:32px}:host.xl-l .mat-icon{font-size:40px;height:40px;width:40px;line-height:40px}:host.xl-xl .mat-icon{font-size:48px;height:48px;width:48px;line-height:48px}:host.xl-xxl .mat-icon{font-size:56px;height:56px;width:56px;line-height:56px}:host.xl-xxxl .mat-icon{font-size:64px;height:64px;width:64px;line-height:64px}}@media (max-width: 1919px){:host.lg-xs .mat-icon{font-size:12px;height:12px;width:12px;line-height:12px}:host.lg-s .mat-icon{font-size:16px;height:16px;width:16px;line-height:16px}:host.lg-sm .mat-icon{font-size:20px;height:20px;width:20px;line-height:20px}:host.lg-m .mat-icon{font-size:32px;height:32px;width:32px;line-height:32px}:host.lg-l .mat-icon{font-size:40px;height:40px;width:40px;line-height:40px}:host.lg-xl .mat-icon{font-size:48px;height:48px;width:48px;line-height:48px}:host.lg-xxl .mat-icon{font-size:56px;height:56px;width:56px;line-height:56px}:host.lg-xxxl .mat-icon{font-size:64px;height:64px;width:64px;line-height:64px}}@media (max-width: 1279px){:host.md-xs .mat-icon{font-size:12px;height:12px;width:12px;line-height:12px}:host.md-s .mat-icon{font-size:16px;height:16px;width:16px;line-height:16px}:host.md-sm .mat-icon{font-size:20px;height:20px;width:20px;line-height:20px}:host.md-m .mat-icon{font-size:32px;height:32px;width:32px;line-height:32px}:host.md-l .mat-icon{font-size:40px;height:40px;width:40px;line-height:40px}:host.md-xl .mat-icon{font-size:48px;height:48px;width:48px;line-height:48px}:host.md-xxl .mat-icon{font-size:56px;height:56px;width:56px;line-height:56px}:host.md-xxxl .mat-icon{font-size:64px;height:64px;width:64px;line-height:64px}}@media (max-width: 959px){:host.sm-xs .mat-icon{font-size:12px;height:12px;width:12px;line-height:12px}:host.sm-s .mat-icon{font-size:16px;height:16px;width:16px;line-height:16px}:host.sm-sm .mat-icon{font-size:20px;height:20px;width:20px;line-height:20px}:host.sm-m .mat-icon{font-size:32px;height:32px;width:32px;line-height:32px}:host.sm-l .mat-icon{font-size:40px;height:40px;width:40px;line-height:40px}:host.sm-xl .mat-icon{font-size:48px;height:48px;width:48px;line-height:48px}:host.sm-xxl .mat-icon{font-size:56px;height:56px;width:56px;line-height:56px}:host.sm-xxxl .mat-icon{font-size:64px;height:64px;width:64px;line-height:64px}}@media (max-width: 599px){:host.xs-xs .mat-icon{font-size:12px;height:12px;width:12px;line-height:12px}:host.xs-s .mat-icon{font-size:16px;height:16px;width:16px;line-height:16px}:host.xs-sm .mat-icon{font-size:20px;height:20px;width:20px;line-height:20px}:host.xs-m .mat-icon{font-size:32px;height:32px;width:32px;line-height:32px}:host.xs-l .mat-icon{font-size:40px;height:40px;width:40px;line-height:40px}:host.xs-xl .mat-icon{font-size:48px;height:48px;width:48px;line-height:48px}:host.xs-xxl .mat-icon{font-size:56px;height:56px;width:56px;line-height:56px}:host.xs-xxxl .mat-icon{font-size:64px;height:64px;width:64px;line-height:64px}}\n"] }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], icon: [{
                type: Input
            }], fontSet: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], decorative: [{
                type: Input
            }] } });

class NavbarDesignDirective {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
    }
    ngOnInit() {
        this.applyMargin();
    }
    ngAfterViewInit() {
        this.applyMargin();
    }
    applyMargin() {
        if (!this.selectedElement) {
            return;
        }
        const container = this.selectedElement.elementRef.nativeElement.closest('.mat-toolbar');
        if (!container) {
            return;
        }
        const containerWidth = container.getBoundingClientRect().width;
        const selectedElementRect = this.selectedElement.elementRef.nativeElement.getBoundingClientRect();
        let left = selectedElementRect.left - container.getBoundingClientRect().left;
        let childWidth = 0; // Initialize childWidth to 0
        const tabLinkElements = this.elementRef.nativeElement.querySelectorAll('a.mat-mdc-tab-link');
        for (const item of tabLinkElements) {
            childWidth += item.getBoundingClientRect().width;
        }
        if (childWidth + left > containerWidth) {
            left = containerWidth - childWidth;
        }
        // Assign the calculated margin-left to the host element
        this.renderer.setStyle(this.elementRef.nativeElement, 'margin-left', `${Math.round(left)}px`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarDesignDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: NavbarDesignDirective, selector: "[micNavbarDesign]", inputs: { selectedElement: "selectedElement" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarDesignDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[micNavbarDesign]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }], propDecorators: { selectedElement: [{
                type: Input
            }] } });

/**
 * Use sanitizer to secure html
 */
class SafeHtmlDirective {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(html) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SafeHtmlDirective, deps: [{ token: i1$6.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: SafeHtmlDirective, name: "safeHTML" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SafeHtmlDirective, decorators: [{
            type: Pipe,
            args: [{ name: 'safeHTML' }]
        }], ctorParameters: () => [{ type: i1$6.DomSanitizer }] });

class NavbarLinkPipe {
    transform(current, selected) {
        return selected && selected === current;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarLinkPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: NavbarLinkPipe, name: "navbarLink" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarLinkPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'navbarLink'
                }]
        }] });

/**
 * This component is a container for each links
 */
class NavbarLinksComponent {
    constructor() {
        this.color = signal('primary');
        this.classes = `mic-navbar-links`;
        this.active = signal('');
        this.wasInside = true;
    }
    select(link, element) {
        this.selected = link;
        this.selectedElement = element;
        this.active.set(null);
    }
    unselect() {
        this.selected = null;
        this.selectedElement = null;
    }
    clickInside() {
        this.wasInside = true;
    }
    clickout() {
        if (!this.wasInside) {
            this.unselect();
        }
        this.wasInside = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarLinksComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: NavbarLinksComponent, selector: "mic-navbar-links", inputs: { ariaLabel: "ariaLabel", subItemAriaLabel: "subItemAriaLabel" }, host: { listeners: { "click": "clickInside()", "document:click": "clickout()" }, properties: { "class": "this.classes" } }, queries: [{ propertyName: "links", predicate: NavbarLinkComponent }], ngImport: i0, template: "<div class=\"flex flex-row {{ color() }}\">\n  <div class=\"flex flex-row justify-end\">\n    <nav #tabs mat-tab-nav-bar class=\"navbar-links\" [attr.aria-label]=\"ariaLabel\" [tabPanel]=\"tabPanel\">\n      @for (link of links; track link; let index = $index) {\n      <a\n        mat-tab-link\n        class=\"nav-tab-link flex flex-row justify-center\"\n        (click)=\"select(link, refElement)\"\n        [routerLink]=\"link.link\"\n        [active]=\"link | navbarLink : selected\"\n        [disableRipple]=\"true\"\n        #refElement\n      >\n        @if (link.icon) {\n        <mic-icon [icon]=\"link.icon\"></mic-icon>\n        }\n        <span [class.md-hidden]=\"link.icon\" [innerHtml]=\"link.label | safeHTML\" [ngClass]=\"{ 'align-right': link.alignRight }\"></span>\n      </a>\n      }\n    </nav>\n    <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>\n    @if (selected && selected.children?.length) {\n    <div class=\"navbar-children\">\n      <nav\n        #refChild\n        mat-tab-nav-bar\n        micNavbarDesign\n        [selectedElement]=\"selectedElement\"\n        [attr.aria-label]=\"ariaLabel\"\n        [tabPanel]=\"tabPanel2\"\n      >\n        @for (subLink of selected.children; track subLink; let index = $index) {\n        <a\n          mat-tab-link\n          class=\"nav-tab-link flex flex-row justify-center\"\n          (click)=\"unselect()\"\n          [routerLink]=\"subLink.link\"\n          [active]=\"active() === subLink.link\"\n          [disableRipple]=\"true\"\n        >\n          @if (subLink.icon) {\n          <mic-icon [icon]=\"subLink.icon\"></mic-icon>\n          }\n          <span [class.md-hidden]=\"subLink.icon\">{{ subLink.label }}</span>\n        </a>\n        }\n      </nav>\n      <mat-tab-nav-panel #tabPanel2></mat-tab-nav-panel>\n    </div>\n    }\n  </div>\n</div>\n", styles: [".navbar-links ::ng-deep .mdc-tab__content{height:auto}.navbar-links .mat-mdc-tab-link.nav-tab-link{opacity:1;min-width:70px;transition:.5s cubic-bezier(.35,0,.25,1);padding:10px}.navbar-links .mat-mdc-tab-link.nav-tab-link .align-right{text-align:right}.navbar-links .mat-mdc-tab-link.nav-tab-link .mic-icon{margin-right:5px}.navbar-links .closely .mat-mdc-tab-link.nav-tab-link{height:50px}.navbar-children{position:absolute;top:63px;left:0;width:100%;box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.navbar-children ::ng-deep .mat-mdc-tab-header-pagination{display:none}@media screen and (max-width: 599px){.mat-mdc-tab-link.nav-tab-link{height:55px}.navbar-children{top:55px}}@media screen and (min-width: 600px){.mat-mdc-tab-link.nav-tab-link{height:63px}}@media screen and (max-width: 959px){.mat-mdc-tab-link.nav-tab-link .mic-icon{margin-right:0}}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: i3$4.MatTabNav, selector: "[mat-tab-nav-bar]", inputs: ["fitInkBarToContent", "mat-stretch-tabs", "animationDuration", "backgroundColor", "disableRipple", "color", "tabPanel"], exportAs: ["matTabNavBar", "matTabNav"] }, { kind: "component", type: i3$4.MatTabNavPanel, selector: "mat-tab-nav-panel", inputs: ["id"], exportAs: ["matTabNavPanel"] }, { kind: "component", type: i3$4.MatTabLink, selector: "[mat-tab-link], [matTabLink]", inputs: ["active", "disabled", "disableRipple", "tabIndex", "id"], exportAs: ["matTabLink"] }, { kind: "component", type: IconComponent, selector: "mic-icon", inputs: ["icon", "fontSet", "ariaLabel", "decorative"] }, { kind: "directive", type: NavbarDesignDirective, selector: "[micNavbarDesign]", inputs: ["selectedElement"] }, { kind: "pipe", type: SafeHtmlDirective, name: "safeHTML" }, { kind: "pipe", type: NavbarLinkPipe, name: "navbarLink" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarLinksComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-navbar-links', template: "<div class=\"flex flex-row {{ color() }}\">\n  <div class=\"flex flex-row justify-end\">\n    <nav #tabs mat-tab-nav-bar class=\"navbar-links\" [attr.aria-label]=\"ariaLabel\" [tabPanel]=\"tabPanel\">\n      @for (link of links; track link; let index = $index) {\n      <a\n        mat-tab-link\n        class=\"nav-tab-link flex flex-row justify-center\"\n        (click)=\"select(link, refElement)\"\n        [routerLink]=\"link.link\"\n        [active]=\"link | navbarLink : selected\"\n        [disableRipple]=\"true\"\n        #refElement\n      >\n        @if (link.icon) {\n        <mic-icon [icon]=\"link.icon\"></mic-icon>\n        }\n        <span [class.md-hidden]=\"link.icon\" [innerHtml]=\"link.label | safeHTML\" [ngClass]=\"{ 'align-right': link.alignRight }\"></span>\n      </a>\n      }\n    </nav>\n    <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>\n    @if (selected && selected.children?.length) {\n    <div class=\"navbar-children\">\n      <nav\n        #refChild\n        mat-tab-nav-bar\n        micNavbarDesign\n        [selectedElement]=\"selectedElement\"\n        [attr.aria-label]=\"ariaLabel\"\n        [tabPanel]=\"tabPanel2\"\n      >\n        @for (subLink of selected.children; track subLink; let index = $index) {\n        <a\n          mat-tab-link\n          class=\"nav-tab-link flex flex-row justify-center\"\n          (click)=\"unselect()\"\n          [routerLink]=\"subLink.link\"\n          [active]=\"active() === subLink.link\"\n          [disableRipple]=\"true\"\n        >\n          @if (subLink.icon) {\n          <mic-icon [icon]=\"subLink.icon\"></mic-icon>\n          }\n          <span [class.md-hidden]=\"subLink.icon\">{{ subLink.label }}</span>\n        </a>\n        }\n      </nav>\n      <mat-tab-nav-panel #tabPanel2></mat-tab-nav-panel>\n    </div>\n    }\n  </div>\n</div>\n", styles: [".navbar-links ::ng-deep .mdc-tab__content{height:auto}.navbar-links .mat-mdc-tab-link.nav-tab-link{opacity:1;min-width:70px;transition:.5s cubic-bezier(.35,0,.25,1);padding:10px}.navbar-links .mat-mdc-tab-link.nav-tab-link .align-right{text-align:right}.navbar-links .mat-mdc-tab-link.nav-tab-link .mic-icon{margin-right:5px}.navbar-links .closely .mat-mdc-tab-link.nav-tab-link{height:50px}.navbar-children{position:absolute;top:63px;left:0;width:100%;box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.navbar-children ::ng-deep .mat-mdc-tab-header-pagination{display:none}@media screen and (max-width: 599px){.mat-mdc-tab-link.nav-tab-link{height:55px}.navbar-children{top:55px}}@media screen and (min-width: 600px){.mat-mdc-tab-link.nav-tab-link{height:63px}}@media screen and (max-width: 959px){.mat-mdc-tab-link.nav-tab-link .mic-icon{margin-right:0}}\n"] }]
        }], propDecorators: { ariaLabel: [{
                type: Input
            }], subItemAriaLabel: [{
                type: Input
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }], links: [{
                type: ContentChildren,
                args: [NavbarLinkComponent]
            }], clickInside: [{
                type: HostListener,
                args: ['click']
            }], clickout: [{
                type: HostListener,
                args: ['document:click']
            }] } });

/**
 * Component to display a navbar
 */
class NavbarComponent {
    constructor(router) {
        this.router = router;
        /**
         * Color 'white' or 'primary' (default value is primary)
         */
        this.color = 'primary';
        /**
         * Navbar mode (default value is large)
         */
        this.mode = 'large';
        this.class = 'mic-navbar';
    }
    ngAfterContentInit() {
        this.router.events
            .pipe(startWith({ url: this.router.url }), filter$1((event) => event instanceof NavigationStart))
            .subscribe((event) => {
            this.links.forEach((links) => {
                links.active.set(event.url);
                links.color.set(this.color);
            });
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarComponent, deps: [{ token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: NavbarComponent, selector: "mic-navbar", inputs: { color: "color", mode: "mode" }, host: { properties: { "class": "this.class" } }, queries: [{ propertyName: "links", predicate: NavbarLinksComponent }], ngImport: i0, template: "<mat-toolbar class=\"flex flex-row justify-between {{ color }} {{ mode }} gap-2\">\n  <ng-content></ng-content>\n</mat-toolbar>\n", styles: [".mic-elevation-1{box-shadow:0 4px 8px #6666661f}.mic-elevation-2{box-shadow:0 8px 16px #66666629}.mic-elevation-3{box-shadow:0 16px 32px #6663}.mic-elevation-4{box-shadow:0 32px 64px #66666652}:host{z-index:2;min-height:3.125rem}.mat-toolbar{position:relative;font-size:15px;z-index:2;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-toolbar:first-of-type{padding:0 10px;height:auto}.mat-toolbar:last-of-type{border-top:1px outset rgba(0,0,0,.12)}.mat-toolbar.closely{height:3.125rem}@media screen and (max-width: 599px){.mat-toolbar.closely{height:auto}}\n"], dependencies: [{ kind: "component", type: i2$4.MatToolbar, selector: "mat-toolbar", inputs: ["color"], exportAs: ["matToolbar"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-navbar', template: "<mat-toolbar class=\"flex flex-row justify-between {{ color }} {{ mode }} gap-2\">\n  <ng-content></ng-content>\n</mat-toolbar>\n", styles: [".mic-elevation-1{box-shadow:0 4px 8px #6666661f}.mic-elevation-2{box-shadow:0 8px 16px #66666629}.mic-elevation-3{box-shadow:0 16px 32px #6663}.mic-elevation-4{box-shadow:0 32px 64px #66666652}:host{z-index:2;min-height:3.125rem}.mat-toolbar{position:relative;font-size:15px;z-index:2;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-toolbar:first-of-type{padding:0 10px;height:auto}.mat-toolbar:last-of-type{border-top:1px outset rgba(0,0,0,.12)}.mat-toolbar.closely{height:3.125rem}@media screen and (max-width: 599px){.mat-toolbar.closely{height:auto}}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.Router }], propDecorators: { color: [{
                type: Input
            }], mode: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }], links: [{
                type: ContentChildren,
                args: [NavbarLinksComponent]
            }] } });

class FooterComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: FooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: FooterComponent, selector: "mic-footer", ngImport: i0, template: "<footer role=\"contentinfo\" id=\"footer\" tabindex=\"-1\" class=\"w-full\">\n  <mic-navbar mode=\"closely\" class=\"footer-navbar\">\n    <ng-content></ng-content>\n  </mic-navbar>\n</footer>\n", dependencies: [{ kind: "component", type: NavbarComponent, selector: "mic-navbar", inputs: ["color", "mode"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: FooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-footer', template: "<footer role=\"contentinfo\" id=\"footer\" tabindex=\"-1\" class=\"w-full\">\n  <mic-navbar mode=\"closely\" class=\"footer-navbar\">\n    <ng-content></ng-content>\n  </mic-navbar>\n</footer>\n" }]
        }] });

/**
 * Navbar icon component allow to display links with only a little icon
 */
class NavbarIconComponent {
    constructor() {
        /**
         * Color 'white' or 'primary' (default value is primary)
         */
        this.color = 'primary';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: NavbarIconComponent, selector: "mic-navbar-icon", inputs: { icon: "icon", color: "color" }, ngImport: i0, template: "<button mat-icon-button class=\"mic-icon-button-medium\" [attr.aria-label]=\"icon\">\r\n  <mic-icon [icon]=\"icon\"></mic-icon>\r\n</button>\r\n", styles: [":host{align-items:center;display:flex}\n"], dependencies: [{ kind: "component", type: i1.MatIconButton, selector: "button[mat-icon-button]", exportAs: ["matButton"] }, { kind: "component", type: IconComponent, selector: "mic-icon", inputs: ["icon", "fontSet", "ariaLabel", "decorative"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-navbar-icon', template: "<button mat-icon-button class=\"mic-icon-button-medium\" [attr.aria-label]=\"icon\">\r\n  <mic-icon [icon]=\"icon\"></mic-icon>\r\n</button>\r\n", styles: [":host{align-items:center;display:flex}\n"] }]
        }], propDecorators: { icon: [{
                type: Input
            }], color: [{
                type: Input
            }] } });

/**
 * Inside a navbar, this component allow to add space between elements
 */
class NavbarSpacerComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarSpacerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: NavbarSpacerComponent, selector: "mic-navbar-spacer", ngImport: i0, template: '', isInline: true, styles: [":host{flex:1 1 100%}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarSpacerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-navbar-spacer', template: '', styles: [":host{flex:1 1 100%}\n"] }]
        }] });

/**
 * Inside a navbar, this component allow to display a profile button
 *
 */
class NavbarProfileComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarProfileComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: NavbarProfileComponent, selector: "mic-navbar-profile", inputs: { src: "src", alt: "alt" }, ngImport: i0, template: "<div class=\"flex flex-row justify-center\">\r\n  <img [src]=\"src\" [alt]=\"alt\" class=\"mic-navbar-profile\" />\r\n</div>\r\n", styles: [".mic-navbar-profile{height:40px;border-radius:40px;margin:0 5px}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarProfileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-navbar-profile', template: "<div class=\"flex flex-row justify-center\">\r\n  <img [src]=\"src\" [alt]=\"alt\" class=\"mic-navbar-profile\" />\r\n</div>\r\n", styles: [".mic-navbar-profile{height:40px;border-radius:40px;margin:0 5px}\n"] }]
        }], propDecorators: { src: [{
                type: Input
            }], alt: [{
                type: Input
            }] } });

const imports$e = [CommonModule, MaterialModule];
const declarations$4 = [IconComponent];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { IconModule } from '@michelin/theme';</code>
 */
class IconModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: IconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: IconModule, declarations: [IconComponent], imports: [CommonModule, MaterialModule], exports: [IconComponent, CommonModule, MaterialModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: IconModule, imports: [imports$e, CommonModule, MaterialModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: IconModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$e,
                    declarations: declarations$4,
                    exports: [...declarations$4, ...imports$e]
                }]
        }] });

const imports$d = [CommonModule];
const declarations$3 = [SafeHtmlDirective];
/** <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { UtiltiesModule } from '@michelin/theme';</code>
 */
class UtilitiesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: UtilitiesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: UtilitiesModule, declarations: [SafeHtmlDirective], imports: [CommonModule], exports: [SafeHtmlDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: UtilitiesModule, imports: [imports$d] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: UtilitiesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$d,
                    declarations: declarations$3,
                    exports: [...declarations$3]
                }]
        }] });

const imports$c = [CommonModule, RouterModule, MaterialModule, IconModule, UtilitiesModule];
const components$b = [
    NavbarComponent,
    NavbarLinkComponent,
    NavbarLinksComponent,
    NavbarIconComponent,
    NavbarProfileComponent,
    NavbarSpacerComponent
];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { NavbarModule } from '@michelin/theme';</code>
 */
class NavbarModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: NavbarModule, declarations: [NavbarComponent,
            NavbarLinkComponent,
            NavbarLinksComponent,
            NavbarIconComponent,
            NavbarProfileComponent,
            NavbarSpacerComponent, NavbarLinkPipe, NavbarDesignDirective], imports: [CommonModule, RouterModule, MaterialModule, IconModule, UtilitiesModule], exports: [NavbarComponent,
            NavbarLinkComponent,
            NavbarLinksComponent,
            NavbarIconComponent,
            NavbarProfileComponent,
            NavbarSpacerComponent, CommonModule, RouterModule, MaterialModule, IconModule, UtilitiesModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarModule, imports: [imports$c, CommonModule, RouterModule, MaterialModule, IconModule, UtilitiesModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: NavbarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$c,
                    declarations: [...components$b, NavbarLinkPipe, NavbarDesignDirective],
                    exports: [...components$b, ...imports$c]
                }]
        }] });

const imports$b = [CommonModule];
const components$a = [FooterComponent];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { FooterModule } from '@michelin/theme';</code>
 */
class FooterModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: FooterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: FooterModule, declarations: [FooterComponent], imports: [CommonModule, NavbarModule], exports: [FooterComponent, CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: FooterModule, imports: [imports$b, NavbarModule, CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: FooterModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [imports$b, NavbarModule],
                    declarations: [...components$a],
                    exports: [...components$a, ...imports$b]
                }]
        }] });

class HeaderComponent {
    constructor() {
        /**
         * Navbar color (default 'primary')
         */
        this.color = 'primary';
        /**
         * Label to go to the main content / Bypass link
         */
        this.goToMain = 'Go to the main content';
        /**
         * Label to go to the main navigation / Bypass link
         */
        this.goToNav = 'Go to the main navigation';
        /**
         * Label to go to the footer / Bypass link
         */
        this.goToFooter = 'Go to the footer';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: HeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: HeaderComponent, selector: "mic-header", inputs: { color: "color", goToMain: "goToMain", goToNav: "goToNav", goToFooter: "goToFooter" }, ngImport: i0, template: "<header role=\"banner\">\n  <mic-navbar [color]=\"color\">\n    <nav class=\"bypass-links\" role=\"navigation\" aria-label=\"Bypass links\">\n      <ul id=\"bypass\" class=\"bypass-list\">\n        <li>\n          <a class=\"bypass {{ color }}\" href=\"#main-navigation\">{{ goToNav }}</a>\n        </li>\n        <li>\n          <a class=\"bypass {{ color }}\" href=\"#main-content\">{{ goToMain }}</a>\n        </li>\n        <li>\n          <a class=\"bypass {{ color }}\" href=\"#footer\">{{ goToFooter }}</a>\n        </li>\n      </ul>\n    </nav>\n    <div class=\"header-navbar\">\n      <ng-content></ng-content>\n    </div>\n  </mic-navbar>\n</header>\n", styles: [":host{height:max-content}:host .bypass{display:inline-block;position:absolute;left:-999rem;top:.5rem;width:20rem;z-index:100;padding:.5rem}:host .bypass:focus{left:.5rem}:host .bypass-links{width:0}:host .bypass-list{margin:0}:host .bypass-list li{list-style-type:none}:host .header-navbar{width:100%}\n"], dependencies: [{ kind: "component", type: NavbarComponent, selector: "mic-navbar", inputs: ["color", "mode"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: HeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-header', template: "<header role=\"banner\">\n  <mic-navbar [color]=\"color\">\n    <nav class=\"bypass-links\" role=\"navigation\" aria-label=\"Bypass links\">\n      <ul id=\"bypass\" class=\"bypass-list\">\n        <li>\n          <a class=\"bypass {{ color }}\" href=\"#main-navigation\">{{ goToNav }}</a>\n        </li>\n        <li>\n          <a class=\"bypass {{ color }}\" href=\"#main-content\">{{ goToMain }}</a>\n        </li>\n        <li>\n          <a class=\"bypass {{ color }}\" href=\"#footer\">{{ goToFooter }}</a>\n        </li>\n      </ul>\n    </nav>\n    <div class=\"header-navbar\">\n      <ng-content></ng-content>\n    </div>\n  </mic-navbar>\n</header>\n", styles: [":host{height:max-content}:host .bypass{display:inline-block;position:absolute;left:-999rem;top:.5rem;width:20rem;z-index:100;padding:.5rem}:host .bypass:focus{left:.5rem}:host .bypass-links{width:0}:host .bypass-list{margin:0}:host .bypass-list li{list-style-type:none}:host .header-navbar{width:100%}\n"] }]
        }], propDecorators: { color: [{
                type: Input
            }], goToMain: [{
                type: Input
            }], goToNav: [{
                type: Input
            }], goToFooter: [{
                type: Input
            }] } });

const imports$a = [CommonModule];
const components$9 = [HeaderComponent];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { HeaderModule } from '@michelin/theme';</code>
 */
class HeaderModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: HeaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: HeaderModule, declarations: [HeaderComponent], imports: [CommonModule, NavbarModule], exports: [HeaderComponent, CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: HeaderModule, imports: [imports$a, NavbarModule, CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: HeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [imports$a, NavbarModule],
                    declarations: [...components$9],
                    exports: [...components$9, ...imports$a]
                }]
        }] });

/**
 * Icon model
 */
class Icon {
}

/**
 * Component to Michelin logo
 */
class LogoComponent {
    constructor() {
        /**
         * Type of logo (color)
         */
        this.type = 'group';
        /**
         * Logo width (default 160px)
         */
        this.width = '160px';
        /**
         * Logo height (default 60px)
         */
        this.height = '60px';
        /**
         * AriaLabel is the label of the logo used for assistive technologies through the aria-label attribute.
         * (default 'Homepage - Michelin')
         */
        this.ariaLabel = 'Homepage - Michelin';
        /**
         * Link to the target page of the logo.
         * (default '/')
         */
        this.link = '/';
        /**
         * Link target (default _self)
         */
        this.target = '_self';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: LogoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: LogoComponent, selector: "mic-logo", inputs: { type: "type", width: "width", height: "height", ariaLabel: "ariaLabel", link: "link", target: "target" }, ngImport: i0, template: "<mic-link [routerLink]=\"link\" [ariaLabel]=\"ariaLabel\" [target]=\"target\">\n  <div class=\"logo-{{ type }}\" [ngStyle]=\"{ width: width, height: height }\" aria-hidden=\"true\" alt=\"Michelin\"></div>\n</mic-link>\n", styles: [":host{height:100%}.logo,.logo-commercial-white,.logo-commercial,.logo-group,.logo-group-white{background-size:contain;background-position:center;background-repeat:no-repeat}@media screen and (max-width: 599px){.logo,.logo-commercial-white,.logo-commercial,.logo-group,.logo-group-white{margin-top:-8px}}.logo-group-white{background-image:url('data:image/svg+xml,<?xml version=\"1.0\" encoding=\"utf-8\"?>%0A<!-- Generator: Adobe Illustrator 22.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->%0A<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"%0A%09 viewBox=\"0 0 822.3 219.1\" style=\"enable-background:new 0 0 822.3 219.1;\" xml:space=\"preserve\">%0A<style type=\"text/css\">%0A%09.st0{fill:%23FFFFFF;}%0A<\\/style>%0A<path d=\"M243,166.9c0.3-0.1,0.6-0.2,0.9-0.3c0,0,0.5-0.2,0.7-0.2c3-1,9.7-4.5,12.2-9.5c5.1-1.9,8.8-4.5,11.1-7.6%0A%09c4.4-0.8,7.8-2.7,9.7-3.7c4.4-2.5,7.5-4.9,9.4-7.5c1.6-2.1,2.6-3.7,3.4-5.4c1.5-0.8,3.2-1.8,5.4-3.3c7.7-5.1,9.3-14.5,9.5-15.6%0A%09c0-0.2,0.1-0.5,0.1-0.7c0.4,0,0.8,0,1.2,0c7.7,0,17.8-4.8,23.2-7.5l0.1,0c0.8-0.4,1.6-0.8,1.9-0.9c1.8-0.8,5.5-2.8,9.3-5.3%0A%09c4.9-3.3,8.2-6.3,10-9.1c0.3-0.4,0.5-0.9,0.7-1.4l3.2-2c0.9-0.6,1.7-1.4,2.2-2.4c0.9-0.5,1.6-0.9,1.8-1.1c2.5-1.6,3.6-4.4,2.7-7.1%0A%09l0-0.1c-0.8-2.4-3-5.3-6.7-6.2c-1.3-2.8-4.1-4.4-7.2-4.4c-0.7,0-1.3,0.1-1.7,0.2c-0.2,0-1,0.2-7,1.7l-8.9,2.1%0A%09c0.8-2.2,0.7-4.6-0.3-6.6c-1.2-2.5-3.7-4.1-6.3-4.1c-0.9,0-1.8,0.2-2.6,0.6l-0.1,0c-0.3,0.2-1,0.5-16.9,10.8%0A%09c-0.2,0.1-0.4,0.3-0.6,0.4c-7.7,6.7-10.5,10.7-11.2,11.7c-0.4,0.5-1,1.5-1.6,2.8c-0.4-0.2-0.8-0.4-1.2-0.6c-3.2-1.4-6.5-2.1-9.9-2.1%0A%09c-6.1,0-10.4,2.4-11.5,3.1c-0.6,0.3-2.9,1.7-6.3,4.4c-1.4,1.1-2.6,2.3-3.7,3.7c-2.3,0.5-4.2,1.2-5.6,1.9c-1.8,0.9-3.5,2.3-5.4,3.8%0A%09l-0.1,0.1c-0.3,0.3-0.6,0.5-1,0.8c-0.8,0.6-2.9,2.3-4.9,5.1l-0.2,0c-0.3,0.1-2.8,0.6-6,2.1c-0.8,0.4-1.6,0.8-2.3,1.3%0A%09c-1.8,0.1-4.6,0.4-8.3,1.5l-0.2,0c-0.3-0.1-3.1-0.6-6.5-0.6c-1.5,0-2.9,0.1-4.1,0.3c-0.8,0.1-3.7,0.6-6.1,1.3%0A%09c-1.2,0.3-4.1,1.3-7.5,3.5c-7.3-1.7-14.6-2.2-19.2-2.4c4.4-5.9,6.5-12.7,5.8-18.5c-1.4-11-8.8-17.5-11.5-19.4%0A%09c-4.6-19.2-18-27.4-29-28.6c-2.2-2.5-6.3-4.1-11-4.1c-1.9,0-3.7,0.2-5.5,0.7c-5.9,1.6-10.6,6.1-11.5,11%0A%09c-5.9,4.9-15.1,15.9-12.5,35.6c-2.2,3-6.5,10.6-3.6,22.2c2,7.9,6.9,13.6,14.3,16.6c-5.7,2.8-10.7,6.1-14.9,10%0A%09c-0.3,0.2-0.5,0.5-0.7,0.7c-9.9,0.5-18.9,4.6-26,11.9c-5.1,5.2-8.6,11.2-10.8,16.5H243z\"/>%0A<path class=\"st0\" d=\"M264.1,143.6c0.2,0,0.4,0,0.6,0c4.2-0.1,7.5-1.9,9.9-3.3c2-1.1,5.3-3.2,7.3-5.5c-1,0.1-2.1,0.2-3.2,0.2%0A%09c-4.2,0-8.5-1.2-12.6-3.6c-5-3-8.9-7.6-11-13.2c-1.6-4.3-2.2-9.1-1.6-12.8c0.1-0.5,0.4-2,1-4c-1.5,0.8-3.4,2.4-5.3,3.9%0A%09c-3.1,2.4-12.8,12.6-4,27.5C250.2,140.6,257.8,143.6,264.1,143.6z M268.7,126.9c3.8,2.2,7.1,2.9,9.9,2.9c3.9,0,6.6-1.4,7.4-1.8%0A%09c1.3-0.6,2.8-1.3,6.3-3.7c5.7-3.8,6.8-11.4,6.8-11.4c0,0,0,0,0,0l-2,1.3c0,0-5.2,3.3-8,2.9c-2.6-0.4-5.8-4.3-4.4-4.3%0A%09c0.6,0,3.8,1.7,6.3,0.2c0.9-0.6,4.5-2.8,6.9-4.2c-0.7-2.9,0.1-4.4,2.3-2.2c1.5,1.5,6.6,1.4,7.7,1.4c0.1,0,0.2,0,0.3,0%0A%09c0.8-0.1,1.7-0.2,2.5-0.4c7.6-1.6,16.7-6.5,19-7.5c3.1-1.3,13.8-7.5,17-12.4c0.3-0.4,0-0.8,0-0.9c-0.2-0.3-1-1.1-2.3-1.2%0A%09c-1.3-0.1-2.9,0.6-4.4,2.1c-5.5,5.2-11.4,6.8-11.6,6.9c-0.1,0-0.2,0-0.3,0c-0.5,0-0.9-0.3-1.1-0.8c-0.2-0.6,0.2-1.2,0.8-1.4%0A%09c0.1,0,5.6-1.6,10.7-6.4c2.1-2,4.2-2.9,6.2-2.7c1.8,0.2,3,1.2,3.6,1.8c1.1-0.7,3.9-2.4,4-2.5c0.1,0,0.7-0.6,0-1.7c0,0,0,0,0,0%0A%09c-0.6-0.8-1.2-1.3-1.9-1.5c-1.6-0.4-4.1,0.5-7.3,2.6c-6,3.8-14.7,5.9-15.1,6c-0.1,0-0.2,0-0.3,0c-0.5,0-1-0.3-1.1-0.9%0A%09c-0.1-0.6,0.2-1.2,0.8-1.3c0.1,0,8.8-2.1,14.4-5.7c3.9-2.5,6.7-3.4,9-2.9c1.5,0.3,2.7,1.3,3.6,2.8c0,0,0,0.1,0,0.1%0A%09c0.6-0.3,1.3-0.7,1.8-1.1c0.5-0.3,0.7-0.6,0.5-1.1c-0.4-1.2-1.7-2.9-3.9-2.9c-0.4,0-0.8,0.1-1.3,0.2l-0.2,0.1%0A%09c-1.5,0.5-2.3,0.7-2.8,0.8l-21.3,6.3c-0.2,0.1-0.4,0.1-0.5,0c-0.4-0.1-0.7-0.4-0.9-0.8c-0.2-0.6,0.2-1.2,0.7-1.4l23.9-7.1%0A%09c0-0.1,0-0.1,0-0.2c-0.5-1.9-1.9-2.2-2.8-2.2c-0.3,0-0.5,0-0.6,0.1c-0.5,0.1-26.6,6.4-30.1,7.2c-0.6,0.2-3.9,1-6,1.9%0A%09c-0.6,0.3-0.7-0.4-0.1-0.8c0.5-0.4,3.6-2.2,6-3.1c0.5-0.2,1.2-0.7,1.7-1c1.7-1.3,3.9-3,5.8-5.5c2.3-3.1,0.5-5.4-0.9-5.4%0A%09c-0.2,0-0.3,0-0.4,0.1c-0.7,0.4-16.3,10.5-16.3,10.5c-2.8,2.4-4.9,4.5-6.4,6.1c0,0,0,0,0,0c-1.3,1.3-2.3,2.5-3.2,3.6%0A%09c-0.3,0.4-0.5,0.7-0.6,0.9c-1.5,2.1-2.1,3.6-2.1,3.6c-0.2,0.5-0.5,1.4-0.5,1.4s-5.6,3.3-6.8,3.9c-2.4,1.3-2.9,3-3.6,3%0A%09c-1,0,0.4-3.6,1.5-5.1c0.4-0.6,1.1-1.2,1.9-1.7c-2.7-1.2-5.2-1.6-7.3-1.6c-5.1,0-8.4,2.2-8.4,2.2s-2.1,1.2-5.7,4%0A%09c-5.4,4.1-6.4,11.1-6.4,11.1C257.7,110.9,259.6,121.5,268.7,126.9z M225,166.9c-1.3-0.4-2.7-0.9-4-1.5c-3.5-1.6-6.7-4-9.2-6.8%0A%09c-2.7-3-4.8-6.7-6.2-10.9c-1.3-4.1-1.8-8.6-1.4-12.8c0.4-4.3,1.9-8.5,4.3-12.2c1.6-2.6,3.7-4.8,6-6.7c-0.2,0-0.5,0.1-0.7,0.1%0A%09c0,0-3.1,0.4-5.3,1.1s-9.8,3.5-13.8,11.3c-4.1,7.8-3.6,14.6-2.7,19c0.9,4.4,3.6,10.2,6.4,12.9c2.2,2.3,4.7,4.7,8.7,6.4l-9.6,0%0A%09c-1.1-1-2-1.9-2.8-2.7c-3.8-3.9-6.8-10.8-7.7-15.6c-1.6-7.8-0.5-15.4,3.2-22.5c1.2-2.2,2.6-4.3,4.3-6.1c-8.3-1.5-16.2-1.6-18.8-1.6%0A%09c-0.3,0.6-0.7,1.1-1.2,1.6c-3,2.6-5.5,3.2-3.7,1.3c1.7-2,1.6-4.1,1.1-4.6c-0.4-0.4-1.1-0.1-1.5,0c-4.9,1.8-5.8,1-4.8,0.4%0A%09c4.4-2.7,6.9-5.1,8.4-6.6c3.7-4.2,6.7-10.3,6-15.9c-0.8-6.5-4.5-11.7-8.3-14.7c-0.4-0.3-0.7-0.6-0.9-0.7c-0.1-0.1-0.2-0.2-0.3-0.2%0A%09c0,0,0,0,0,0c0,0,0,0,0,0c-0.6-0.4-1.4-0.9-2-1.1c-1-0.3-0.7-1,0.4-1.3c-0.1-0.5-0.2-1.1-0.4-1.6c-0.1-0.5-0.3-1-0.4-1.5%0A%09c-4.4-14.6-14.8-20.8-23.4-21.7c-0.1,0-0.2,0-0.3,0c-2-0.2-3.4-0.2-3.7-0.2c-1.4-0.2-0.8-0.8,0-1.1c0.3-0.1,0.4-0.4,0.3-0.6%0A%09c-1-1.5-5.6-2.9-10.4-1.5c-2.5,0.7-4.7,2.3-6,3.9c-0.2,0.3-0.4,0.7-0.6,1c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.6,0.5,0.4,0.5,0.4%0A%09c2.3-0.5,3.3,0.1,1.5,1.1c-1.1,0.6-2.7,1.7-3.8,2.5c-2.6,2-6,5.3-8.4,10.3c-2.2,4.6-3.3,10-3.1,15.8c0.1,0.8,0.1,2.4,0.2,2.9%0A%09c0.1,0.6,0.5,1.2,1.9,1c1.9-0.2,3.1-0.6,1.4,0.8c-0.7,0.5-2.9,2.6-4.2,4.2c-2.6,3.3-4.6,9.4-2.6,17.1c1.7,6.6,5.8,11,12.3,13.1%0A%09c3.9,1.1,12.8,2.6,19.7,2.2c0.7,0,0.9,0.1,0.8,0.4c-0.1,0.3-0.6,0.5-1.3,0.6c-1.1,0.2-3.5,0.6-7.6,1c-0.9,0.1-1.6,0.7-1.7,1.1%0A%09c0,0,0,0,0,0.1c-0.5,1.8,3.2,3.3,3.6,3.5c1.4,0.4,0.8,1.2,0.2,1.3c-2.6,0.5-7.3-0.6-9.8-0.8c-1.7-0.1-3,0.2-3.5,0.5%0A%09c-5.9,2.6-10.9,5.9-15,9.7c-4.6,4.3-8.1,9.4-10.4,15c-1.4,3.5-2.2,6.8-2.6,9.6h-5.3c0.4-3.3,1.3-7.3,3.1-11.6%0A%09c1.5-3.6,3.3-7,5.6-10.1c-6.4,1.3-12.1,4.5-16.9,9.4c-3.3,3.3-6.1,7.5-8.4,12.2l-24.1,0l-3.8,10.4h710.7l3.8-10.4L225,166.9z%0A%09 M215.7,155c4.5,4.9,10.6,7.6,15.8,7.7c0.2,0,0.3,0,0.5,0c5,0,8.6-1.4,10.7-2.1c1.3-0.4,3-1.3,4.6-2.4c-0.4,0-0.7,0-1.1,0%0A%09c-3.4,0-6.8-0.7-9.9-2.1c-3.4-1.5-6.4-3.8-8.9-6.8c-1.9-2.3-3.5-4.9-4.9-8.1c-2.6-6.1-3-16.3,2.4-24.4c0.1-0.1,0.2-0.3,0.3-0.4%0A%09c-0.5,0.2-1,0.3-1.6,0.5c-1.2,0.4-2.5,1-3.8,1.8c-5.3,3.4-9.7,9.4-10.4,16.7S211.2,150.2,215.7,155z M238.4,151.3%0A%09c2.7,1.2,5.4,1.7,7.8,1.7c2.8,0,5.3-0.6,7.3-1.3c2.1-0.7,4.5-1.8,6.6-3.2c-2.9-0.5-5.7-1.4-8.3-2.8c-4.4-2.3-8.1-5.8-10.9-10.2%0A%09l0-0.1l0-0.1c-5.6-9.4-4.8-17.4-3.1-22.5c-2.7,1.2-6.1,3.3-8.5,6.8c-4.4,6.5-3.9,14.8-1.9,19.3C229.2,143.6,232.5,148.7,238.4,151.3%0A%09z\"/>%0A<path d=\"M135.6,99.1c-1.4,1-1.7,1.7-1.9,2.2c-0.2,0.5-0.2,1-0.1,1.2c0.1,0.2,0,0.5-0.2,0.6h0h0c0,0,0,0,0,0c-0.2,0.1-0.4,0-0.5,0%0A%09c-0.1-0.1-0.2-0.2-0.3-0.3c-0.4-0.9,0-2.9,1-3.8c0.4-0.4,0.9-0.7,1.4-0.9c0.2-0.1,0.7-0.3,1,0.1C136.2,98.6,135.9,98.9,135.6,99.1%0A%09 M168.4,92.7c-0.3,0.1-0.4-0.3-0.6-0.8c-0.9,1.2-2.9,3.1-3.2,3.5c-0.4,0.6-0.8,1.2-1.2,1.8c-0.6,1.1-1.1,2.1-1.9,3.1%0A%09c-1,1.3-2.2,2.5-3.6,3.3c-2.7,1.6-6,2.4-9.1,1.9c-1.6-0.3-3.2-0.9-4.7-1.6c-1.2-0.6-2.5-1.3-3.8-1.4c-1.5,0-3.1,0.1-4.6-0.1%0A%09c-0.5-0.1-1-0.3-1.1-0.8c-0.2-0.7,0.3-1.5,1-1.5l0,0c0.2,0,0.5,0.1,0.7,0.1c0.5,0,1,0.1,1.5,0.1c5.4,0.2,11-0.7,16.1-2.3%0A%09c3.2-1,6.3-2.3,9-4.2c1.1-0.8,2.2-1.7,3.1-2.7c0.1-0.2,0.3-0.4,0.4-0.5c-0.1-0.1-0.2-0.1-0.3-0.1c-0.3-0.1-0.3-0.6,0.2-0.7%0A%09c0.5-0.1,1.2,0.1,1.5,0.4c0.3,0.3,0.5,0.7,0.6,1.3C168.8,91.9,168.8,92.6,168.4,92.7 M161.2,97.3c-4.8,2.6-10.3,4-15.7,4.7%0A%09c1.5,0.7,3,1.2,4.6,1.4c1.5,0.1,2.9-0.1,4.3-0.5c1.4-0.4,2.8-1.1,4-2C159.6,99.8,160.5,98.6,161.2,97.3 M130.7,85.7%0A%09c-0.9-1.6-1.4-3.4-1.7-5.2c-0.3-1.8-0.4-3.7,0-5.5c0.3-1.8,1.1-3.4,2.6-4.4c1.2-0.9,2.7-1.4,4.2-1.4c0.4,0,0.8,0,1.2,0.1%0A%09c3.8,0.8,5.6,3.9,7.1,8.3c1.7,4.8,0.5,10.8-2.6,12.1c-0.8,0.3-2,0.7-2,0.7c-0.8,0.2-1.6,0.4-2.4,0.4c-0.9,0-1.8-0.2-2.6-0.7%0A%09C132.8,89,131.6,87.3,130.7,85.7 M132,85c0.9,1.7,2,3,3.2,3.7c0.6,0.3,1.2,0.5,1.9,0.5c0.6,0,1.2-0.1,2-0.3l0,0%0A%09c0.3-0.1,1.3-0.4,1.8-0.6c1-0.4,1.8-1.8,2.2-3.6c0.1-0.7,0.2-1.4,0.2-2.1c-0.2,2.3-1.4,4.1-3,4.4c-2.4,0.6-5.1-2-6-5.8%0A%09c-0.2-1-0.3-2-0.3-2.9c0.5,0.6,1.1,0.9,1.8,0.7c0.9-0.2,1.4-1.4,1.1-2.6c-0.3-0.9-1-1.6-1.7-1.7c0.5-0.7,1.2-1.2,1.9-1.4%0A%09c1.8-0.4,3.7,0.8,4.9,3c0-0.1-0.1-0.2-0.1-0.3c-1.2-2.4-3.3-4.9-7.3-3.8c-5.3,1.4-4.1,8.3-3.5,10.4C131.3,83.4,131.6,84.2,132,85%0A%09 M156.8,84C156.8,84,156.8,84,156.8,84C156.8,84,156.7,83.9,156.8,84C156.7,83.9,156.7,84,156.8,84 M150.5,77.5%0A%09c-0.4-1.6-1-4-0.8-6.3c0.2-3.3,1.9-5.2,3.9-5.9c2.5-0.8,5.2,0.5,6.7,2.4c0.9,1.1,1.7,2.7,2.4,4.3c0.2,0.5,0.5,1.1,0.7,1.7%0A%09c0.6,1.8,0.9,3.6,0.8,5.3c-0.1,1-0.2,2-0.6,2.8c-0.3,0.9-0.9,2.1-1.9,2.7c-0.7,0.4-1.5,0.5-2.1,0.7l0,0c-0.6,0.1-1.2,0.2-1.9,0.2%0A%09c-0.4,0-0.8,0-1.2-0.1c-0.1,0-0.1,0-0.2,0l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0l0,0l0,0c-1.7-0.5-2.7-1.8-3.6-2.9%0A%09c-0.7-1-1.2-2.1-1.6-3.1l0,0c0,0-0.1-0.2-0.2-0.6c-0.1-0.2-0.2-0.5-0.2-0.7l0,0l0,0C150.6,77.7,150.6,77.6,150.5,77.5 M151.4,73.1%0A%09c0,1.4,0.2,3,0.6,4.4c0.4,1.4,1,2.8,1.8,4c0.7,1,1.6,2,2.9,2.4c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.1,0c0,0,0,0,0,0%0A%09c0.3,0.1,0.6,0.1,0.9,0.1c0.5,0,1-0.1,1.6-0.2c0.6-0.1,1.2-0.3,1.8-0.6c0.7-0.4,1-1.2,1.3-1.9c0.3-0.8,0.4-1.6,0.5-2.4%0A%09c0.1-1.4-0.1-2.9-0.6-4.3c0,0.1,0,0.1,0,0.2c0.8,3.7-0.3,7-2.5,7.5c-2.2,0.5-4.6-2.1-5.4-5.7c-0.2-1-0.3-1.9-0.3-2.8%0A%09c0.4,0.6,1.1,1,1.8,0.8c0.9-0.2,1.4-1.4,1.1-2.5c-0.3-1-1.1-1.7-1.9-1.7c0.4-0.6,1-1.1,1.7-1.2c1.4-0.3,2.9,0.6,4,2.4%0A%09c-0.3-0.5-0.6-1-0.9-1.5c-0.8-1.1-2-2.2-3.4-2.5c-0.2,0-0.5-0.1-0.7-0.1c-1.3,0-2.6,0.6-3.3,1.6C151.6,70.2,151.4,71.7,151.4,73.1\"%0A%09/>%0A<path class=\"st0\" d=\"M448.4,100.9L433,142.6h20.2l15.4-41.7H448.4z M562.8,100.9l-5.6,15h-10.2l5.5-15h-19.3L518,142.6h19.2%0A%09l5.2-14.1h10.2l-5.2,14.1h19.2l15.4-41.7H562.8z M408.4,100.9l-14.8,22.4c0,0,0.9-11.7,1.2-14.6c0.2-2.1-0.1-7.9-5.3-7.9h-23.4%0A%09l-15.4,41.7H369l11.1-30.2l-2.3,30.2h16.3l20-29.7l-10.9,29.7h18.4l15.4-41.7H408.4z M496.6,101.2c-12.2,2.5-28.8,11.5-28.7,27.9%0A%09c0.1,9.5,11.5,14.7,24.7,14.4c7.4-0.2,14.4-1.5,15.2-1.7l4.9-12.6c-6.4,1-12.6,2.6-17.5,0.6c-8.7-3.5-3.4-12.6,2.8-15.4%0A%09c2.7-1.2,6.4-2.4,10.9-2.3c1.8,0,6.4,0.1,8.1,4.1l6.1-14.7C512.6,98.9,502.1,100.1,496.6,101.2z M693.7,100.9l-15.4,41.7h20.2%0A%09l15.4-41.7H693.7z M608.5,111.8h23.1l4.1-10.9h-42.1l-15.4,41.7h42.6l4.1-11.3h-23.5l1.7-4.6h22l3.8-10.3h-22L608.5,111.8z%0A%09 M763.7,100.9l-10.5,28.6c0.1-2.9,0.7-14.3,1.1-20.8c0.1-2.7-0.4-4.8-1.7-6.1c-1.6-1.7-3.6-1.7-3.7-1.7h-23.5L710,142.6H727%0A%09l10.9-29.6l-1.3,29.6h28.6l15.4-41.7H763.7z M666.2,100.9h-19.7l-15.4,41.7h39.5l5.1-13.9h-19.8L666.2,100.9z\"/>%0A</svg>%0A')}.logo-group{background-image:url('data:image/svg+xml,<?xml version=\"1.0\" encoding=\"utf-8\"?>%0A<!-- Generator: Adobe Illustrator 22.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->%0A<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"%0A%09 viewBox=\"0 0 822.3 219.1\" style=\"enable-background:new 0 0 822.3 219.1;\" xml:space=\"preserve\">%0A<style type=\"text/css\">%0A%09.st0{fill:%231C1C1C;}%0A%09.st1{fill:%23FFFFFF;}%0A%09.st2{fill:%23004F9E;}%0A<\\/style>%0A<path class=\"st0\" d=\"M243,166.9c0.3-0.1,0.6-0.2,0.9-0.3c0,0,0.5-0.2,0.7-0.2c3-1,9.7-4.5,12.2-9.5c5.1-1.9,8.8-4.5,11.1-7.6%0A%09c4.4-0.8,7.8-2.7,9.7-3.7c4.4-2.5,7.5-4.9,9.4-7.5c1.6-2.1,2.6-3.7,3.4-5.4c1.5-0.8,3.2-1.8,5.4-3.3c7.7-5.1,9.3-14.5,9.5-15.6%0A%09c0-0.2,0.1-0.5,0.1-0.7c0.4,0,0.8,0,1.2,0c7.7,0,17.8-4.8,23.2-7.5l0.1,0c0.8-0.4,1.6-0.8,1.9-0.9c1.8-0.8,5.5-2.8,9.3-5.3%0A%09c4.9-3.3,8.2-6.3,10-9.1c0.3-0.4,0.5-0.9,0.7-1.4l3.2-2c0.9-0.6,1.7-1.4,2.2-2.4c0.9-0.5,1.6-0.9,1.8-1.1c2.5-1.6,3.6-4.4,2.7-7.1%0A%09l0-0.1c-0.8-2.4-3-5.3-6.7-6.2c-1.3-2.8-4.1-4.4-7.2-4.4c-0.7,0-1.3,0.1-1.7,0.2c-0.2,0-1,0.2-7,1.7l-8.9,2.1%0A%09c0.8-2.2,0.7-4.6-0.3-6.6c-1.2-2.5-3.7-4.1-6.3-4.1c-0.9,0-1.8,0.2-2.6,0.6l-0.1,0c-0.3,0.2-1,0.5-16.9,10.8%0A%09c-0.2,0.1-0.4,0.3-0.6,0.4c-7.7,6.7-10.5,10.7-11.2,11.7c-0.4,0.5-1,1.5-1.6,2.8c-0.4-0.2-0.8-0.4-1.2-0.6c-3.2-1.4-6.5-2.1-9.9-2.1%0A%09c-6.1,0-10.4,2.4-11.5,3.1c-0.6,0.3-2.9,1.7-6.3,4.4c-1.4,1.1-2.6,2.3-3.7,3.7c-2.3,0.5-4.2,1.2-5.6,1.9c-1.8,0.9-3.5,2.3-5.4,3.8%0A%09l-0.1,0.1c-0.3,0.3-0.6,0.5-1,0.8c-0.8,0.6-2.9,2.3-4.9,5.1l-0.2,0c-0.3,0.1-2.8,0.6-6,2.1c-0.8,0.4-1.6,0.8-2.3,1.3%0A%09c-1.8,0.1-4.6,0.4-8.3,1.5l-0.2,0c-0.3-0.1-3.1-0.6-6.5-0.6c-1.5,0-2.9,0.1-4.1,0.3c-0.8,0.1-3.7,0.6-6.1,1.3%0A%09c-1.2,0.3-4.1,1.3-7.5,3.5c-7.3-1.7-14.6-2.2-19.2-2.4c4.4-5.9,6.5-12.7,5.8-18.5c-1.4-11-8.8-17.5-11.5-19.4%0A%09c-4.6-19.2-18-27.4-29-28.6c-2.2-2.5-6.3-4.1-11-4.1c-1.9,0-3.7,0.2-5.5,0.7c-5.9,1.6-10.6,6.1-11.5,11%0A%09c-5.9,4.9-15.1,15.9-12.5,35.6c-2.2,3-6.5,10.6-3.6,22.2c2,7.9,6.9,13.6,14.3,16.6c-5.7,2.8-10.7,6.1-14.9,10%0A%09c-0.3,0.2-0.5,0.5-0.7,0.7c-9.9,0.5-18.9,4.6-26,11.9c-5.1,5.2-8.6,11.2-10.8,16.5H243z\"/>%0A<path class=\"st1\" d=\"M242.6,160.6c-2.1,0.7-5.7,2.1-10.7,2.1c-0.2,0-0.3,0-0.5,0c-5.2-0.1-11.4-2.8-15.8-7.7%0A%09c-4.5-4.9-6.9-12.3-6.2-19.6c0.7-7.3,5.1-13.4,10.4-16.7c1.2-0.8,2.5-1.4,3.8-1.8c0.5-0.2,1.1-0.4,1.6-0.5c-0.1,0.1-0.2,0.3-0.3,0.4%0A%09c-5.4,8-5,18.3-2.4,24.4c1.4,3.2,3,5.8,4.9,8.1c2.5,3,5.5,5.3,8.9,6.8c3.2,1.4,6.5,2.1,9.9,2.1c0.4,0,0.7,0,1.1,0%0A%09C245.6,159.3,243.9,160.2,242.6,160.6\"/>%0A<path class=\"st1\" d=\"M253.5,151.7c-2,0.7-4.5,1.3-7.3,1.3c-2.4,0-5.1-0.5-7.8-1.7c-5.9-2.6-9.1-7.7-11.1-12.2%0A%09c-2-4.6-2.4-12.8,1.9-19.3c2.4-3.5,5.8-5.6,8.5-6.8c-1.7,5.1-2.5,13,3.1,22.5l0,0.1l0,0.1c2.8,4.5,6.5,7.9,10.9,10.2%0A%09c2.6,1.4,5.4,2.3,8.3,2.8C258,149.9,255.6,150.9,253.5,151.7\"/>%0A<path class=\"st1\" d=\"M274.5,140.3c-2.4,1.3-5.7,3.1-9.9,3.3c-0.2,0-0.4,0-0.6,0c-6.3,0-13.9-3-18.8-10.9c-8.8-14.8,0.8-25,4-27.5%0A%09c1.9-1.5,3.8-3,5.3-3.9c-0.7,2-1,3.5-1,4c-0.7,3.7-0.1,8.5,1.6,12.8c2.2,5.7,6,10.3,11,13.2c4.1,2.4,8.3,3.6,12.6,3.6%0A%09c1.2,0,2.3-0.1,3.2-0.2C279.8,137.1,276.6,139.2,274.5,140.3\"/>%0A<path class=\"st1\" d=\"M86.4,166.9c0.4-3.3,1.3-7.3,3.1-11.6c1.5-3.6,3.3-7,5.6-10.1c-6.4,1.3-12.1,4.5-16.9,9.4%0A%09c-3.3,3.3-6.1,7.5-8.4,12.2H86.4z\"/>%0A<path class=\"st1\" d=\"M197.4,166.9c-1.1-1-2-1.9-2.8-2.7c-3.8-3.9-6.8-10.8-7.7-15.6c-1.6-7.8-0.5-15.4,3.2-22.5%0A%09c1.2-2.2,2.6-4.3,4.3-6.1c-8.3-1.5-16.2-1.6-18.8-1.6c-0.3,0.6-0.7,1.1-1.2,1.6c-3,2.6-5.5,3.2-3.7,1.3c1.7-2,1.6-4.1,1.1-4.6%0A%09c-0.4-0.4-1.1-0.1-1.5,0c-4.9,1.8-5.8,1-4.8,0.4c4.4-2.7,6.9-5.1,8.4-6.6c3.7-4.2,6.7-10.3,6-15.9c-0.8-6.5-4.5-11.6-8.3-14.7%0A%09c-0.4-0.3-0.7-0.6-0.9-0.7c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0,0,0c0,0,0,0,0,0c-0.6-0.4-1.4-0.9-2-1.1c-1-0.3-0.7-1,0.4-1.3%0A%09c-0.1-0.5-0.2-1.1-0.4-1.6c-0.1-0.5-0.3-1-0.4-1.5c-4.4-14.6-14.8-20.8-23.4-21.7c-0.1,0-0.2,0-0.3,0c-2-0.2-3.4-0.2-3.7-0.2%0A%09c-1.4-0.2-0.8-0.8,0-1.1c0.3-0.1,0.4-0.4,0.3-0.6c-1-1.5-5.6-2.9-10.4-1.5c-2.5,0.7-4.7,2.3-6,3.9c-0.2,0.3-0.4,0.7-0.6,1%0A%09c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.6,0.5,0.4,0.5,0.4c2.3-0.5,3.3,0.1,1.5,1.1c-1.1,0.6-2.7,1.7-3.8,2.5c-2.6,2-6,5.3-8.4,10.3%0A%09c-2.2,4.6-3.3,10-3.1,15.8c0.1,0.8,0.1,2.4,0.2,2.9c0.1,0.6,0.5,1.2,1.9,1c1.9-0.2,3.1-0.6,1.4,0.8c-0.7,0.5-2.9,2.6-4.2,4.2%0A%09c-2.6,3.3-4.6,9.4-2.6,17.1c1.7,6.6,5.8,11,12.3,13.1c3.9,1.1,12.8,2.6,19.7,2.2c0.7,0,0.9,0.1,0.8,0.4c-0.1,0.3-0.6,0.5-1.3,0.6%0A%09c-1.1,0.2-3.5,0.6-7.6,1c-0.9,0.1-1.6,0.7-1.7,1.1c0,0,0,0,0,0.1c-0.5,1.8,3.2,3.3,3.6,3.5c1.4,0.4,0.8,1.2,0.2,1.3%0A%09c-2.6,0.5-7.3-0.6-9.8-0.8c-1.7-0.1-3,0.2-3.5,0.5c-5.9,2.6-10.9,5.9-15,9.7c-4.6,4.3-8.1,9.4-10.4,15c-1.4,3.5-2.2,6.8-2.6,9.6%0A%09H197.4z\"/>%0A<path class=\"st1\" d=\"M198.3,160.5c2.2,2.3,4.7,4.7,8.7,6.4h18c-1.3-0.4-2.7-0.9-4-1.5c-3.5-1.6-6.7-4-9.2-6.8%0A%09c-2.7-3-4.8-6.7-6.2-10.9c-1.3-4.1-1.8-8.6-1.4-12.8c0.4-4.3,1.9-8.5,4.3-12.2c1.6-2.6,3.7-4.8,6-6.7c-0.2,0-0.5,0.1-0.7,0.1%0A%09c0,0-3.1,0.4-5.3,1.1c-2.2,0.7-9.8,3.5-13.8,11.3c-4.1,7.8-3.6,14.6-2.7,19C192.9,152,195.6,157.8,198.3,160.5\"/>%0A<path class=\"st1\" d=\"M356.1,79.2c-0.5,0.3-1.2,0.7-1.8,1.1c0,0,0-0.1,0-0.1c-0.9-1.5-2.1-2.5-3.6-2.8c-2.3-0.5-5.2,0.4-9,2.9%0A%09c-5.6,3.6-14.3,5.7-14.4,5.7c-0.6,0.1-1,0.7-0.8,1.3c0.1,0.5,0.6,0.9,1.1,0.9c0.1,0,0.2,0,0.3,0c0.4-0.1,9.2-2.2,15.1-6%0A%09c3.2-2.1,5.7-3,7.3-2.6c0.8,0.2,1.4,0.6,1.9,1.5c0,0,0,0,0,0c0.7,1.1,0.1,1.7,0,1.7c-0.1,0-2.8,1.8-4,2.5c-0.6-0.6-1.8-1.6-3.6-1.8%0A%09c-2-0.2-4.1,0.7-6.2,2.7c-5.1,4.8-10.6,6.3-10.7,6.4c-0.6,0.2-0.9,0.8-0.8,1.4c0.1,0.5,0.6,0.8,1.1,0.8c0.1,0,0.2,0,0.3,0%0A%09c0.2-0.1,6.1-1.7,11.6-6.9c1.6-1.5,3.1-2.2,4.4-2.1c1.3,0.1,2.1,1,2.3,1.2c0.1,0.1,0.3,0.5,0,0.9c-3.1,4.9-13.9,11.1-17,12.4%0A%09c-2.3,1-11.5,5.9-19,7.5c-0.8,0.2-1.7,0.3-2.5,0.4c-0.1,0-0.2,0-0.3,0c-1.1,0-6.2,0.1-7.7-1.4c-2.2-2.2-3-0.6-2.3,2.2%0A%09c-2.4,1.5-6,3.6-6.9,4.2c-2.5,1.5-5.7-0.2-6.3-0.2c-1.3,0,1.8,3.9,4.4,4.3c2.8,0.4,8-2.9,8-2.9l2-1.3c0,0,0,0,0,0%0A%09c0,0-1.2,7.6-6.8,11.4c-3.5,2.3-5,3.1-6.3,3.7c-0.9,0.4-3.5,1.8-7.4,1.8c-2.8,0-6.1-0.7-9.9-2.9c-9.1-5.4-10.9-16-10.1-20.7%0A%09c0,0,1-7,6.4-11.1c3.6-2.8,5.7-4,5.7-4s3.4-2.2,8.4-2.2c2.2,0,4.7,0.4,7.3,1.6c-0.8,0.6-1.5,1.2-1.9,1.7c-1,1.6-2.5,5.1-1.5,5.1%0A%09c0.7,0,1.2-1.8,3.6-3c1.2-0.6,6.8-3.9,6.8-3.9s0.2-0.9,0.5-1.4c0,0,0.7-1.5,2.1-3.6c0.1-0.1,0.3-0.4,0.6-0.9%0A%09c0.8-1.1,1.9-2.4,3.2-3.6c0,0,0,0,0,0c1.5-1.6,3.6-3.6,6.4-6.1c0,0,15.6-10.1,16.3-10.5c0.1-0.1,0.3-0.1,0.4-0.1%0A%09c1.3,0,3.2,2.3,0.9,5.4c-1.9,2.5-4.1,4.2-5.8,5.5c-0.5,0.4-1.2,0.8-1.7,1c-2.4,0.8-5.5,2.7-6,3.1c-0.5,0.4-0.5,1.1,0.1,0.8%0A%09c2.1-0.9,5.4-1.7,6-1.9c3.6-0.8,29.7-7.1,30.1-7.2c0.1,0,0.4-0.1,0.6-0.1c0.9,0,2.4,0.3,2.8,2.2c0,0.1,0,0.1,0,0.2l-23.9,7.1%0A%09c-0.6,0.2-0.9,0.8-0.7,1.4c0.1,0.4,0.5,0.7,0.9,0.8c0.2,0,0.4,0,0.5,0l21.3-6.3c0.4-0.1,1.2-0.3,2.8-0.8l0.2-0.1%0A%09c0.5-0.1,0.9-0.2,1.3-0.2c2.2,0,3.5,1.8,3.9,2.9C356.7,78.6,356.5,78.9,356.1,79.2\"/>%0A<path class=\"st0\" d=\"M135.6,99.1c-1.4,1-1.7,1.7-1.9,2.2c-0.2,0.5-0.2,1-0.1,1.2c0.1,0.2,0,0.5-0.2,0.6h0h0c0,0,0,0,0,0%0A%09c-0.2,0.1-0.4,0-0.5,0c-0.1-0.1-0.2-0.2-0.3-0.3c-0.4-0.9,0-2.9,1-3.8c0.4-0.4,0.9-0.7,1.4-0.9c0.2-0.1,0.7-0.3,1,0.1%0A%09C136.2,98.6,135.9,98.9,135.6,99.1 M168.4,92.7c-0.3,0.1-0.4-0.3-0.6-0.8c-0.9,1.2-2.9,3.1-3.2,3.5c-0.4,0.6-0.8,1.2-1.2,1.8%0A%09c-0.6,1.1-1.1,2.1-1.9,3.1c-1,1.3-2.2,2.5-3.6,3.3c-2.7,1.6-6,2.4-9.1,1.9c-1.6-0.3-3.2-0.9-4.7-1.6c-1.2-0.6-2.5-1.3-3.8-1.4%0A%09c-1.5,0-3.1,0.1-4.6-0.1c-0.5-0.1-1-0.3-1.1-0.8c-0.2-0.7,0.3-1.5,1-1.5l0,0c0.2,0,0.5,0.1,0.7,0.1c0.5,0,1,0.1,1.5,0.1%0A%09c5.4,0.2,11-0.7,16.1-2.3c3.2-1,6.3-2.3,9-4.2c1.1-0.8,2.2-1.7,3.1-2.7c0.1-0.2,0.3-0.4,0.4-0.5c-0.1-0.1-0.2-0.1-0.3-0.1%0A%09c-0.3-0.1-0.3-0.6,0.2-0.7c0.5-0.1,1.2,0.1,1.5,0.4c0.3,0.3,0.5,0.7,0.6,1.3C168.8,91.9,168.8,92.6,168.4,92.7 M161.2,97.3%0A%09c-4.8,2.6-10.3,4-15.7,4.7c1.5,0.7,3,1.2,4.6,1.4c1.5,0.1,2.9-0.1,4.3-0.5c1.4-0.4,2.8-1.1,4-2C159.6,99.8,160.5,98.6,161.2,97.3%0A%09 M130.7,85.7c-0.9-1.6-1.4-3.4-1.7-5.2c-0.3-1.8-0.4-3.7,0-5.5c0.3-1.8,1.1-3.4,2.6-4.4c1.2-0.9,2.7-1.4,4.2-1.4%0A%09c0.4,0,0.8,0,1.2,0.1c3.8,0.8,5.6,3.9,7.1,8.3c1.7,4.8,0.5,10.8-2.6,12.1c-0.8,0.3-2,0.7-2,0.7c-0.8,0.2-1.6,0.4-2.4,0.4%0A%09c-0.9,0-1.8-0.2-2.6-0.7C132.8,89,131.6,87.3,130.7,85.7 M132,85c0.9,1.7,2,3,3.2,3.7c0.6,0.3,1.2,0.5,1.9,0.5c0.6,0,1.2-0.1,2-0.3%0A%09l0,0c0.3-0.1,1.3-0.4,1.8-0.6c1-0.4,1.8-1.8,2.2-3.6c0.1-0.7,0.2-1.4,0.2-2.1c-0.2,2.3-1.4,4.1-3,4.4c-2.4,0.6-5.1-2-6-5.8%0A%09c-0.2-1-0.3-2-0.3-2.9c0.5,0.6,1.1,0.9,1.8,0.7c0.9-0.2,1.4-1.4,1.1-2.6c-0.3-0.9-1-1.6-1.7-1.7c0.5-0.7,1.2-1.2,1.9-1.4%0A%09c1.8-0.4,3.7,0.8,4.9,3c0-0.1-0.1-0.2-0.1-0.3c-1.2-2.4-3.3-4.9-7.3-3.8c-5.3,1.4-4.1,8.3-3.5,10.4C131.3,83.4,131.6,84.2,132,85%0A%09 M156.8,84C156.8,84,156.8,84,156.8,84C156.8,84,156.7,83.9,156.8,84C156.7,83.9,156.7,84,156.8,84 M150.5,77.5%0A%09c-0.4-1.6-1-4-0.8-6.3c0.2-3.3,1.9-5.2,3.9-5.9c2.5-0.8,5.2,0.5,6.7,2.4c0.9,1.1,1.7,2.7,2.4,4.3c0.2,0.5,0.5,1.1,0.7,1.7%0A%09c0.6,1.8,0.9,3.6,0.8,5.3c-0.1,1-0.2,2-0.6,2.8c-0.3,0.9-0.9,2.1-1.9,2.7c-0.7,0.4-1.5,0.5-2.1,0.7l0,0c-0.6,0.1-1.2,0.2-1.9,0.2%0A%09c-0.4,0-0.8,0-1.2-0.1c-0.1,0-0.1,0-0.2,0l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0l0,0l0,0c-1.7-0.5-2.7-1.8-3.6-2.9%0A%09c-0.7-1-1.2-2.1-1.6-3.1l0,0c0,0-0.1-0.2-0.2-0.6c-0.1-0.2-0.2-0.5-0.2-0.7l0,0l0,0C150.6,77.7,150.6,77.6,150.5,77.5 M151.4,73.1%0A%09c0,1.4,0.2,3,0.6,4.4c0.4,1.4,1,2.8,1.8,4c0.7,1,1.6,2,2.9,2.4c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.1,0c0,0,0,0,0,0%0A%09c0.3,0.1,0.6,0.1,0.9,0.1c0.5,0,1-0.1,1.6-0.2c0.6-0.1,1.2-0.3,1.8-0.6c0.7-0.4,1-1.2,1.3-1.9c0.3-0.8,0.4-1.6,0.5-2.4%0A%09c0.1-1.4-0.1-2.9-0.6-4.3c0,0.1,0,0.1,0,0.2c0.8,3.7-0.3,7-2.5,7.5c-2.2,0.5-4.6-2.1-5.4-5.7c-0.2-1-0.3-1.9-0.3-2.8%0A%09c0.4,0.6,1.1,1,1.8,0.8c0.9-0.2,1.4-1.4,1.1-2.5c-0.3-1-1.1-1.7-1.9-1.7c0.4-0.6,1-1.1,1.7-1.2c1.4-0.3,2.9,0.6,4,2.4%0A%09c-0.3-0.5-0.6-1-0.9-1.5c-0.8-1.1-2-2.2-3.4-2.5c-0.2,0-0.5-0.1-0.7-0.1c-1.3,0-2.6,0.6-3.3,1.6C151.6,70.2,151.4,71.7,151.4,73.1\"%0A%09/>%0A<path class=\"st2\" d=\"M448.4,100.9L433,142.6h20.2l15.4-41.7H448.4z M763.7,100.9l-10.5,28.6c0.1-2.9,0.7-14.3,1.1-20.8%0A%09c0.1-2.7-0.4-4.8-1.7-6.1c-1.6-1.7-3.6-1.7-3.7-1.7h-23.5L710,142.6H727l10.9-29.6l-1.3,29.6h28.6l15.4-41.7H763.7z M408.4,100.9%0A%09l-14.8,22.4c0,0,0.9-11.7,1.2-14.6c0.2-2.1-0.1-7.9-5.3-7.9h-23.4l-15.4,41.7H369l11.1-30.2l-2.3,30.2h16.3l20-29.7l-10.9,29.7h18.4%0A%09l15.4-41.7H408.4z M562.8,100.9l-5.6,15h-10.2l5.5-15h-19.3L518,142.6h19.2l5.2-14.1h10.2l-5.2,14.1h19.2l15.4-41.7H562.8z%0A%09 M496.6,101.2c-12.2,2.5-28.8,11.5-28.7,27.9c0.1,9.5,11.5,14.7,24.7,14.4c7.4-0.2,14.4-1.5,15.2-1.7l4.9-12.6%0A%09c-6.4,1-12.6,2.6-17.5,0.6c-8.7-3.5-3.4-12.6,2.8-15.4c2.7-1.2,6.4-2.4,10.9-2.3c1.8,0,6.4,0.1,8.1,4.1l6.1-14.7%0A%09C512.6,98.9,502.1,100.1,496.6,101.2z M608.5,111.8h23.1l4.1-10.9h-42.1l-15.4,41.7h42.6l4.1-11.3h-23.5l1.7-4.6h22l3.8-10.3h-22%0A%09L608.5,111.8z M693.7,100.9l-15.4,41.7h20.2l15.4-41.7H693.7z M666.2,100.9h-19.7l-15.4,41.7h39.5l5.1-13.9h-19.8L666.2,100.9z\"/>%0A<polygon class=\"st2\" points=\"756.2,166.9 45.6,166.9 41.7,177.4 752.4,177.4 \"/>%0A</svg>%0A')}.logo-commercial{background-image:url('data:image/svg+xml,<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 897.05 264.69\"><defs><style>.cls-1{fill:%23fce500;}.cls-2{fill:%2327509b;}.cls-3{fill:%23fff;}<\\/style></defs><title>Michelin_C_H_WhiteBG_RGB_0703</title><polygon class=\"cls-1\" points=\"720.71 195.03 89.11 195.03 84.03 208.97 715.59 208.97 720.71 195.03\"/><path class=\"cls-2\" d=\"M460.75,112c-16.35,3.35-38.5,15.36-38.27,37.28.14,12.64,15.41,19.66,32.92,19.17a141,141,0,0,0,20.36-2.27l6.5-16.88c-8.6,1.36-16.86,3.42-23.34.83-11.68-4.67-4.49-16.82,3.77-20.59a33,33,0,0,1,14.54-3.12c2.47,0,8.5.15,10.84,5.48l8.17-19.58C482.18,108.82,468.07,110.47,460.75,112Zm88.6-.51-7.44,20.07H528.33l7.39-20.07H510l-20.46,55.73h25.66l7-18.87h13.61l-7,18.87h25.69L575,111.45Zm-153.15,0-20.53,55.72h27l20.5-55.72Zm-53.68,0-19.72,29.93s1.25-15.66,1.57-19.43c.23-2.87-.12-10.5-7.11-10.5H286l-20.51,55.72h24.46l14.86-40.31-3.13,40.31H323.4l26.66-39.6-14.55,39.6h24.63l20.51-55.72Zm476.23,0L804.68,149.7c.19-3.85,1-19.06,1.43-27.83.19-3.61-.59-6.36-2.31-8.19a7.45,7.45,0,0,0-4.91-2.23H767.53L747,167.18H769.8l14.54-39.47-1.72,39.47h38.18l20.52-55.73Zm-94.29,0L704,167.17h27l20.5-55.72ZM610.33,126h30.79l5.42-14.6H590.25l-20.51,55.73h56.91l5.53-15H600.76l2.3-6.2h29.32l5-13.72H608.09Zm77.4-14.6H661.47l-20.54,55.73h52.73l6.82-18.52H674Z\"/><path d=\"M60.16,91.7l.06.14.42,1a117.5,117.5,0,0,0,5.6,11.86,37,37,0,0,0,4.11,6.07,21.62,21.62,0,0,0-3.24,7.15,21.89,21.89,0,0,0,1,11.69,25.37,25.37,0,0,0,2.21,4.81l0,0,0,0a2.21,2.21,0,0,0-.09.4A22.74,22.74,0,0,0,79.49,156a25.07,25.07,0,0,0,3.41,2.15,17.61,17.61,0,0,0,6,8.27,24.09,24.09,0,0,0,6.75,3.72l0,.07A20.45,20.45,0,0,0,107.17,178a26.14,26.14,0,0,0,3.76.76,2,2,0,0,0,.19.22,21.54,21.54,0,0,0,9.07,5.08,23.32,23.32,0,0,0,1,11H254.86a24,24,0,0,0-3.53-12.71,2.14,2.14,0,0,0-.21-.28,25.42,25.42,0,0,0-20.26-28.33c-.67-.13-1.37-.24-2.06-.32h-.28A55.52,55.52,0,0,0,212,142.32c.08-.36.15-.71.23-1l.27-.09C219.73,138,224,132.7,225,125.73A22.9,22.9,0,0,0,221,109.87a2.07,2.07,0,0,0,0-.22c.74-7.44-.38-13.94-3.33-19.3a23.05,23.05,0,0,0-10.27-9.82l-.06,0c-1.18-4-6.28-7-11.73-6.9-4.3.12-9,2.13-10.75,5.43-6.54,2.36-16.69,8.45-19.76,23.86a20.49,20.49,0,0,0-2.8,30.58,97.72,97.72,0,0,0-18.84,2l-.24.06a25.76,25.76,0,0,0-21-4.12,2.15,2.15,0,0,0-.76.37,38,38,0,0,0-6.44-1.31,2.12,2.12,0,0,0-.43,0,21.07,21.07,0,0,0-5.19-8.71c-.12-.12-.4-.34-.4-.36l0,0a50.56,50.56,0,0,0-1.33-6,17.73,17.73,0,0,0-4.89-8.1,19.28,19.28,0,0,0-5.56-3.85,14,14,0,0,0,.56-1.86,4.2,4.2,0,0,0,.08-.47c0-.07.78-7.52,1.67-11.94l0-.16C102,73.86,102,73.64,102.05,73.47v-.09a4.89,4.89,0,0,0-1.33-3.73,6.59,6.59,0,0,0-4.87-2,7.76,7.76,0,0,0-6.64,3.8,20.71,20.71,0,0,0-2,4.55c-2.52-4.88-5.82-11.31-8.19-16l-.13-.24a6.31,6.31,0,0,0-5.33-3,6.65,6.65,0,0,0-2.34.43,6.25,6.25,0,0,0-4.1-1.51,7.16,7.16,0,0,0-2.28.39,6.16,6.16,0,0,0-4.21,6.12,6,6,0,0,0-3.91,4.56,7.85,7.85,0,0,0,.16,3.32c0,.09.05.23.12.44l-.19.28c-1.49,2.34-2.26,6.65,3.35,20.88\"/><path class=\"cls-3\" d=\"M250.57,195h-5.29a25.75,25.75,0,0,0,4.12-6.81,19.49,19.49,0,0,1,1.16,6.81\"/><path class=\"cls-3\" d=\"M163.51,137.8a13.53,13.53,0,0,1,3.12.59c2,.75,5.88,4.5,8,4.83.37,0,1.34-.19.29-.94-.29-.21-2.74-2.39-1.83-3.52l0,0a1.1,1.1,0,0,1,1.2-.46c3.07.76,5.63,1.2,6.51,1.33.54.08.93.09,1.15-.1s.06-.32-.54-.49c-4.74-1.27-10-3.31-13.62-6.06a17,17,0,0,1-6.76-15.62,16.39,16.39,0,0,1,6.37-10.93,18.44,18.44,0,0,1,4.31-2c1.72-.62-1.1-1.07-1.3-1.11-.72-.12-.76-.86-.17-3.12a25.31,25.31,0,0,1,16.56-17.22,31.89,31.89,0,0,1,3.77-.95c1.66-.25,1-1-.86-1.22,0,0-.64,0-.33-.45a4.57,4.57,0,0,1,.95-.83,11,11,0,0,1,5.45-1.58c3.87-.1,7.21,2.06,7.6,4.05,0,0,.14.4-.33.42-.74,0-1.34.34-.32.85.24.12,1.27.43,2.72,1.1l.21.11c2.92,1.36,12,6.88,11.34,22.5h0c0,.47-.06.94-.09,1.4s-.09.86-.14,1.29c-.85-.1-1.23.26-.62.88a18.66,18.66,0,0,1,2.17,2.79,19.06,19.06,0,0,1,2.52,12,14.76,14.76,0,0,1-7.63,11,36.56,36.56,0,0,1-9.58,3.65c-.91.21-.48,1.39,3.74,1.33.36,0,1.13.08,1.35.5.49.91-.35,2.69-2.19,3.77-1.58.93-.32,1.13,1.88.47a7.76,7.76,0,0,1,2.55.67,50.18,50.18,0,0,1,19.33,15.34c4.68,6.72,6.38,12,4.91,15.33s-5.65,3.82-5.68,3.82h-.07c-16.34,2.54-44.69-1.94-64.24-7.7a116.59,116.59,0,0,1-13.12-4.81,27.41,27.41,0,0,0-4.44-29.15l-.29-.31a92.63,92.63,0,0,1,16.11-1.32\"/><path class=\"cls-3\" d=\"M243.49,166.9a21.11,21.11,0,0,1-3.78,27.77c.1-3.87-.58-8.38-3.43-12a9.74,9.74,0,0,0,2.89-3.68c2.16-4.84.37-11.43-5.32-19.6l0-.05-.37-.48a21,21,0,0,1,10.05,8\"/><path class=\"cls-3\" d=\"M144.47,142.28c6.53,7.36,7.63,18.56,2.61,26.64-5.62,9.06-15.7,13.54-25.08,11.15a19.85,19.85,0,0,1-3.83-1.4,23.52,23.52,0,0,0,2.64-.55c9.23-2.5,16.12-11,17.15-21.19a24.54,24.54,0,0,0-5-17.65,21.18,21.18,0,0,0-4.65-4.33,22,22,0,0,1,16.15,7.33\"/><path class=\"cls-3\" d=\"M129.61,142a20.21,20.21,0,0,1,4.07,14.54c-.85,8.41-6.48,15.43-14,17.47a20.54,20.54,0,0,1-16.58-2.53A22.89,22.89,0,0,0,124,155.76a21.7,21.7,0,0,0-.28-14.1,20.72,20.72,0,0,0-3.2-5.68,18.06,18.06,0,0,1,9,6\"/><path class=\"cls-3\" d=\"M115.26,142.22a25.46,25.46,0,0,0,.44-5.21A17,17,0,0,1,120,154.45c-2.8,8.71-12.08,14.24-20.68,12.32a18.86,18.86,0,0,1-10.43-6.41,22.36,22.36,0,0,0,4.72.51,22,22,0,0,0,8.81-1.84,22.66,22.66,0,0,0,12.89-16.81\"/><path class=\"cls-3\" d=\"M108.83,127.88s0,0,0,0A19.27,19.27,0,0,1,111,141.41a17.86,17.86,0,0,1-29,11.19,18.83,18.83,0,0,1-7.66-13.14v0c.44.39.9.75,1.37,1.09a20.31,20.31,0,0,0,12,3.72,21.64,21.64,0,0,0,5.69-.72c7.86-2.22,11.71-6.94,13.56-10.51a20.61,20.61,0,0,0,1.84-5.13\"/><path class=\"cls-3\" d=\"M60.48,73l.17-.12a1.41,1.41,0,0,1,.52-.3l.19,0,.57,0a2,2,0,0,1,.4.1c1.24.45,2.15,2,2.44,4.21a25.27,25.27,0,0,0,3.9,10.6.93.93,0,1,0,1.52-1.09,23.69,23.69,0,0,1-3.56-9.76c-.39-2.93-1.72-5-3.65-5.72a3.74,3.74,0,0,0-1.41-.23A10.81,10.81,0,0,1,61,69.14c-.19-.8-.55-2.39,1.23-3l.34-.1h.18c1.29-.16,3,.43,4.67,6.46a46.29,46.29,0,0,0,5.25,11.17.93.93,0,0,0,1.56-1,45.17,45.17,0,0,1-5-10.65c-.73-2.6-1.76-5.43-3.51-6.88-.25-.64-.53-1.35-.6-1.58-.3-.89-.61-2.87,1.09-3.43a3,3,0,0,1,.94-.17,2.71,2.71,0,0,1,2.37,2c0,.12.11.25.17.39l7.67,18.32a.71.71,0,0,0,.24.33.86.86,0,0,0,1.36-1L71.49,62.24a1.64,1.64,0,0,1,.85-.88A2.71,2.71,0,0,1,73.56,61a2.07,2.07,0,0,1,1.69.94S85.16,81.42,87,84.78a19,19,0,0,0-1.45,2.82c-.13.5.2.95.44.48a28.9,28.9,0,0,1,2-2.57l0,0h0a.28.28,0,0,0,.07-.11c.47-.83,1.92-4.7,2.5-5.92a20.61,20.61,0,0,1,2.15-5.73,3.58,3.58,0,0,1,3.06-1.81c1.12,0,2,.57,2,1.15,0,.26-2.43,15.29-2.43,15.29-.63,3.14-1.19,7.64-1.5,10.25a12.67,12.67,0,0,1-.21,1.89l0,.2s0,.14-.09.37a19.58,19.58,0,0,1-1.4,4l.78,3.58h0c.31,1.51.65,3.13.78,3.62.57,2-.16,3.22.21,3.63.52.57,1.78-2.14,2.11-3.54a14.74,14.74,0,0,0-.53-5,15,15,0,0,1,4.22,2.95,13.47,13.47,0,0,1,3.82,6.28A37.26,37.26,0,0,1,105,123.8c.05,1.93-.61,12.18-12.73,15.59a17.18,17.18,0,0,1-4.5.56A16,16,0,0,1,78.27,137c-5.86-4.17-8.15-13.28-7-18.1a17.24,17.24,0,0,1,2.31-5.29,8.29,8.29,0,0,0,1.72.8l.35,1.66c0,.2,1,4.83,2.78,6.24a5.89,5.89,0,0,0,3.29.89c.53,0,1.8-.06,2-.61a.5.5,0,0,0-.14-.56,2.49,2.49,0,0,0-.56-.35c-.86-.47-2.47-1.33-2.81-2.91-.19-.89-.93-4-1.36-5.85,1.8-1.43,2-3-.36-2.51a4.6,4.6,0,0,1-3.75-1.17C70,105.11,65.08,92.4,64.09,90.15c-4-10.2-4.86-15.67-3.61-17.2\"/><path class=\"cls-3\" d=\"M124.42,184.86a25.13,25.13,0,0,0,2.67.15c8.82,0,17.42-4.65,22.89-12.67A118,118,0,0,0,164,177.51a230,230,0,0,0,34.65,7.2,158.68,158.68,0,0,0,19.83,1.4,76.86,76.86,0,0,0,11.61-.78,12.92,12.92,0,0,0,2.25-.55c2.65,2.79,3.17,6.83,3,10.25H125.85a17.62,17.62,0,0,1-1.42-10.18\"/><path d=\"M182.83,117.2c-.1-.37-.57-.37-.73-.37a4.14,4.14,0,0,0-1.36.28,3.08,3.08,0,0,0-1.92,2.53.44.44,0,0,0,.13.31.53.53,0,0,0,.4.16h0a.36.36,0,0,0,.35-.36,1.52,1.52,0,0,1,.43-.87,3.82,3.82,0,0,1,2.17-1c.25-.06.6-.25.5-.62\"/><path d=\"M199.92,126.06a9.78,9.78,0,0,1-3.73.34,10.54,10.54,0,0,1-3.59-.91,11.59,11.59,0,0,1-3.24-2.42,40.63,40.63,0,0,0,13.77,1.19,10.08,10.08,0,0,1-3.21,1.8m9.75-6c-.46-.05-.58.34-.4.49a1.24,1.24,0,0,1,.18.19L209,121a15.58,15.58,0,0,1-3.26,1.08,28,28,0,0,1-8.39.45,44.42,44.42,0,0,1-13.45-3.19l-1.13-.5c-.19-.08-.37-.2-.56-.27h0a.93.93,0,0,0-1.24.82,1,1,0,0,0,.67,1,27.84,27.84,0,0,0,3.58,1.47,9.13,9.13,0,0,1,2.62,2.23,14.87,14.87,0,0,0,3.23,2.62,12.28,12.28,0,0,0,7.78,1.37,10.11,10.11,0,0,0,3.79-1.41,24.06,24.06,0,0,0,2.37-1.78,11.82,11.82,0,0,1,1.44-1c.3-.17,2.4-1,3.51-1.65,0,.39,0,.73.24.78s.55-.49.65-.94a2,2,0,0,0-.11-1.17,1.52,1.52,0,0,0-1.05-.76\"/><path d=\"M184.28,104.41c.16-1.74,1.17-7.2,5.53-6.76,3.32.33,4.21,2.78,4.46,4.92,0,.09,0,.19,0,.29a10,10,0,0,1-.71,4.94,9.39,9.39,0,0,1-.77,1.53,3.91,3.91,0,0,1-2.65,2.1h-.25a6.42,6.42,0,0,0,2.85-5.15c.29-3.22-1.24-6-3.43-6.18a3.41,3.41,0,0,0-2.82,1.33,1.95,1.95,0,0,1,.11,3.75,1.54,1.54,0,0,1-1.44-1.25,8.66,8.66,0,0,0-.32,1.66,7,7,0,0,0,1.24,4.9,2.88,2.88,0,0,1-.36-.36,7.37,7.37,0,0,1-1.38-3.63,10.61,10.61,0,0,1-.07-2.11m.51,6.49a4.15,4.15,0,0,0,1.8,1.27,7,7,0,0,0,1.91.39,16,16,0,0,0,1.72.08c2.68-.11,5.21-4.23,5.29-8.26.08-3.67-.41-6.49-3.06-8.14a4.79,4.79,0,0,0-.87-.42,6,6,0,0,0-3.59-.16,5.39,5.39,0,0,0-3.16,2.58,13.38,13.38,0,0,0-1.49,4.07,12.52,12.52,0,0,0-.19,4.37,8.6,8.6,0,0,0,1.65,4.23\"/><path d=\"M211.3,108a10.76,10.76,0,0,1-.6,2,7.39,7.39,0,0,1-2.2,3.13,2.81,2.81,0,0,1-1.22.5,6.59,6.59,0,0,0,2.68-5.08c.29-3.22-1.2-6-3.33-6.17a3.33,3.33,0,0,0-2.77,1.34,1.69,1.69,0,0,1,1.44,1.79,1.72,1.72,0,0,1-1.34,2,1.5,1.5,0,0,1-1.41-1.24,8.64,8.64,0,0,0-.31,1.66,6.79,6.79,0,0,0,1.46,5.21,4.38,4.38,0,0,1-1.6-2.52,9,9,0,0,1-.33-1.66,10.12,10.12,0,0,1,.58-4.92l.09-.28c.77-2,2.22-4.11,5.41-3.6,4.19.68,3.75,6.16,3.46,7.87m1.05-6.06a5.31,5.31,0,0,0-2.3-3.27,5.73,5.73,0,0,0-3.41-.75,4.76,4.76,0,0,0-.91.19c-2.9.92-4.06,3.49-4.92,7-.94,3.88.38,8.46,2.85,9.24a14.5,14.5,0,0,0,1.63.35,6.57,6.57,0,0,0,1.88.11,4,4,0,0,0,2-.76,8.62,8.62,0,0,0,2.61-3.65,12.66,12.66,0,0,0,.92-4.23,13.52,13.52,0,0,0-.36-4.27\"/></svg>')}.logo-commercial-white{background-image:url('data:image/svg+xml,<?xml version=\"1.0\" encoding=\"utf-8\"?>%0A<!-- Generator: Adobe Illustrator 22.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->%0A<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"%0A%09 viewBox=\"0 0 897.1 264.7\" style=\"enable-background:new 0 0 897.1 264.7;\" xml:space=\"preserve\">%0A<style type=\"text/css\">%0A%09.st0{fill:%23FCE500;}%0A%09.st1{fill:%23FFFFFF;}%0A<\\/style>%0A<path d=\"M251.3,182.3c-0.1-0.1-0.1-0.2-0.2-0.3c0.8-6.2-0.6-12.3-4.1-17.5c-3.8-5.6-9.5-9.5-16.2-10.8c-0.7-0.1-1.4-0.2-2.1-0.3%0A%09c-0.1,0-0.2,0-0.3,0c-6.8-6.6-14-10-16.6-11.1c0.1-0.4,0.2-0.7,0.2-1c0.1,0,0.2-0.1,0.3-0.1c7.3-3.2,11.6-8.5,12.5-15.5%0A%09c0.7-5.5-0.8-11.6-3.9-15.9c0-0.1,0-0.1,0-0.2c0.7-7.4-0.4-13.9-3.3-19.3c-2.4-4.4-6.1-7.9-10.3-9.8c0,0,0,0-0.1,0%0A%09c-1.2-4-6.3-7-11.7-6.9c-4.3,0.1-9,2.1-10.7,5.4c-6.5,2.4-16.7,8.5-19.8,23.9c-4.5,3.4-7.5,8.4-8.2,13.9c-0.8,6.1,1.3,12.2,5.4,16.7%0A%09c-4.2,0-10.9,0.4-18.8,2c-0.1,0-0.2,0-0.2,0.1c-6.1-4.3-14-6-21-4.1c-0.3,0.1-0.5,0.2-0.8,0.4c-2-0.6-4.1-1-6.4-1.3%0A%09c-0.1,0-0.3,0-0.4,0c-1-3.3-2.8-6.3-5.2-8.7c-0.1-0.1-0.4-0.3-0.4-0.4l0,0c-0.4-2.4-1-5-1.3-6c-0.7-2.4-1.8-5-4.9-8.1%0A%09c-2-2-4.1-3.2-5.6-3.9c0.3-0.8,0.5-1.5,0.6-1.9c0-0.2,0.1-0.3,0.1-0.5c0-0.1,0.8-7.5,1.7-11.9c0-0.1,0-0.1,0-0.2%0A%09c2.4-15.2,2.4-15.4,2.5-15.5v-0.1c0.1-1.4-0.4-2.7-1.3-3.7c-1.2-1.3-2.9-2-4.9-2c-2.7,0-5.1,1.4-6.6,3.8c-0.9,1.4-1.5,3.1-2,4.6%0A%09c-2.5-4.9-5.8-11.3-8.2-16c0-0.1-0.1-0.2-0.1-0.2c-0.8-1.4-2.7-3-5.3-3c-0.8,0-1.6,0.1-2.3,0.4c-1.1-1-2.6-1.5-4.1-1.5%0A%09c-0.8,0-1.5,0.1-2.3,0.4c-2.7,0.9-4.2,3.3-4.2,6.1c-2.1,0.8-3.5,2.4-3.9,4.6c-0.3,1.5,0,2.7,0.2,3.3c0,0.1,0.1,0.2,0.1,0.4%0A%09c-0.1,0.1-0.1,0.2-0.2,0.3c-1.5,2.3-2.3,6.7,3.4,20.9c0,0,0,0.1,0.1,0.1c0.1,0.2,0.2,0.6,0.4,1c1,2.4,3.1,7.4,5.6,11.9%0A%09c1.4,2.5,2.8,4.5,4.1,6.1c-1,1.5-2.5,4-3.2,7.2c-0.8,3.3-0.4,7.6,1,11.7c0.6,1.7,1.3,3.3,2.2,4.8l0,0l0,0c0,0.1-0.1,0.3-0.1,0.4%0A%09c-1,8.1,2.4,16,9.3,21.2c1.1,0.8,2.2,1.5,3.4,2.2c1,3.1,3.1,5.9,6,8.3c2,1.6,4.3,2.9,6.8,3.7c0,0,0,0,0,0.1%0A%09c2.6,3.7,6.5,6.3,11.4,7.7c1.2,0.3,2.5,0.6,3.8,0.8c0.1,0.1,0.1,0.1,0.2,0.2c2.4,2.3,5.5,4.1,9.1,5.1c-0.6,4.7,0,8.3,1,11h133.7%0A%09C254.9,190.6,253.7,186.3,251.3,182.3z\"/>%0A<polygon class=\"st0\" points=\"720.7,195 89.1,195 84,209 715.6,209 \"/>%0A<path class=\"st1\" d=\"M460.7,112c-16.3,3.3-38.5,15.4-38.3,37.3c0.1,12.6,15.4,19.7,32.9,19.2c9.8-0.3,19.2-2.1,20.4-2.3l6.5-16.9%0A%09c-8.6,1.4-16.9,3.4-23.3,0.8c-11.7-4.7-4.5-16.8,3.8-20.6c3.6-1.7,8.6-3.2,14.5-3.1c2.5,0,8.5,0.2,10.8,5.5l8.2-19.6%0A%09C482.2,108.8,468.1,110.5,460.7,112z M549.4,111.4l-7.4,20.1h-13.6l7.4-20.1H510l-20.5,55.7h25.7l7-18.9h13.6l-7,18.9h25.7%0A%09l20.5-55.7C575,111.4,549.4,111.4,549.4,111.4z M396.2,111.4l-20.5,55.7h27l20.5-55.7C423.2,111.4,396.2,111.4,396.2,111.4z%0A%09 M342.5,111.4l-19.7,29.9c0,0,1.3-15.7,1.6-19.4c0.2-2.9-0.1-10.5-7.1-10.5H286l-20.5,55.7H290l14.9-40.3l-3.1,40.3h21.7l26.7-39.6%0A%09l-14.6,39.6h24.6l20.5-55.7C380.7,111.4,342.5,111.4,342.5,111.4z M818.8,111.4l-14.1,38.2c0.2-3.9,1-19.1,1.4-27.8%0A%09c0.2-3.6-0.6-6.4-2.3-8.2c-2.1-2.2-4.9-2.2-4.9-2.2h-31.4L747,167.2h22.8l14.5-39.5l-1.7,39.5h38.2l20.5-55.7L818.8,111.4%0A%09L818.8,111.4z M724.5,111.4L704,167.2h27l20.5-55.7L724.5,111.4L724.5,111.4z M610.3,126h30.8l5.4-14.6h-56.3l-20.5,55.7h56.9%0A%09l5.5-15h-31.4l2.3-6.2h29.3l5-13.7H608L610.3,126z M687.7,111.4h-26.3l-20.5,55.7h52.7l6.8-18.5H674L687.7,111.4z\"/>%0A<path class=\"st1\" d=\"M250.6,195h-5.3c1.7-2,3.1-4.3,4.1-6.8C250.2,190.4,250.6,192.7,250.6,195\"/>%0A<path class=\"st1\" d=\"M163.5,137.8c0,0,2,0.1,3.1,0.6c2,0.8,5.9,4.5,8,4.8c0.4,0,1.3-0.2,0.3-0.9c-0.3-0.2-2.7-2.4-1.8-3.5l0,0%0A%09c0.3-0.5,0.7-0.6,1.2-0.5c3.1,0.8,5.6,1.2,6.5,1.3c0.5,0.1,0.9,0.1,1.2-0.1c0.2-0.2,0.1-0.3-0.5-0.5c-4.7-1.3-10-3.3-13.6-6.1%0A%09c-4.9-3.8-7.5-9.7-6.8-15.6c0.6-4.3,2.8-8.2,6.4-10.9c1.4-1,3.7-1.8,4.3-2c1.7-0.6-1.1-1.1-1.3-1.1c-0.7-0.1-0.8-0.9-0.2-3.1%0A%09c3.3-10.5,10.5-15.2,16.6-17.2c1.1-0.3,2.7-0.8,3.8-0.9c1.7-0.3,1-1-0.9-1.2c0,0-0.6,0-0.3-0.5c0.1-0.1,0.4-0.5,0.9-0.8%0A%09c1.4-0.9,3.3-1.5,5.5-1.6c3.9-0.1,7.2,2.1,7.6,4.1c0,0,0.1,0.4-0.3,0.4c-0.7,0-1.3,0.3-0.3,0.8c0.2,0.1,1.3,0.4,2.7,1.1%0A%09c0.1,0,0.1,0.1,0.2,0.1c2.9,1.4,12,6.9,11.3,22.5l0,0c0,0.5-0.1,0.9-0.1,1.4c0,0.4-0.1,0.9-0.1,1.3c-0.9-0.1-1.2,0.3-0.6,0.9%0A%09c0.4,0.4,1.5,1.8,2.2,2.8c2,3.4,3.1,7.8,2.5,12c-0.7,5.6-4.2,9-7.6,11c-1.5,0.9-5.1,2.6-9.6,3.6c-0.9,0.2-0.5,1.4,3.7,1.3%0A%09c0.4,0,1.1,0.1,1.3,0.5c0.5,0.9-0.4,2.7-2.2,3.8c-1.6,0.9-0.3,1.1,1.9,0.5c0.6-0.1,2.3,0.6,2.5,0.7c3.6,1.6,12.6,6.2,19.3,15.3%0A%09c4.7,6.7,6.4,12,4.9,15.3c-1.4,3.2-5.7,3.8-5.7,3.8s0,0-0.1,0c-16.3,2.5-44.7-1.9-64.2-7.7c-3.5-1-8.7-2.9-13.1-4.8%0A%09c4.3-9.3,2.6-21.2-4.4-29.2c-0.1-0.1-0.2-0.2-0.3-0.3C154.4,137.9,160.2,137.8,163.5,137.8\"/>%0A<path class=\"st1\" d=\"M243.5,166.9c3.1,4.7,4.3,10.3,3.2,15.9c-0.9,4.7-3.4,8.9-7,11.9c0.1-3.9-0.6-8.4-3.4-12%0A%09c1.1-0.9,2.2-2.1,2.9-3.7c2.2-4.8,0.4-11.4-5.3-19.6c0,0,0,0,0-0.1c-0.1-0.2-0.2-0.3-0.4-0.5C237.5,160.4,241,163.2,243.5,166.9\"/>%0A<path class=\"st1\" d=\"M144.5,142.3c6.5,7.4,7.6,18.6,2.6,26.6c-5.6,9.1-15.7,13.5-25.1,11.2c-1.4-0.3-2.6-0.8-3.8-1.4%0A%09c0.9-0.1,1.8-0.3,2.6-0.6c9.2-2.5,16.1-11,17.2-21.2c0.6-6.4-1.2-12.9-5-17.6c-1.3-1.7-2.9-3.1-4.7-4.3%0A%09C134.3,135,140.4,137.6,144.5,142.3\"/>%0A<path class=\"st1\" d=\"M129.6,142c3.1,3.9,4.6,9.2,4.1,14.5c-0.9,8.4-6.5,15.4-14,17.5c-6.3,1.7-12.4,0.2-16.6-2.5%0A%09c9.2-0.2,18-6.5,20.9-15.7c1.5-4.6,1.4-9.6-0.3-14.1c-0.8-2.1-1.9-4-3.2-5.7C124.5,137.2,127.4,139.2,129.6,142\"/>%0A<path class=\"st1\" d=\"M115.3,142.2c0.3-1.7,0.5-3.5,0.4-5.2c4.5,4.3,6.3,11.1,4.3,17.4c-2.8,8.7-12.1,14.2-20.7,12.3%0A%09c-3.6-0.8-7.9-3.1-10.4-6.4c1.6,0.3,3.1,0.5,4.7,0.5c3,0,6-0.6,8.8-1.8C109,156.1,113.8,149.9,115.3,142.2\"/>%0A<path class=\"st1\" d=\"M108.8,127.9L108.8,127.9c2.3,3.8,3.1,8.6,2.2,13.5c-1.2,6.3-5.1,11.4-10.4,13.7c-6.1,2.6-13,1.7-18.6-2.5%0A%09c-4.4-3.3-7.1-8.1-7.7-13.1l0,0c0.4,0.4,0.9,0.8,1.4,1.1c3.4,2.4,7.5,3.7,12,3.7c3,0,5.3-0.6,5.7-0.7c7.9-2.2,11.7-6.9,13.6-10.5%0A%09C107.9,131.2,108.5,129.4,108.8,127.9\"/>%0A<path class=\"st1\" d=\"M60.5,73c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.3-0.2,0.5-0.3c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0,0.6,0%0A%09c0.1,0,0.3,0,0.4,0.1c1.2,0.5,2.2,2,2.4,4.2c0.8,6.3,3.8,10.4,3.9,10.6c0.2,0.3,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.5-0.2%0A%09c0.4-0.3,0.5-0.9,0.2-1.3c0,0-2.8-3.9-3.6-9.8c-0.4-2.9-1.7-5-3.7-5.7c-0.5-0.2-0.9-0.2-1.4-0.2c-0.3-0.6-0.5-1.1-0.6-1.4%0A%09c-0.2-0.8-0.5-2.4,1.2-3c0.1,0,0.2-0.1,0.3-0.1s0.1,0,0.2,0c1.3-0.2,3,0.4,4.7,6.5c1.6,5.5,5.1,10.9,5.2,11.2%0A%09c0.2,0.3,0.5,0.4,0.8,0.4c0.2,0,0.4,0,0.5-0.2c0.4-0.3,0.5-0.9,0.3-1.3c0-0.1-3.5-5.4-5-10.6c-0.7-2.6-1.8-5.4-3.5-6.9%0A%09c-0.2-0.6-0.5-1.4-0.6-1.6c-0.3-0.9-0.6-2.9,1.1-3.4c0.3-0.1,0.7-0.2,0.9-0.2c1.3,0,2,1.2,2.4,2c0,0.1,0.1,0.3,0.2,0.4l7.7,18.3%0A%09c0,0.1,0.1,0.3,0.2,0.3c0.2,0.2,0.6,0.3,0.9,0.2c0.4-0.2,0.7-0.7,0.5-1.1l-7.5-17.8c0.1-0.3,0.4-0.7,0.8-0.9%0A%09c0.5-0.2,0.9-0.3,1.2-0.3c1.1,0,1.7,0.9,1.7,0.9S85.2,81.4,87,84.8c-0.8,1.3-1.4,2.5-1.5,2.8c-0.1,0.5,0.2,0.9,0.4,0.5%0A%09c0.6-0.8,1.4-1.8,2-2.6l0,0l0,0l0.1-0.1c0.5-0.8,1.9-4.7,2.5-5.9c0.4-1.8,1.2-4.2,2.2-5.7c0.8-1.3,2-1.8,3.1-1.8s2,0.6,2,1.1%0A%09c0,0.3-2.4,15.3-2.4,15.3c-0.6,3.1-1.2,7.6-1.5,10.2c0,0.6-0.1,1.3-0.2,1.9c0,0.1,0,0.2,0,0.2s0,0.1-0.1,0.4c-0.5,2.3-1.4,4-1.4,4%0A%09l0.8,3.6l0,0c0.3,1.5,0.6,3.1,0.8,3.6c0.6,2-0.2,3.2,0.2,3.6c0.5,0.6,1.8-2.1,2.1-3.5c0.3-1.1-0.2-3.4-0.5-5%0A%09c1.1,0.5,2.7,1.4,4.2,2.9c2.6,2.6,3.3,4.6,3.8,6.3c0.5,1.7,1.3,5.2,1.4,7.2c0.1,1.9-0.6,12.2-12.7,15.6c0,0-1.9,0.6-4.5,0.6%0A%09c-2.7,0-6.2-0.6-9.5-2.9c-5.9-4.2-8.2-13.3-7-18.1c0.5-2.3,1.5-4.1,2.3-5.3c0.6,0.3,1.1,0.6,1.7,0.8l0.4,1.7c0,0.2,1,4.8,2.8,6.2%0A%09c1.1,0.8,2.8,0.9,3.3,0.9s1.8-0.1,2-0.6c0-0.1,0.1-0.3-0.1-0.6c-0.1-0.1-0.2-0.2-0.6-0.4c-0.9-0.5-2.5-1.3-2.8-2.9%0A%09c-0.2-0.9-0.9-4-1.4-5.9c1.8-1.4,2-3-0.4-2.5c-1.4,0.3-2.7-0.4-3.8-1.2C70,105.1,65,92.4,64,90.1C60.1,79.9,59.2,74.5,60.5,73\"/>%0A<path class=\"st1\" d=\"M124.4,184.9c0.9,0.1,1.8,0.1,2.7,0.1c8.8,0,17.4-4.7,22.9-12.7c4.7,2.1,10.2,4.1,14.1,5.2%0A%09c10.8,3.2,23.1,5.7,34.7,7.2c7.3,0.9,14,1.4,19.8,1.4c4.4,0,8.3-0.3,11.6-0.8c0.2,0,1.1-0.2,2.2-0.6c2.6,2.8,3.2,6.8,3,10.2H125.8%0A%09C124.8,193,123.9,189.7,124.4,184.9\"/>%0A<path d=\"M184.8,110.9c0.5,0.6,1.1,1,1.8,1.3c0.6,0.2,1.2,0.3,1.9,0.4c0,0,1.1,0.1,1.7,0.1c2.7-0.1,5.2-4.2,5.3-8.3%0A%09c0.1-3.7-0.4-6.5-3.1-8.1c-0.3-0.2-0.6-0.3-0.9-0.4c-1.1-0.4-2.5-0.5-3.6-0.2c-1.4,0.4-2.4,1.4-3.2,2.6c-0.7,1.2-1.2,2.7-1.5,4.1%0A%09s-0.4,2.9-0.2,4.4C183.3,108.1,183.8,109.7,184.8,110.9z M184.3,104.4c0.2-1.7,1.2-7.2,5.5-6.8c3.3,0.3,4.2,2.8,4.5,4.9%0A%09c0,0.1,0,0.2,0,0.3c0.2,2.1-0.2,3.6-0.7,4.9c-0.2,0.5-0.5,1.1-0.8,1.5c-0.8,1.3-1.8,2.1-2.6,2.1c-0.1,0-0.2,0-0.2,0%0A%09c1.5-0.8,2.6-2.8,2.8-5.2c0.3-3.2-1.2-6-3.4-6.2c-1-0.1-2,0.4-2.8,1.3c0.8,0,1.4,0.8,1.5,1.8c0,1-0.6,1.9-1.4,2%0A%09c-0.7,0-1.2-0.5-1.4-1.2c-0.2,0.5-0.3,1.1-0.3,1.7c-0.2,2,0.3,3.8,1.2,4.9c-0.1-0.1-0.3-0.2-0.4-0.4c-0.7-0.8-1.2-2.1-1.4-3.6%0A%09C184.3,105.8,184.2,105.1,184.3,104.4z M209.7,120.1c-0.5-0.1-0.6,0.3-0.4,0.5c0.1,0,0.1,0.1,0.2,0.2c-0.2,0.1-0.3,0.2-0.5,0.3%0A%09c-1,0.5-2.1,0.8-3.3,1.1c-2.7,0.6-5.6,0.7-8.4,0.4c-4.6-0.4-9.2-1.4-13.5-3.2c-0.4-0.2-0.8-0.3-1.1-0.5c-0.2-0.1-0.4-0.2-0.6-0.3%0A%09l0,0c-0.6-0.2-1.2,0.2-1.2,0.8c0,0.5,0.3,0.8,0.7,1c1.1,0.6,2.4,1,3.6,1.5c1.1,0.5,1.8,1.4,2.6,2.2c1,1,2,1.9,3.2,2.6%0A%09c2.3,1.3,5.2,1.8,7.8,1.4c1.4-0.2,2.6-0.7,3.8-1.4c0.8-0.5,1.6-1.2,2.4-1.8c0.5-0.4,0.9-0.7,1.4-1c0.3-0.2,2.4-1,3.5-1.6%0A%09c0,0.4,0,0.7,0.2,0.8c0.3,0.1,0.5-0.5,0.6-0.9c0.1-0.5,0-0.9-0.1-1.2C210.6,120.6,210.1,120.1,209.7,120.1z M199.9,126.1%0A%09c-1.2,0.4-2.5,0.4-3.7,0.3s-2.5-0.4-3.6-0.9c-1.2-0.6-2.3-1.5-3.2-2.4c4.5,1.1,9.2,1.7,13.8,1.2C202.2,125,201.1,125.7,199.9,126.1z%0A%09 M182.8,117.2c-0.1-0.4-0.6-0.4-0.7-0.4c-0.4,0-1,0.1-1.4,0.3c-1.1,0.4-2,1.7-1.9,2.5c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.2,0.4,0.2%0A%09l0,0l0,0l0,0c0.2,0,0.3-0.2,0.3-0.4c0-0.2,0.1-0.6,0.4-0.9c0.3-0.3,0.8-0.8,2.2-1C182.6,117.8,182.9,117.6,182.8,117.2z%0A%09 M212.4,101.9c-0.4-1.3-1.1-2.6-2.3-3.3c-1-0.6-2.2-0.9-3.4-0.7c-0.3,0-0.6,0.1-0.9,0.2c-2.9,0.9-4.1,3.5-4.9,7%0A%09c-0.9,3.9,0.4,8.5,2.9,9.2c0.6,0.2,1.6,0.4,1.6,0.4c0.6,0.1,1.3,0.2,1.9,0.1c0.7-0.1,1.4-0.3,2-0.8c1.2-0.9,2-2.3,2.6-3.6%0A%09c0.6-1.4,0.8-2.8,0.9-4.2C212.8,104.8,212.7,103.3,212.4,101.9z M211.3,108c-0.1,0.7-0.3,1.4-0.6,2c-0.6,1.4-1.4,2.5-2.2,3.1%0A%09c-0.4,0.3-0.8,0.4-1.2,0.5c1.4-0.8,2.5-2.8,2.7-5.1c0.3-3.2-1.2-6-3.3-6.2c-1-0.1-2,0.4-2.8,1.3c0.8,0,1.4,0.8,1.4,1.8%0A%09s-0.6,1.9-1.3,2c-0.6,0-1.2-0.5-1.4-1.2c-0.2,0.5-0.3,1.1-0.3,1.7c-0.2,2.2,0.4,4.1,1.5,5.2c-0.6-0.4-1.2-1.3-1.6-2.5%0A%09c-0.2-0.5-0.3-1.1-0.3-1.7c-0.1-1.4-0.2-2.9,0.6-4.9c0-0.1,0.1-0.2,0.1-0.3c0.8-2,2.2-4.1,5.4-3.6C212,100.8,211.6,106.3,211.3,108z%0A%09\"/>%0A</svg>%0A')}\n"], dependencies: [{ kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: LinkComponent, selector: "mic-link", inputs: ["id", "href", "target", "label", "ariaLabel", "color", "icon", "iconPosition", "rel", "routerLink", "disabled", "active", "titleNewWindow"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: LogoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-logo', template: "<mic-link [routerLink]=\"link\" [ariaLabel]=\"ariaLabel\" [target]=\"target\">\n  <div class=\"logo-{{ type }}\" [ngStyle]=\"{ width: width, height: height }\" aria-hidden=\"true\" alt=\"Michelin\"></div>\n</mic-link>\n", styles: [":host{height:100%}.logo,.logo-commercial-white,.logo-commercial,.logo-group,.logo-group-white{background-size:contain;background-position:center;background-repeat:no-repeat}@media screen and (max-width: 599px){.logo,.logo-commercial-white,.logo-commercial,.logo-group,.logo-group-white{margin-top:-8px}}.logo-group-white{background-image:url('data:image/svg+xml,<?xml version=\"1.0\" encoding=\"utf-8\"?>%0A<!-- Generator: Adobe Illustrator 22.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->%0A<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"%0A%09 viewBox=\"0 0 822.3 219.1\" style=\"enable-background:new 0 0 822.3 219.1;\" xml:space=\"preserve\">%0A<style type=\"text/css\">%0A%09.st0{fill:%23FFFFFF;}%0A<\\/style>%0A<path d=\"M243,166.9c0.3-0.1,0.6-0.2,0.9-0.3c0,0,0.5-0.2,0.7-0.2c3-1,9.7-4.5,12.2-9.5c5.1-1.9,8.8-4.5,11.1-7.6%0A%09c4.4-0.8,7.8-2.7,9.7-3.7c4.4-2.5,7.5-4.9,9.4-7.5c1.6-2.1,2.6-3.7,3.4-5.4c1.5-0.8,3.2-1.8,5.4-3.3c7.7-5.1,9.3-14.5,9.5-15.6%0A%09c0-0.2,0.1-0.5,0.1-0.7c0.4,0,0.8,0,1.2,0c7.7,0,17.8-4.8,23.2-7.5l0.1,0c0.8-0.4,1.6-0.8,1.9-0.9c1.8-0.8,5.5-2.8,9.3-5.3%0A%09c4.9-3.3,8.2-6.3,10-9.1c0.3-0.4,0.5-0.9,0.7-1.4l3.2-2c0.9-0.6,1.7-1.4,2.2-2.4c0.9-0.5,1.6-0.9,1.8-1.1c2.5-1.6,3.6-4.4,2.7-7.1%0A%09l0-0.1c-0.8-2.4-3-5.3-6.7-6.2c-1.3-2.8-4.1-4.4-7.2-4.4c-0.7,0-1.3,0.1-1.7,0.2c-0.2,0-1,0.2-7,1.7l-8.9,2.1%0A%09c0.8-2.2,0.7-4.6-0.3-6.6c-1.2-2.5-3.7-4.1-6.3-4.1c-0.9,0-1.8,0.2-2.6,0.6l-0.1,0c-0.3,0.2-1,0.5-16.9,10.8%0A%09c-0.2,0.1-0.4,0.3-0.6,0.4c-7.7,6.7-10.5,10.7-11.2,11.7c-0.4,0.5-1,1.5-1.6,2.8c-0.4-0.2-0.8-0.4-1.2-0.6c-3.2-1.4-6.5-2.1-9.9-2.1%0A%09c-6.1,0-10.4,2.4-11.5,3.1c-0.6,0.3-2.9,1.7-6.3,4.4c-1.4,1.1-2.6,2.3-3.7,3.7c-2.3,0.5-4.2,1.2-5.6,1.9c-1.8,0.9-3.5,2.3-5.4,3.8%0A%09l-0.1,0.1c-0.3,0.3-0.6,0.5-1,0.8c-0.8,0.6-2.9,2.3-4.9,5.1l-0.2,0c-0.3,0.1-2.8,0.6-6,2.1c-0.8,0.4-1.6,0.8-2.3,1.3%0A%09c-1.8,0.1-4.6,0.4-8.3,1.5l-0.2,0c-0.3-0.1-3.1-0.6-6.5-0.6c-1.5,0-2.9,0.1-4.1,0.3c-0.8,0.1-3.7,0.6-6.1,1.3%0A%09c-1.2,0.3-4.1,1.3-7.5,3.5c-7.3-1.7-14.6-2.2-19.2-2.4c4.4-5.9,6.5-12.7,5.8-18.5c-1.4-11-8.8-17.5-11.5-19.4%0A%09c-4.6-19.2-18-27.4-29-28.6c-2.2-2.5-6.3-4.1-11-4.1c-1.9,0-3.7,0.2-5.5,0.7c-5.9,1.6-10.6,6.1-11.5,11%0A%09c-5.9,4.9-15.1,15.9-12.5,35.6c-2.2,3-6.5,10.6-3.6,22.2c2,7.9,6.9,13.6,14.3,16.6c-5.7,2.8-10.7,6.1-14.9,10%0A%09c-0.3,0.2-0.5,0.5-0.7,0.7c-9.9,0.5-18.9,4.6-26,11.9c-5.1,5.2-8.6,11.2-10.8,16.5H243z\"/>%0A<path class=\"st0\" d=\"M264.1,143.6c0.2,0,0.4,0,0.6,0c4.2-0.1,7.5-1.9,9.9-3.3c2-1.1,5.3-3.2,7.3-5.5c-1,0.1-2.1,0.2-3.2,0.2%0A%09c-4.2,0-8.5-1.2-12.6-3.6c-5-3-8.9-7.6-11-13.2c-1.6-4.3-2.2-9.1-1.6-12.8c0.1-0.5,0.4-2,1-4c-1.5,0.8-3.4,2.4-5.3,3.9%0A%09c-3.1,2.4-12.8,12.6-4,27.5C250.2,140.6,257.8,143.6,264.1,143.6z M268.7,126.9c3.8,2.2,7.1,2.9,9.9,2.9c3.9,0,6.6-1.4,7.4-1.8%0A%09c1.3-0.6,2.8-1.3,6.3-3.7c5.7-3.8,6.8-11.4,6.8-11.4c0,0,0,0,0,0l-2,1.3c0,0-5.2,3.3-8,2.9c-2.6-0.4-5.8-4.3-4.4-4.3%0A%09c0.6,0,3.8,1.7,6.3,0.2c0.9-0.6,4.5-2.8,6.9-4.2c-0.7-2.9,0.1-4.4,2.3-2.2c1.5,1.5,6.6,1.4,7.7,1.4c0.1,0,0.2,0,0.3,0%0A%09c0.8-0.1,1.7-0.2,2.5-0.4c7.6-1.6,16.7-6.5,19-7.5c3.1-1.3,13.8-7.5,17-12.4c0.3-0.4,0-0.8,0-0.9c-0.2-0.3-1-1.1-2.3-1.2%0A%09c-1.3-0.1-2.9,0.6-4.4,2.1c-5.5,5.2-11.4,6.8-11.6,6.9c-0.1,0-0.2,0-0.3,0c-0.5,0-0.9-0.3-1.1-0.8c-0.2-0.6,0.2-1.2,0.8-1.4%0A%09c0.1,0,5.6-1.6,10.7-6.4c2.1-2,4.2-2.9,6.2-2.7c1.8,0.2,3,1.2,3.6,1.8c1.1-0.7,3.9-2.4,4-2.5c0.1,0,0.7-0.6,0-1.7c0,0,0,0,0,0%0A%09c-0.6-0.8-1.2-1.3-1.9-1.5c-1.6-0.4-4.1,0.5-7.3,2.6c-6,3.8-14.7,5.9-15.1,6c-0.1,0-0.2,0-0.3,0c-0.5,0-1-0.3-1.1-0.9%0A%09c-0.1-0.6,0.2-1.2,0.8-1.3c0.1,0,8.8-2.1,14.4-5.7c3.9-2.5,6.7-3.4,9-2.9c1.5,0.3,2.7,1.3,3.6,2.8c0,0,0,0.1,0,0.1%0A%09c0.6-0.3,1.3-0.7,1.8-1.1c0.5-0.3,0.7-0.6,0.5-1.1c-0.4-1.2-1.7-2.9-3.9-2.9c-0.4,0-0.8,0.1-1.3,0.2l-0.2,0.1%0A%09c-1.5,0.5-2.3,0.7-2.8,0.8l-21.3,6.3c-0.2,0.1-0.4,0.1-0.5,0c-0.4-0.1-0.7-0.4-0.9-0.8c-0.2-0.6,0.2-1.2,0.7-1.4l23.9-7.1%0A%09c0-0.1,0-0.1,0-0.2c-0.5-1.9-1.9-2.2-2.8-2.2c-0.3,0-0.5,0-0.6,0.1c-0.5,0.1-26.6,6.4-30.1,7.2c-0.6,0.2-3.9,1-6,1.9%0A%09c-0.6,0.3-0.7-0.4-0.1-0.8c0.5-0.4,3.6-2.2,6-3.1c0.5-0.2,1.2-0.7,1.7-1c1.7-1.3,3.9-3,5.8-5.5c2.3-3.1,0.5-5.4-0.9-5.4%0A%09c-0.2,0-0.3,0-0.4,0.1c-0.7,0.4-16.3,10.5-16.3,10.5c-2.8,2.4-4.9,4.5-6.4,6.1c0,0,0,0,0,0c-1.3,1.3-2.3,2.5-3.2,3.6%0A%09c-0.3,0.4-0.5,0.7-0.6,0.9c-1.5,2.1-2.1,3.6-2.1,3.6c-0.2,0.5-0.5,1.4-0.5,1.4s-5.6,3.3-6.8,3.9c-2.4,1.3-2.9,3-3.6,3%0A%09c-1,0,0.4-3.6,1.5-5.1c0.4-0.6,1.1-1.2,1.9-1.7c-2.7-1.2-5.2-1.6-7.3-1.6c-5.1,0-8.4,2.2-8.4,2.2s-2.1,1.2-5.7,4%0A%09c-5.4,4.1-6.4,11.1-6.4,11.1C257.7,110.9,259.6,121.5,268.7,126.9z M225,166.9c-1.3-0.4-2.7-0.9-4-1.5c-3.5-1.6-6.7-4-9.2-6.8%0A%09c-2.7-3-4.8-6.7-6.2-10.9c-1.3-4.1-1.8-8.6-1.4-12.8c0.4-4.3,1.9-8.5,4.3-12.2c1.6-2.6,3.7-4.8,6-6.7c-0.2,0-0.5,0.1-0.7,0.1%0A%09c0,0-3.1,0.4-5.3,1.1s-9.8,3.5-13.8,11.3c-4.1,7.8-3.6,14.6-2.7,19c0.9,4.4,3.6,10.2,6.4,12.9c2.2,2.3,4.7,4.7,8.7,6.4l-9.6,0%0A%09c-1.1-1-2-1.9-2.8-2.7c-3.8-3.9-6.8-10.8-7.7-15.6c-1.6-7.8-0.5-15.4,3.2-22.5c1.2-2.2,2.6-4.3,4.3-6.1c-8.3-1.5-16.2-1.6-18.8-1.6%0A%09c-0.3,0.6-0.7,1.1-1.2,1.6c-3,2.6-5.5,3.2-3.7,1.3c1.7-2,1.6-4.1,1.1-4.6c-0.4-0.4-1.1-0.1-1.5,0c-4.9,1.8-5.8,1-4.8,0.4%0A%09c4.4-2.7,6.9-5.1,8.4-6.6c3.7-4.2,6.7-10.3,6-15.9c-0.8-6.5-4.5-11.7-8.3-14.7c-0.4-0.3-0.7-0.6-0.9-0.7c-0.1-0.1-0.2-0.2-0.3-0.2%0A%09c0,0,0,0,0,0c0,0,0,0,0,0c-0.6-0.4-1.4-0.9-2-1.1c-1-0.3-0.7-1,0.4-1.3c-0.1-0.5-0.2-1.1-0.4-1.6c-0.1-0.5-0.3-1-0.4-1.5%0A%09c-4.4-14.6-14.8-20.8-23.4-21.7c-0.1,0-0.2,0-0.3,0c-2-0.2-3.4-0.2-3.7-0.2c-1.4-0.2-0.8-0.8,0-1.1c0.3-0.1,0.4-0.4,0.3-0.6%0A%09c-1-1.5-5.6-2.9-10.4-1.5c-2.5,0.7-4.7,2.3-6,3.9c-0.2,0.3-0.4,0.7-0.6,1c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.6,0.5,0.4,0.5,0.4%0A%09c2.3-0.5,3.3,0.1,1.5,1.1c-1.1,0.6-2.7,1.7-3.8,2.5c-2.6,2-6,5.3-8.4,10.3c-2.2,4.6-3.3,10-3.1,15.8c0.1,0.8,0.1,2.4,0.2,2.9%0A%09c0.1,0.6,0.5,1.2,1.9,1c1.9-0.2,3.1-0.6,1.4,0.8c-0.7,0.5-2.9,2.6-4.2,4.2c-2.6,3.3-4.6,9.4-2.6,17.1c1.7,6.6,5.8,11,12.3,13.1%0A%09c3.9,1.1,12.8,2.6,19.7,2.2c0.7,0,0.9,0.1,0.8,0.4c-0.1,0.3-0.6,0.5-1.3,0.6c-1.1,0.2-3.5,0.6-7.6,1c-0.9,0.1-1.6,0.7-1.7,1.1%0A%09c0,0,0,0,0,0.1c-0.5,1.8,3.2,3.3,3.6,3.5c1.4,0.4,0.8,1.2,0.2,1.3c-2.6,0.5-7.3-0.6-9.8-0.8c-1.7-0.1-3,0.2-3.5,0.5%0A%09c-5.9,2.6-10.9,5.9-15,9.7c-4.6,4.3-8.1,9.4-10.4,15c-1.4,3.5-2.2,6.8-2.6,9.6h-5.3c0.4-3.3,1.3-7.3,3.1-11.6%0A%09c1.5-3.6,3.3-7,5.6-10.1c-6.4,1.3-12.1,4.5-16.9,9.4c-3.3,3.3-6.1,7.5-8.4,12.2l-24.1,0l-3.8,10.4h710.7l3.8-10.4L225,166.9z%0A%09 M215.7,155c4.5,4.9,10.6,7.6,15.8,7.7c0.2,0,0.3,0,0.5,0c5,0,8.6-1.4,10.7-2.1c1.3-0.4,3-1.3,4.6-2.4c-0.4,0-0.7,0-1.1,0%0A%09c-3.4,0-6.8-0.7-9.9-2.1c-3.4-1.5-6.4-3.8-8.9-6.8c-1.9-2.3-3.5-4.9-4.9-8.1c-2.6-6.1-3-16.3,2.4-24.4c0.1-0.1,0.2-0.3,0.3-0.4%0A%09c-0.5,0.2-1,0.3-1.6,0.5c-1.2,0.4-2.5,1-3.8,1.8c-5.3,3.4-9.7,9.4-10.4,16.7S211.2,150.2,215.7,155z M238.4,151.3%0A%09c2.7,1.2,5.4,1.7,7.8,1.7c2.8,0,5.3-0.6,7.3-1.3c2.1-0.7,4.5-1.8,6.6-3.2c-2.9-0.5-5.7-1.4-8.3-2.8c-4.4-2.3-8.1-5.8-10.9-10.2%0A%09l0-0.1l0-0.1c-5.6-9.4-4.8-17.4-3.1-22.5c-2.7,1.2-6.1,3.3-8.5,6.8c-4.4,6.5-3.9,14.8-1.9,19.3C229.2,143.6,232.5,148.7,238.4,151.3%0A%09z\"/>%0A<path d=\"M135.6,99.1c-1.4,1-1.7,1.7-1.9,2.2c-0.2,0.5-0.2,1-0.1,1.2c0.1,0.2,0,0.5-0.2,0.6h0h0c0,0,0,0,0,0c-0.2,0.1-0.4,0-0.5,0%0A%09c-0.1-0.1-0.2-0.2-0.3-0.3c-0.4-0.9,0-2.9,1-3.8c0.4-0.4,0.9-0.7,1.4-0.9c0.2-0.1,0.7-0.3,1,0.1C136.2,98.6,135.9,98.9,135.6,99.1%0A%09 M168.4,92.7c-0.3,0.1-0.4-0.3-0.6-0.8c-0.9,1.2-2.9,3.1-3.2,3.5c-0.4,0.6-0.8,1.2-1.2,1.8c-0.6,1.1-1.1,2.1-1.9,3.1%0A%09c-1,1.3-2.2,2.5-3.6,3.3c-2.7,1.6-6,2.4-9.1,1.9c-1.6-0.3-3.2-0.9-4.7-1.6c-1.2-0.6-2.5-1.3-3.8-1.4c-1.5,0-3.1,0.1-4.6-0.1%0A%09c-0.5-0.1-1-0.3-1.1-0.8c-0.2-0.7,0.3-1.5,1-1.5l0,0c0.2,0,0.5,0.1,0.7,0.1c0.5,0,1,0.1,1.5,0.1c5.4,0.2,11-0.7,16.1-2.3%0A%09c3.2-1,6.3-2.3,9-4.2c1.1-0.8,2.2-1.7,3.1-2.7c0.1-0.2,0.3-0.4,0.4-0.5c-0.1-0.1-0.2-0.1-0.3-0.1c-0.3-0.1-0.3-0.6,0.2-0.7%0A%09c0.5-0.1,1.2,0.1,1.5,0.4c0.3,0.3,0.5,0.7,0.6,1.3C168.8,91.9,168.8,92.6,168.4,92.7 M161.2,97.3c-4.8,2.6-10.3,4-15.7,4.7%0A%09c1.5,0.7,3,1.2,4.6,1.4c1.5,0.1,2.9-0.1,4.3-0.5c1.4-0.4,2.8-1.1,4-2C159.6,99.8,160.5,98.6,161.2,97.3 M130.7,85.7%0A%09c-0.9-1.6-1.4-3.4-1.7-5.2c-0.3-1.8-0.4-3.7,0-5.5c0.3-1.8,1.1-3.4,2.6-4.4c1.2-0.9,2.7-1.4,4.2-1.4c0.4,0,0.8,0,1.2,0.1%0A%09c3.8,0.8,5.6,3.9,7.1,8.3c1.7,4.8,0.5,10.8-2.6,12.1c-0.8,0.3-2,0.7-2,0.7c-0.8,0.2-1.6,0.4-2.4,0.4c-0.9,0-1.8-0.2-2.6-0.7%0A%09C132.8,89,131.6,87.3,130.7,85.7 M132,85c0.9,1.7,2,3,3.2,3.7c0.6,0.3,1.2,0.5,1.9,0.5c0.6,0,1.2-0.1,2-0.3l0,0%0A%09c0.3-0.1,1.3-0.4,1.8-0.6c1-0.4,1.8-1.8,2.2-3.6c0.1-0.7,0.2-1.4,0.2-2.1c-0.2,2.3-1.4,4.1-3,4.4c-2.4,0.6-5.1-2-6-5.8%0A%09c-0.2-1-0.3-2-0.3-2.9c0.5,0.6,1.1,0.9,1.8,0.7c0.9-0.2,1.4-1.4,1.1-2.6c-0.3-0.9-1-1.6-1.7-1.7c0.5-0.7,1.2-1.2,1.9-1.4%0A%09c1.8-0.4,3.7,0.8,4.9,3c0-0.1-0.1-0.2-0.1-0.3c-1.2-2.4-3.3-4.9-7.3-3.8c-5.3,1.4-4.1,8.3-3.5,10.4C131.3,83.4,131.6,84.2,132,85%0A%09 M156.8,84C156.8,84,156.8,84,156.8,84C156.8,84,156.7,83.9,156.8,84C156.7,83.9,156.7,84,156.8,84 M150.5,77.5%0A%09c-0.4-1.6-1-4-0.8-6.3c0.2-3.3,1.9-5.2,3.9-5.9c2.5-0.8,5.2,0.5,6.7,2.4c0.9,1.1,1.7,2.7,2.4,4.3c0.2,0.5,0.5,1.1,0.7,1.7%0A%09c0.6,1.8,0.9,3.6,0.8,5.3c-0.1,1-0.2,2-0.6,2.8c-0.3,0.9-0.9,2.1-1.9,2.7c-0.7,0.4-1.5,0.5-2.1,0.7l0,0c-0.6,0.1-1.2,0.2-1.9,0.2%0A%09c-0.4,0-0.8,0-1.2-0.1c-0.1,0-0.1,0-0.2,0l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0l0,0l0,0c-1.7-0.5-2.7-1.8-3.6-2.9%0A%09c-0.7-1-1.2-2.1-1.6-3.1l0,0c0,0-0.1-0.2-0.2-0.6c-0.1-0.2-0.2-0.5-0.2-0.7l0,0l0,0C150.6,77.7,150.6,77.6,150.5,77.5 M151.4,73.1%0A%09c0,1.4,0.2,3,0.6,4.4c0.4,1.4,1,2.8,1.8,4c0.7,1,1.6,2,2.9,2.4c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.1,0c0,0,0,0,0,0%0A%09c0.3,0.1,0.6,0.1,0.9,0.1c0.5,0,1-0.1,1.6-0.2c0.6-0.1,1.2-0.3,1.8-0.6c0.7-0.4,1-1.2,1.3-1.9c0.3-0.8,0.4-1.6,0.5-2.4%0A%09c0.1-1.4-0.1-2.9-0.6-4.3c0,0.1,0,0.1,0,0.2c0.8,3.7-0.3,7-2.5,7.5c-2.2,0.5-4.6-2.1-5.4-5.7c-0.2-1-0.3-1.9-0.3-2.8%0A%09c0.4,0.6,1.1,1,1.8,0.8c0.9-0.2,1.4-1.4,1.1-2.5c-0.3-1-1.1-1.7-1.9-1.7c0.4-0.6,1-1.1,1.7-1.2c1.4-0.3,2.9,0.6,4,2.4%0A%09c-0.3-0.5-0.6-1-0.9-1.5c-0.8-1.1-2-2.2-3.4-2.5c-0.2,0-0.5-0.1-0.7-0.1c-1.3,0-2.6,0.6-3.3,1.6C151.6,70.2,151.4,71.7,151.4,73.1\"%0A%09/>%0A<path class=\"st0\" d=\"M448.4,100.9L433,142.6h20.2l15.4-41.7H448.4z M562.8,100.9l-5.6,15h-10.2l5.5-15h-19.3L518,142.6h19.2%0A%09l5.2-14.1h10.2l-5.2,14.1h19.2l15.4-41.7H562.8z M408.4,100.9l-14.8,22.4c0,0,0.9-11.7,1.2-14.6c0.2-2.1-0.1-7.9-5.3-7.9h-23.4%0A%09l-15.4,41.7H369l11.1-30.2l-2.3,30.2h16.3l20-29.7l-10.9,29.7h18.4l15.4-41.7H408.4z M496.6,101.2c-12.2,2.5-28.8,11.5-28.7,27.9%0A%09c0.1,9.5,11.5,14.7,24.7,14.4c7.4-0.2,14.4-1.5,15.2-1.7l4.9-12.6c-6.4,1-12.6,2.6-17.5,0.6c-8.7-3.5-3.4-12.6,2.8-15.4%0A%09c2.7-1.2,6.4-2.4,10.9-2.3c1.8,0,6.4,0.1,8.1,4.1l6.1-14.7C512.6,98.9,502.1,100.1,496.6,101.2z M693.7,100.9l-15.4,41.7h20.2%0A%09l15.4-41.7H693.7z M608.5,111.8h23.1l4.1-10.9h-42.1l-15.4,41.7h42.6l4.1-11.3h-23.5l1.7-4.6h22l3.8-10.3h-22L608.5,111.8z%0A%09 M763.7,100.9l-10.5,28.6c0.1-2.9,0.7-14.3,1.1-20.8c0.1-2.7-0.4-4.8-1.7-6.1c-1.6-1.7-3.6-1.7-3.7-1.7h-23.5L710,142.6H727%0A%09l10.9-29.6l-1.3,29.6h28.6l15.4-41.7H763.7z M666.2,100.9h-19.7l-15.4,41.7h39.5l5.1-13.9h-19.8L666.2,100.9z\"/>%0A</svg>%0A')}.logo-group{background-image:url('data:image/svg+xml,<?xml version=\"1.0\" encoding=\"utf-8\"?>%0A<!-- Generator: Adobe Illustrator 22.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->%0A<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"%0A%09 viewBox=\"0 0 822.3 219.1\" style=\"enable-background:new 0 0 822.3 219.1;\" xml:space=\"preserve\">%0A<style type=\"text/css\">%0A%09.st0{fill:%231C1C1C;}%0A%09.st1{fill:%23FFFFFF;}%0A%09.st2{fill:%23004F9E;}%0A<\\/style>%0A<path class=\"st0\" d=\"M243,166.9c0.3-0.1,0.6-0.2,0.9-0.3c0,0,0.5-0.2,0.7-0.2c3-1,9.7-4.5,12.2-9.5c5.1-1.9,8.8-4.5,11.1-7.6%0A%09c4.4-0.8,7.8-2.7,9.7-3.7c4.4-2.5,7.5-4.9,9.4-7.5c1.6-2.1,2.6-3.7,3.4-5.4c1.5-0.8,3.2-1.8,5.4-3.3c7.7-5.1,9.3-14.5,9.5-15.6%0A%09c0-0.2,0.1-0.5,0.1-0.7c0.4,0,0.8,0,1.2,0c7.7,0,17.8-4.8,23.2-7.5l0.1,0c0.8-0.4,1.6-0.8,1.9-0.9c1.8-0.8,5.5-2.8,9.3-5.3%0A%09c4.9-3.3,8.2-6.3,10-9.1c0.3-0.4,0.5-0.9,0.7-1.4l3.2-2c0.9-0.6,1.7-1.4,2.2-2.4c0.9-0.5,1.6-0.9,1.8-1.1c2.5-1.6,3.6-4.4,2.7-7.1%0A%09l0-0.1c-0.8-2.4-3-5.3-6.7-6.2c-1.3-2.8-4.1-4.4-7.2-4.4c-0.7,0-1.3,0.1-1.7,0.2c-0.2,0-1,0.2-7,1.7l-8.9,2.1%0A%09c0.8-2.2,0.7-4.6-0.3-6.6c-1.2-2.5-3.7-4.1-6.3-4.1c-0.9,0-1.8,0.2-2.6,0.6l-0.1,0c-0.3,0.2-1,0.5-16.9,10.8%0A%09c-0.2,0.1-0.4,0.3-0.6,0.4c-7.7,6.7-10.5,10.7-11.2,11.7c-0.4,0.5-1,1.5-1.6,2.8c-0.4-0.2-0.8-0.4-1.2-0.6c-3.2-1.4-6.5-2.1-9.9-2.1%0A%09c-6.1,0-10.4,2.4-11.5,3.1c-0.6,0.3-2.9,1.7-6.3,4.4c-1.4,1.1-2.6,2.3-3.7,3.7c-2.3,0.5-4.2,1.2-5.6,1.9c-1.8,0.9-3.5,2.3-5.4,3.8%0A%09l-0.1,0.1c-0.3,0.3-0.6,0.5-1,0.8c-0.8,0.6-2.9,2.3-4.9,5.1l-0.2,0c-0.3,0.1-2.8,0.6-6,2.1c-0.8,0.4-1.6,0.8-2.3,1.3%0A%09c-1.8,0.1-4.6,0.4-8.3,1.5l-0.2,0c-0.3-0.1-3.1-0.6-6.5-0.6c-1.5,0-2.9,0.1-4.1,0.3c-0.8,0.1-3.7,0.6-6.1,1.3%0A%09c-1.2,0.3-4.1,1.3-7.5,3.5c-7.3-1.7-14.6-2.2-19.2-2.4c4.4-5.9,6.5-12.7,5.8-18.5c-1.4-11-8.8-17.5-11.5-19.4%0A%09c-4.6-19.2-18-27.4-29-28.6c-2.2-2.5-6.3-4.1-11-4.1c-1.9,0-3.7,0.2-5.5,0.7c-5.9,1.6-10.6,6.1-11.5,11%0A%09c-5.9,4.9-15.1,15.9-12.5,35.6c-2.2,3-6.5,10.6-3.6,22.2c2,7.9,6.9,13.6,14.3,16.6c-5.7,2.8-10.7,6.1-14.9,10%0A%09c-0.3,0.2-0.5,0.5-0.7,0.7c-9.9,0.5-18.9,4.6-26,11.9c-5.1,5.2-8.6,11.2-10.8,16.5H243z\"/>%0A<path class=\"st1\" d=\"M242.6,160.6c-2.1,0.7-5.7,2.1-10.7,2.1c-0.2,0-0.3,0-0.5,0c-5.2-0.1-11.4-2.8-15.8-7.7%0A%09c-4.5-4.9-6.9-12.3-6.2-19.6c0.7-7.3,5.1-13.4,10.4-16.7c1.2-0.8,2.5-1.4,3.8-1.8c0.5-0.2,1.1-0.4,1.6-0.5c-0.1,0.1-0.2,0.3-0.3,0.4%0A%09c-5.4,8-5,18.3-2.4,24.4c1.4,3.2,3,5.8,4.9,8.1c2.5,3,5.5,5.3,8.9,6.8c3.2,1.4,6.5,2.1,9.9,2.1c0.4,0,0.7,0,1.1,0%0A%09C245.6,159.3,243.9,160.2,242.6,160.6\"/>%0A<path class=\"st1\" d=\"M253.5,151.7c-2,0.7-4.5,1.3-7.3,1.3c-2.4,0-5.1-0.5-7.8-1.7c-5.9-2.6-9.1-7.7-11.1-12.2%0A%09c-2-4.6-2.4-12.8,1.9-19.3c2.4-3.5,5.8-5.6,8.5-6.8c-1.7,5.1-2.5,13,3.1,22.5l0,0.1l0,0.1c2.8,4.5,6.5,7.9,10.9,10.2%0A%09c2.6,1.4,5.4,2.3,8.3,2.8C258,149.9,255.6,150.9,253.5,151.7\"/>%0A<path class=\"st1\" d=\"M274.5,140.3c-2.4,1.3-5.7,3.1-9.9,3.3c-0.2,0-0.4,0-0.6,0c-6.3,0-13.9-3-18.8-10.9c-8.8-14.8,0.8-25,4-27.5%0A%09c1.9-1.5,3.8-3,5.3-3.9c-0.7,2-1,3.5-1,4c-0.7,3.7-0.1,8.5,1.6,12.8c2.2,5.7,6,10.3,11,13.2c4.1,2.4,8.3,3.6,12.6,3.6%0A%09c1.2,0,2.3-0.1,3.2-0.2C279.8,137.1,276.6,139.2,274.5,140.3\"/>%0A<path class=\"st1\" d=\"M86.4,166.9c0.4-3.3,1.3-7.3,3.1-11.6c1.5-3.6,3.3-7,5.6-10.1c-6.4,1.3-12.1,4.5-16.9,9.4%0A%09c-3.3,3.3-6.1,7.5-8.4,12.2H86.4z\"/>%0A<path class=\"st1\" d=\"M197.4,166.9c-1.1-1-2-1.9-2.8-2.7c-3.8-3.9-6.8-10.8-7.7-15.6c-1.6-7.8-0.5-15.4,3.2-22.5%0A%09c1.2-2.2,2.6-4.3,4.3-6.1c-8.3-1.5-16.2-1.6-18.8-1.6c-0.3,0.6-0.7,1.1-1.2,1.6c-3,2.6-5.5,3.2-3.7,1.3c1.7-2,1.6-4.1,1.1-4.6%0A%09c-0.4-0.4-1.1-0.1-1.5,0c-4.9,1.8-5.8,1-4.8,0.4c4.4-2.7,6.9-5.1,8.4-6.6c3.7-4.2,6.7-10.3,6-15.9c-0.8-6.5-4.5-11.6-8.3-14.7%0A%09c-0.4-0.3-0.7-0.6-0.9-0.7c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0,0,0c0,0,0,0,0,0c-0.6-0.4-1.4-0.9-2-1.1c-1-0.3-0.7-1,0.4-1.3%0A%09c-0.1-0.5-0.2-1.1-0.4-1.6c-0.1-0.5-0.3-1-0.4-1.5c-4.4-14.6-14.8-20.8-23.4-21.7c-0.1,0-0.2,0-0.3,0c-2-0.2-3.4-0.2-3.7-0.2%0A%09c-1.4-0.2-0.8-0.8,0-1.1c0.3-0.1,0.4-0.4,0.3-0.6c-1-1.5-5.6-2.9-10.4-1.5c-2.5,0.7-4.7,2.3-6,3.9c-0.2,0.3-0.4,0.7-0.6,1%0A%09c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.6,0.5,0.4,0.5,0.4c2.3-0.5,3.3,0.1,1.5,1.1c-1.1,0.6-2.7,1.7-3.8,2.5c-2.6,2-6,5.3-8.4,10.3%0A%09c-2.2,4.6-3.3,10-3.1,15.8c0.1,0.8,0.1,2.4,0.2,2.9c0.1,0.6,0.5,1.2,1.9,1c1.9-0.2,3.1-0.6,1.4,0.8c-0.7,0.5-2.9,2.6-4.2,4.2%0A%09c-2.6,3.3-4.6,9.4-2.6,17.1c1.7,6.6,5.8,11,12.3,13.1c3.9,1.1,12.8,2.6,19.7,2.2c0.7,0,0.9,0.1,0.8,0.4c-0.1,0.3-0.6,0.5-1.3,0.6%0A%09c-1.1,0.2-3.5,0.6-7.6,1c-0.9,0.1-1.6,0.7-1.7,1.1c0,0,0,0,0,0.1c-0.5,1.8,3.2,3.3,3.6,3.5c1.4,0.4,0.8,1.2,0.2,1.3%0A%09c-2.6,0.5-7.3-0.6-9.8-0.8c-1.7-0.1-3,0.2-3.5,0.5c-5.9,2.6-10.9,5.9-15,9.7c-4.6,4.3-8.1,9.4-10.4,15c-1.4,3.5-2.2,6.8-2.6,9.6%0A%09H197.4z\"/>%0A<path class=\"st1\" d=\"M198.3,160.5c2.2,2.3,4.7,4.7,8.7,6.4h18c-1.3-0.4-2.7-0.9-4-1.5c-3.5-1.6-6.7-4-9.2-6.8%0A%09c-2.7-3-4.8-6.7-6.2-10.9c-1.3-4.1-1.8-8.6-1.4-12.8c0.4-4.3,1.9-8.5,4.3-12.2c1.6-2.6,3.7-4.8,6-6.7c-0.2,0-0.5,0.1-0.7,0.1%0A%09c0,0-3.1,0.4-5.3,1.1c-2.2,0.7-9.8,3.5-13.8,11.3c-4.1,7.8-3.6,14.6-2.7,19C192.9,152,195.6,157.8,198.3,160.5\"/>%0A<path class=\"st1\" d=\"M356.1,79.2c-0.5,0.3-1.2,0.7-1.8,1.1c0,0,0-0.1,0-0.1c-0.9-1.5-2.1-2.5-3.6-2.8c-2.3-0.5-5.2,0.4-9,2.9%0A%09c-5.6,3.6-14.3,5.7-14.4,5.7c-0.6,0.1-1,0.7-0.8,1.3c0.1,0.5,0.6,0.9,1.1,0.9c0.1,0,0.2,0,0.3,0c0.4-0.1,9.2-2.2,15.1-6%0A%09c3.2-2.1,5.7-3,7.3-2.6c0.8,0.2,1.4,0.6,1.9,1.5c0,0,0,0,0,0c0.7,1.1,0.1,1.7,0,1.7c-0.1,0-2.8,1.8-4,2.5c-0.6-0.6-1.8-1.6-3.6-1.8%0A%09c-2-0.2-4.1,0.7-6.2,2.7c-5.1,4.8-10.6,6.3-10.7,6.4c-0.6,0.2-0.9,0.8-0.8,1.4c0.1,0.5,0.6,0.8,1.1,0.8c0.1,0,0.2,0,0.3,0%0A%09c0.2-0.1,6.1-1.7,11.6-6.9c1.6-1.5,3.1-2.2,4.4-2.1c1.3,0.1,2.1,1,2.3,1.2c0.1,0.1,0.3,0.5,0,0.9c-3.1,4.9-13.9,11.1-17,12.4%0A%09c-2.3,1-11.5,5.9-19,7.5c-0.8,0.2-1.7,0.3-2.5,0.4c-0.1,0-0.2,0-0.3,0c-1.1,0-6.2,0.1-7.7-1.4c-2.2-2.2-3-0.6-2.3,2.2%0A%09c-2.4,1.5-6,3.6-6.9,4.2c-2.5,1.5-5.7-0.2-6.3-0.2c-1.3,0,1.8,3.9,4.4,4.3c2.8,0.4,8-2.9,8-2.9l2-1.3c0,0,0,0,0,0%0A%09c0,0-1.2,7.6-6.8,11.4c-3.5,2.3-5,3.1-6.3,3.7c-0.9,0.4-3.5,1.8-7.4,1.8c-2.8,0-6.1-0.7-9.9-2.9c-9.1-5.4-10.9-16-10.1-20.7%0A%09c0,0,1-7,6.4-11.1c3.6-2.8,5.7-4,5.7-4s3.4-2.2,8.4-2.2c2.2,0,4.7,0.4,7.3,1.6c-0.8,0.6-1.5,1.2-1.9,1.7c-1,1.6-2.5,5.1-1.5,5.1%0A%09c0.7,0,1.2-1.8,3.6-3c1.2-0.6,6.8-3.9,6.8-3.9s0.2-0.9,0.5-1.4c0,0,0.7-1.5,2.1-3.6c0.1-0.1,0.3-0.4,0.6-0.9%0A%09c0.8-1.1,1.9-2.4,3.2-3.6c0,0,0,0,0,0c1.5-1.6,3.6-3.6,6.4-6.1c0,0,15.6-10.1,16.3-10.5c0.1-0.1,0.3-0.1,0.4-0.1%0A%09c1.3,0,3.2,2.3,0.9,5.4c-1.9,2.5-4.1,4.2-5.8,5.5c-0.5,0.4-1.2,0.8-1.7,1c-2.4,0.8-5.5,2.7-6,3.1c-0.5,0.4-0.5,1.1,0.1,0.8%0A%09c2.1-0.9,5.4-1.7,6-1.9c3.6-0.8,29.7-7.1,30.1-7.2c0.1,0,0.4-0.1,0.6-0.1c0.9,0,2.4,0.3,2.8,2.2c0,0.1,0,0.1,0,0.2l-23.9,7.1%0A%09c-0.6,0.2-0.9,0.8-0.7,1.4c0.1,0.4,0.5,0.7,0.9,0.8c0.2,0,0.4,0,0.5,0l21.3-6.3c0.4-0.1,1.2-0.3,2.8-0.8l0.2-0.1%0A%09c0.5-0.1,0.9-0.2,1.3-0.2c2.2,0,3.5,1.8,3.9,2.9C356.7,78.6,356.5,78.9,356.1,79.2\"/>%0A<path class=\"st0\" d=\"M135.6,99.1c-1.4,1-1.7,1.7-1.9,2.2c-0.2,0.5-0.2,1-0.1,1.2c0.1,0.2,0,0.5-0.2,0.6h0h0c0,0,0,0,0,0%0A%09c-0.2,0.1-0.4,0-0.5,0c-0.1-0.1-0.2-0.2-0.3-0.3c-0.4-0.9,0-2.9,1-3.8c0.4-0.4,0.9-0.7,1.4-0.9c0.2-0.1,0.7-0.3,1,0.1%0A%09C136.2,98.6,135.9,98.9,135.6,99.1 M168.4,92.7c-0.3,0.1-0.4-0.3-0.6-0.8c-0.9,1.2-2.9,3.1-3.2,3.5c-0.4,0.6-0.8,1.2-1.2,1.8%0A%09c-0.6,1.1-1.1,2.1-1.9,3.1c-1,1.3-2.2,2.5-3.6,3.3c-2.7,1.6-6,2.4-9.1,1.9c-1.6-0.3-3.2-0.9-4.7-1.6c-1.2-0.6-2.5-1.3-3.8-1.4%0A%09c-1.5,0-3.1,0.1-4.6-0.1c-0.5-0.1-1-0.3-1.1-0.8c-0.2-0.7,0.3-1.5,1-1.5l0,0c0.2,0,0.5,0.1,0.7,0.1c0.5,0,1,0.1,1.5,0.1%0A%09c5.4,0.2,11-0.7,16.1-2.3c3.2-1,6.3-2.3,9-4.2c1.1-0.8,2.2-1.7,3.1-2.7c0.1-0.2,0.3-0.4,0.4-0.5c-0.1-0.1-0.2-0.1-0.3-0.1%0A%09c-0.3-0.1-0.3-0.6,0.2-0.7c0.5-0.1,1.2,0.1,1.5,0.4c0.3,0.3,0.5,0.7,0.6,1.3C168.8,91.9,168.8,92.6,168.4,92.7 M161.2,97.3%0A%09c-4.8,2.6-10.3,4-15.7,4.7c1.5,0.7,3,1.2,4.6,1.4c1.5,0.1,2.9-0.1,4.3-0.5c1.4-0.4,2.8-1.1,4-2C159.6,99.8,160.5,98.6,161.2,97.3%0A%09 M130.7,85.7c-0.9-1.6-1.4-3.4-1.7-5.2c-0.3-1.8-0.4-3.7,0-5.5c0.3-1.8,1.1-3.4,2.6-4.4c1.2-0.9,2.7-1.4,4.2-1.4%0A%09c0.4,0,0.8,0,1.2,0.1c3.8,0.8,5.6,3.9,7.1,8.3c1.7,4.8,0.5,10.8-2.6,12.1c-0.8,0.3-2,0.7-2,0.7c-0.8,0.2-1.6,0.4-2.4,0.4%0A%09c-0.9,0-1.8-0.2-2.6-0.7C132.8,89,131.6,87.3,130.7,85.7 M132,85c0.9,1.7,2,3,3.2,3.7c0.6,0.3,1.2,0.5,1.9,0.5c0.6,0,1.2-0.1,2-0.3%0A%09l0,0c0.3-0.1,1.3-0.4,1.8-0.6c1-0.4,1.8-1.8,2.2-3.6c0.1-0.7,0.2-1.4,0.2-2.1c-0.2,2.3-1.4,4.1-3,4.4c-2.4,0.6-5.1-2-6-5.8%0A%09c-0.2-1-0.3-2-0.3-2.9c0.5,0.6,1.1,0.9,1.8,0.7c0.9-0.2,1.4-1.4,1.1-2.6c-0.3-0.9-1-1.6-1.7-1.7c0.5-0.7,1.2-1.2,1.9-1.4%0A%09c1.8-0.4,3.7,0.8,4.9,3c0-0.1-0.1-0.2-0.1-0.3c-1.2-2.4-3.3-4.9-7.3-3.8c-5.3,1.4-4.1,8.3-3.5,10.4C131.3,83.4,131.6,84.2,132,85%0A%09 M156.8,84C156.8,84,156.8,84,156.8,84C156.8,84,156.7,83.9,156.8,84C156.7,83.9,156.7,84,156.8,84 M150.5,77.5%0A%09c-0.4-1.6-1-4-0.8-6.3c0.2-3.3,1.9-5.2,3.9-5.9c2.5-0.8,5.2,0.5,6.7,2.4c0.9,1.1,1.7,2.7,2.4,4.3c0.2,0.5,0.5,1.1,0.7,1.7%0A%09c0.6,1.8,0.9,3.6,0.8,5.3c-0.1,1-0.2,2-0.6,2.8c-0.3,0.9-0.9,2.1-1.9,2.7c-0.7,0.4-1.5,0.5-2.1,0.7l0,0c-0.6,0.1-1.2,0.2-1.9,0.2%0A%09c-0.4,0-0.8,0-1.2-0.1c-0.1,0-0.1,0-0.2,0l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0l0,0l0,0c-1.7-0.5-2.7-1.8-3.6-2.9%0A%09c-0.7-1-1.2-2.1-1.6-3.1l0,0c0,0-0.1-0.2-0.2-0.6c-0.1-0.2-0.2-0.5-0.2-0.7l0,0l0,0C150.6,77.7,150.6,77.6,150.5,77.5 M151.4,73.1%0A%09c0,1.4,0.2,3,0.6,4.4c0.4,1.4,1,2.8,1.8,4c0.7,1,1.6,2,2.9,2.4c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.1,0c0,0,0,0,0,0%0A%09c0.3,0.1,0.6,0.1,0.9,0.1c0.5,0,1-0.1,1.6-0.2c0.6-0.1,1.2-0.3,1.8-0.6c0.7-0.4,1-1.2,1.3-1.9c0.3-0.8,0.4-1.6,0.5-2.4%0A%09c0.1-1.4-0.1-2.9-0.6-4.3c0,0.1,0,0.1,0,0.2c0.8,3.7-0.3,7-2.5,7.5c-2.2,0.5-4.6-2.1-5.4-5.7c-0.2-1-0.3-1.9-0.3-2.8%0A%09c0.4,0.6,1.1,1,1.8,0.8c0.9-0.2,1.4-1.4,1.1-2.5c-0.3-1-1.1-1.7-1.9-1.7c0.4-0.6,1-1.1,1.7-1.2c1.4-0.3,2.9,0.6,4,2.4%0A%09c-0.3-0.5-0.6-1-0.9-1.5c-0.8-1.1-2-2.2-3.4-2.5c-0.2,0-0.5-0.1-0.7-0.1c-1.3,0-2.6,0.6-3.3,1.6C151.6,70.2,151.4,71.7,151.4,73.1\"%0A%09/>%0A<path class=\"st2\" d=\"M448.4,100.9L433,142.6h20.2l15.4-41.7H448.4z M763.7,100.9l-10.5,28.6c0.1-2.9,0.7-14.3,1.1-20.8%0A%09c0.1-2.7-0.4-4.8-1.7-6.1c-1.6-1.7-3.6-1.7-3.7-1.7h-23.5L710,142.6H727l10.9-29.6l-1.3,29.6h28.6l15.4-41.7H763.7z M408.4,100.9%0A%09l-14.8,22.4c0,0,0.9-11.7,1.2-14.6c0.2-2.1-0.1-7.9-5.3-7.9h-23.4l-15.4,41.7H369l11.1-30.2l-2.3,30.2h16.3l20-29.7l-10.9,29.7h18.4%0A%09l15.4-41.7H408.4z M562.8,100.9l-5.6,15h-10.2l5.5-15h-19.3L518,142.6h19.2l5.2-14.1h10.2l-5.2,14.1h19.2l15.4-41.7H562.8z%0A%09 M496.6,101.2c-12.2,2.5-28.8,11.5-28.7,27.9c0.1,9.5,11.5,14.7,24.7,14.4c7.4-0.2,14.4-1.5,15.2-1.7l4.9-12.6%0A%09c-6.4,1-12.6,2.6-17.5,0.6c-8.7-3.5-3.4-12.6,2.8-15.4c2.7-1.2,6.4-2.4,10.9-2.3c1.8,0,6.4,0.1,8.1,4.1l6.1-14.7%0A%09C512.6,98.9,502.1,100.1,496.6,101.2z M608.5,111.8h23.1l4.1-10.9h-42.1l-15.4,41.7h42.6l4.1-11.3h-23.5l1.7-4.6h22l3.8-10.3h-22%0A%09L608.5,111.8z M693.7,100.9l-15.4,41.7h20.2l15.4-41.7H693.7z M666.2,100.9h-19.7l-15.4,41.7h39.5l5.1-13.9h-19.8L666.2,100.9z\"/>%0A<polygon class=\"st2\" points=\"756.2,166.9 45.6,166.9 41.7,177.4 752.4,177.4 \"/>%0A</svg>%0A')}.logo-commercial{background-image:url('data:image/svg+xml,<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 897.05 264.69\"><defs><style>.cls-1{fill:%23fce500;}.cls-2{fill:%2327509b;}.cls-3{fill:%23fff;}<\\/style></defs><title>Michelin_C_H_WhiteBG_RGB_0703</title><polygon class=\"cls-1\" points=\"720.71 195.03 89.11 195.03 84.03 208.97 715.59 208.97 720.71 195.03\"/><path class=\"cls-2\" d=\"M460.75,112c-16.35,3.35-38.5,15.36-38.27,37.28.14,12.64,15.41,19.66,32.92,19.17a141,141,0,0,0,20.36-2.27l6.5-16.88c-8.6,1.36-16.86,3.42-23.34.83-11.68-4.67-4.49-16.82,3.77-20.59a33,33,0,0,1,14.54-3.12c2.47,0,8.5.15,10.84,5.48l8.17-19.58C482.18,108.82,468.07,110.47,460.75,112Zm88.6-.51-7.44,20.07H528.33l7.39-20.07H510l-20.46,55.73h25.66l7-18.87h13.61l-7,18.87h25.69L575,111.45Zm-153.15,0-20.53,55.72h27l20.5-55.72Zm-53.68,0-19.72,29.93s1.25-15.66,1.57-19.43c.23-2.87-.12-10.5-7.11-10.5H286l-20.51,55.72h24.46l14.86-40.31-3.13,40.31H323.4l26.66-39.6-14.55,39.6h24.63l20.51-55.72Zm476.23,0L804.68,149.7c.19-3.85,1-19.06,1.43-27.83.19-3.61-.59-6.36-2.31-8.19a7.45,7.45,0,0,0-4.91-2.23H767.53L747,167.18H769.8l14.54-39.47-1.72,39.47h38.18l20.52-55.73Zm-94.29,0L704,167.17h27l20.5-55.72ZM610.33,126h30.79l5.42-14.6H590.25l-20.51,55.73h56.91l5.53-15H600.76l2.3-6.2h29.32l5-13.72H608.09Zm77.4-14.6H661.47l-20.54,55.73h52.73l6.82-18.52H674Z\"/><path d=\"M60.16,91.7l.06.14.42,1a117.5,117.5,0,0,0,5.6,11.86,37,37,0,0,0,4.11,6.07,21.62,21.62,0,0,0-3.24,7.15,21.89,21.89,0,0,0,1,11.69,25.37,25.37,0,0,0,2.21,4.81l0,0,0,0a2.21,2.21,0,0,0-.09.4A22.74,22.74,0,0,0,79.49,156a25.07,25.07,0,0,0,3.41,2.15,17.61,17.61,0,0,0,6,8.27,24.09,24.09,0,0,0,6.75,3.72l0,.07A20.45,20.45,0,0,0,107.17,178a26.14,26.14,0,0,0,3.76.76,2,2,0,0,0,.19.22,21.54,21.54,0,0,0,9.07,5.08,23.32,23.32,0,0,0,1,11H254.86a24,24,0,0,0-3.53-12.71,2.14,2.14,0,0,0-.21-.28,25.42,25.42,0,0,0-20.26-28.33c-.67-.13-1.37-.24-2.06-.32h-.28A55.52,55.52,0,0,0,212,142.32c.08-.36.15-.71.23-1l.27-.09C219.73,138,224,132.7,225,125.73A22.9,22.9,0,0,0,221,109.87a2.07,2.07,0,0,0,0-.22c.74-7.44-.38-13.94-3.33-19.3a23.05,23.05,0,0,0-10.27-9.82l-.06,0c-1.18-4-6.28-7-11.73-6.9-4.3.12-9,2.13-10.75,5.43-6.54,2.36-16.69,8.45-19.76,23.86a20.49,20.49,0,0,0-2.8,30.58,97.72,97.72,0,0,0-18.84,2l-.24.06a25.76,25.76,0,0,0-21-4.12,2.15,2.15,0,0,0-.76.37,38,38,0,0,0-6.44-1.31,2.12,2.12,0,0,0-.43,0,21.07,21.07,0,0,0-5.19-8.71c-.12-.12-.4-.34-.4-.36l0,0a50.56,50.56,0,0,0-1.33-6,17.73,17.73,0,0,0-4.89-8.1,19.28,19.28,0,0,0-5.56-3.85,14,14,0,0,0,.56-1.86,4.2,4.2,0,0,0,.08-.47c0-.07.78-7.52,1.67-11.94l0-.16C102,73.86,102,73.64,102.05,73.47v-.09a4.89,4.89,0,0,0-1.33-3.73,6.59,6.59,0,0,0-4.87-2,7.76,7.76,0,0,0-6.64,3.8,20.71,20.71,0,0,0-2,4.55c-2.52-4.88-5.82-11.31-8.19-16l-.13-.24a6.31,6.31,0,0,0-5.33-3,6.65,6.65,0,0,0-2.34.43,6.25,6.25,0,0,0-4.1-1.51,7.16,7.16,0,0,0-2.28.39,6.16,6.16,0,0,0-4.21,6.12,6,6,0,0,0-3.91,4.56,7.85,7.85,0,0,0,.16,3.32c0,.09.05.23.12.44l-.19.28c-1.49,2.34-2.26,6.65,3.35,20.88\"/><path class=\"cls-3\" d=\"M250.57,195h-5.29a25.75,25.75,0,0,0,4.12-6.81,19.49,19.49,0,0,1,1.16,6.81\"/><path class=\"cls-3\" d=\"M163.51,137.8a13.53,13.53,0,0,1,3.12.59c2,.75,5.88,4.5,8,4.83.37,0,1.34-.19.29-.94-.29-.21-2.74-2.39-1.83-3.52l0,0a1.1,1.1,0,0,1,1.2-.46c3.07.76,5.63,1.2,6.51,1.33.54.08.93.09,1.15-.1s.06-.32-.54-.49c-4.74-1.27-10-3.31-13.62-6.06a17,17,0,0,1-6.76-15.62,16.39,16.39,0,0,1,6.37-10.93,18.44,18.44,0,0,1,4.31-2c1.72-.62-1.1-1.07-1.3-1.11-.72-.12-.76-.86-.17-3.12a25.31,25.31,0,0,1,16.56-17.22,31.89,31.89,0,0,1,3.77-.95c1.66-.25,1-1-.86-1.22,0,0-.64,0-.33-.45a4.57,4.57,0,0,1,.95-.83,11,11,0,0,1,5.45-1.58c3.87-.1,7.21,2.06,7.6,4.05,0,0,.14.4-.33.42-.74,0-1.34.34-.32.85.24.12,1.27.43,2.72,1.1l.21.11c2.92,1.36,12,6.88,11.34,22.5h0c0,.47-.06.94-.09,1.4s-.09.86-.14,1.29c-.85-.1-1.23.26-.62.88a18.66,18.66,0,0,1,2.17,2.79,19.06,19.06,0,0,1,2.52,12,14.76,14.76,0,0,1-7.63,11,36.56,36.56,0,0,1-9.58,3.65c-.91.21-.48,1.39,3.74,1.33.36,0,1.13.08,1.35.5.49.91-.35,2.69-2.19,3.77-1.58.93-.32,1.13,1.88.47a7.76,7.76,0,0,1,2.55.67,50.18,50.18,0,0,1,19.33,15.34c4.68,6.72,6.38,12,4.91,15.33s-5.65,3.82-5.68,3.82h-.07c-16.34,2.54-44.69-1.94-64.24-7.7a116.59,116.59,0,0,1-13.12-4.81,27.41,27.41,0,0,0-4.44-29.15l-.29-.31a92.63,92.63,0,0,1,16.11-1.32\"/><path class=\"cls-3\" d=\"M243.49,166.9a21.11,21.11,0,0,1-3.78,27.77c.1-3.87-.58-8.38-3.43-12a9.74,9.74,0,0,0,2.89-3.68c2.16-4.84.37-11.43-5.32-19.6l0-.05-.37-.48a21,21,0,0,1,10.05,8\"/><path class=\"cls-3\" d=\"M144.47,142.28c6.53,7.36,7.63,18.56,2.61,26.64-5.62,9.06-15.7,13.54-25.08,11.15a19.85,19.85,0,0,1-3.83-1.4,23.52,23.52,0,0,0,2.64-.55c9.23-2.5,16.12-11,17.15-21.19a24.54,24.54,0,0,0-5-17.65,21.18,21.18,0,0,0-4.65-4.33,22,22,0,0,1,16.15,7.33\"/><path class=\"cls-3\" d=\"M129.61,142a20.21,20.21,0,0,1,4.07,14.54c-.85,8.41-6.48,15.43-14,17.47a20.54,20.54,0,0,1-16.58-2.53A22.89,22.89,0,0,0,124,155.76a21.7,21.7,0,0,0-.28-14.1,20.72,20.72,0,0,0-3.2-5.68,18.06,18.06,0,0,1,9,6\"/><path class=\"cls-3\" d=\"M115.26,142.22a25.46,25.46,0,0,0,.44-5.21A17,17,0,0,1,120,154.45c-2.8,8.71-12.08,14.24-20.68,12.32a18.86,18.86,0,0,1-10.43-6.41,22.36,22.36,0,0,0,4.72.51,22,22,0,0,0,8.81-1.84,22.66,22.66,0,0,0,12.89-16.81\"/><path class=\"cls-3\" d=\"M108.83,127.88s0,0,0,0A19.27,19.27,0,0,1,111,141.41a17.86,17.86,0,0,1-29,11.19,18.83,18.83,0,0,1-7.66-13.14v0c.44.39.9.75,1.37,1.09a20.31,20.31,0,0,0,12,3.72,21.64,21.64,0,0,0,5.69-.72c7.86-2.22,11.71-6.94,13.56-10.51a20.61,20.61,0,0,0,1.84-5.13\"/><path class=\"cls-3\" d=\"M60.48,73l.17-.12a1.41,1.41,0,0,1,.52-.3l.19,0,.57,0a2,2,0,0,1,.4.1c1.24.45,2.15,2,2.44,4.21a25.27,25.27,0,0,0,3.9,10.6.93.93,0,1,0,1.52-1.09,23.69,23.69,0,0,1-3.56-9.76c-.39-2.93-1.72-5-3.65-5.72a3.74,3.74,0,0,0-1.41-.23A10.81,10.81,0,0,1,61,69.14c-.19-.8-.55-2.39,1.23-3l.34-.1h.18c1.29-.16,3,.43,4.67,6.46a46.29,46.29,0,0,0,5.25,11.17.93.93,0,0,0,1.56-1,45.17,45.17,0,0,1-5-10.65c-.73-2.6-1.76-5.43-3.51-6.88-.25-.64-.53-1.35-.6-1.58-.3-.89-.61-2.87,1.09-3.43a3,3,0,0,1,.94-.17,2.71,2.71,0,0,1,2.37,2c0,.12.11.25.17.39l7.67,18.32a.71.71,0,0,0,.24.33.86.86,0,0,0,1.36-1L71.49,62.24a1.64,1.64,0,0,1,.85-.88A2.71,2.71,0,0,1,73.56,61a2.07,2.07,0,0,1,1.69.94S85.16,81.42,87,84.78a19,19,0,0,0-1.45,2.82c-.13.5.2.95.44.48a28.9,28.9,0,0,1,2-2.57l0,0h0a.28.28,0,0,0,.07-.11c.47-.83,1.92-4.7,2.5-5.92a20.61,20.61,0,0,1,2.15-5.73,3.58,3.58,0,0,1,3.06-1.81c1.12,0,2,.57,2,1.15,0,.26-2.43,15.29-2.43,15.29-.63,3.14-1.19,7.64-1.5,10.25a12.67,12.67,0,0,1-.21,1.89l0,.2s0,.14-.09.37a19.58,19.58,0,0,1-1.4,4l.78,3.58h0c.31,1.51.65,3.13.78,3.62.57,2-.16,3.22.21,3.63.52.57,1.78-2.14,2.11-3.54a14.74,14.74,0,0,0-.53-5,15,15,0,0,1,4.22,2.95,13.47,13.47,0,0,1,3.82,6.28A37.26,37.26,0,0,1,105,123.8c.05,1.93-.61,12.18-12.73,15.59a17.18,17.18,0,0,1-4.5.56A16,16,0,0,1,78.27,137c-5.86-4.17-8.15-13.28-7-18.1a17.24,17.24,0,0,1,2.31-5.29,8.29,8.29,0,0,0,1.72.8l.35,1.66c0,.2,1,4.83,2.78,6.24a5.89,5.89,0,0,0,3.29.89c.53,0,1.8-.06,2-.61a.5.5,0,0,0-.14-.56,2.49,2.49,0,0,0-.56-.35c-.86-.47-2.47-1.33-2.81-2.91-.19-.89-.93-4-1.36-5.85,1.8-1.43,2-3-.36-2.51a4.6,4.6,0,0,1-3.75-1.17C70,105.11,65.08,92.4,64.09,90.15c-4-10.2-4.86-15.67-3.61-17.2\"/><path class=\"cls-3\" d=\"M124.42,184.86a25.13,25.13,0,0,0,2.67.15c8.82,0,17.42-4.65,22.89-12.67A118,118,0,0,0,164,177.51a230,230,0,0,0,34.65,7.2,158.68,158.68,0,0,0,19.83,1.4,76.86,76.86,0,0,0,11.61-.78,12.92,12.92,0,0,0,2.25-.55c2.65,2.79,3.17,6.83,3,10.25H125.85a17.62,17.62,0,0,1-1.42-10.18\"/><path d=\"M182.83,117.2c-.1-.37-.57-.37-.73-.37a4.14,4.14,0,0,0-1.36.28,3.08,3.08,0,0,0-1.92,2.53.44.44,0,0,0,.13.31.53.53,0,0,0,.4.16h0a.36.36,0,0,0,.35-.36,1.52,1.52,0,0,1,.43-.87,3.82,3.82,0,0,1,2.17-1c.25-.06.6-.25.5-.62\"/><path d=\"M199.92,126.06a9.78,9.78,0,0,1-3.73.34,10.54,10.54,0,0,1-3.59-.91,11.59,11.59,0,0,1-3.24-2.42,40.63,40.63,0,0,0,13.77,1.19,10.08,10.08,0,0,1-3.21,1.8m9.75-6c-.46-.05-.58.34-.4.49a1.24,1.24,0,0,1,.18.19L209,121a15.58,15.58,0,0,1-3.26,1.08,28,28,0,0,1-8.39.45,44.42,44.42,0,0,1-13.45-3.19l-1.13-.5c-.19-.08-.37-.2-.56-.27h0a.93.93,0,0,0-1.24.82,1,1,0,0,0,.67,1,27.84,27.84,0,0,0,3.58,1.47,9.13,9.13,0,0,1,2.62,2.23,14.87,14.87,0,0,0,3.23,2.62,12.28,12.28,0,0,0,7.78,1.37,10.11,10.11,0,0,0,3.79-1.41,24.06,24.06,0,0,0,2.37-1.78,11.82,11.82,0,0,1,1.44-1c.3-.17,2.4-1,3.51-1.65,0,.39,0,.73.24.78s.55-.49.65-.94a2,2,0,0,0-.11-1.17,1.52,1.52,0,0,0-1.05-.76\"/><path d=\"M184.28,104.41c.16-1.74,1.17-7.2,5.53-6.76,3.32.33,4.21,2.78,4.46,4.92,0,.09,0,.19,0,.29a10,10,0,0,1-.71,4.94,9.39,9.39,0,0,1-.77,1.53,3.91,3.91,0,0,1-2.65,2.1h-.25a6.42,6.42,0,0,0,2.85-5.15c.29-3.22-1.24-6-3.43-6.18a3.41,3.41,0,0,0-2.82,1.33,1.95,1.95,0,0,1,.11,3.75,1.54,1.54,0,0,1-1.44-1.25,8.66,8.66,0,0,0-.32,1.66,7,7,0,0,0,1.24,4.9,2.88,2.88,0,0,1-.36-.36,7.37,7.37,0,0,1-1.38-3.63,10.61,10.61,0,0,1-.07-2.11m.51,6.49a4.15,4.15,0,0,0,1.8,1.27,7,7,0,0,0,1.91.39,16,16,0,0,0,1.72.08c2.68-.11,5.21-4.23,5.29-8.26.08-3.67-.41-6.49-3.06-8.14a4.79,4.79,0,0,0-.87-.42,6,6,0,0,0-3.59-.16,5.39,5.39,0,0,0-3.16,2.58,13.38,13.38,0,0,0-1.49,4.07,12.52,12.52,0,0,0-.19,4.37,8.6,8.6,0,0,0,1.65,4.23\"/><path d=\"M211.3,108a10.76,10.76,0,0,1-.6,2,7.39,7.39,0,0,1-2.2,3.13,2.81,2.81,0,0,1-1.22.5,6.59,6.59,0,0,0,2.68-5.08c.29-3.22-1.2-6-3.33-6.17a3.33,3.33,0,0,0-2.77,1.34,1.69,1.69,0,0,1,1.44,1.79,1.72,1.72,0,0,1-1.34,2,1.5,1.5,0,0,1-1.41-1.24,8.64,8.64,0,0,0-.31,1.66,6.79,6.79,0,0,0,1.46,5.21,4.38,4.38,0,0,1-1.6-2.52,9,9,0,0,1-.33-1.66,10.12,10.12,0,0,1,.58-4.92l.09-.28c.77-2,2.22-4.11,5.41-3.6,4.19.68,3.75,6.16,3.46,7.87m1.05-6.06a5.31,5.31,0,0,0-2.3-3.27,5.73,5.73,0,0,0-3.41-.75,4.76,4.76,0,0,0-.91.19c-2.9.92-4.06,3.49-4.92,7-.94,3.88.38,8.46,2.85,9.24a14.5,14.5,0,0,0,1.63.35,6.57,6.57,0,0,0,1.88.11,4,4,0,0,0,2-.76,8.62,8.62,0,0,0,2.61-3.65,12.66,12.66,0,0,0,.92-4.23,13.52,13.52,0,0,0-.36-4.27\"/></svg>')}.logo-commercial-white{background-image:url('data:image/svg+xml,<?xml version=\"1.0\" encoding=\"utf-8\"?>%0A<!-- Generator: Adobe Illustrator 22.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->%0A<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"%0A%09 viewBox=\"0 0 897.1 264.7\" style=\"enable-background:new 0 0 897.1 264.7;\" xml:space=\"preserve\">%0A<style type=\"text/css\">%0A%09.st0{fill:%23FCE500;}%0A%09.st1{fill:%23FFFFFF;}%0A<\\/style>%0A<path d=\"M251.3,182.3c-0.1-0.1-0.1-0.2-0.2-0.3c0.8-6.2-0.6-12.3-4.1-17.5c-3.8-5.6-9.5-9.5-16.2-10.8c-0.7-0.1-1.4-0.2-2.1-0.3%0A%09c-0.1,0-0.2,0-0.3,0c-6.8-6.6-14-10-16.6-11.1c0.1-0.4,0.2-0.7,0.2-1c0.1,0,0.2-0.1,0.3-0.1c7.3-3.2,11.6-8.5,12.5-15.5%0A%09c0.7-5.5-0.8-11.6-3.9-15.9c0-0.1,0-0.1,0-0.2c0.7-7.4-0.4-13.9-3.3-19.3c-2.4-4.4-6.1-7.9-10.3-9.8c0,0,0,0-0.1,0%0A%09c-1.2-4-6.3-7-11.7-6.9c-4.3,0.1-9,2.1-10.7,5.4c-6.5,2.4-16.7,8.5-19.8,23.9c-4.5,3.4-7.5,8.4-8.2,13.9c-0.8,6.1,1.3,12.2,5.4,16.7%0A%09c-4.2,0-10.9,0.4-18.8,2c-0.1,0-0.2,0-0.2,0.1c-6.1-4.3-14-6-21-4.1c-0.3,0.1-0.5,0.2-0.8,0.4c-2-0.6-4.1-1-6.4-1.3%0A%09c-0.1,0-0.3,0-0.4,0c-1-3.3-2.8-6.3-5.2-8.7c-0.1-0.1-0.4-0.3-0.4-0.4l0,0c-0.4-2.4-1-5-1.3-6c-0.7-2.4-1.8-5-4.9-8.1%0A%09c-2-2-4.1-3.2-5.6-3.9c0.3-0.8,0.5-1.5,0.6-1.9c0-0.2,0.1-0.3,0.1-0.5c0-0.1,0.8-7.5,1.7-11.9c0-0.1,0-0.1,0-0.2%0A%09c2.4-15.2,2.4-15.4,2.5-15.5v-0.1c0.1-1.4-0.4-2.7-1.3-3.7c-1.2-1.3-2.9-2-4.9-2c-2.7,0-5.1,1.4-6.6,3.8c-0.9,1.4-1.5,3.1-2,4.6%0A%09c-2.5-4.9-5.8-11.3-8.2-16c0-0.1-0.1-0.2-0.1-0.2c-0.8-1.4-2.7-3-5.3-3c-0.8,0-1.6,0.1-2.3,0.4c-1.1-1-2.6-1.5-4.1-1.5%0A%09c-0.8,0-1.5,0.1-2.3,0.4c-2.7,0.9-4.2,3.3-4.2,6.1c-2.1,0.8-3.5,2.4-3.9,4.6c-0.3,1.5,0,2.7,0.2,3.3c0,0.1,0.1,0.2,0.1,0.4%0A%09c-0.1,0.1-0.1,0.2-0.2,0.3c-1.5,2.3-2.3,6.7,3.4,20.9c0,0,0,0.1,0.1,0.1c0.1,0.2,0.2,0.6,0.4,1c1,2.4,3.1,7.4,5.6,11.9%0A%09c1.4,2.5,2.8,4.5,4.1,6.1c-1,1.5-2.5,4-3.2,7.2c-0.8,3.3-0.4,7.6,1,11.7c0.6,1.7,1.3,3.3,2.2,4.8l0,0l0,0c0,0.1-0.1,0.3-0.1,0.4%0A%09c-1,8.1,2.4,16,9.3,21.2c1.1,0.8,2.2,1.5,3.4,2.2c1,3.1,3.1,5.9,6,8.3c2,1.6,4.3,2.9,6.8,3.7c0,0,0,0,0,0.1%0A%09c2.6,3.7,6.5,6.3,11.4,7.7c1.2,0.3,2.5,0.6,3.8,0.8c0.1,0.1,0.1,0.1,0.2,0.2c2.4,2.3,5.5,4.1,9.1,5.1c-0.6,4.7,0,8.3,1,11h133.7%0A%09C254.9,190.6,253.7,186.3,251.3,182.3z\"/>%0A<polygon class=\"st0\" points=\"720.7,195 89.1,195 84,209 715.6,209 \"/>%0A<path class=\"st1\" d=\"M460.7,112c-16.3,3.3-38.5,15.4-38.3,37.3c0.1,12.6,15.4,19.7,32.9,19.2c9.8-0.3,19.2-2.1,20.4-2.3l6.5-16.9%0A%09c-8.6,1.4-16.9,3.4-23.3,0.8c-11.7-4.7-4.5-16.8,3.8-20.6c3.6-1.7,8.6-3.2,14.5-3.1c2.5,0,8.5,0.2,10.8,5.5l8.2-19.6%0A%09C482.2,108.8,468.1,110.5,460.7,112z M549.4,111.4l-7.4,20.1h-13.6l7.4-20.1H510l-20.5,55.7h25.7l7-18.9h13.6l-7,18.9h25.7%0A%09l20.5-55.7C575,111.4,549.4,111.4,549.4,111.4z M396.2,111.4l-20.5,55.7h27l20.5-55.7C423.2,111.4,396.2,111.4,396.2,111.4z%0A%09 M342.5,111.4l-19.7,29.9c0,0,1.3-15.7,1.6-19.4c0.2-2.9-0.1-10.5-7.1-10.5H286l-20.5,55.7H290l14.9-40.3l-3.1,40.3h21.7l26.7-39.6%0A%09l-14.6,39.6h24.6l20.5-55.7C380.7,111.4,342.5,111.4,342.5,111.4z M818.8,111.4l-14.1,38.2c0.2-3.9,1-19.1,1.4-27.8%0A%09c0.2-3.6-0.6-6.4-2.3-8.2c-2.1-2.2-4.9-2.2-4.9-2.2h-31.4L747,167.2h22.8l14.5-39.5l-1.7,39.5h38.2l20.5-55.7L818.8,111.4%0A%09L818.8,111.4z M724.5,111.4L704,167.2h27l20.5-55.7L724.5,111.4L724.5,111.4z M610.3,126h30.8l5.4-14.6h-56.3l-20.5,55.7h56.9%0A%09l5.5-15h-31.4l2.3-6.2h29.3l5-13.7H608L610.3,126z M687.7,111.4h-26.3l-20.5,55.7h52.7l6.8-18.5H674L687.7,111.4z\"/>%0A<path class=\"st1\" d=\"M250.6,195h-5.3c1.7-2,3.1-4.3,4.1-6.8C250.2,190.4,250.6,192.7,250.6,195\"/>%0A<path class=\"st1\" d=\"M163.5,137.8c0,0,2,0.1,3.1,0.6c2,0.8,5.9,4.5,8,4.8c0.4,0,1.3-0.2,0.3-0.9c-0.3-0.2-2.7-2.4-1.8-3.5l0,0%0A%09c0.3-0.5,0.7-0.6,1.2-0.5c3.1,0.8,5.6,1.2,6.5,1.3c0.5,0.1,0.9,0.1,1.2-0.1c0.2-0.2,0.1-0.3-0.5-0.5c-4.7-1.3-10-3.3-13.6-6.1%0A%09c-4.9-3.8-7.5-9.7-6.8-15.6c0.6-4.3,2.8-8.2,6.4-10.9c1.4-1,3.7-1.8,4.3-2c1.7-0.6-1.1-1.1-1.3-1.1c-0.7-0.1-0.8-0.9-0.2-3.1%0A%09c3.3-10.5,10.5-15.2,16.6-17.2c1.1-0.3,2.7-0.8,3.8-0.9c1.7-0.3,1-1-0.9-1.2c0,0-0.6,0-0.3-0.5c0.1-0.1,0.4-0.5,0.9-0.8%0A%09c1.4-0.9,3.3-1.5,5.5-1.6c3.9-0.1,7.2,2.1,7.6,4.1c0,0,0.1,0.4-0.3,0.4c-0.7,0-1.3,0.3-0.3,0.8c0.2,0.1,1.3,0.4,2.7,1.1%0A%09c0.1,0,0.1,0.1,0.2,0.1c2.9,1.4,12,6.9,11.3,22.5l0,0c0,0.5-0.1,0.9-0.1,1.4c0,0.4-0.1,0.9-0.1,1.3c-0.9-0.1-1.2,0.3-0.6,0.9%0A%09c0.4,0.4,1.5,1.8,2.2,2.8c2,3.4,3.1,7.8,2.5,12c-0.7,5.6-4.2,9-7.6,11c-1.5,0.9-5.1,2.6-9.6,3.6c-0.9,0.2-0.5,1.4,3.7,1.3%0A%09c0.4,0,1.1,0.1,1.3,0.5c0.5,0.9-0.4,2.7-2.2,3.8c-1.6,0.9-0.3,1.1,1.9,0.5c0.6-0.1,2.3,0.6,2.5,0.7c3.6,1.6,12.6,6.2,19.3,15.3%0A%09c4.7,6.7,6.4,12,4.9,15.3c-1.4,3.2-5.7,3.8-5.7,3.8s0,0-0.1,0c-16.3,2.5-44.7-1.9-64.2-7.7c-3.5-1-8.7-2.9-13.1-4.8%0A%09c4.3-9.3,2.6-21.2-4.4-29.2c-0.1-0.1-0.2-0.2-0.3-0.3C154.4,137.9,160.2,137.8,163.5,137.8\"/>%0A<path class=\"st1\" d=\"M243.5,166.9c3.1,4.7,4.3,10.3,3.2,15.9c-0.9,4.7-3.4,8.9-7,11.9c0.1-3.9-0.6-8.4-3.4-12%0A%09c1.1-0.9,2.2-2.1,2.9-3.7c2.2-4.8,0.4-11.4-5.3-19.6c0,0,0,0,0-0.1c-0.1-0.2-0.2-0.3-0.4-0.5C237.5,160.4,241,163.2,243.5,166.9\"/>%0A<path class=\"st1\" d=\"M144.5,142.3c6.5,7.4,7.6,18.6,2.6,26.6c-5.6,9.1-15.7,13.5-25.1,11.2c-1.4-0.3-2.6-0.8-3.8-1.4%0A%09c0.9-0.1,1.8-0.3,2.6-0.6c9.2-2.5,16.1-11,17.2-21.2c0.6-6.4-1.2-12.9-5-17.6c-1.3-1.7-2.9-3.1-4.7-4.3%0A%09C134.3,135,140.4,137.6,144.5,142.3\"/>%0A<path class=\"st1\" d=\"M129.6,142c3.1,3.9,4.6,9.2,4.1,14.5c-0.9,8.4-6.5,15.4-14,17.5c-6.3,1.7-12.4,0.2-16.6-2.5%0A%09c9.2-0.2,18-6.5,20.9-15.7c1.5-4.6,1.4-9.6-0.3-14.1c-0.8-2.1-1.9-4-3.2-5.7C124.5,137.2,127.4,139.2,129.6,142\"/>%0A<path class=\"st1\" d=\"M115.3,142.2c0.3-1.7,0.5-3.5,0.4-5.2c4.5,4.3,6.3,11.1,4.3,17.4c-2.8,8.7-12.1,14.2-20.7,12.3%0A%09c-3.6-0.8-7.9-3.1-10.4-6.4c1.6,0.3,3.1,0.5,4.7,0.5c3,0,6-0.6,8.8-1.8C109,156.1,113.8,149.9,115.3,142.2\"/>%0A<path class=\"st1\" d=\"M108.8,127.9L108.8,127.9c2.3,3.8,3.1,8.6,2.2,13.5c-1.2,6.3-5.1,11.4-10.4,13.7c-6.1,2.6-13,1.7-18.6-2.5%0A%09c-4.4-3.3-7.1-8.1-7.7-13.1l0,0c0.4,0.4,0.9,0.8,1.4,1.1c3.4,2.4,7.5,3.7,12,3.7c3,0,5.3-0.6,5.7-0.7c7.9-2.2,11.7-6.9,13.6-10.5%0A%09C107.9,131.2,108.5,129.4,108.8,127.9\"/>%0A<path class=\"st1\" d=\"M60.5,73c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.3-0.2,0.5-0.3c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0,0.6,0%0A%09c0.1,0,0.3,0,0.4,0.1c1.2,0.5,2.2,2,2.4,4.2c0.8,6.3,3.8,10.4,3.9,10.6c0.2,0.3,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.5-0.2%0A%09c0.4-0.3,0.5-0.9,0.2-1.3c0,0-2.8-3.9-3.6-9.8c-0.4-2.9-1.7-5-3.7-5.7c-0.5-0.2-0.9-0.2-1.4-0.2c-0.3-0.6-0.5-1.1-0.6-1.4%0A%09c-0.2-0.8-0.5-2.4,1.2-3c0.1,0,0.2-0.1,0.3-0.1s0.1,0,0.2,0c1.3-0.2,3,0.4,4.7,6.5c1.6,5.5,5.1,10.9,5.2,11.2%0A%09c0.2,0.3,0.5,0.4,0.8,0.4c0.2,0,0.4,0,0.5-0.2c0.4-0.3,0.5-0.9,0.3-1.3c0-0.1-3.5-5.4-5-10.6c-0.7-2.6-1.8-5.4-3.5-6.9%0A%09c-0.2-0.6-0.5-1.4-0.6-1.6c-0.3-0.9-0.6-2.9,1.1-3.4c0.3-0.1,0.7-0.2,0.9-0.2c1.3,0,2,1.2,2.4,2c0,0.1,0.1,0.3,0.2,0.4l7.7,18.3%0A%09c0,0.1,0.1,0.3,0.2,0.3c0.2,0.2,0.6,0.3,0.9,0.2c0.4-0.2,0.7-0.7,0.5-1.1l-7.5-17.8c0.1-0.3,0.4-0.7,0.8-0.9%0A%09c0.5-0.2,0.9-0.3,1.2-0.3c1.1,0,1.7,0.9,1.7,0.9S85.2,81.4,87,84.8c-0.8,1.3-1.4,2.5-1.5,2.8c-0.1,0.5,0.2,0.9,0.4,0.5%0A%09c0.6-0.8,1.4-1.8,2-2.6l0,0l0,0l0.1-0.1c0.5-0.8,1.9-4.7,2.5-5.9c0.4-1.8,1.2-4.2,2.2-5.7c0.8-1.3,2-1.8,3.1-1.8s2,0.6,2,1.1%0A%09c0,0.3-2.4,15.3-2.4,15.3c-0.6,3.1-1.2,7.6-1.5,10.2c0,0.6-0.1,1.3-0.2,1.9c0,0.1,0,0.2,0,0.2s0,0.1-0.1,0.4c-0.5,2.3-1.4,4-1.4,4%0A%09l0.8,3.6l0,0c0.3,1.5,0.6,3.1,0.8,3.6c0.6,2-0.2,3.2,0.2,3.6c0.5,0.6,1.8-2.1,2.1-3.5c0.3-1.1-0.2-3.4-0.5-5%0A%09c1.1,0.5,2.7,1.4,4.2,2.9c2.6,2.6,3.3,4.6,3.8,6.3c0.5,1.7,1.3,5.2,1.4,7.2c0.1,1.9-0.6,12.2-12.7,15.6c0,0-1.9,0.6-4.5,0.6%0A%09c-2.7,0-6.2-0.6-9.5-2.9c-5.9-4.2-8.2-13.3-7-18.1c0.5-2.3,1.5-4.1,2.3-5.3c0.6,0.3,1.1,0.6,1.7,0.8l0.4,1.7c0,0.2,1,4.8,2.8,6.2%0A%09c1.1,0.8,2.8,0.9,3.3,0.9s1.8-0.1,2-0.6c0-0.1,0.1-0.3-0.1-0.6c-0.1-0.1-0.2-0.2-0.6-0.4c-0.9-0.5-2.5-1.3-2.8-2.9%0A%09c-0.2-0.9-0.9-4-1.4-5.9c1.8-1.4,2-3-0.4-2.5c-1.4,0.3-2.7-0.4-3.8-1.2C70,105.1,65,92.4,64,90.1C60.1,79.9,59.2,74.5,60.5,73\"/>%0A<path class=\"st1\" d=\"M124.4,184.9c0.9,0.1,1.8,0.1,2.7,0.1c8.8,0,17.4-4.7,22.9-12.7c4.7,2.1,10.2,4.1,14.1,5.2%0A%09c10.8,3.2,23.1,5.7,34.7,7.2c7.3,0.9,14,1.4,19.8,1.4c4.4,0,8.3-0.3,11.6-0.8c0.2,0,1.1-0.2,2.2-0.6c2.6,2.8,3.2,6.8,3,10.2H125.8%0A%09C124.8,193,123.9,189.7,124.4,184.9\"/>%0A<path d=\"M184.8,110.9c0.5,0.6,1.1,1,1.8,1.3c0.6,0.2,1.2,0.3,1.9,0.4c0,0,1.1,0.1,1.7,0.1c2.7-0.1,5.2-4.2,5.3-8.3%0A%09c0.1-3.7-0.4-6.5-3.1-8.1c-0.3-0.2-0.6-0.3-0.9-0.4c-1.1-0.4-2.5-0.5-3.6-0.2c-1.4,0.4-2.4,1.4-3.2,2.6c-0.7,1.2-1.2,2.7-1.5,4.1%0A%09s-0.4,2.9-0.2,4.4C183.3,108.1,183.8,109.7,184.8,110.9z M184.3,104.4c0.2-1.7,1.2-7.2,5.5-6.8c3.3,0.3,4.2,2.8,4.5,4.9%0A%09c0,0.1,0,0.2,0,0.3c0.2,2.1-0.2,3.6-0.7,4.9c-0.2,0.5-0.5,1.1-0.8,1.5c-0.8,1.3-1.8,2.1-2.6,2.1c-0.1,0-0.2,0-0.2,0%0A%09c1.5-0.8,2.6-2.8,2.8-5.2c0.3-3.2-1.2-6-3.4-6.2c-1-0.1-2,0.4-2.8,1.3c0.8,0,1.4,0.8,1.5,1.8c0,1-0.6,1.9-1.4,2%0A%09c-0.7,0-1.2-0.5-1.4-1.2c-0.2,0.5-0.3,1.1-0.3,1.7c-0.2,2,0.3,3.8,1.2,4.9c-0.1-0.1-0.3-0.2-0.4-0.4c-0.7-0.8-1.2-2.1-1.4-3.6%0A%09C184.3,105.8,184.2,105.1,184.3,104.4z M209.7,120.1c-0.5-0.1-0.6,0.3-0.4,0.5c0.1,0,0.1,0.1,0.2,0.2c-0.2,0.1-0.3,0.2-0.5,0.3%0A%09c-1,0.5-2.1,0.8-3.3,1.1c-2.7,0.6-5.6,0.7-8.4,0.4c-4.6-0.4-9.2-1.4-13.5-3.2c-0.4-0.2-0.8-0.3-1.1-0.5c-0.2-0.1-0.4-0.2-0.6-0.3%0A%09l0,0c-0.6-0.2-1.2,0.2-1.2,0.8c0,0.5,0.3,0.8,0.7,1c1.1,0.6,2.4,1,3.6,1.5c1.1,0.5,1.8,1.4,2.6,2.2c1,1,2,1.9,3.2,2.6%0A%09c2.3,1.3,5.2,1.8,7.8,1.4c1.4-0.2,2.6-0.7,3.8-1.4c0.8-0.5,1.6-1.2,2.4-1.8c0.5-0.4,0.9-0.7,1.4-1c0.3-0.2,2.4-1,3.5-1.6%0A%09c0,0.4,0,0.7,0.2,0.8c0.3,0.1,0.5-0.5,0.6-0.9c0.1-0.5,0-0.9-0.1-1.2C210.6,120.6,210.1,120.1,209.7,120.1z M199.9,126.1%0A%09c-1.2,0.4-2.5,0.4-3.7,0.3s-2.5-0.4-3.6-0.9c-1.2-0.6-2.3-1.5-3.2-2.4c4.5,1.1,9.2,1.7,13.8,1.2C202.2,125,201.1,125.7,199.9,126.1z%0A%09 M182.8,117.2c-0.1-0.4-0.6-0.4-0.7-0.4c-0.4,0-1,0.1-1.4,0.3c-1.1,0.4-2,1.7-1.9,2.5c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.2,0.4,0.2%0A%09l0,0l0,0l0,0c0.2,0,0.3-0.2,0.3-0.4c0-0.2,0.1-0.6,0.4-0.9c0.3-0.3,0.8-0.8,2.2-1C182.6,117.8,182.9,117.6,182.8,117.2z%0A%09 M212.4,101.9c-0.4-1.3-1.1-2.6-2.3-3.3c-1-0.6-2.2-0.9-3.4-0.7c-0.3,0-0.6,0.1-0.9,0.2c-2.9,0.9-4.1,3.5-4.9,7%0A%09c-0.9,3.9,0.4,8.5,2.9,9.2c0.6,0.2,1.6,0.4,1.6,0.4c0.6,0.1,1.3,0.2,1.9,0.1c0.7-0.1,1.4-0.3,2-0.8c1.2-0.9,2-2.3,2.6-3.6%0A%09c0.6-1.4,0.8-2.8,0.9-4.2C212.8,104.8,212.7,103.3,212.4,101.9z M211.3,108c-0.1,0.7-0.3,1.4-0.6,2c-0.6,1.4-1.4,2.5-2.2,3.1%0A%09c-0.4,0.3-0.8,0.4-1.2,0.5c1.4-0.8,2.5-2.8,2.7-5.1c0.3-3.2-1.2-6-3.3-6.2c-1-0.1-2,0.4-2.8,1.3c0.8,0,1.4,0.8,1.4,1.8%0A%09s-0.6,1.9-1.3,2c-0.6,0-1.2-0.5-1.4-1.2c-0.2,0.5-0.3,1.1-0.3,1.7c-0.2,2.2,0.4,4.1,1.5,5.2c-0.6-0.4-1.2-1.3-1.6-2.5%0A%09c-0.2-0.5-0.3-1.1-0.3-1.7c-0.1-1.4-0.2-2.9,0.6-4.9c0-0.1,0.1-0.2,0.1-0.3c0.8-2,2.2-4.1,5.4-3.6C212,100.8,211.6,106.3,211.3,108z%0A%09\"/>%0A</svg>%0A')}\n"] }]
        }], propDecorators: { type: [{
                type: Input
            }], width: [{
                type: Input
            }], height: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], link: [{
                type: Input
            }], target: [{
                type: Input
            }] } });

const imports$9 = [CommonModule, LinkModule];
const components$8 = [LogoComponent];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { LogoModule } from '@michelin/theme';</code>
 */
class LogoModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: LogoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: LogoModule, declarations: [LogoComponent], imports: [CommonModule, LinkModule], exports: [LogoComponent, CommonModule, LinkModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: LogoModule, imports: [imports$9, CommonModule, LinkModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: LogoModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$9,
                    declarations: [...components$8],
                    exports: [...components$8, ...imports$9]
                }]
        }] });

/**
 * Manage the sidebar behaviour with the service
 *
 * Support toggle on sidebar
 */
class SidebarService {
    constructor() {
        this.sideNavToggle = new Subject();
        this.sideNavCollapse = new Subject();
        this.sideNav = new BehaviorSubject({});
        this.sideNavOpenDefault = true;
    }
    toggle(type, toggler, opened) {
        return this.sideNavToggle.next({ type, toggler, opened });
    }
    switch(type, toggler, opened, collapsed) {
        return this.sideNav.next({ type, toggler, opened, collapsed });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SidebarService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SidebarService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SidebarService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class MainContentComponent {
    constructor(sidebarService, breakpointObserver) {
        this.sidebarService = sidebarService;
        this.breakpointObserver = breakpointObserver;
        this.class = 'sidenav-opened sidenav-expanded';
    }
    ngAfterContentInit() {
        this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
            this.small = result.breakpoints[Breakpoints.XSmall] || result.breakpoints[Breakpoints.Small];
        });
        if (!this.small) {
            this.sidebarService.sideNav.subscribe((sidenav) => {
                if (sidenav.opened && sidenav.collapsed) {
                    this.class = `sidenav-opened sidenav-collapsed sidenav-${sidenav.type}`;
                }
                else if (sidenav.opened) {
                    this.class = `sidenav-opened sidenav-expanded sidenav-${sidenav.type}`;
                }
                else {
                    this.class = `sidenav-closed sidenav-${sidenav.type}`;
                }
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: MainContentComponent, deps: [{ token: SidebarService }, { token: i2$5.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: MainContentComponent, selector: "mic-main-content", host: { properties: { "class": "this.class" } }, ngImport: i0, template: "<div class=\"flex flex-col fill justify-between\">\n  <main role=\"main\" id=\"main-content\" tabindex=\"-1\" class=\"flex-1\">\n    <ng-content select=\"[content]\"></ng-content>\n  </main>\n  <ng-content select=\"mic-footer\"></ng-content>\n</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: MainContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-main-content', template: "<div class=\"flex flex-col fill justify-between\">\n  <main role=\"main\" id=\"main-content\" tabindex=\"-1\" class=\"flex-1\">\n    <ng-content select=\"[content]\"></ng-content>\n  </main>\n  <ng-content select=\"mic-footer\"></ng-content>\n</div>\n" }]
        }], ctorParameters: () => [{ type: SidebarService }, { type: i2$5.BreakpointObserver }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }] } });

const imports$8 = [CommonModule, MaterialModule];
const components$7 = [MainContentComponent];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { MainContentModule } from '@michelin/theme';</code>
 */
class MainContentModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: MainContentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: MainContentModule, declarations: [MainContentComponent], imports: [CommonModule, MaterialModule], exports: [MainContentComponent, CommonModule, MaterialModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: MainContentModule, imports: [imports$8, CommonModule, MaterialModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: MainContentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$8,
                    declarations: [...components$7],
                    exports: [...components$7, ...imports$8]
                }]
        }] });

/**
 * Define modal button configuration
 */
class ModalButton {
}

/**
 * Modal content component
 */
class ModalContentComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    ngOnInit() {
        // Treat button options
        this.buttonCancel = this.manageButton(this.data.cancel);
        this.buttonConfirm = this.manageButton(this.data.confirm, 'primary');
    }
    onCancelClick() {
        this.dialogRef.close({
            id: this.data.id,
            result: false
        });
    }
    onConfirmClick() {
        this.dialogRef.close({
            id: this.data.id,
            result: true
        });
    }
    manageButton(button, defaultColor) {
        const newButton = new ModalButton();
        if (typeof button === 'string') {
            newButton.text = button;
            newButton.color = defaultColor;
        }
        if (typeof button === 'object') {
            newButton.text = button.text;
            newButton.color = button.color;
            newButton.icon = button.icon;
        }
        return newButton;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ModalContentComponent, deps: [{ token: i1$7.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: ModalContentComponent, selector: "ng-component", ngImport: i0, template: "@if (data.title) {\n<h3 mat-dialog-title class=\"flex flex-row\">\n  <span class=\"flex-1\">{{ data.title }}</span>\n  <button mat-icon-button class=\"mic-icon-button-large\" aria-label=\"Close\" (click)=\"onCancelClick()\">\n    <mat-icon aria-hidden=\"false\">close</mat-icon>\n  </button>\n</h3>\n} @if (data.content) {\n<mat-dialog-content micScrollBar>\n  <ng-template [ngTemplateOutlet]=\"data.content\"></ng-template>\n</mat-dialog-content>\n} @if (data.cancel || data.confirm) {\n<mat-divider></mat-divider>\n} @if (data.cancel || data.confirm) {\n<mat-dialog-actions class=\"flex flex-row align-end\">\n  @if (data.cancel) {\n  <button mat-flat-button mat-dialog-close [color]=\"buttonCancel.color\" (click)=\"onCancelClick()\" tabindex=\"0\">\n    @if (buttonCancel?.icon) {\n    <mic-icon [icon]=\"buttonCancel.icon\"></mic-icon>\n    }\n    <span>{{ buttonCancel.text }}</span>\n  </button>\n  } @if (data.confirm) {\n  <button mat-flat-button [color]=\"buttonConfirm.color\" (click)=\"onConfirmClick()\" tabindex=\"0\">\n    @if (buttonConfirm?.icon) {\n    <mic-icon [icon]=\"buttonConfirm.icon\"></mic-icon>\n    }\n    <span>{{ buttonConfirm.text }}</span>\n  </button>\n  }\n</mat-dialog-actions>\n}\n", styles: [":host{padding:24px 0}::ng-deep .mat-mdc-dialog-surface{overflow:hidden;border-radius:8px!important}.mat-mdc-dialog-title{font-size:24px;font-weight:700;margin:0;display:flex}.mat-divider{margin:24px -24px 0}.mat-mdc-dialog-content{color:inherit}.mat-mdc-dialog-actions{padding:0;margin-bottom:-20px;justify-content:end}.mat-mdc-dialog-actions button{margin:16px 16px 16px 0}\n"], dependencies: [{ kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i1.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", exportAs: ["matButton"] }, { kind: "component", type: i1.MatIconButton, selector: "button[mat-icon-button]", exportAs: ["matButton"] }, { kind: "directive", type: i1$7.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$7.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$7.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "directive", type: i1$7.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "component", type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i5$2.MatDivider, selector: "mat-divider", inputs: ["vertical", "inset"] }, { kind: "component", type: IconComponent, selector: "mic-icon", inputs: ["icon", "fontSet", "ariaLabel", "decorative"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ModalContentComponent, decorators: [{
            type: Component,
            args: [{ template: "@if (data.title) {\n<h3 mat-dialog-title class=\"flex flex-row\">\n  <span class=\"flex-1\">{{ data.title }}</span>\n  <button mat-icon-button class=\"mic-icon-button-large\" aria-label=\"Close\" (click)=\"onCancelClick()\">\n    <mat-icon aria-hidden=\"false\">close</mat-icon>\n  </button>\n</h3>\n} @if (data.content) {\n<mat-dialog-content micScrollBar>\n  <ng-template [ngTemplateOutlet]=\"data.content\"></ng-template>\n</mat-dialog-content>\n} @if (data.cancel || data.confirm) {\n<mat-divider></mat-divider>\n} @if (data.cancel || data.confirm) {\n<mat-dialog-actions class=\"flex flex-row align-end\">\n  @if (data.cancel) {\n  <button mat-flat-button mat-dialog-close [color]=\"buttonCancel.color\" (click)=\"onCancelClick()\" tabindex=\"0\">\n    @if (buttonCancel?.icon) {\n    <mic-icon [icon]=\"buttonCancel.icon\"></mic-icon>\n    }\n    <span>{{ buttonCancel.text }}</span>\n  </button>\n  } @if (data.confirm) {\n  <button mat-flat-button [color]=\"buttonConfirm.color\" (click)=\"onConfirmClick()\" tabindex=\"0\">\n    @if (buttonConfirm?.icon) {\n    <mic-icon [icon]=\"buttonConfirm.icon\"></mic-icon>\n    }\n    <span>{{ buttonConfirm.text }}</span>\n  </button>\n  }\n</mat-dialog-actions>\n}\n", styles: [":host{padding:24px 0}::ng-deep .mat-mdc-dialog-surface{overflow:hidden;border-radius:8px!important}.mat-mdc-dialog-title{font-size:24px;font-weight:700;margin:0;display:flex}.mat-divider{margin:24px -24px 0}.mat-mdc-dialog-content{color:inherit}.mat-mdc-dialog-actions{padding:0;margin-bottom:-20px;justify-content:end}.mat-mdc-dialog-actions button{margin:16px 16px 16px 0}\n"] }]
        }], ctorParameters: () => [{ type: i1$7.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }] });

/**
 * Component to build modal
 */
class ModalComponent {
    constructor(dialog) {
        this.dialog = dialog;
        this.result = new EventEmitter();
    }
    open(data) {
        const dialogRef = this.dialog.open(ModalContentComponent, {
            width: data.width + 'px',
            data
        });
        dialogRef.afterClosed().subscribe((result) => {
            this.result.emit(result);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ModalComponent, deps: [{ token: i1$7.MatDialog }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: ModalComponent, selector: "mic-modal", outputs: { result: "result" }, ngImport: i0, template: ``, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'mic-modal',
                    template: ``
                }]
        }], ctorParameters: () => [{ type: i1$7.MatDialog }], propDecorators: { result: [{
                type: Output
            }] } });

const imports$7 = [CommonModule, MaterialModule, FormsModule, IconModule];
const components$6 = [ModalComponent, ModalContentComponent];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { ModalModule } from '@michelin/theme';</code>
 */
class ModalModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: ModalModule, declarations: [ModalComponent, ModalContentComponent], imports: [CommonModule, MaterialModule, FormsModule, IconModule], exports: [ModalComponent, ModalContentComponent, CommonModule, MaterialModule, FormsModule, IconModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ModalModule, imports: [imports$7, CommonModule, MaterialModule, FormsModule, IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$7,
                    declarations: [...components$6],
                    exports: [...components$6, ...imports$7]
                }]
        }] });

/**
 * Directive to associated content to the pagination html
 *
 */
class PaginatorContentDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: PaginatorContentDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: PaginatorContentDirective, selector: "[micPaginatorContent]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: PaginatorContentDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[micPaginatorContent]'
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });

class MicCustomPaginatorDirective {
    get nbPagesToShow() {
        return this.defaultNbPagesToShow();
    }
    set nbPagesToShow(value) {
        this.defaultNbPagesToShow.set(value % 2 === 0 ? value + 1 : value);
    }
    get numOfPages() {
        return this.paginator.getNumberOfPages();
    }
    get lastPageIndex() {
        return this.paginator.getNumberOfPages() - 1;
    }
    /**
     *  Constructor
     *
     */
    constructor(paginator, containerRef, renderer, differs) {
        this.paginator = paginator;
        this.containerRef = containerRef;
        this.renderer = renderer;
        this.differs = differs;
        this.pageGapTxt = '...';
        this.rangeStart = signal(0);
        this.rangeEnd = signal(0);
        this.buttons = [];
        this.currentPage = signal({
            length: 0,
            pageIndex: 0,
            pageSize: 2,
            previousPageIndex: 0
        });
        this.defaultNbPagesToShow = signal(5);
        this.micCustomPaginator = false;
        this.dataDiffer = this.differs.find({}).create();
    }
    ngDoCheck() {
        if (this.micCustomPaginator) {
            const dataChanges = this.dataDiffer.diff(this.paginator);
            if (dataChanges) {
                dataChanges.forEachItem((item) => {
                    switch (item.key) {
                        case '_pageSize':
                            this.handlePageSizeChange(item.currentValue);
                            break;
                        case '_pageIndex':
                            this.handlePageIndexChange(item.currentValue);
                            break;
                        case '_length':
                            this.handleLengthChange(item.currentValue);
                            break;
                    }
                });
            }
        }
    }
    /**
     * Update page data on page size change
     *
     * @param newPageSize new page size
     */
    handlePageSizeChange(newPageSize) {
        if (this.currentPage().pageSize !== newPageSize) {
            this.rangeStart.set(0);
            this.currentPage().pageIndex = 0;
            this.currentPage().pageSize = newPageSize;
            this.buildPageNumbers(this.currentPage().pageIndex);
        }
    }
    /**
     * Update page data on page data change
     *
     * @param newPageIndex new page index
     */
    handlePageIndexChange(newPageIndex) {
        if (this.currentPage().pageIndex !== newPageIndex) {
            this.currentPage().pageIndex = newPageIndex;
            this.buildPageNumbers(newPageIndex);
        }
    }
    /**
     * Update page data on paginator data length change
     *
     * @param newLength new data length
     */
    handleLengthChange(newLength) {
        if (this.currentPage.length !== newLength) {
            this.rangeStart.set(0);
            this.currentPage().pageIndex = 0;
            this.currentPage().length = newLength;
            this.buildPageNumbers(this.currentPage().pageIndex);
        }
    }
    /**
     * Compute the new pages range from the page change record
     *
     * @param item page change record
     */
    computePageRange(currentPageIndex) {
        const nbPagesBefore = Math.round((this.nbPagesToShow - 1) / 2);
        // compute range start
        const newRangeStart = currentPageIndex - nbPagesBefore;
        let startRangeDiff = 0;
        if (newRangeStart < 0) {
            this.rangeStart.set(0);
            startRangeDiff = Math.abs(newRangeStart);
        }
        else {
            this.rangeStart.set(newRangeStart);
        }
        // compure range end
        const newRangeEnd = currentPageIndex + nbPagesBefore;
        let endRangeDiff = 0;
        if (newRangeEnd > this.numOfPages - 1) {
            this.rangeEnd.set(this.numOfPages - 1);
            endRangeDiff = Math.abs(this.numOfPages - 1 - newRangeEnd);
        }
        else {
            this.rangeEnd.set(newRangeEnd);
        }
        // Adjust the range if we've hit a bound
        if (startRangeDiff > 0) {
            this.rangeEnd.set(Math.min(this.rangeEnd() + startRangeDiff, this.numOfPages - 1));
        }
        if (endRangeDiff > 0) {
            this.rangeStart.set(Math.max(this.rangeStart() - endRangeDiff, 0));
        }
    }
    /**
     * Create the pagination button based on the rangeStart and rangeEnd
     *
     */
    buildPageNumbers(currentPageIndex) {
        this.computePageRange(currentPageIndex);
        const pageInfo = this.containerRef.element.nativeElement.querySelector('.mat-mdc-paginator-range-label');
        if (pageInfo) {
            pageInfo.remove();
        }
        const actionContainer = this.containerRef.element.nativeElement.querySelector('.mat-mdc-paginator-range-actions');
        const nextPageNode = this.containerRef.element.nativeElement.querySelector('.mat-mdc-paginator-navigation-next');
        const previousPageNode = this.containerRef.element.nativeElement.querySelector('.mat-mdc-paginator-navigation-previous');
        // remove buttons before creating new ones
        if (this.buttons.length > 0) {
            this.buttons.forEach((button) => {
                this.renderer.removeChild(actionContainer, button);
            });
            this.buttons.length = 0;
        }
        for (let i = this.rangeStart(); i <= this.rangeEnd(); i++) {
            this.renderer.insertBefore(actionContainer, this.createButton(i, this.paginator.pageIndex), nextPageNode);
        }
        // add the ... buttons
        // before numerotation
        if (this.rangeStart() > 0) {
            this.renderer.insertBefore(actionContainer, this.createButton(this.pageGapTxt, this.rangeStart()), previousPageNode.nextSibling);
        }
        // after numerotation
        if (this.rangeEnd() < this.numOfPages - 1) {
            this.renderer.insertBefore(actionContainer, this.createButton(this.pageGapTxt, this.rangeEnd()), nextPageNode);
        }
    }
    /**
     * Create a pagination button
     *
     * @param i Index of the button
     * @param pageIndex Current page index
     * @returns MatButton element
     */
    createButton(i, pageIndex) {
        const linkBtn = this.renderer.createElement('button');
        this.renderer.addClass(linkBtn, 'mat-mdc-tooltip-trigger');
        this.renderer.addClass(linkBtn, 'mat-mdc-button-base');
        this.renderer.addClass(linkBtn, 'mic-page-button');
        this.renderer.setAttribute(linkBtn, 'aria-label', 'Page ' + pageIndex.toString());
        this.renderer.setAttribute(linkBtn, 'matTooltip', 'Page ' + pageIndex.toString());
        const pagingTxt = isNaN(i) ? this.pageGapTxt : +(i + 1);
        const text = this.renderer.createText(pagingTxt + '');
        switch (i) {
            case pageIndex:
                // the page is the current page
                this.renderer.addClass(linkBtn, 'mic-current-page');
                this.renderer.setAttribute(linkBtn, 'disabled', 'disabled');
                break;
            case this.pageGapTxt:
                // ... button
                const newIndex = pageIndex < this.currentPage().pageIndex ? Math.max(0, pageIndex - 1) : Math.min(pageIndex + 1, this.lastPageIndex);
                this.renderer.addClass(linkBtn, 'page-gap');
                this.renderer.listen(linkBtn, 'click', () => {
                    this.switchPage(newIndex);
                });
                break;
            default:
                this.renderer.listen(linkBtn, 'click', () => {
                    this.switchPage(i);
                });
                break;
        }
        this.renderer.appendChild(linkBtn, text);
        // Add button to private array for state
        this.buttons.push(linkBtn);
        return linkBtn;
    }
    /*
     * Helper function to switch page when clicking on a page number
     *
     */
    switchPage(i) {
        const previousPageIndex = this.paginator.pageIndex;
        this.paginator.pageIndex = i;
        this.paginator['_emitPageEvent'](previousPageIndex);
        this.buildPageNumbers(i);
    }
    /*
     * Initialize default state after view init
     *
     */
    ngAfterViewInit() {
        if (this.micCustomPaginator) {
            this.rangeStart.set(0);
            this.rangeEnd.set(this.nbPagesToShow - 1);
            this.buildPageNumbers(this.rangeStart());
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: MicCustomPaginatorDirective, deps: [{ token: i1$4.MatPaginator }, { token: i0.ViewContainerRef }, { token: i0.Renderer2 }, { token: i0.KeyValueDiffers }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: MicCustomPaginatorDirective, selector: "[micCustomPaginator]", inputs: { micCustomPaginator: "micCustomPaginator", nbPagesToShow: "nbPagesToShow" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: MicCustomPaginatorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[micCustomPaginator]'
                }]
        }], ctorParameters: () => [{ type: i1$4.MatPaginator }, { type: i0.ViewContainerRef }, { type: i0.Renderer2 }, { type: i0.KeyValueDiffers }], propDecorators: { micCustomPaginator: [{
                type: Input
            }], nbPagesToShow: [{
                type: Input
            }] } });

/**
 * Component to manage pagination
 */
class PaginatorComponent {
    get position() {
        return this.config?.position || 'bottom';
    }
    get doublePaginatorThreshold() {
        return this.config?.bottomAndTopPaginatorThreshold || DEFAULT_PAGESIZE;
    }
    get pageSizeOptions() {
        return this.config?.pageSizeOptions || DEFAULT_PAGESIZE_OPTIONS;
    }
    get pageSize() {
        return this.filtersFormGroup?.controls?.limit?.value || DEFAULT_PAGESIZE;
    }
    get pageIndex() {
        return this.filtersFormGroup?.controls?.page?.value ? this.filtersFormGroup.controls.page.value - 1 : 0;
    }
    get defaultType() {
        return !this.config.type || this.config.type === 'default';
    }
    get pageNumberStyle() {
        return this.config?.style === 'pageNumber';
    }
    get emptyParams() {
        return this.filtersFormGroup.controls
            ? Object.keys(this.filtersFormGroup.controls).reduce((emptyParams, key) => {
                emptyParams[key] = null;
                return emptyParams;
            }, {})
            : {};
    }
    constructor(router, route, changeDetector, element) {
        this.router = router;
        this.route = route;
        this.changeDetector = changeDetector;
        this.element = element;
        /**
         * Detect changes on displayed data
         */
        this.dataChanged = new EventEmitter();
        this.scrollAnimationTime = 300;
        this.scrollClass = '.os-host';
        this.buttonContainerClass = '.mic-load-more-button-container';
        this.scrollAnimationType = 'linear';
        this.paginatorSubscr = [];
        this.filtersFormGroup = new PaginatorFormGroup({});
        this.emptySort = 'null:asc';
        this.firstLoading = true;
        this.extraFilters = false;
        this.loading = new BehaviorSubject(false);
        this.data = [];
        this.dataSourceSubject = new BehaviorSubject(null);
    }
    ngAfterViewChecked() {
        if (typeof this.fetcher !== 'function') {
            throw new Error('Missing fetcher. Datasource will be never provided');
        }
        this.dataTotalSubscr = defer(() => this.dataSourceSubject).subscribe((res) => {
            this.dataTotalSize = res ? res.count : 0;
            this.data = res ? res.items : [];
        });
        if (!this.formSubscr) {
            this.formSubscr = this.filtersFormGroup.valueChanges
                .pipe(startWith(null, this.filtersFormGroup.value), pairwise(), filter$1(([x, y]) => {
                return (JSON.stringify(y) !== JSON.stringify(this.emptyParams) && JSON.stringify(x) !== JSON.stringify(y) && y.sort !== this.emptySort);
            }))
                .subscribe(() => {
                this.loadData();
                this.changeDetector.detectChanges();
            });
        }
    }
    ngOnDestroy() {
        if (this.dataSubscr) {
            this.dataSubscr.unsubscribe();
        }
        if (this.formSubscr) {
            this.formSubscr.unsubscribe();
        }
        this.paginatorSubscr.forEach((sub) => {
            sub.unsubscribe();
        });
        if (this.dataTotalSubscr) {
            this.dataTotalSubscr.unsubscribe();
        }
    }
    ngOnChanges() {
        const state = StorageConfig.getState(this.config.type === 'button' ? null : this.storage, this.route);
        this.filtersFormGroup = new PaginatorFormGroup(state, state.extraFilters);
        if (!state.limit) {
            this.filtersFormGroup.patchValue({ limit: this.config?.pageSize || DEFAULT_PAGESIZE });
        }
        this.init();
    }
    /**
     * Init subscriptions to detect page change and apply pagination state to filters form group
     */
    init() {
        // Clear if subscriptions exists
        this.paginatorSubscr.forEach((sub) => {
            sub.unsubscribe();
        });
        // Manage case with two paginators (bottom / top)
        [this.paginatorRef1, this.paginatorRef2].forEach((paginator, index) => {
            if (paginator) {
                this.paginatorSubscr[index] = paginator.page.subscribe(({ pageIndex, pageSize }) => {
                    this.filtersFormGroup.patchValue({ page: pageIndex + 1, limit: pageSize });
                });
            }
        });
        this.initScrollCallbacks();
    }
    /**
     * Load more data
     * Patch values using form group and reuse the main method
     */
    loadMore() {
        if (this.data.length !== this.dataTotalSize) {
            const actualPageIndex = this.filtersFormGroup.value.page;
            this.filtersFormGroup.patchValue({ page: actualPageIndex + 1 });
        }
    }
    /**
     * Init scrollbar options to track scroll events
     * Usefull in the case of configuration for infinite scroll
     *
     * @returns
     */
    initScrollCallbacks() {
        if (this.config.type !== 'scroll') {
            return;
        }
        // Init options if not exists
        if (!this.config.options) {
            this.config.options = {};
        }
        // Init options if not exists
        if (!this.config.options.scrollOptions) {
            this.config.options.scrollOptions = { scrollbars: { autoHide: 'move' } };
        }
        // Define callback to track scroll events
        this.config.options.scrollOptions.callbacks = {
            onScrollStop: () => {
                // get the position of the scrollbar
                const scrollInfo = this.scrollbarInstance.scroll.scroll();
                // check if the scrollbar has reached the bottom
                if (scrollInfo.position.y + 1 >= scrollInfo.max.y) {
                    this.loadMore();
                }
            }
        };
    }
    /**
     * Update paginator extra filters
     * Set filter form group with pagination state (reset page)
     * Merge current extra filters with others in parameter
     */
    patchExtraFilters(extraFilters) {
        this.filtersFormGroup.patchValue({
            page: 1,
            extraFilters: {
                ...this.filtersFormGroup.get('extraFilters').value,
                ...extraFilters
            }
        });
        this.extraFilters = true;
    }
    /**
     * Get paginator filters associated with the formGroup
     * Return the pagination state (page, sort...) and extra filters
     */
    getFilters() {
        return this.filtersFormGroup.value;
    }
    /**
     * Apply a sort using form group
     */
    sortData(active, dir) {
        // In the case of load more button, back to the first page
        const page = this.config.type === 'button' ? 1 : this.filtersFormGroup.value.page;
        this.filtersFormGroup.patchValue({ sort: `${active}:${dir}`, page });
    }
    /**
     * Load data in the pagination using fetcher method
     * Filters are retrieve from the form group and pass as parameter to the fetcher
     */
    loadData() {
        // Enable loading spinner
        this.loading.next(true);
        const filters = new PaginatorFilters(this.filtersFormGroup.value);
        this.resetDataSubscription();
        StorageConfig.storeState(this.storage, filters, this.router);
        this.dataSubscr = this.fetcher(filters)
            .pipe(catchError(() => {
            this.loading.next(false);
            return of({ items: [], count: 0 });
        }))
            .subscribe((res) => {
            // Disable loading spinner
            this.loading.next(false);
            // Concat data in the case of load more button
            const prependData = !this.defaultType && filters.page !== 1 ? this.data : [];
            this.dataSourceSubject.next({
                items: [
                    ...prependData,
                    ...res.items.map((i) => {
                        return {
                            ...i,
                            page: filters.page
                        };
                    })
                ],
                count: res.count
            });
            this.dataChanged.emit(this.data);
            // Manage automatic scroll on the table
            if (OverlayScrollbars && !this.firstLoading && !this.extraFilters) {
                const parentElement = this.element.nativeElement.closest(this.scrollClass);
                const scroll = OverlayScrollbars(parentElement);
                if (scroll) {
                    if (!this.defaultType) {
                        const button = this.element.nativeElement.querySelector(this.buttonContainerClass);
                        const y = button.offsetTop;
                        setTimeout(() => {
                            scroll.scroll({ y }, this.scrollAnimationTime, this.scrollAnimationType);
                        }, 0);
                    }
                    else {
                        scroll.scroll(this.element.nativeElement, this.scrollAnimationTime, this.scrollAnimationType);
                    }
                }
            }
            this.extraFilters = false;
            this.firstLoading = false;
            this.resetDataSubscription();
        });
    }
    /**
     * Reset subscription to load data through fetcher method
     */
    resetDataSubscription() {
        if (this.dataSubscr) {
            this.dataSubscr.unsubscribe();
            this.dataSubscr = null;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: PaginatorComponent, deps: [{ token: i1$1.Router }, { token: i1$1.ActivatedRoute }, { token: i0.ChangeDetectorRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: PaginatorComponent, selector: "mic-paginator", inputs: { fetcher: "fetcher", config: "config", storage: "storage", color: "color" }, outputs: { dataChanged: "dataChanged" }, queries: [{ propertyName: "contentQuery", first: true, predicate: PaginatorContentDirective, descendants: true }, { propertyName: "stylePaginator", first: true, predicate: MicCustomPaginatorDirective, descendants: true }], viewQueries: [{ propertyName: "scrollbarInstance", first: true, predicate: ScrollBarDirective, descendants: true, static: true }, { propertyName: "paginatorRef1", first: true, predicate: ["paginator1"], descendants: true, static: true }, { propertyName: "paginatorRef2", first: true, predicate: ["paginator2"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div [class]=\"position === 'top' || config.type === 'button' ? 'flex flex-col' : 'flex flex-col-reverse'\">\n  <div class=\"flex flex-row flex-wrap gap-2\" [class]=\"config?.horizontalPosition === 'left' ? 'flex-row-reverse' : ''\">\n    <div class=\"flex-1 min-w-1on2\">\n      @if (contentQuery) {\n      <ng-container *ngTemplateOutlet=\"contentQuery.templateRef\"></ng-container>\n      }\n    </div>\n    <div class=\"flex justify-end items-end\">\n      <mat-paginator\n        [micCustomPaginator]=\"pageNumberStyle === true\"\n        [nbPagesToShow]=\"config.options?.nbPagesToShow || 5\"\n        #paginator1\n        [class.hidden]=\"!defaultType || (dataTotalSize - 1 < pageSize && dataTotalSize - 1 < pageSizeOptions[0])\"\n        [length]=\"dataTotalSize\"\n        [pageIndex]=\"pageIndex\"\n        [pageSize]=\"pageSize\"\n        [pageSizeOptions]=\"pageSizeOptions\"\n      >\n      </mat-paginator>\n    </div>\n  </div>\n  <mic-spinner-overlay [color]=\"config?.loaderColor\" [disableSpinner]=\"!defaultType\" [loading]=\"loading | async\">\n    <div\n      class=\"flex flex-col\"\n      micScrollBar\n      [micScrollBarOptions]=\"config.options?.scrollOptions\"\n      [ngStyle]=\"{ 'max-height': config?.options?.maxHeight }\"\n    >\n      <ng-content></ng-content>\n      @if (!defaultType && data.length !== dataTotalSize) {\n      <div class=\"mic-load-more-button-container flex-1 self-center\">\n        <button\n          [class.hidden]=\"config.type !== 'button'\"\n          mat-raised-button\n          color=\"primary\"\n          class=\"mic-load-more-button\"\n          (click)=\"loadMore()\"\n          [loading]=\"loading | async\"\n        >\n          {{ config.loadMoreButtonLabel }}\n        </button>\n      </div>\n      }\n    </div>\n  </mic-spinner-overlay>\n  <div class=\"paginator-container flex flex-row md-flex-col\" [class]=\"config?.horizontalPosition === 'left' ? 'flex-row-reverse' : ''\">\n    <div class=\"paginator-content flex-1\"></div>\n    @if (pageNumberStyle) {\n    <mat-paginator\n      #paginator2\n      [micCustomPaginator]=\"pageNumberStyle === true\"\n      [nbPagesToShow]=\"config.options?.nbPagesToShow || 5\"\n      [class.hidden]=\"\n        !defaultType || (dataTotalSize - 1 < pageSize && dataTotalSize - 1 < pageSizeOptions[0]) || doublePaginatorThreshold >= data?.length\n      \"\n      [length]=\"dataTotalSize\"\n      [pageIndex]=\"pageIndex\"\n      [pageSize]=\"pageSize\"\n      [pageSizeOptions]=\"pageSizeOptions\"\n    >\n    </mat-paginator>\n    }\n  </div>\n</div>\n", styles: [".mic-load-more-button{margin:15px 0}\n"], dependencies: [{ kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i1.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", exportAs: ["matButton"] }, { kind: "component", type: i1$4.MatPaginator, selector: "mat-paginator", inputs: ["color", "pageIndex", "length", "pageSize", "pageSizeOptions", "hidePageSize", "showFirstLastButtons", "selectConfig", "disabled"], outputs: ["page"], exportAs: ["matPaginator"] }, { kind: "component", type: SpinnerOverlayComponent, selector: "mic-spinner-overlay", inputs: ["loading", "color", "diameter", "disableSpinner", "ariaLabel"] }, { kind: "directive", type: SpinnerButtonDirective, selector: "button[mat-button][loading], button[mat-raised-button][loading], button[mat-icon-button][loading],\n             button[mat-fab][loading], button[mat-mini-fab][loading], button[mat-stroked-button][loading],\n             button[mat-flat-button][loading]", inputs: ["loading", "disabled", "color"] }, { kind: "directive", type: ScrollBarDirective, selector: "[micScrollBar]", inputs: ["micScrollBar", "micScrollBarOptions"] }, { kind: "directive", type: MicCustomPaginatorDirective, selector: "[micCustomPaginator]", inputs: ["micCustomPaginator", "nbPagesToShow"] }, { kind: "pipe", type: i2.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: PaginatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-paginator', template: "<div [class]=\"position === 'top' || config.type === 'button' ? 'flex flex-col' : 'flex flex-col-reverse'\">\n  <div class=\"flex flex-row flex-wrap gap-2\" [class]=\"config?.horizontalPosition === 'left' ? 'flex-row-reverse' : ''\">\n    <div class=\"flex-1 min-w-1on2\">\n      @if (contentQuery) {\n      <ng-container *ngTemplateOutlet=\"contentQuery.templateRef\"></ng-container>\n      }\n    </div>\n    <div class=\"flex justify-end items-end\">\n      <mat-paginator\n        [micCustomPaginator]=\"pageNumberStyle === true\"\n        [nbPagesToShow]=\"config.options?.nbPagesToShow || 5\"\n        #paginator1\n        [class.hidden]=\"!defaultType || (dataTotalSize - 1 < pageSize && dataTotalSize - 1 < pageSizeOptions[0])\"\n        [length]=\"dataTotalSize\"\n        [pageIndex]=\"pageIndex\"\n        [pageSize]=\"pageSize\"\n        [pageSizeOptions]=\"pageSizeOptions\"\n      >\n      </mat-paginator>\n    </div>\n  </div>\n  <mic-spinner-overlay [color]=\"config?.loaderColor\" [disableSpinner]=\"!defaultType\" [loading]=\"loading | async\">\n    <div\n      class=\"flex flex-col\"\n      micScrollBar\n      [micScrollBarOptions]=\"config.options?.scrollOptions\"\n      [ngStyle]=\"{ 'max-height': config?.options?.maxHeight }\"\n    >\n      <ng-content></ng-content>\n      @if (!defaultType && data.length !== dataTotalSize) {\n      <div class=\"mic-load-more-button-container flex-1 self-center\">\n        <button\n          [class.hidden]=\"config.type !== 'button'\"\n          mat-raised-button\n          color=\"primary\"\n          class=\"mic-load-more-button\"\n          (click)=\"loadMore()\"\n          [loading]=\"loading | async\"\n        >\n          {{ config.loadMoreButtonLabel }}\n        </button>\n      </div>\n      }\n    </div>\n  </mic-spinner-overlay>\n  <div class=\"paginator-container flex flex-row md-flex-col\" [class]=\"config?.horizontalPosition === 'left' ? 'flex-row-reverse' : ''\">\n    <div class=\"paginator-content flex-1\"></div>\n    @if (pageNumberStyle) {\n    <mat-paginator\n      #paginator2\n      [micCustomPaginator]=\"pageNumberStyle === true\"\n      [nbPagesToShow]=\"config.options?.nbPagesToShow || 5\"\n      [class.hidden]=\"\n        !defaultType || (dataTotalSize - 1 < pageSize && dataTotalSize - 1 < pageSizeOptions[0]) || doublePaginatorThreshold >= data?.length\n      \"\n      [length]=\"dataTotalSize\"\n      [pageIndex]=\"pageIndex\"\n      [pageSize]=\"pageSize\"\n      [pageSizeOptions]=\"pageSizeOptions\"\n    >\n    </mat-paginator>\n    }\n  </div>\n</div>\n", styles: [".mic-load-more-button{margin:15px 0}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.Router }, { type: i1$1.ActivatedRoute }, { type: i0.ChangeDetectorRef }, { type: i0.ElementRef }], propDecorators: { fetcher: [{
                type: Input
            }], config: [{
                type: Input
            }], storage: [{
                type: Input
            }], color: [{
                type: Input
            }], dataChanged: [{
                type: Output
            }], scrollbarInstance: [{
                type: ViewChild,
                args: [ScrollBarDirective, { static: true }]
            }], paginatorRef1: [{
                type: ViewChild,
                args: ['paginator1', { static: true }]
            }], paginatorRef2: [{
                type: ViewChild,
                args: ['paginator2', { static: true }]
            }], contentQuery: [{
                type: ContentChild,
                args: [PaginatorContentDirective]
            }], stylePaginator: [{
                type: ContentChild,
                args: [MicCustomPaginatorDirective]
            }] } });

const modules$2 = [CommonModule, MaterialModule, LoaderModule, ScrollbarModule];
const declarations$2 = [PaginatorComponent, PaginatorContentDirective, MicCustomPaginatorDirective];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { PaginatorModule } from '@michelin/theme';</code>
 */
class PaginatorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: PaginatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: PaginatorModule, declarations: [PaginatorComponent, PaginatorContentDirective, MicCustomPaginatorDirective], imports: [CommonModule, MaterialModule, LoaderModule, ScrollbarModule], exports: [PaginatorComponent, PaginatorContentDirective, MicCustomPaginatorDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: PaginatorModule, imports: [modules$2] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: PaginatorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: modules$2,
                    declarations: declarations$2,
                    exports: declarations$2,
                    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
                }]
        }] });

/**
 * Sidebar toggler component
 */
class SidebarTogglerComponent {
    constructor(sidebarService, breakpointObserver) {
        this.sidebarService = sidebarService;
        this.breakpointObserver = breakpointObserver;
        /**
         * Is the toggler always display (default = false)
         *
         * When false, toggler is displayed in function of responsive breakpoints
         */
        this.alwaysDisplay = false;
        /**
         * Sidebar type : left or right (default = left)
         */
        this.type = 'left';
        /**
         * Is the default sidebar state open
         */
        this.open = true;
        this.collapsed = this.sidebarService.sideNav.value.collapsed;
    }
    ngOnInit() {
        this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium]).subscribe((result) => {
            const small = result.breakpoints[Breakpoints.XSmall] || result.breakpoints[Breakpoints.Small];
            this.opened = !small;
            this.show = small;
        });
        this.sidebarService.sideNavToggle
            .pipe(filter$1((subject) => subject.toggler === this.id && subject.type === this.type))
            .subscribe((subject) => {
            this.opened = subject.opened;
        });
        this.sidebarService.sideNav.next({
            type: this.type,
            toggler: this.id,
            opened: this.opened,
            collapsed: this.collapsed
        });
        if (!this.open) {
            this.sidebarService.sideNavOpenDefault = this.open;
            this.toggle();
        }
    }
    toggle() {
        const toggler = this.id;
        const opened = !this.opened;
        const type = this.type;
        const collapsed = this.sidebarService.sideNav.value.collapsed;
        this.sidebarService.sideNav.next({ type, toggler, opened, collapsed });
        this.sidebarService.sideNavToggle.next({ type, toggler, opened });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SidebarTogglerComponent, deps: [{ token: SidebarService }, { token: i2$5.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: SidebarTogglerComponent, selector: "mic-sidebar-toggler", inputs: { id: "id", alwaysDisplay: "alwaysDisplay", type: "type", open: "open" }, ngImport: i0, template: "@if (show || alwaysDisplay) {\n<button mat-icon-button (click)=\"toggle()\" attr.aria-controls=\"navigation-menu-sidenav-{{ type }}\" [attr.aria-expanded]=\"opened\">\n  <mat-icon [class.rotate]=\"type === 'right' && opened\" aria-hidden=\"false\" aria-label=\"menu\">{{ opened ? 'menu_open' : 'menu' }}</mat-icon>\n</button>\n}\n", styles: [":host{display:block;height:max-content}\n"], dependencies: [{ kind: "component", type: i1.MatIconButton, selector: "button[mat-icon-button]", exportAs: ["matButton"] }, { kind: "component", type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SidebarTogglerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-sidebar-toggler', template: "@if (show || alwaysDisplay) {\n<button mat-icon-button (click)=\"toggle()\" attr.aria-controls=\"navigation-menu-sidenav-{{ type }}\" [attr.aria-expanded]=\"opened\">\n  <mat-icon [class.rotate]=\"type === 'right' && opened\" aria-hidden=\"false\" aria-label=\"menu\">{{ opened ? 'menu_open' : 'menu' }}</mat-icon>\n</button>\n}\n", styles: [":host{display:block;height:max-content}\n"] }]
        }], ctorParameters: () => [{ type: SidebarService }, { type: i2$5.BreakpointObserver }], propDecorators: { id: [{
                type: Input
            }], alwaysDisplay: [{
                type: Input
            }], type: [{
                type: Input
            }], open: [{
                type: Input
            }] } });

/**
 * Component to display item in the sidebar
 *
 * Item can be nested
 */
class SidebarItemComponent {
    constructor(router) {
        this.router = router;
        /**
         * Direction : ltr or rtl (default = ltr)
         */
        this.direction = 'ltr';
        /**
         * Display mode : closely or large (default = closely)
         */
        this.mode = 'closely';
        /**
         * Add tag on items to filter selection
         */
        this.tags = [];
        /**
         * Event emit when an item is selected
         */
        this.selected = new EventEmitter();
        this.classes = 'mic-sidebar-item';
        this.hasChild = false;
    }
    ngOnInit() {
        this.router.events
            .pipe(filter$1((event) => event instanceof NavigationStart))
            .subscribe((event) => {
            this.active = this.getPath(event.url);
        });
        this.active = this.getPath(this.router.url);
    }
    ngAfterContentInit() {
        this.hasChild = this.children.toArray().length > 0;
    }
    /**
     * Determine path from an url
     * Exclude hash and parameters
     *
     * @param url
     * @returns
     */
    getPath(url) {
        return url.split('#')[0].split('?')[0];
    }
    /**
     * Trigger click event on the sidebar item
     * If item has children, nothing todo
     * If item is a leaf, notify the selection
     *
     * @param event
     */
    click(event, item) {
        if (item.children?.length) {
            event.preventDefault();
        }
        item.selected.emit(item);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SidebarItemComponent, deps: [{ token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: SidebarItemComponent, selector: "mic-sidebar-item", inputs: { id: "id", direction: "direction", mode: "mode", icon: "icon", link: "link", label: "label", tags: "tags", search: "search" }, outputs: { selected: "selected" }, host: { properties: { "class": "this.classes" } }, queries: [{ propertyName: "children", predicate: i0.forwardRef(() => SidebarItemComponent) }], ngImport: i0, template: "<ng-template #simpleItem let-item=\"item\" let-subItem=\"subItem\">\n  <a\n    id=\"{{ item.id }}\"\n    dir=\"ltr\"\n    class=\"flex flex-1 items-center {{ item.mode === 'closely' && !subItem ? 'flex-col' : 'flex-row' }} {{ direction }} {{ mode }} {{\n      displayColor\n    }}\"\n    [ngClass]=\"{\n      active: (active.startsWith(item.link) && item.link !== '/') || (item.link === '/' && active === '/')\n    }\"\n    [routerLink]=\"item.link ? [item.link] : null\"\n    matRipple\n    (click)=\"click($event, item)\"\n  >\n    @if (item.icon) {\n    <mic-icon [icon]=\"item.icon\"></mic-icon>\n    } @if (item.label) {\n    <span [style.margin-left]=\"subItem && !item.icon ? '32px' : '2px'\">{{ item.label }}</span>\n    }\n  </a>\n</ng-template>\n<ng-template #itemWithChildren let-item=\"item\" let-subItem=\"subItem\">\n  <mat-expansion-panel\n    [expanded]=\"active.indexOf(item.link) >= 0\"\n    dir=\"ltr\"\n    [ngClass]=\"{ active: active.startsWith(item.link) }\"\n    class=\"mic-menu-expansion-panel {{ item.displayColor }}\"\n  >\n    <mat-expansion-panel-header>\n      <mat-panel-title class=\"mic-menu-expansion-panel-title\" [ngStyle]=\"subItem && !item.icon ? { 'padding-left': '32px' } : {}\">\n        @if (item.icon) {\n        <mic-icon [icon]=\"item.icon\"></mic-icon>\n        } @if (item.label) {\n        <span>{{ item.label }}</span>\n        }\n      </mat-panel-title>\n    </mat-expansion-panel-header>\n    @for (subItem of item.children; track subItem) {\n    <ng-container\n      [ngTemplateOutlet]=\"!subItem.hasChild ? simpleItem : itemWithChildren\"\n      [ngTemplateOutletContext]=\"{ item: subItem, subItem: true }\"\n    >\n    </ng-container>\n    }\n  </mat-expansion-panel>\n</ng-template>\n<ng-container\n  [ngTemplateOutlet]=\"mode !== 'large' || !hasChild ? simpleItem : itemWithChildren\"\n  [ngTemplateOutletContext]=\"{ item: this, subItem: false }\"\n>\n</ng-container>\n", styles: [":host{width:100%;display:flex;flex-direction:column}a{cursor:pointer;text-align:center;text-decoration:none;height:56px;min-height:56px;padding-block:10px 5px}a span{font-size:11px;text-decoration:none;line-height:15px}a.large{padding:16px}a.large .mic-icon{margin-top:0;margin-right:5px}a.large span{font-size:15px;font-weight:400;line-height:24px;margin-left:10px;margin-right:10px}a.large.active span,a.large.active mat-icon{font-weight:700}a.closely.rtl,a.closely.ltr{padding-inline:5px;white-space:normal}a.closely.active.rtl{padding-inline-start:0;border-inline-start:5px solid}a.closely.active.rtl .mic-icon{margin-inline-start:0}a.closely.active.ltr{padding-inline-end:0;border-inline-end:5px solid}a.closely.active.ltr .mic-icon{margin-inline-end:0}.mic-menu-expansion-panel{background:none;min-height:56px;box-shadow:none;border-radius:0}.mic-menu-expansion-panel.active .mat-expansion-panel-header{font-weight:700}.mic-menu-expansion-panel .mat-expansion-panel-header{padding:0 16px}.mic-menu-expansion-panel .mat-expansion-panel-header:hover{background-color:transparent}.mic-menu-expansion-panel .mic-menu-expansion-panel-title{margin-left:0}.mic-menu-expansion-panel .mic-menu-expansion-panel-title .mic-icon{margin-right:7px}::ng-deep .mic-menu-expansion-panel>.mat-expansion-panel-content>.mat-expansion-panel-body{padding:0;flex-direction:column!important;display:block}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i1$1.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i3$5.Dir, selector: "[dir]", inputs: ["dir"], outputs: ["dirChange"], exportAs: ["dir"] }, { kind: "component", type: i4$2.MatExpansionPanel, selector: "mat-expansion-panel", inputs: ["hideToggle", "togglePosition"], outputs: ["afterExpand", "afterCollapse"], exportAs: ["matExpansionPanel"] }, { kind: "component", type: i4$2.MatExpansionPanelHeader, selector: "mat-expansion-panel-header", inputs: ["expandedHeight", "collapsedHeight", "tabIndex"] }, { kind: "directive", type: i4$2.MatExpansionPanelTitle, selector: "mat-panel-title" }, { kind: "directive", type: i3$2.MatRipple, selector: "[mat-ripple], [matRipple]", inputs: ["matRippleColor", "matRippleUnbounded", "matRippleCentered", "matRippleRadius", "matRippleAnimation", "matRippleDisabled", "matRippleTrigger"], exportAs: ["matRipple"] }, { kind: "component", type: IconComponent, selector: "mic-icon", inputs: ["icon", "fontSet", "ariaLabel", "decorative"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SidebarItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-sidebar-item', template: "<ng-template #simpleItem let-item=\"item\" let-subItem=\"subItem\">\n  <a\n    id=\"{{ item.id }}\"\n    dir=\"ltr\"\n    class=\"flex flex-1 items-center {{ item.mode === 'closely' && !subItem ? 'flex-col' : 'flex-row' }} {{ direction }} {{ mode }} {{\n      displayColor\n    }}\"\n    [ngClass]=\"{\n      active: (active.startsWith(item.link) && item.link !== '/') || (item.link === '/' && active === '/')\n    }\"\n    [routerLink]=\"item.link ? [item.link] : null\"\n    matRipple\n    (click)=\"click($event, item)\"\n  >\n    @if (item.icon) {\n    <mic-icon [icon]=\"item.icon\"></mic-icon>\n    } @if (item.label) {\n    <span [style.margin-left]=\"subItem && !item.icon ? '32px' : '2px'\">{{ item.label }}</span>\n    }\n  </a>\n</ng-template>\n<ng-template #itemWithChildren let-item=\"item\" let-subItem=\"subItem\">\n  <mat-expansion-panel\n    [expanded]=\"active.indexOf(item.link) >= 0\"\n    dir=\"ltr\"\n    [ngClass]=\"{ active: active.startsWith(item.link) }\"\n    class=\"mic-menu-expansion-panel {{ item.displayColor }}\"\n  >\n    <mat-expansion-panel-header>\n      <mat-panel-title class=\"mic-menu-expansion-panel-title\" [ngStyle]=\"subItem && !item.icon ? { 'padding-left': '32px' } : {}\">\n        @if (item.icon) {\n        <mic-icon [icon]=\"item.icon\"></mic-icon>\n        } @if (item.label) {\n        <span>{{ item.label }}</span>\n        }\n      </mat-panel-title>\n    </mat-expansion-panel-header>\n    @for (subItem of item.children; track subItem) {\n    <ng-container\n      [ngTemplateOutlet]=\"!subItem.hasChild ? simpleItem : itemWithChildren\"\n      [ngTemplateOutletContext]=\"{ item: subItem, subItem: true }\"\n    >\n    </ng-container>\n    }\n  </mat-expansion-panel>\n</ng-template>\n<ng-container\n  [ngTemplateOutlet]=\"mode !== 'large' || !hasChild ? simpleItem : itemWithChildren\"\n  [ngTemplateOutletContext]=\"{ item: this, subItem: false }\"\n>\n</ng-container>\n", styles: [":host{width:100%;display:flex;flex-direction:column}a{cursor:pointer;text-align:center;text-decoration:none;height:56px;min-height:56px;padding-block:10px 5px}a span{font-size:11px;text-decoration:none;line-height:15px}a.large{padding:16px}a.large .mic-icon{margin-top:0;margin-right:5px}a.large span{font-size:15px;font-weight:400;line-height:24px;margin-left:10px;margin-right:10px}a.large.active span,a.large.active mat-icon{font-weight:700}a.closely.rtl,a.closely.ltr{padding-inline:5px;white-space:normal}a.closely.active.rtl{padding-inline-start:0;border-inline-start:5px solid}a.closely.active.rtl .mic-icon{margin-inline-start:0}a.closely.active.ltr{padding-inline-end:0;border-inline-end:5px solid}a.closely.active.ltr .mic-icon{margin-inline-end:0}.mic-menu-expansion-panel{background:none;min-height:56px;box-shadow:none;border-radius:0}.mic-menu-expansion-panel.active .mat-expansion-panel-header{font-weight:700}.mic-menu-expansion-panel .mat-expansion-panel-header{padding:0 16px}.mic-menu-expansion-panel .mat-expansion-panel-header:hover{background-color:transparent}.mic-menu-expansion-panel .mic-menu-expansion-panel-title{margin-left:0}.mic-menu-expansion-panel .mic-menu-expansion-panel-title .mic-icon{margin-right:7px}::ng-deep .mic-menu-expansion-panel>.mat-expansion-panel-content>.mat-expansion-panel-body{padding:0;flex-direction:column!important;display:block}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.Router }], propDecorators: { children: [{
                type: ContentChildren,
                args: [forwardRef(() => SidebarItemComponent)]
            }], id: [{
                type: Input
            }], direction: [{
                type: Input
            }], mode: [{
                type: Input
            }], icon: [{
                type: Input
            }], link: [{
                type: Input
            }], label: [{
                type: Input
            }], tags: [{
                type: Input
            }], search: [{
                type: Input
            }], selected: [{
                type: Output
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

/**
 * Component to display sidebar
 *
 * Support position, colorations, closely mode
 */
class SidebarComponent {
    constructor(router, sidebarService, breakpointObserver) {
        this.router = router;
        this.sidebarService = sidebarService;
        this.breakpointObserver = breakpointObserver;
        /**
         * Theme color : white or primary (default = primary)
         */
        this.color = 'white';
        /**
         * Display mode : closely or large (default = closely)
         */
        this.mode = 'closely';
        /**
         * Direction : ltr or rtl (default = ltr)
         */
        this.direction = 'ltr';
        this.classes = 'mic-sidebar';
        this.search = new FormControl('');
        this.treeControl = new NestedTreeControl((node) => node.children.toArray());
        this.datasource = new MatTreeNestedDataSource();
        this.children = [];
        this.hasChild = (_, node) => !!node.children && node.children.length > 0;
        this.type = 'left';
    }
    ngOnInit() {
        this.initSearchField();
        this.initRouter();
    }
    initSearchField() {
        this.search.valueChanges.pipe(debounceTime(200), distinctUntilChanged()).subscribe((search) => {
            if (this.children.length) {
                this.datasource.data = this.children.filter((value) => {
                    if (value.label.toLowerCase().indexOf((search || '').toLowerCase()) > -1) {
                        return true;
                    }
                    return (value.tags
                        .join('||')
                        .toLowerCase()
                        .indexOf((search || '').toLowerCase()) > -1);
                });
            }
        });
    }
    initRouter() {
        if (this.mode === 'closely') {
            this.router.events
                .pipe(filter$1((event) => event instanceof NavigationEnd))
                .subscribe((event) => {
                let selected = false;
                this.items.forEach((menu) => {
                    if (event.url.includes(menu.link)) {
                        this.select(menu, false);
                        selected = true;
                    }
                });
                if (!selected) {
                    this.children = [];
                }
            });
        }
        this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
            this.small = result.breakpoints[Breakpoints.XSmall] || result.breakpoints[Breakpoints.Small];
        });
    }
    ngAfterContentInit() {
        this.manageSidebarItems();
        this.items.changes.subscribe(() => {
            this.manageSidebarItems();
        });
    }
    manageSidebarItems() {
        this.items.forEach((menu) => {
            menu.mode = this.mode;
            menu.direction = this.direction;
            menu.displayColor = this.color;
            if (menu.mode === 'closely') {
                if (this.router.url.includes(menu.link) && menu.children.toArray().length) {
                    this.select(menu, false);
                }
                menu.selected.subscribe((selected) => {
                    this.select(selected, true);
                });
            }
            else {
                menu.selected.subscribe(() => this.updateSidebar());
            }
        });
        this.sidenavCollapsed(this.children);
    }
    select(menu, exact) {
        this.search.reset();
        const children = menu.children ? menu.children.toArray() : [];
        this.selected = menu;
        this.children = children;
        this.treeControl.dataNodes = children;
        if (exact) {
            this.treeControl.collapseAll();
        }
        const activeIndex = children.findIndex((child) => this.router.url.includes(child.link));
        if (activeIndex >= 0) {
            this.treeControl.expand(this.treeControl.dataNodes[activeIndex]);
        }
        this.datasource.data = children;
        if (children.length === 0 && exact) {
            this.updateSidebar();
        }
        this.sidenavCollapsed(this.children);
    }
    updateSidebar(menu) {
        if (menu) {
            menu.selected.emit(menu);
        }
        if (this.small && this.subject && this.subject.toggler) {
            this.sidebarService.sideNavToggle.next(this.subject);
        }
    }
    sidenavCollapsed(children) {
        const type = this.type;
        const toggler = this.sidebarService.sideNav.value.toggler;
        const opened = this.sidebarService.sideNav.value.opened;
        const collapsed = children.length ? false : true;
        this.sidebarService.sideNav.next({ type, toggler, opened, collapsed });
    }
    collapseMenu() {
        this.children = [];
        this.sidenavCollapsed(this.children);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SidebarComponent, deps: [{ token: i1$1.Router }, { token: SidebarService }, { token: i2$5.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: SidebarComponent, selector: "mic-sidebar", inputs: { color: "color", mode: "mode", direction: "direction", collapseConfig: "collapseConfig" }, host: { properties: { "class": "this.classes" } }, queries: [{ propertyName: "items", predicate: SidebarItemComponent }], ngImport: i0, template: "<div [dir]=\"direction\" class=\"flex flex-row navbar-container\" [attr.aria-expanded]=\"children.length > 0\">\n  <div class=\"flex flex-col {{ color }} {{ mode === 'closely' ? 'w-20' : 'w-64' }}\">\n    <div micScrollBar class=\"flex-1\">\n      <div class=\"flex flex-col flex-1 h-full\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n  </div>\n  @if (children.length > 0) {\n  <div class=\"flex flex-col w-60\">\n    @if (children.length) {\n    <div micScrollBar class=\"sidebar-children-level flex-col flex-1 {{ direction }}\" dir=\"ltr\">\n      <div class=\"navbar-header flex flex-row justify-center self-center gap-2\" dir=\"ltr\">\n        <mic-icon [icon]=\"selected.icon\"></mic-icon> <strong>{{ selected.label }}</strong>\n      </div>\n      <div class=\"flex flex-row items-center\">\n        @if (selected.search) {\n        <mat-form-field class=\"w-4on5\">\n          <mat-label>{{ selected.search.label }}</mat-label>\n          <input\n            class=\"flex-1\"\n            matInput\n            type=\"text\"\n            [placeholder]=\"selected.search.placeholder\"\n            [formControl]=\"search\"\n            autocomplete=\"off\"\n          />\n          <mat-icon matSuffix>search</mat-icon>\n        </mat-form-field>\n        }\n      </div>\n      <mat-tree #tree [dataSource]=\"datasource\" [treeControl]=\"treeControl\">\n        <mat-tree-node *matTreeNodeDef=\"let node\" matTreeNodeToggle>\n          <a\n            (click)=\"updateSidebar(node)\"\n            dir=\"ltr\"\n            [routerLink]=\"node.link ? [node.link] : null\"\n            [routerLinkActiveOptions]=\"{ exact: false }\"\n            routerLinkActive=\"active\"\n            class=\"flex flex-row gap-2 mat-tree-node\"\n            [style.margin-left]=\"'10px'\"\n          >\n            @if (node.icon) {\n            <mic-icon [icon]=\"node.icon\"></mic-icon>\n            }\n            <span [style.margin-left]=\"node.icon ? '0px' : '30px'\">{{ node.label }}</span>\n          </a>\n        </mat-tree-node>\n        <mat-nested-tree-node *matTreeNodeDef=\"let node; when: hasChild\">\n          <div class=\"mat-tree-node\" dir=\"ltr\">\n            <button mat-icon-button matTreeNodeToggle>\n              <mat-icon>\n                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}\n              </mat-icon>\n            </button>\n            <span matTreeNodeToggle>{{ node.label }}</span>\n          </div>\n          <div [class.hidden]=\"!treeControl.isExpanded(node)\" class=\"pl-6\">\n            <ng-container matTreeNodeOutlet></ng-container>\n          </div>\n        </mat-nested-tree-node>\n      </mat-tree>\n    </div>\n    } @if (collapseConfig && collapseConfig.enable) {\n    <div class=\"sidebar-children-level collapse-link\">\n      <button class=\"mat-tree-node collapse-button\" (click)=\"collapseMenu()\">\n        @if (direction === 'ltr') {\n        <mat-icon>menu_open</mat-icon>\n        }\n        <span [style.margin-left]=\"'10px'\">{{ collapseConfig.label }}</span>\n        @if (direction === 'rtl') {\n        <mat-icon class=\"rotate\">menu_open</mat-icon>\n        }\n      </button>\n    </div>\n    }\n  </div>\n  }\n</div>\n", styles: [":host{display:flex;height:100%;flex:1;flex-direction:column}.navbar-container{height:100%}.sidebar-children-level{padding:10px;overflow:auto}.sidebar-children-level .navbar-header{margin-top:10px;margin-bottom:20px;width:100%}.sidebar-children-level ul,.sidebar-children-level li{margin-top:0;margin-bottom:0;list-style-type:none}.sidebar-children-level a{text-decoration:none;cursor:pointer}.sidebar-children-level a.active,.sidebar-children-level a:hover{color:unset;font-weight:700}.sidebar-children-level .mat-tree-node span{cursor:pointer;margin-left:4px}.sidebar-children-level .mat-tree-node .active{text-decoration:underline}.sidebar-children-level.collapse-link{padding:0 10px;overflow:hidden;border-left-width:1px;border-left-style:solid;border-top-width:1px;border-top-style:solid}.sidebar-children-level.collapse-link .collapse-button{border:0;background:transparent;width:100%}\n"], dependencies: [{ kind: "directive", type: i1$1.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i1$1.RouterLinkActive, selector: "[routerLinkActive]", inputs: ["routerLinkActiveOptions", "ariaCurrentWhenActive", "routerLinkActive"], outputs: ["isActiveChange"], exportAs: ["routerLinkActive"] }, { kind: "directive", type: i3$5.Dir, selector: "[dir]", inputs: ["dir"], outputs: ["dirChange"], exportAs: ["dir"] }, { kind: "directive", type: i5$3.MatNestedTreeNode, selector: "mat-nested-tree-node", inputs: ["matNestedTreeNode", "disabled", "tabIndex"], exportAs: ["matNestedTreeNode"] }, { kind: "directive", type: i5$3.MatTreeNodeDef, selector: "[matTreeNodeDef]", inputs: ["matTreeNodeDefWhen", "matTreeNode"] }, { kind: "directive", type: i5$3.MatTreeNodeToggle, selector: "[matTreeNodeToggle]", inputs: ["matTreeNodeToggleRecursive"] }, { kind: "component", type: i5$3.MatTree, selector: "mat-tree", exportAs: ["matTree"] }, { kind: "directive", type: i5$3.MatTreeNode, selector: "mat-tree-node", inputs: ["disabled", "tabIndex"], exportAs: ["matTreeNode"] }, { kind: "directive", type: i5$3.MatTreeNodeOutlet, selector: "[matTreeNodeOutlet]" }, { kind: "component", type: i1.MatIconButton, selector: "button[mat-icon-button]", exportAs: ["matButton"] }, { kind: "component", type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i3$3.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i4$1.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i4$1.MatLabel, selector: "mat-label" }, { kind: "directive", type: i4$1.MatSuffix, selector: "[matSuffix], [matIconSuffix], [matTextSuffix]", inputs: ["matTextSuffix"] }, { kind: "directive", type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: ScrollBarDirective, selector: "[micScrollBar]", inputs: ["micScrollBar", "micScrollBarOptions"] }, { kind: "component", type: IconComponent, selector: "mic-icon", inputs: ["icon", "fontSet", "ariaLabel", "decorative"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SidebarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-sidebar', template: "<div [dir]=\"direction\" class=\"flex flex-row navbar-container\" [attr.aria-expanded]=\"children.length > 0\">\n  <div class=\"flex flex-col {{ color }} {{ mode === 'closely' ? 'w-20' : 'w-64' }}\">\n    <div micScrollBar class=\"flex-1\">\n      <div class=\"flex flex-col flex-1 h-full\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n  </div>\n  @if (children.length > 0) {\n  <div class=\"flex flex-col w-60\">\n    @if (children.length) {\n    <div micScrollBar class=\"sidebar-children-level flex-col flex-1 {{ direction }}\" dir=\"ltr\">\n      <div class=\"navbar-header flex flex-row justify-center self-center gap-2\" dir=\"ltr\">\n        <mic-icon [icon]=\"selected.icon\"></mic-icon> <strong>{{ selected.label }}</strong>\n      </div>\n      <div class=\"flex flex-row items-center\">\n        @if (selected.search) {\n        <mat-form-field class=\"w-4on5\">\n          <mat-label>{{ selected.search.label }}</mat-label>\n          <input\n            class=\"flex-1\"\n            matInput\n            type=\"text\"\n            [placeholder]=\"selected.search.placeholder\"\n            [formControl]=\"search\"\n            autocomplete=\"off\"\n          />\n          <mat-icon matSuffix>search</mat-icon>\n        </mat-form-field>\n        }\n      </div>\n      <mat-tree #tree [dataSource]=\"datasource\" [treeControl]=\"treeControl\">\n        <mat-tree-node *matTreeNodeDef=\"let node\" matTreeNodeToggle>\n          <a\n            (click)=\"updateSidebar(node)\"\n            dir=\"ltr\"\n            [routerLink]=\"node.link ? [node.link] : null\"\n            [routerLinkActiveOptions]=\"{ exact: false }\"\n            routerLinkActive=\"active\"\n            class=\"flex flex-row gap-2 mat-tree-node\"\n            [style.margin-left]=\"'10px'\"\n          >\n            @if (node.icon) {\n            <mic-icon [icon]=\"node.icon\"></mic-icon>\n            }\n            <span [style.margin-left]=\"node.icon ? '0px' : '30px'\">{{ node.label }}</span>\n          </a>\n        </mat-tree-node>\n        <mat-nested-tree-node *matTreeNodeDef=\"let node; when: hasChild\">\n          <div class=\"mat-tree-node\" dir=\"ltr\">\n            <button mat-icon-button matTreeNodeToggle>\n              <mat-icon>\n                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}\n              </mat-icon>\n            </button>\n            <span matTreeNodeToggle>{{ node.label }}</span>\n          </div>\n          <div [class.hidden]=\"!treeControl.isExpanded(node)\" class=\"pl-6\">\n            <ng-container matTreeNodeOutlet></ng-container>\n          </div>\n        </mat-nested-tree-node>\n      </mat-tree>\n    </div>\n    } @if (collapseConfig && collapseConfig.enable) {\n    <div class=\"sidebar-children-level collapse-link\">\n      <button class=\"mat-tree-node collapse-button\" (click)=\"collapseMenu()\">\n        @if (direction === 'ltr') {\n        <mat-icon>menu_open</mat-icon>\n        }\n        <span [style.margin-left]=\"'10px'\">{{ collapseConfig.label }}</span>\n        @if (direction === 'rtl') {\n        <mat-icon class=\"rotate\">menu_open</mat-icon>\n        }\n      </button>\n    </div>\n    }\n  </div>\n  }\n</div>\n", styles: [":host{display:flex;height:100%;flex:1;flex-direction:column}.navbar-container{height:100%}.sidebar-children-level{padding:10px;overflow:auto}.sidebar-children-level .navbar-header{margin-top:10px;margin-bottom:20px;width:100%}.sidebar-children-level ul,.sidebar-children-level li{margin-top:0;margin-bottom:0;list-style-type:none}.sidebar-children-level a{text-decoration:none;cursor:pointer}.sidebar-children-level a.active,.sidebar-children-level a:hover{color:unset;font-weight:700}.sidebar-children-level .mat-tree-node span{cursor:pointer;margin-left:4px}.sidebar-children-level .mat-tree-node .active{text-decoration:underline}.sidebar-children-level.collapse-link{padding:0 10px;overflow:hidden;border-left-width:1px;border-left-style:solid;border-top-width:1px;border-top-style:solid}.sidebar-children-level.collapse-link .collapse-button{border:0;background:transparent;width:100%}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.Router }, { type: SidebarService }, { type: i2$5.BreakpointObserver }], propDecorators: { color: [{
                type: Input
            }], mode: [{
                type: Input
            }], direction: [{
                type: Input
            }], collapseConfig: [{
                type: Input
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }], items: [{
                type: ContentChildren,
                args: [SidebarItemComponent]
            }] } });

/* eslint-disable no-shadow */
class SidebarParameter {
    constructor() {
        this.mode = 'side';
    }
}

/**
 * Component to manage sidebar behaviour
 */
class SidebarContainerComponent {
    constructor(sidebarService, breakpointObserver) {
        this.sidebarService = sidebarService;
        this.breakpointObserver = breakpointObserver;
        this.class = 'mic-sidebar-container';
        /**
         * Aria label for left sidebar.
         */
        this.ariaLabelLeft = 'Left navigation menu';
        /**
         * Aria label for right sidebar.
         */
        this.ariaLabelRight = 'Right navigation menu';
        this.leftParameter = new SidebarParameter();
        this.rightParameter = new SidebarParameter();
    }
    ngOnInit() {
        this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium]).subscribe((result) => {
            const small = result.breakpoints[Breakpoints.XSmall] || result.breakpoints[Breakpoints.Small];
            if (this.leftToggler) {
                this.leftParameter.opened = !small;
                this.leftParameter.mode = !small ? 'side' : 'over';
            }
            if (this.rightToggler) {
                this.rightParameter.opened = !small;
                this.rightParameter.mode = !small ? 'side' : 'over';
            }
        });
        if (!this.leftToggler) {
            this.leftParameter.opened = true;
        }
        if (!this.rightToggler) {
            this.rightParameter.opened = true;
        }
        this.checkOpenDefault();
    }
    ngAfterViewInit() {
        this.sidebarService.sideNavToggle
            .pipe(filter$1((subject) => [this.leftToggler, this.rightToggler].indexOf(subject.toggler) >= 0))
            .subscribe((subject) => {
            const sidebar = subject.type === 'left' ? this.left : this.right;
            if (subject.opened) {
                sidebar.open();
            }
            else {
                sidebar.close();
            }
        });
    }
    ngAfterContentInit() {
        this.sidebars.forEach((item) => {
            const type = !item.position || item.position === 'start' ? 'left' : 'right';
            const toggler = !item.position || item.position === 'start' ? this.leftToggler : this.rightToggler;
            item.subject = { type, toggler };
        });
    }
    onLeftClose() {
        if (this.leftToggler) {
            this.sidebarService.toggle('left', this.leftToggler, false);
        }
    }
    onRightClose() {
        if (this.rightToggler) {
            this.sidebarService.toggle('right', this.rightToggler, false);
        }
    }
    checkOpenDefault() {
        if (!this.sidebarService.sideNavOpenDefault) {
            if (this.leftToggler) {
                this.leftParameter.opened = false;
            }
            if (this.rightToggler) {
                this.rightParameter.opened = false;
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SidebarContainerComponent, deps: [{ token: SidebarService }, { token: i2$5.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: SidebarContainerComponent, selector: "mic-sidebar-container", inputs: { leftToggler: "leftToggler", rightToggler: "rightToggler", ariaLabelLeft: "ariaLabelLeft", ariaLabelRight: "ariaLabelRight" }, host: { properties: { "class": "this.class" } }, queries: [{ propertyName: "sidebars", predicate: SidebarComponent }], viewQueries: [{ propertyName: "left", first: true, predicate: ["left"], descendants: true }, { propertyName: "right", first: true, predicate: ["right"], descendants: true }], ngImport: i0, template: "<mat-sidenav-container class=\"flex-1\" [autosize]=\"true\">\n  <mat-sidenav\n    id=\"navigation-menu-sidenav-left\"\n    class=\"navigation-menu-sidenav mic-elevation-2 {{ leftParameter.mode }}\"\n    position=\"start\"\n    #left\n    [mode]=\"leftParameter.mode\"\n    [opened]=\"leftParameter.opened\"\n    (closedStart)=\"onLeftClose()\"\n  >\n    <ng-content select=\"mic-sidebar:not([position=end])\"></ng-content>\n  </mat-sidenav>\n  <mat-sidenav\n    id=\"navigation-menu-sidenav-right\"\n    class=\"navigation-menu-sidenav mic-elevation-2 {{ rightParameter.mode }}\"\n    position=\"end\"\n    #right\n    [mode]=\"rightParameter.mode\"\n    [opened]=\"rightParameter.opened\"\n    (closedStart)=\"onRightClose()\"\n  >\n    <ng-content select=\"mic-sidebar[position=end]\"></ng-content>\n  </mat-sidenav>\n  <mat-sidenav-content micScrollBar>\n    <ng-content select=\"[main]\"></ng-content>\n  </mat-sidenav-content>\n</mat-sidenav-container>\n", styles: ["::ng-deep .sidebar-container-content{padding:20px;flex:1}::ng-deep .mat-sidenav-content .mat-toolbar{height:fit-content}::ng-deep .mat-sidenav-content .simplebar-content:first-child{height:100%}.mat-drawer-backdrop.mat-drawer-shown{opacity:.2}:host{flex:1 1 .000000001px;box-sizing:border-box;flex-direction:column;display:flex}\n"], dependencies: [{ kind: "component", type: i3$6.MatSidenav, selector: "mat-sidenav", inputs: ["fixedInViewport", "fixedTopGap", "fixedBottomGap"], exportAs: ["matSidenav"] }, { kind: "component", type: i3$6.MatSidenavContainer, selector: "mat-sidenav-container", exportAs: ["matSidenavContainer"] }, { kind: "component", type: i3$6.MatSidenavContent, selector: "mat-sidenav-content" }, { kind: "directive", type: ScrollBarDirective, selector: "[micScrollBar]", inputs: ["micScrollBar", "micScrollBarOptions"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SidebarContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-sidebar-container', template: "<mat-sidenav-container class=\"flex-1\" [autosize]=\"true\">\n  <mat-sidenav\n    id=\"navigation-menu-sidenav-left\"\n    class=\"navigation-menu-sidenav mic-elevation-2 {{ leftParameter.mode }}\"\n    position=\"start\"\n    #left\n    [mode]=\"leftParameter.mode\"\n    [opened]=\"leftParameter.opened\"\n    (closedStart)=\"onLeftClose()\"\n  >\n    <ng-content select=\"mic-sidebar:not([position=end])\"></ng-content>\n  </mat-sidenav>\n  <mat-sidenav\n    id=\"navigation-menu-sidenav-right\"\n    class=\"navigation-menu-sidenav mic-elevation-2 {{ rightParameter.mode }}\"\n    position=\"end\"\n    #right\n    [mode]=\"rightParameter.mode\"\n    [opened]=\"rightParameter.opened\"\n    (closedStart)=\"onRightClose()\"\n  >\n    <ng-content select=\"mic-sidebar[position=end]\"></ng-content>\n  </mat-sidenav>\n  <mat-sidenav-content micScrollBar>\n    <ng-content select=\"[main]\"></ng-content>\n  </mat-sidenav-content>\n</mat-sidenav-container>\n", styles: ["::ng-deep .sidebar-container-content{padding:20px;flex:1}::ng-deep .mat-sidenav-content .mat-toolbar{height:fit-content}::ng-deep .mat-sidenav-content .simplebar-content:first-child{height:100%}.mat-drawer-backdrop.mat-drawer-shown{opacity:.2}:host{flex:1 1 .000000001px;box-sizing:border-box;flex-direction:column;display:flex}\n"] }]
        }], ctorParameters: () => [{ type: SidebarService }, { type: i2$5.BreakpointObserver }], propDecorators: { sidebars: [{
                type: ContentChildren,
                args: [SidebarComponent]
            }], left: [{
                type: ViewChild,
                args: ['left']
            }], right: [{
                type: ViewChild,
                args: ['right']
            }], class: [{
                type: HostBinding,
                args: ['class']
            }], leftToggler: [{
                type: Input
            }], rightToggler: [{
                type: Input
            }], ariaLabelLeft: [{
                type: Input
            }], ariaLabelRight: [{
                type: Input
            }] } });

/**
 * Inside a sidebar, this component allow to add space between elements
 */
class SidebarSpacerComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SidebarSpacerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: SidebarSpacerComponent, selector: "mic-sidebar-spacer", ngImport: i0, template: '', isInline: true, styles: [":host{flex-grow:1;border-bottom:1px rgba(200,200,200,.5) solid}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SidebarSpacerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-sidebar-spacer', template: '', styles: [":host{flex-grow:1;border-bottom:1px rgba(200,200,200,.5) solid}\n"] }]
        }] });

const imports$6 = [CommonModule, RouterModule, MaterialModule, ScrollbarModule, IconModule];
const providers$1 = [SidebarService];
const components$5 = [SidebarTogglerComponent, SidebarContainerComponent, SidebarComponent, SidebarItemComponent, SidebarSpacerComponent];
/**
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { SidebarModule } from '@michelin/theme';</code>
 */
class SidebarModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SidebarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: SidebarModule, declarations: [SidebarTogglerComponent, SidebarContainerComponent, SidebarComponent, SidebarItemComponent, SidebarSpacerComponent], imports: [CommonModule, RouterModule, MaterialModule, ScrollbarModule, IconModule], exports: [SidebarTogglerComponent, SidebarContainerComponent, SidebarComponent, SidebarItemComponent, SidebarSpacerComponent, CommonModule, RouterModule, MaterialModule, ScrollbarModule, IconModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SidebarModule, providers: providers$1, imports: [imports$6, CommonModule, RouterModule, MaterialModule, ScrollbarModule, IconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: SidebarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$6,
                    providers: providers$1,
                    declarations: [...components$5],
                    exports: [...components$5, ...imports$6]
                }]
        }] });

/**
 * Component for tag status
 */
class StatusComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: StatusComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: StatusComponent, selector: "mic-status", host: { classAttribute: "mic-status" }, ngImport: i0, template: "<mat-chip disableRipple class=\"mr-2\">\n  <ng-content></ng-content>\n</mat-chip>\n", dependencies: [{ kind: "component", type: i9.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["role", "id", "aria-label", "aria-description", "value", "color", "removable", "highlighted", "disableRipple", "disabled", "tabIndex"], outputs: ["removed", "destroyed"], exportAs: ["matChip"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: StatusComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-status', host: { class: 'mic-status' }, template: "<mat-chip disableRipple class=\"mr-2\">\n  <ng-content></ng-content>\n</mat-chip>\n" }]
        }] });

const imports$5 = [CommonModule, MaterialModule];
const components$4 = [StatusComponent];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { StatusModule } from '@michelin/theme';</code>
 */
class StatusModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: StatusModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: StatusModule, declarations: [StatusComponent], imports: [CommonModule, MaterialModule], exports: [StatusComponent, CommonModule, MaterialModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: StatusModule, imports: [imports$5, CommonModule, MaterialModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: StatusModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$5,
                    declarations: [...components$4],
                    exports: [...components$4, ...imports$5]
                }]
        }] });

class ThemingService {
    constructor(overlay) {
        this.overlay = overlay;
        this.themeChange = new Subject();
        try {
            this.theme = JSON.parse(localStorage.getItem(`mic-theme`) || '{}');
            this.setOverlay(this.theme);
        }
        catch {
            this.theme = { className: '' };
        }
    }
    display(className, isDark) {
        const theme = { className, isDark };
        localStorage.setItem(`mic-theme`, JSON.stringify(theme));
        if (this.theme.className !== className) {
            this.setOverlay(theme);
        }
        this.themeChange.next({ className, isDark });
        this.theme = theme;
        return className;
    }
    setOverlay(theme) {
        if (this.theme && this.theme.className.length) {
            this.overlay.getContainerElement().classList.remove(this.theme.className);
        }
        if (theme.className) {
            this.overlay.getContainerElement().classList.add(theme.className);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ThemingService, deps: [{ token: i1$8.OverlayContainer }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ThemingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ThemingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$8.OverlayContainer }] });

var MaterialIconFonts;
(function (MaterialIconFonts) {
    MaterialIconFonts["filled"] = "material-icons-filled";
    MaterialIconFonts["round"] = "material-icons-round";
    MaterialIconFonts["outlined"] = "material-icons-outlined";
    MaterialIconFonts["sharp"] = "material-icons-sharp";
    MaterialIconFonts["twotone"] = "material-icons-twotone";
})(MaterialIconFonts || (MaterialIconFonts = {}));

const imports$4 = [CommonModule];
const providers = [ThemingService];
const MATERIAL_ICONS_DEFAULT_FONT = new InjectionToken('MATERIAL_ICONS_DEFAULT_FONT (configure material icons font here)');
/** <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { ThemeModule } from '@michelin/theme';</code>
 */
class ThemingModule {
    constructor(iconRegistry, iconFont) {
        this.iconRegistry = iconRegistry;
        const fontLigature = 'mat-ligature-font';
        // Register each material font set
        Object.keys(MaterialIconFonts).forEach((key) => {
            this.iconRegistry.registerFontClassAlias(key, `material-icons-${key} ${fontLigature}`);
        });
        // Use injection token to get default icon font set
        this.iconRegistry.setDefaultFontSetClass(iconFont ? iconFont.valueOf() : MaterialIconFonts.filled.valueOf(), fontLigature);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ThemingModule, deps: [{ token: i2$2.MatIconRegistry }, { token: MATERIAL_ICONS_DEFAULT_FONT, optional: true }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: ThemingModule, imports: [CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ThemingModule, providers: providers, imports: [imports$4] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ThemingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$4,
                    providers
                }]
        }], ctorParameters: () => [{ type: i2$2.MatIconRegistry }, { type: MaterialIconFonts, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [MATERIAL_ICONS_DEFAULT_FONT]
                }] }] });

/**
 * Directive use to add associated actions to the mic-table
 * Actions could be displayed in different places, it depend of paginator component too
 *
 */
class TableActionsDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableActionsDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: TableActionsDirective, selector: "[micTableActions]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableActionsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[micTableActions]'
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });

/**
 * Directive use to define cell template
 *
 * In table configuration, cell definition need to correspond with micCellTemplateName
 */
class TableCellTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableCellTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: TableCellTemplateDirective, selector: "[micCellTemplate]", inputs: { name: ["micCellTemplateName", "name"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableCellTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[micCellTemplate]'
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }], propDecorators: { name: [{
                type: Input,
                args: ['micCellTemplateName']
            }] } });

/**
 * Directive use to customize table columns inside mic-table
 * - Change columns order
 * - Change column display
 * The implementation is present in Table component
 *
 * @see TableComponent
 */
class TableColumnSelectorDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableColumnSelectorDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: TableColumnSelectorDirective, selector: "[micTableColumnSelector]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableColumnSelectorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[micTableColumnSelector]'
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });

/**
 * Directive use to customize group header
 * inside a mic-table component
 */
class TableGroupHeaderDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableGroupHeaderDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: TableGroupHeaderDirective, selector: "[micGroupHeader]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableGroupHeaderDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[micGroupHeader]'
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });

/**
 * Directive use to define header cell template
 *
 * In table configuration, cell definition need to correspond with micHeaderCellTemplateName
 */
class TableHeaderCellTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableHeaderCellTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: TableHeaderCellTemplateDirective, selector: "[micHeaderCellTemplate]", inputs: { name: ["micHeaderCellTemplateName", "name"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableHeaderCellTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[micHeaderCellTemplate]'
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }], propDecorators: { name: [{
                type: Input,
                args: ['micHeaderCellTemplateName']
            }] } });

class TableNoDataTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableNoDataTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: TableNoDataTemplateDirective, selector: "[micTableNoData]", inputs: { name: ["micTableNoDataName", "name"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableNoDataTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[micTableNoData]'
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }], propDecorators: { name: [{
                type: Input,
                args: ['micTableNoDataName']
            }] } });

/**
 * Directive use to column for actions on each table line
 * inside a mic-table component
 */
class TableRowActionsDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableRowActionsDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: TableRowActionsDirective, selector: "[micTableRowActions]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableRowActionsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[micTableRowActions]'
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });

class TableRowDetailDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableRowDetailDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: TableRowDetailDirective, selector: "[micRowDetail]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableRowDetailDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[micRowDetail]'
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });

/**
 * Directive use to display menu on each table line
 * inside a mic-table component
 */
class TableRowMenuDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableRowMenuDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: TableRowMenuDirective, selector: "[micTableRowMenu]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableRowMenuDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[micTableRowMenu]'
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });

class ExpandableItem {
}
class FilterFetcher {
}
class FilterConfig extends FilterFetcher {
}
class Tag {
}
class FiltersConfig {
}
class GroupColumn {
}
/**
 * Table options
 */
class TableOption {
}
/**
 * Define the selection behavior for the table
 */
class TableSelection {
}
/**
 * Define row specifications
 */
class TableRowSpecification {
}
/**
 * Main configuration class for table component
 */
class TableConfig {
    /**
     * Get stored state from the table config
     *
     * @param config
     * @param route
     * @returns
     */
    static getState(config, route) {
        return StorageConfig.getState(config.storage, route);
    }
    /**
     * Store columns
     *
     * Available storage :
     * - sessionStorage
     * - localStorage
     * - query parameters
     *
     * @param config
     * @param columns
     * @param otherColumns
     * @param router
     */
    static storeColumns(config, columns, otherColumns, router) {
        const storage = config.storage;
        // Storage and columns should exists on configuration
        if (!storage || !storage.options?.columns) {
            return;
        }
        // Store in local or session storage
        if (storage.type instanceof Storage) {
            if (!storage.options?.prefix) {
                throw new Error('Missing options.prefix to save state in localstorage or sessionstorage');
            }
            storage.type.setItem(`${storage.options.prefix}columns`, JSON.stringify([...columns, ...otherColumns]));
        }
        // Store in query parameters
        if (storage.type === 'query' && router) {
            router.navigate([], {
                queryParams: StorageConfig.addPrefix(storage.options?.prefix, {
                    columns: columns.join(',')
                }),
                queryParamsHandling: 'merge',
                replaceUrl: true
            });
        }
    }
    /**
     * Get displayed columns from storage
     *
     * Available storage :
     * - sessionStorage
     * - localStorage
     * - query parameters
     *
     * @param config
     * @param route
     * @returns
     */
    static getColumns(config, route) {
        const columns = TableConfig.getStoredColumns(config, route);
        if (columns) {
            return columns;
        }
        return Object.keys(config.columns).filter((key) => config.columns[key].display !== false);
    }
    /**
     * Get columns from storage
     *
     * @param config
     * @param route
     * @returns
     */
    static getStoredColumns(config, route) {
        let columns;
        const storage = config.storage;
        // Storage and columns should exists on confguration
        if (!storage || !storage.options?.columns) {
            return;
        }
        // Get columns in local or session storage
        if (storage.type instanceof Storage) {
            if (!storage.options?.prefix) {
                throw new Error('Missing options.prefix to save state in localstorage or sessionstorage');
            }
            const storedColumns = JSON.parse(storage.type.getItem(`${storage.options.prefix}columns`));
            if (storedColumns) {
                columns = storedColumns;
            }
        }
        // Get columns in query parameters
        if (storage.type === 'query') {
            const queryParams = StorageConfig.removePrefix(storage.options?.prefix, route.snapshot.queryParams);
            if (queryParams.columns && queryParams.columns.toString().length) {
                columns = queryParams.columns
                    .toString()
                    .split(',')
                    .filter((col) => Object.keys(config.columns).indexOf(col) >= 0);
            }
        }
        return columns;
    }
}
class Group {
    constructor() {
        this.level = 0;
        this.totalCounts = 0;
    }
}
class CellRowConfig {
}

/**
 * Directive use to customize cell
 * inside a mic-table component
 */
class TableCellDirective {
    constructor(elementRef, renderer, viewContainerRef) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.viewContainerRef = viewContainerRef;
    }
    ngOnChanges() {
        if (!this.column) {
            return;
        }
        const config = this.column.cell;
        if (typeof config === 'string') {
            this.renderTemplate(config);
        }
        else if (typeof config === 'function') {
            this.renderText(config);
        }
    }
    /**
     * Render the template text in the dom
     * using the giving function
     * This function is provide by cell config
     *
     * @see TableConfig
     * @see Column
     */
    renderText(textFunc) {
        this.viewContainerRef.clear();
        const parentNode = this.renderer.parentNode(this.elementRef.nativeElement);
        if (this.textNode) {
            this.renderer.removeChild(parentNode, this.textNode);
        }
        const textResult = textFunc(this.item);
        this.textNode = this.renderer.createText(textResult || '');
        this.renderer.appendChild(parentNode, this.textNode);
    }
    /**
     * Render the template view in the dom
     * using the template name
     */
    renderTemplate(templateName) {
        this.viewContainerRef.clear();
        const template = this.templateFinder(templateName);
        if (template) {
            this.viewContainerRef.createEmbeddedView(template, { $implicit: this.item });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableCellDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: TableCellDirective, selector: "[micCell]", inputs: { column: ["micCell", "column"], item: "item", templateFinder: "templateFinder" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableCellDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[micCell]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ViewContainerRef }], propDecorators: { column: [{
                type: Input,
                args: ['micCell']
            }], item: [{
                type: Input
            }], templateFinder: [{
                type: Input
            }] } });

/**
 * Directive use to customize header cell
 * inside a mic-table component
 */
class TableHeaderCellDirective {
    constructor(elementRef, renderer, viewContainerRef) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.viewContainerRef = viewContainerRef;
    }
    ngOnChanges() {
        if (!this.column) {
            return;
        }
        this.renderTemplate(this.column.header);
    }
    /**
     * Render the template view in the dom
     * using the template name
     */
    renderTemplate(header) {
        this.viewContainerRef.clear();
        const template = this.templateFinder ? this.templateFinder(header) : null;
        if (!template) {
            if (this.textNode) {
                this.renderer.removeChild(this.elementRef.nativeElement, this.textNode);
            }
            this.textNode = this.renderer.createText(header || '');
            this.renderer.appendChild(this.elementRef.nativeElement, this.textNode);
        }
        else {
            if (this.textNode) {
                this.renderer.removeChild(this.elementRef.nativeElement, this.textNode);
            }
            this.viewContainerRef.createEmbeddedView(template);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableHeaderCellDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: TableHeaderCellDirective, selector: "[micHeaderCell]", inputs: { column: ["micHeaderCell", "column"], templateFinder: "templateFinder" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableHeaderCellDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[micHeaderCell]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ViewContainerRef }], propDecorators: { column: [{
                type: Input,
                args: ['micHeaderCell']
            }], templateFinder: [{
                type: Input
            }] } });

class TableRowCellClassPipe {
    transform(functionName, cellConfig) {
        switch (functionName) {
            case 'cellClass':
                return this.getCellClass(cellConfig.columns, cellConfig.columnKey, cellConfig.config, cellConfig.item);
            case 'rowClass':
                return this.getRowClass(cellConfig?.config, cellConfig?.item, cellConfig?.expandedRow);
            default:
                return '';
        }
    }
    /**
     * Build cell classes for column key
     */
    getCellClass(columns, columnKey, config, item) {
        const { align, clazz } = columns[columnKey] || { align: 'left' };
        // Manage cell class with two method
        // - Directly as string
        // - Using a method that receive item as parameter
        let classes = [];
        if (typeof clazz === 'function' && item) {
            classes = [clazz(item)];
        }
        else if (clazz) {
            classes = [clazz];
        }
        return [...classes, ...(Boolean(config.onRowClick) ? ['clickable'] : []), `mic-cell-${columnKey}`, `align-${align}`].join(' ');
    }
    /**
     * Build row classes
     */
    getRowClass(config, item, expandedRow) {
        const classes = [config && Boolean(config.onRowClick) ? 'clickable' : ''];
        if (config?.rows?.clazz) {
            const clazz = config.rows?.clazz;
            if (typeof clazz === 'function' && item) {
                classes.push(clazz(item));
            }
            else if (clazz) {
                classes.push(clazz);
            }
        }
        if (item === expandedRow) {
            classes.push('expanded');
        }
        return classes.join(' ');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableRowCellClassPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: TableRowCellClassPipe, name: "groupClass" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableRowCellClassPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'groupClass'
                }]
        }] });

/* eslint-disable brace-style */
/**
 * Table component
 */
class TableComponent {
    constructor(route, router, changeDetector, breakpointObserver, formBuilder, themeService, differs, groupsDiffers) {
        this.route = route;
        this.router = router;
        this.changeDetector = changeDetector;
        this.breakpointObserver = breakpointObserver;
        this.formBuilder = formBuilder;
        this.themeService = themeService;
        this.differs = differs;
        this.groupsDiffers = groupsDiffers;
        /**
         * Method to compare items
         *
         * @param i
         * @param j
         * @returns
         */
        this.compareWith = (i, j) => i === j;
        this.configColumnDiffers = [];
        // Selection model
        // Update with first checkboxes column
        this.selection = new SelectionModel(true, [], true, this.compare);
        // columns attributes
        // form to manage columns display and sort
        this.columnForm = this.formBuilder.group({
            selected: new FormArray([])
        });
        this.filterDateControls = {};
        this.expandedRows = [];
        this.collapsed = [];
        this.theme = signal(this.themeService.theme?.className);
        this.dragDisabled = true;
        this.templateFinder = (name) => (this.cells && this.cells[name] && this.cells[name].templateRef) || null;
        this.headerTemplateFinder = (name) => (this.headerCells && this.headerCells[name] && this.headerCells[name].templateRef) || null;
        this.sortGroupPredicate = (index, item) => {
            return !(this.config.groupBy?.fields && this.config.groupBy?.fields?.length > 0 && index === 0);
        };
    }
    get columnFormArray() {
        return this.columnForm.controls.selected;
    }
    compare(o1, o2) {
        // Fix Selection Model isSelected with object (TODO: need to find a more efficient solution)
        return JSON.stringify(o1) === JSON.stringify(o2);
    }
    ngOnInit() {
        this.dataSourceDiffer = this.differs.find({}).create();
        this.configDiffer = this.differs.find({}).create();
        this.collapsedDiffer = this.differs.find({}).create();
        this.dataDiffer = this.differs.find({}).create();
        this.groupsDataDiffer = this.groupsDiffers.find([]).create();
        if (this.config.groupBy?.fields?.length > 0) {
            this.groupedData = new MatTableDataSource(); //this.getSubGroups(this.data, 0, this.config.groupBy.fields, null));
            this.groupedData.filterPredicate = this.customFilterPredicate.bind(this);
            if (!this.config.sort) {
                this.config.sort = { default: '' };
            }
            this.config.sort.default = this.config.groupBy.fields[0] + ':asc';
        }
        if (this.compareWith) {
            this.selection.compareWith = this.compareWith;
        }
        // Manage filter configuration by creating formcontrols for each activated filter
        this.manageFilterConfiguration();
        // Detect theme change
        this.themeSubscr = this.themeService.themeChange.subscribe((theme) => {
            this.theme.set(theme?.className);
        });
        // Combine fetcher with datasource input
        return this.mergeFetcherAndDatasource();
    }
    manageFilterConfiguration() {
        const { extraFilters } = TableConfig.getState(this.config, this.route);
        if (this.filtersConfig) {
            this.filters = this.filtersConfig.columns;
            this.filterControls = Object.keys(this.filtersConfig?.columns).reduce((controls, key) => {
                if (extraFilters && extraFilters[key]) {
                    let values = extraFilters[key];
                    if (typeof extraFilters[key] === 'string') {
                        values = extraFilters[key].split(',');
                    }
                    controls[key] = new UntypedFormControl(values);
                }
                else {
                    if (this.filtersConfig.columns[key].type === 'date') {
                        this.filterDateControls[key + 'Start'] = new UntypedFormControl(null);
                        this.filterDateControls[key + 'End'] = new UntypedFormControl(null);
                    }
                    controls[key] = new UntypedFormControl([]);
                }
                return controls;
            }, {});
        }
    }
    /**
     * Define a fetcher if not declare
     * Fetcher allow to filter datasource with pagination result
     *
     * Manage pages and sorts
     */
    mergeFetcherAndDatasource() {
        // Needed to make pagination work without fetcher input
        if (!this.fetcher && this.config.paginator) {
            this.fetcher = (filters) => {
                if (!this.dataSource.filteredData || !this.dataSource.filteredData.length) {
                    return of({ items: [], count: 0 });
                }
                this.sortDataSource(filters);
                const sortedItems = this.dataSource.filteredData.slice((filters.page - 1) * filters.limit, filters.page * filters.limit);
                return of({
                    items: sortedItems,
                    count: this.dataSource.filteredData.length
                });
            };
        }
    }
    /**
     * Sort data using pagination filters
     *
     * @param filters
     */
    sortDataSource(filters) {
        this.dataSource.filteredData.sort((a, b) => {
            if (!filters.sort && !this.config.sort?.default) {
                return 0;
            }
            const sort = filters.sort ? filters.sort.split(':') : this.config.sort?.default?.split(':');
            const direction = sort[1];
            let first = a[sort[0]];
            let second = b[sort[0]];
            // Manage case of specific data accessor
            if (this.dataSource.sortingDataAccessor) {
                first = this.dataSource.sortingDataAccessor(a, sort[0]);
                second = this.dataSource.sortingDataAccessor(b, sort[0]);
            }
            return first < second ? (direction === 'desc' ? 1 : -1) : direction === 'desc' ? -1 : 1;
        });
    }
    ngAfterViewInit() {
        if (this.sort) {
            if (this.sortSubscr) {
                this.sortSubscr.unsubscribe();
            }
            if (this.paginator) {
                if (this.activeSort && this.activeSortDirection) {
                    this.paginator.sortData(this.activeSort, this.activeSortDirection);
                }
                this.sortSubscr = this.sort.sortChange.subscribe((e) => {
                    if (this.config.sort?.resetPaginationOnSortChange) {
                        this.paginator.patchExtraFilters({});
                    }
                    this.paginator.sortData(e.active, e.direction);
                });
            }
            if (this.dataSource) {
                this.dataSource.sort = this.sort;
            }
        }
    }
    ngAfterContentInit() {
        // Get cell templates using query
        this.cells = this.cellsQuery.reduce((acc, cell) => ({ ...acc, ...(cell.name ? { [cell.name]: cell } : {}) }), {});
        // Get header cell templates using query
        this.headerCells = this.headerCellsQuery.reduce((acc, cell) => ({ ...acc, ...(cell.name ? { [cell.name]: cell } : {}) }), {});
    }
    ngDoCheck() {
        // Detect change on datasource using key value differ
        // If changes are detect, the resetFilters method is trigger to apply fetcher and refresh data
        const datasourceChanges = this.dataSourceDiffer.diff(this.dataSource);
        if (datasourceChanges && this.dataSource) {
            this.resetFilters();
        }
        const collapsedChanges = this.collapsedDiffer.diff(this.collapsed);
        if (collapsedChanges && this.collapsed) {
            this.ds.filter = performance.now().toString();
        }
        const dataChanges = this.dataDiffer.diff(this.data);
        const groupChanges = this.groupsDataDiffer.diff(this.config.groupBy?.groups);
        if ((dataChanges || groupChanges) && this.data && this.groupedData) {
            this.groupedData.data = this.groupBy(this.data, this.config.groupBy.fields).sort((o1, o2) => {
                if (this.sort) {
                    if (o1[this.sort.active] === o2[this.sort.active]) {
                        return 0;
                    }
                    else {
                        return (this.sort.direction === 'asc' ? 1 : -1) * (o1[this.sort.active] < o2[this.sort.active] ? -1 : 1);
                    }
                }
                return 0;
            });
            this.table.renderRows();
        }
        // Detect change on config input
        // If changes are detect, the configuration method is triggered
        this.doCheckOnConfiguration();
    }
    ngOnDestroy() {
        // Unsubscribe all subscription
        if (this.sortSubscr) {
            this.sortSubscr.unsubscribe();
        }
        if (this.themeSubscr) {
            this.themeSubscr.unsubscribe();
        }
        if (this.breakPointSubscr) {
            this.breakPointSubscr.unsubscribe();
        }
        if (this.columnsSubscr) {
            this.columnsSubscr.unsubscribe();
        }
    }
    /**
     * Init differs to detect change on table config columns
     */
    initConfigurationColumnsDiffer() {
        Object.keys(this.config.columns).forEach((key, index) => {
            this.configColumnDiffers[index] = this.differs.find(this.config.columns[key]).create();
        });
    }
    getCheckLabel(row) {
        return this.config?.selection?.columnKeyForCheckboxLabel ? row[this.config?.selection?.columnKeyForCheckboxLabel] : null;
    }
    /**
     * Change detection on table config attributes and each columns using differs
     * Use for dynamic translation refresh (using ngx-translate)
     */
    doCheckOnConfiguration() {
        // If changes are detect, the configuration method is triggered
        const configChanges = this.configDiffer.diff(this.config);
        if (configChanges && this.config) {
            this.initConfiguration();
            // For the initial configuration, differs for each columns need to be created
            this.initConfigurationColumnsDiffer();
            return;
        }
        // Check each columns differs
        const columnsChanges = Object.keys(this.config.columns).reduce((result, key, index) => {
            if (this.configColumnDiffers[index] && this.configColumnDiffers[index].diff(this.config.columns[key])) {
                result = true;
            }
            return result;
        }, false);
        if (columnsChanges) {
            this.initConfiguration();
        }
        // Check default groups
        if (this.config.groupBy?.groups) {
            const groupChanges = this.groupsDataDiffer.diff(this.config.groupBy.groups);
            if (groupChanges) {
                groupChanges.forEachAddedItem((group) => {
                    const toAdd = this.createGroup(0, this.config.groupBy.fields, null, group.item);
                    if (!this.groupedData.data.find((gp) => gp.field === toAdd.field && gp.value === toAdd.value)) {
                        this.groupedData.data.push(toAdd);
                        this.ds.filter = performance.now().toString();
                    }
                });
            }
        }
    }
    /**
     * Init method triggered after config change
     */
    initConfiguration() {
        const config = (this.config || {});
        this.generateColumns(config);
        const { sort } = TableConfig.getState(this.config, this.route);
        const defaultSort = sort || config.sort?.default;
        if (defaultSort) {
            this.activeSort = defaultSort.split(':')[0];
            this.activeSortDirection = defaultSort.split(':')[1] === 'asc' ? 'asc' : 'desc';
        }
        this.changeDetector.markForCheck();
        this.initColumnSelectorSubscr();
        this.initResponsiveBreakpointSubscr();
        this.initSelectionSubscr();
    }
    /**
     * Generates columns from table config
     *
     * @param config TableConfig
     */
    generateColumns(config) {
        this.total = false;
        this.columns = Object.keys(config.columns).reduce((acc, key) => {
            const cfg = config.columns[key];
            if (config.columns[key].total) {
                this.total = true;
            }
            return { ...acc, [key]: this.createColumnFromConfig(cfg, key) };
        }, {});
        this.createColumnKeys(this.columns);
        this.setColumns(true);
    }
    /**
     * Init column form selector subscription
     */
    initColumnSelectorSubscr() {
        if (this.columnsSubscr) {
            this.columnsSubscr.unsubscribe();
        }
        // Detect column selector change to disable checkbox if there is only one value left
        this.columnsSubscr = this.columnForm.valueChanges.subscribe(() => {
            const active = this.orderedColumnKeys.filter((_, index) => {
                // ensure that the checkbox is not disable
                this.columnFormArray.controls[index].enable({ emitEvent: false });
                return this.columnFormArray.controls[index].value === true;
            });
            if (active.length === 1) {
                const desactive = this.columnFormArray.controls.find((control) => control.value === true);
                if (desactive) {
                    desactive.disable({ emitEvent: false });
                }
            }
        });
    }
    /**
     * Init responsive breakpoint event
     * For mobiles, table selector (checkboxes) is displayed first
     */
    initResponsiveBreakpointSubscr() {
        if (this.breakPointSubscr) {
            this.breakPointSubscr.unsubscribe();
        }
        this.breakPointSubscr = this.breakpointObserver.observe(['(max-width: 800px)']).subscribe((bps) => {
            if (bps.matches && (this.rowMenuQuery || this.rowActionsQuery) && !this.columnKeys.includes('table-selector')) {
                this.columnKeys = ['table-selector', ...this.columnKeys];
            }
            else {
                this.columnKeys = this.initialColumnKeys;
            }
            this.small = bps.matches;
            this.changeDetector.detectChanges();
        });
    }
    /**
     * Init row selection event subscription
     */
    initSelectionSubscr() {
        if (Boolean(this.config.onSelectionChange)) {
            if (this.selectionSubscr) {
                this.selectionSubscr.unsubscribe();
            }
            // Detect change on selection model
            this.selectionSubscr = this.selection.changed.subscribe(() => {
                this.selectionChanged(true);
            });
        }
    }
    /**
     * Get datasource
     * Two cases :
     * - Classic Datasource
     * - Datasource through paginator component
     */
    get ds() {
        if (this.config.groupBy) {
            return this.groupedData;
        }
        if (this.paginator && this.paginator.data) {
            return this.paginator.data;
        }
        if (this.dataSource) {
            return this.dataSource;
        }
        return [];
    }
    /**
     * Get table data
     * Two cases :
     * - Classic Datasource
     * - Data through paginator component
     */
    get data() {
        if (this.paginator && this.paginator.data) {
            return this.paginator.data;
        }
        if (this.dataSource) {
            return this.dataSource.data;
        }
        return [];
    }
    /**
     * Update columns depending of form array (sort and display)
     */
    setColumns(init) {
        const cols = this.orderedColumnKeys.slice().filter((_, index) => this.columnFormArray.controls[index].value === true);
        this.columnKeys = [
            ...(this.config.dragAndDrop?.enabled ? ['table-dragger'] : []),
            ...(Boolean(this.config.onSelectionChange) ? ['table-selector'] : []),
            ...(this.rowDetailQuery ? ['table-expander'] : []),
            ...cols,
            ...(this.rowMenuQuery ? ['table-menu'] : []),
            ...(this.rowActionsQuery ? ['table-actions'] : [])
        ];
        if (this.isGroupColumnsQuery()) {
            this.groupColumnsKey = [...this.columnKeys];
            this.config?.groupsColumns?.forEach((groupColumns) => {
                if (groupColumns.columns.length >= 2 && cols.toString().includes(groupColumns.columns.toString())) {
                    const index = this.groupColumnsKey.indexOf(groupColumns.columns[0]);
                    this.groupColumnsKey[index] = groupColumns.name;
                    this.groupColumnsKey.splice(index + 1, groupColumns.columns.length - 1);
                }
            });
        }
        if (!init) {
            TableConfig.storeColumns(this.config, cols, this.otherStoredColumnKeys, this.router);
            if (Boolean(this.config.onColumnsChange)) {
                this.config.onColumnsChange(cols);
            }
        }
        this.initialColumnKeys = [...this.columnKeys];
        this.selection.clear();
    }
    /**
     * Init column object
     * Retrive of table config + default values
     */
    createColumnFromConfig(config, columnKey) {
        return {
            key: columnKey,
            clazz: config.clazz,
            total: config.total,
            totalFormat: config.totalFormat,
            align: config.align || 'left',
            width: config.width || 'auto',
            cell: config.cell || ((item) => of(item ? item[columnKey] : '')),
            header: config.header,
            sortKey: config.sortKey || columnKey,
            sortable: Boolean(config.sortable),
            sticky: config.sticky,
            stickyEnd: config.stickyEnd
        };
    }
    /**
     * Create a form control array with table configuration
     * This form array is made to control columns :
     * - sort
     * - display
     */
    createColumnKeys(columns) {
        // Retrieve columns from storage
        // Only columns present in the configuration can be displayed
        const storedColumns = [...new Set([...TableConfig.getColumns(this.config, this.route), ...Object.keys(columns)])];
        // Other columns are retrieve because they can be reused
        // These columns should stay in storage
        this.otherStoredColumnKeys = storedColumns.filter((col) => !columns[col]);
        this.orderedColumnKeys = columns ? storedColumns.filter((col) => columns[col] && columns[col]?.header?.length) : [];
        this.columnFormArray.clear({ emitEvent: false });
        this.orderedColumnKeys.forEach((key) => {
            this.columnFormArray.push(new FormControl(TableConfig.getColumns(this.config, this.route).indexOf(key) >= 0), {
                emitEvent: false
            });
        });
    }
    /**
     * Does groupColumnQuery exist and not empty
     */
    isGroupColumnsQuery() {
        return this.config?.groupsColumns && this.config?.groupsColumns.length !== 0;
    }
    /**
     * When rows support expanded format
     * This method trigger an event through the table configuration to make some treatments
     */
    onRowExpand(item) {
        if (typeof this.config.onRowExpand !== 'function') {
            return;
        }
        if (!this.expandedRows?.includes(item)) {
            if (this.config.rows?.multipleExpandedRows) {
                this.expandedRows.push(item);
            }
            else {
                this.expandedRows = [item];
            }
        }
        else {
            const index = this.expandedRows.indexOf(item);
            this.expandedRows.splice(index, 1);
        }
        this.config.onRowExpand(this.expandedRows, this.expandedRows.length !== 0);
    }
    /**
     * Manage click on row by using rowClick function in table configuration
     */
    onRowClick(item, e) {
        if (typeof this.config.onRowClick !== 'function') {
            return;
        }
        let elem = e.target;
        while (elem) {
            if (elem.tagName === 'BUTTON') {
                e.stopImmediatePropagation();
                return;
            }
            if (elem.tagName === 'TR') {
                break;
            }
            elem = elem.parentElement;
        }
        //Entire row expand
        if (this.config.rows && this.config.rows.entireRowExpand) {
            this.onRowExpand(item);
        }
        this.config.onRowClick(item, e);
    }
    /**
     * Method triggered when selection changed
     * (or when pagination change to reset all checkbocx)
     */
    selectionChanged(emitEvent) {
        if (emitEvent) {
            this.config.onSelectionChange(this.selection.selected);
        }
        if (this.fetcher && this.data && this.paginator?.config && this.paginator?.config.type !== 'button') {
            const selectedByPage = this.data.reduce((count, elm) => {
                if (this.isSelected(elm)) {
                    count++;
                }
                return count;
            }, 0);
            this.isAllSelected =
                selectedByPage === this.paginator.pageSize || (selectedByPage === this.data.length && this.data.length <= this.paginator.pageSize);
        }
        else {
            this.isAllSelected = this.selection.selected.length === this.data.length;
        }
    }
    /**
     * Method to select/deselect all item in the table
     */
    toggleAll() {
        if (this.isAllSelected) {
            this.selection.deselect(...this.data);
        }
        else {
            this.selection.select(...this.data);
        }
    }
    /**
     * Method to select/deselect all items of a group
     */
    toggleGroup(group) {
        if (this.isGroupSelected(group)) {
            this.selection.deselect(...group.items);
        }
        else {
            this.selection.select(...group.items);
        }
    }
    /**
     * Is the value selected
     *
     * @param value
     * @returns
     */
    isSelected(value) {
        return this.selection.isSelected(value);
    }
    /**
     * Is the group selected
     *
     * @param group
     * @returns
     */
    isGroupSelected(group) {
        let result = true;
        if (group.items?.length <= 0) {
            result = false;
        }
        for (const item of group.items) {
            if (!this.isSelected(item)) {
                result = false;
            }
        }
        return result;
    }
    /**
     * Is a row menu displayed ?
     */
    isMenuDisplayed(item) {
        if (typeof this.config.rows?.menu?.disabled === 'function' && item) {
            return this.config.rows.menu.disabled(item);
        }
        return this.config.rows?.menu?.disabled;
    }
    /**
     * Get sum for a giving column
     */
    getTotal(columnKey) {
        if (!this.columns[columnKey] || !this.columns[columnKey].total) {
            return null;
        }
        return this.data.reduce((acc, item) => item[this.columns[columnKey].key] + acc, 0);
    }
    /**
     * Appy extra filters through paginator
     */
    patchExtraFilters(extraFilters, noSelectionReset = false) {
        if (!noSelectionReset) {
            this.selection.clear();
        }
        if (this.paginator) {
            this.paginator.patchExtraFilters(extraFilters);
        }
    }
    /**
     * Reset filters through paginator
     * Use date to trigger update
     */
    resetFilters(noSelectionReset = false) {
        if (!noSelectionReset) {
            this.selection.clear();
        }
        if (this.paginator) {
            // Refresh table data
            this.paginator.patchExtraFilters({ date: new Date() });
            // Refresh dropdown values
            this.resetFilterDropdownValues();
        }
    }
    /**
     * Get filters through paginator
     */
    getFilters() {
        return !this.paginator ? null : this.paginator.getFilters();
    }
    /**
     * Reset dropdown values (filters)
     * Use date to trigger update
     */
    resetFilterDropdownValues() {
        // Refresh dropdown values
        this.filtersResetValue = { date: new Date() };
    }
    /**
     * Apply the filter value give through the header dropdowns
     */
    applyFilterDropdownValues(opened) {
        // Refresh data when filter dropdown was closed
        if (!opened) {
            this.patchExtraFilters(Object.keys(this.filterControls).reduce((acc, key) => {
                acc[key] = this.filterControls[key].value;
                return acc;
            }, {}));
        }
    }
    /**
     * Action trigger when column are organized
     * (drag & drop)
     */
    dropColumnKey(event) {
        moveItemInArray(this.orderedColumnKeys, event.previousIndex, event.currentIndex);
        moveItemInArray(this.columnFormArray.controls, event.previousIndex, event.currentIndex);
    }
    /**
     * Method triggered when the dropdown to select columns is closed
     * Apply updates if necessary
     */
    onColumnSelectorClose() {
        let needUpdate = false;
        this.orderedColumnKeys.forEach((key, index) => {
            const active = this.columnFormArray.controls[index].value === true;
            if (!active && this.filterControls && this.filterControls[key]) {
                this.filterControls[key].reset([]);
                needUpdate = true;
            }
        });
        if (needUpdate) {
            this.applyFilterDropdownValues(false);
        }
        this.setColumns();
    }
    /********************
     *  GROUP BY
     ********************/
    /**
     * Add groups into existing data
     *
     * @param data table data
     * @param groupByColumns list of data to group on
     * @returns grouped data
     */
    groupBy(data, groupByColumns) {
        const rootGroup = new Group();
        return groupByColumns && groupByColumns.length > 0 ? this.getSubGroups(data, 0, groupByColumns, rootGroup) : data;
    }
    /**
     * Compute sub groups
     *
     * @param data array of data
     * @param level current group level
     * @param groupByColumns array of grouped colums
     * @param parent Parent Group
     * @returns Array of group and data
     */
    getSubGroups(data, level, groupByColumns, parent) {
        if (level >= groupByColumns.length) {
            return data;
        }
        const groups = this.uniqueBy(data
            .filter((item) => item)
            .map((row) => {
            return this.createGroup(level, groupByColumns, parent, row);
        })
            // Concat default groups
            .concat(this.config.groupBy.groups ? this.formatDefaultGroups(level, groupByColumns, parent) : []), JSON.stringify);
        const currentColumn = groupByColumns[level];
        let subGroups = [];
        groups.forEach((group) => {
            const rowsInGroup = data.filter((row) => row && group[currentColumn] === row[currentColumn]);
            group.items = [...rowsInGroup];
            group.totalCounts = rowsInGroup.length;
            const subGroup = this.getSubGroups(rowsInGroup, level + 1, groupByColumns, group);
            subGroup.unshift(group);
            subGroups = subGroups.concat(subGroup);
        });
        return subGroups;
    }
    formatDefaultGroups(level, groupByColumns, parent) {
        return this.config?.groupBy?.groups
            .filter((gr) => {
            return gr[groupByColumns[level]];
        })
            .map((gr) => {
            return this.createGroup(level, groupByColumns, parent, gr);
        });
    }
    createGroup(level, groupByColumns, parent, row) {
        const result = new Group();
        result.level = level + 1;
        result.parent = parent;
        result.field = groupByColumns[level];
        result.value = row[groupByColumns[level]];
        for (let i = 0; i <= level; i++) {
            result[groupByColumns[i]] = row[groupByColumns[i]];
        }
        return result;
    }
    /**
     * Find unique groups in the array of groups
     *
     * @param groups Group array
     * @param getKey function to extract a key from a group
     * @returns array of unique groups
     */
    uniqueBy(groups, getKey) {
        const seen = {};
        return groups.filter((item) => {
            const k = getKey(item);
            let uniqueGroup = false;
            if (!seen.hasOwnProperty(k)) {
                seen[k] = true;
                uniqueGroup = seen[k];
            }
            return uniqueGroup;
        });
    }
    /**
     * Check if the specified item is a group.
     *
     * @param index item index in the table
     * @param item item in the table
     * @returns true if the item is a group
     */
    isGroup(index, item) {
        return item instanceof Group;
    }
    /**
     * Check if the specified item is not a group.
     *
     * @param index item index in the table
     * @param item item in the table
     * @returns false if the item is a group
     */
    isNotGroup(index, item) {
        return !(item instanceof Group);
    }
    /**
     * Filter predicate used on the datasource to check if the data should be displayed in the table
     *
     * @param data Group or data
     * @returns true if the group is at root level
     *          true if the group parent is not collapsed
     *          false if the group parent is collapsed
     */
    customFilterPredicate(data) {
        if (data instanceof Group) {
            return data.level <= 1 ? true : this.isExpanded(data.parent) && this.customFilterPredicate(data.parent);
        }
        else {
            return this.getDataRowVisible(data);
        }
    }
    /**
     * Check if the data should be displayed in the table
     *
     * @param data
     * @returns
     */
    getDataRowVisible(data) {
        const groupRows = this.groupedData.data.filter((row) => {
            if (!(row instanceof Group)) {
                return false;
            }
            let match = true;
            row;
            this.config.groupBy.fields.forEach((field) => {
                if (!row[field]?.toString() || !data[field]?.toString() || row[field] !== data[field]) {
                    match = false;
                }
            });
            return match;
        });
        if (groupRows.length === 0) {
            return true;
        }
        const parent = groupRows[0];
        return this.customFilterPredicate(parent) && this.isExpanded(parent);
    }
    /**
     * Collapse / Uncollaps clicked group
     *
     * @param row Clicked group
     */
    groupHeaderClick(group) {
        if (this.collapsed.filter((item) => this.compare(item, group)).length > 0) {
            this.collapsed.splice(this.collapsed.indexOf(group), 1);
        }
        else {
            this.collapsed.push(group);
        }
    }
    /**
     * Check if the group is expanded or not
     *
     * @param group Group to check
     * @returns true or false
     */
    isExpanded(group) {
        return this.collapsed.filter((item) => JSON.stringify(item) === JSON.stringify(group)).length === 0;
    }
    /**
     * On item dropped
     *
     * @param event Drop event info
     */
    drop(event) {
        if (event.previousIndex === event.currentIndex) {
            return;
        }
        const updatedItems = [];
        this.dragDisabled = true;
        // get update group index and count
        this.getUpdatedGroups(event, updatedItems);
        // re-generate columns or the cols without template are not refreshed
        this.generateColumns(this.config);
        if (this.config.onItemUpdated && updatedItems.length > 0) {
            this.config.onItemUpdated(updatedItems, event);
        }
    }
    /**
     * On item dropped update group data and item index
     *
     * @param event Drop event info
     */
    getUpdatedGroups(event, updatedItems) {
        if (this.config.groupBy?.fields && this.config.groupBy?.fields.length > 0 && event.currentIndex !== 0) {
            // compute the real index of the item in the data array which contains groups
            const realCurrentIndex = this.groupedData.data.indexOf(this.groupedData.filteredData[event.currentIndex]);
            const realPreviousIndex = this.groupedData.data.indexOf(this.groupedData.filteredData[event.previousIndex]);
            moveItemInArray(this.groupedData.data, realPreviousIndex, realCurrentIndex);
            let newGroup;
            for (let i = realCurrentIndex; i >= 0; i--) {
                if (this.groupedData.data[i] instanceof Group) {
                    newGroup = this.groupedData.data[i];
                    break;
                }
            }
            if (newGroup) {
                newGroup.totalCounts++;
                const oldGroup = this.groupedData.data.find((i) => i instanceof Group && i[i.field] === event.item.data[i.field]);
                oldGroup.totalCounts--;
                event.item.data[newGroup.field] = newGroup.value;
                updatedItems.push(event.item.data);
                this.groupedData.data = [...this.groupedData.data];
            }
        }
        else {
            moveItemInArray(this.data, event.previousIndex, event.currentIndex);
            this.updateItemsPosition(updatedItems, event);
            if (this.paginator && this.paginator.data) {
                this.changeDetector.detectChanges();
                this.table.renderRows();
            }
            else if (this.dataSource) {
                this.dataSource = new MatTableDataSource(this.data);
            }
        }
    }
    /**
     * If configured update the item 'positionField'
     *
     * @param updatedItems array of items updated
     * @param event drop Event
     */
    updateItemsPosition(updatedItems, event) {
        if (this.config.dragAndDrop?.positionField) {
            if (!this.config.paginator) {
                // for each elements if the table is not paginated
                this.data.forEach((item, index) => {
                    const itemPosition = item[this.config.dragAndDrop?.positionField];
                    if (itemPosition !== index + 1) {
                        updatedItems.push(item);
                    }
                });
            }
            else {
                event.item.data[this.config.dragAndDrop?.positionField] = event.currentIndex + 1;
            }
        }
        else {
            updatedItems.push(event.item?.data);
        }
    }
    removeFilter(key, value) {
        const control = [...this.filterControls[key].value];
        const index = this.filterControls[key].value.indexOf(value);
        control.splice(index, 1);
        this.filterControls[key].setValue(control);
        this.applyFilterDropdownValues(false);
    }
    openFilterOverlay($event, key) {
        $event.stopPropagation();
        this.filters[key].open = !this.filters[key].open;
    }
    closeFilterOverlay(key) {
        this.filters[key].open = false;
        if (this.filtersConfig.columns[key].type === 'date') {
            if (this.filterDateControls[key + 'Start'].value) {
                this.filterControls[key].setValue([this.filterDateControls[key + 'Start'].value, this.filterDateControls[key + 'End'].value]);
            }
            else {
                this.filterControls[key].setValue([]);
            }
        }
        this.applyFilterDropdownValues(false);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableComponent, deps: [{ token: i1$1.ActivatedRoute }, { token: i1$1.Router }, { token: i0.ChangeDetectorRef }, { token: i2$5.BreakpointObserver }, { token: i3$1.FormBuilder }, { token: ThemingService }, { token: i0.KeyValueDiffers }, { token: i0.IterableDiffers }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: TableComponent, selector: "mic-table", inputs: { config: "config", dataSource: "dataSource", fetcher: "fetcher", filtersConfig: "filtersConfig", compareWith: "compareWith" }, queries: [{ propertyName: "rowMenuQuery", first: true, predicate: TableRowMenuDirective, descendants: true }, { propertyName: "rowActionsQuery", first: true, predicate: TableRowActionsDirective, descendants: true }, { propertyName: "columnSelectorQuery", first: true, predicate: TableColumnSelectorDirective, descendants: true, static: true }, { propertyName: "actionsQuery", first: true, predicate: TableActionsDirective, descendants: true }, { propertyName: "rowDetailQuery", first: true, predicate: TableRowDetailDirective, descendants: true, static: true }, { propertyName: "tableNoData", first: true, predicate: TableNoDataTemplateDirective, descendants: true, static: true }, { propertyName: "groupHeaderQuery", first: true, predicate: TableGroupHeaderDirective, descendants: true }, { propertyName: "cellsQuery", predicate: TableCellTemplateDirective }, { propertyName: "headerCellsQuery", predicate: TableHeaderCellTemplateDirective }], viewQueries: [{ propertyName: "table", first: true, predicate: MatTable, descendants: true }, { propertyName: "sort", first: true, predicate: MatSort, descendants: true }, { propertyName: "paginator", first: true, predicate: PaginatorComponent, descendants: true }], ngImport: i0, template: "@if (config.paginator && fetcher) {\n<mic-paginator\n  #paginator\n  [fetcher]=\"fetcher\"\n  [storage]=\"config.storage\"\n  [config]=\"config.paginator\"\n  (dataChanged)=\"selectionChanged(false)\"\n>\n  @if (config.paginator.position !== 'top' && !config.paginator.forceBottomAction) {\n  <ng-container *ngTemplateOutlet=\"actions\"></ng-container>\n  } @if (filtersConfig?.tags?.display) {\n  <ng-container *ngTemplateOutlet=\"tagsFilter\"></ng-container>\n  }\n  <ng-container *ngTemplateOutlet=\"table\"></ng-container>\n  @if (config.paginator.position === 'top' || config.paginator.forceBottomAction) {\n  <ng-container *micPaginatorContent>\n    <ng-container *ngTemplateOutlet=\"actions\"></ng-container>\n  </ng-container>\n  }\n</mic-paginator>\n} @if (!config.paginator && !fetcher) {\n<ng-container *ngTemplateOutlet=\"actions\"></ng-container>\n@if (filtersConfig?.tags?.display) {\n<ng-container *ngTemplateOutlet=\"tagsFilter\"></ng-container>\n}\n<ng-container *ngTemplateOutlet=\"table\"></ng-container>\n}\n<ng-template #actions>\n  @if (actionsQuery || columnSelectorQuery) {\n  <div class=\"flex flex-row flex-wrap gap-2 m-2\">\n    @if (columnSelectorQuery) {\n    <div [matMenuTriggerFor]=\"columnSelectorMenu\">\n      <ng-container *ngTemplateOutlet=\"columnSelectorQuery.templateRef\"></ng-container>\n    </div>\n    } @if (actionsQuery) {\n    <ng-container *ngTemplateOutlet=\"actionsQuery.templateRef; context: { $implicit: selection.selected }\"></ng-container>\n    }\n  </div>\n  }\n</ng-template>\n<ng-template #tagsFilter>\n  <div class=\"flex flex-row flex-wrap\">\n    @for (key of orderedColumnKeys; track key) { @if (filtersConfig?.tags?.display && filters && filters[key]) { @for (control of\n    filterControls[key].value; track control) {\n    <mat-chip-row class=\"m-1\" [color]=\"filtersConfig?.tags?.color || 'primary'\" (removed)=\"removeFilter(key, control)\">\n      {{ config.columns[key].header + ': ' + control }}\n      <button matChipRemove [attr.aria-label]=\"'remove ' + config.columns[key].header + ': ' + control.value\">\n        <mat-icon>cancel</mat-icon>\n      </button>\n    </mat-chip-row>\n    } } }\n  </div>\n</ng-template>\n<ng-template #table>\n  <div\n    [ngStyle]=\"{ 'max-height': config?.options?.maxHeight }\"\n    class=\"container-scroll\"\n    micScrollBar\n    [micScrollBarOptions]=\"config.options?.scrollOptions\"\n  >\n    <table\n      mat-table\n      matSort\n      multiTemplateDataRows\n      [matSortActive]=\"activeSort\"\n      [matSortDirection]=\"activeSortDirection\"\n      [dataSource]=\"ds\"\n      [@.disabled]=\"config?.rows?.disableExpandAnimation\"\n      cdkDropList\n      (cdkDropListDropped)=\"drop($event)\"\n      [cdkDropListSortPredicate]=\"sortGroupPredicate\"\n      [cdkDropListDisabled]=\"dragDisabled\"\n      role=\"table\"\n      aria-labelledby=\"mic-table\"\n      tabindex=\"0\"\n    >\n      <!-- Group header -->\n      <ng-container matColumnDef=\"groupHeader\">\n        <td tabindex=\"0\" mat-cell colspan=\"999\" *matCellDef=\"let group\">\n          <div [ngClass]=\"'flex flex-row items-center gap-2 mr-2 ml-' + 3 * group.level\">\n            @if (!groupHeaderQuery) {\n            <span [ngClass]=\"'mr-2 ml-' + 4 * group.level\">\n              @if (config.onSelectionChange) {\n              <mat-checkbox\n                (click)=\"$event.stopPropagation()\"\n                (change)=\"$event ? toggleGroup(group) : null\"\n                [checked]=\"isGroupSelected(group)\"\n              >\n              </mat-checkbox>\n              }\n              <strong> {{ group.field }} = {{ group.value }} ({{ group.totalCounts }}) </strong>\n            </span>\n            } @if (groupHeaderQuery) {\n            <ng-container *ngTemplateOutlet=\"groupHeaderQuery.templateRef; context: { $implicit: group }\"></ng-container>\n            } @if (group.totalCounts > 0) {\n            <button class=\"toggle-group\" mat-icon-button (click)=\"groupHeaderClick(group)\">\n              @if (isExpanded(group)) {\n              <mat-icon>expand_less</mat-icon>\n              } @if (!isExpanded(group)) {\n              <mat-icon>expand_more</mat-icon>\n              }\n            </button>\n            }\n          </div>\n        </td>\n      </ng-container>\n      <tr\n        mat-row\n        class=\"group\"\n        cdkDragBoundary=\".cdk-table\"\n        cdkDrag\n        [cdkDragDisabled]=\"true\"\n        cdkDragPreviewContainer=\"parent\"\n        *matRowDef=\"let row; columns: ['groupHeader']; when: isGroup\"\n      ></tr>\n      <!-- Drag and drop -->\n      <ng-container matColumnDef=\"table-dragger\">\n        <th id=\"table-dragger\" mat-header-cell *matHeaderCellDef disableClear=\"true\"></th>\n        <td tabindex=\"0\" mat-cell *matCellDef=\"let row\" class=\"table-dragger\">\n          <mat-icon\n            [ngClass]=\"{\n              'disabled': config.dragAndDrop?.disableDragOnItem ? config.dragAndDrop?.disableDragOnItem(row) : false,\n              'drag-cursor': config.dragAndDrop?.disableDragOnItem ? !config.dragAndDrop?.disableDragOnItem(row) : true\n            }\"\n            (mousedown)=\"dragDisabled = false\"\n            >drag_indicator</mat-icon\n          >\n        </td>\n        <td tabindex=\"0\" mat-footer-cell *matFooterCellDef></td>\n      </ng-container>\n      @for (key of orderedColumnKeys; track key; let isLast = $last) {\n      <ng-container [matColumnDef]=\"key\" [sticky]=\"columns[key].sticky\" [stickyEnd]=\"columns[key].stickyEnd\">\n        <th\n          mat-header-cell\n          *matHeaderCellDef\n          [id]=\"key\"\n          [mat-sort-header]=\"columns[key].sortKey\"\n          [disabled]=\"!columns[key].sortable\"\n          [style.width]=\"small ? undefined : columns[key]?.width\"\n          [ngClass]=\"'cellClass' | groupClass : { config: config, columns: columns, columnKey: key }\"\n        >\n          <div [micHeaderCell]=\"columns[key]\" [templateFinder]=\"headerTemplateFinder\"></div>\n          @if (filters && filters[key]) { @if ( ['text', 'date'].includes(filters[key].type)) {\n          <div class=\"w-14\">\n            <mat-icon\n              class=\"table-filter-icon\"\n              matBadge=\"1\"\n              [matBadgeHidden]=\"filterControls[key].value.length === 0\"\n              matBadgeColor=\"accent\"\n              matBadgeSize=\"small\"\n              aria-hidden=\"false\"\n              [matBadgeDescription]=\"'filter ' + key\"\n              (click)=\"openFilterOverlay($event, key)\"\n              type=\"button\"\n              cdkOverlayOrigin\n              #trigger=\"cdkOverlayOrigin\"\n              >filter_alt\n            </mat-icon>\n            <ng-template\n              cdkConnectedOverlay\n              [cdkConnectedOverlayHasBackdrop]=\"true\"\n              cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\"\n              [cdkConnectedOverlayOrigin]=\"trigger\"\n              [cdkConnectedOverlayOpen]=\"filters[key].open\"\n              (backdropClick)=\"closeFilterOverlay(key)\"\n            >\n              <div class=\"overlay-input-text py-2\">\n                <div class=\"flex flex-row\">\n                  <div class=\"flex flex-row w-1on6\">\n                    <div class=\"mat-select-checked flex flex-col ml-2 gap-1\">\n                      <button mat-icon-button class=\"mic-icon-button-medium\" type=\"button\" (click)=\"closeFilterOverlay(key)\">\n                        <mat-icon>clear</mat-icon>\n                      </button>\n                    </div>\n                  </div>\n                  @if (filters[key].type === 'text') {\n                  <mat-form-field class=\"flex-1\">\n                    <input matInput type=\"text\" autocomplete=\"off\" [formControl]=\"filterControls[key]\" />\n                    <mat-icon matSuffix>search</mat-icon>\n                  </mat-form-field>\n                  <div class=\"w-1on6\"></div>\n                  } @if (filters[key].type === 'date') {\n                  <mat-form-field class=\"flex-1\">\n                    <mat-date-range-input [rangePicker]=\"picker\">\n                      <input matStartDate [formControl]=\"filterDateControls[key + 'Start']\" placeholder=\"Start date\" />\n                      <input matEndDate [formControl]=\"filterDateControls[key + 'End']\" placeholder=\"End date\" />\n                    </mat-date-range-input>\n                    <mat-datepicker-toggle matIconSuffix [for]=\"picker\"></mat-datepicker-toggle>\n                    <mat-date-range-picker #picker></mat-date-range-picker>\n                  </mat-form-field>\n                  <div class=\"w-1on12\"></div>\n                  }\n                </div>\n              </div>\n            </ng-template>\n          </div>\n          } @else {\n          <mic-dropdown-search\n            class=\"w-14 min-w\"\n            color=\"accent\"\n            [multiple]=\"true\"\n            [formControl]=\"filterControls[key]\"\n            [filters]=\"filtersResetValue\"\n            [fetcher]=\"filters[key].fetcher\"\n            [limitSelection]=\"filters[key].limit\"\n            [attribute]=\"filters[key].attribute\"\n            (click)=\"$event.stopPropagation()\"\n            (openedChange)=\"applyFilterDropdownValues($event)\"\n          >\n            <mat-icon\n              class=\"table-filter-icon\"\n              [matBadge]=\"filterControls[key].value.length\"\n              [matBadgeHidden]=\"filterControls[key].value.length === 0\"\n              matBadgeColor=\"accent\"\n              matBadgeSize=\"small\"\n              aria-hidden=\"false\"\n              [matBadgeDescription]=\"'filter ' + key\"\n              >filter_alt</mat-icon\n            >\n          </mic-dropdown-search>\n          } }\n        </th>\n        <td\n          tabindex=\"0\"\n          mat-cell\n          *matCellDef=\"let item\"\n          [ngClass]=\"'cellClass' | groupClass : { config: config, columns: columns, columnKey: key, item: item }\"\n          [attr.data-label]=\"columns[key].header\"\n          [style.width]=\"small ? undefined : columns[key]?.width\"\n        >\n          <ng-container [micCell]=\"columns[key]\" [item]=\"item\" [templateFinder]=\"templateFinder\"></ng-container>\n        </td>\n        <td\n          tabindex=\"0\"\n          mat-footer-cell\n          *matFooterCellDef=\"let item\"\n          [ngClass]=\"'cellClass' | groupClass : { config: config, columns: columns, columnKey: key, item: item }\"\n          [style.width]=\"small ? undefined : columns[key]?.width\"\n        >\n          @if (!columns[key].totalFormat) {\n          {{ getTotal(key) | number }}\n          } @if (columns[key].totalFormat) { @if (columns[key].totalFormat === 'currency') {\n          {{ getTotal(key) | currency : 'EUR' : 'symbol' : '0.0-0' }}\n          } @if (columns[key].totalFormat !== 'currency') {\n          {{ getTotal(key) | number }} {{ columns[key].totalFormat }}\n          } }\n        </td>\n      </ng-container>\n      }\n      <ng-container matColumnDef=\"table-selector\" sticky>\n        <th id=\"table-selector\" mat-header-cell *matHeaderCellDef disableClear=\"true\">\n          @if (!config.selection?.disableHeaderCheckbox) {\n          <mat-checkbox\n            [ngStyle]=\"{ display: !data?.length ? 'none' : 'inline-block' }\"\n            (change)=\"$event ? toggleAll() : null\"\n            [checked]=\"selection.hasValue() && isAllSelected\"\n            [indeterminate]=\"selection.hasValue() && !isAllSelected\"\n            [matTooltip]=\"config?.selection?.allLabel\"\n          >\n          </mat-checkbox>\n          }\n        </th>\n        <td mat-cell *matCellDef=\"let row\" class=\"selector-cell\">\n          @if (config.onSelectionChange) {\n          <mat-checkbox\n            (click)=\"$event.stopPropagation()\"\n            (change)=\"$event ? selection.toggle(row) : null\"\n            [checked]=\"isSelected(row)\"\n            [matTooltip]=\"getCheckLabel(row)\"\n          >\n          </mat-checkbox>\n          } @if (rowMenuQuery) {\n          <div class=\"xs-actions\">\n            <button type=\"button\" mat-icon-button [matMenuTriggerFor]=\"menu\" [disabled]=\"isMenuDisplayed(row)\">\n              <mat-icon>more_horiz</mat-icon>\n            </button>\n            <mat-menu #menu=\"matMenu\">\n              <ng-container *ngTemplateOutlet=\"rowMenuQuery.templateRef; context: { $implicit: row }\"></ng-container>\n            </mat-menu>\n          </div>\n          } @if (rowActionsQuery) {\n          <div class=\"xs-actions\">\n            <ng-container *ngTemplateOutlet=\"rowActionsQuery.templateRef; context: { $implicit: row }\"></ng-container>\n          </div>\n          }\n        </td>\n        <td tabindex=\"0\" mat-footer-cell *matFooterCellDef></td>\n      </ng-container>\n      <ng-container matColumnDef=\"table-expander\">\n        <th id=\"table-expander\" mat-header-cell [style.minWidth]=\"'50px'\" *matHeaderCellDef></th>\n        <td mat-cell [style.minWidth]=\"'50px'\" *matCellDef=\"let row\">\n          @if (!row.disableExpansion) {\n          <button mat-icon-button (click)=\"onRowExpand(row)\">\n            <mat-icon>{{ expandedRows?.includes(row) ? 'expand_less' : 'expand_more' }}</mat-icon>\n          </button>\n          }\n        </td>\n        <td tabindex=\"0\" mat-footer-cell *matFooterCellDef></td>\n      </ng-container>\n      <ng-container matColumnDef=\"table-actions\" stickyEnd>\n        <th id=\"table-actions\" mat-header-cell *matHeaderCellDef></th>\n        <td mat-cell *matCellDef=\"let item\">\n          <ng-container *ngTemplateOutlet=\"rowActionsQuery.templateRef; context: { $implicit: item }\"></ng-container>\n        </td>\n        <td tabindex=\"0\" mat-footer-cell *matFooterCellDef></td>\n      </ng-container>\n      <ng-container matColumnDef=\"table-menu\" stickyEnd>\n        <th id=\"table-menu\" mat-header-cell *matHeaderCellDef></th>\n        <td mat-cell *matCellDef=\"let item\">\n          <button type=\"button\" mat-icon-button [matMenuTriggerFor]=\"menu\" aria-label=\"more_vert\" [disabled]=\"isMenuDisplayed(item)\">\n            <mat-icon aria-hidden=\"false\">more_vert</mat-icon>\n          </button>\n          <mat-menu #menu=\"matMenu\">\n            <ng-container *ngTemplateOutlet=\"rowMenuQuery.templateRef; context: { $implicit: item }\"></ng-container>\n          </mat-menu>\n        </td>\n        <td tabindex=\"0\" mat-footer-cell *matFooterCellDef></td>\n      </ng-container>\n      <ng-container matColumnDef=\"table-expanded-detail\">\n        @if (rowDetailQuery) {\n        <td tabindex=\"0\" mat-cell *matCellDef=\"let row\" [attr.colspan]=\"columnKeys.length\">\n          <div [@detailExpand]=\"expandedRows?.includes(row) ? 'expanded' : 'collapsed'\">\n            <ng-container *ngTemplateOutlet=\"rowDetailQuery.templateRef; context: { $implicit: row }\"></ng-container>\n          </div>\n        </td>\n        }\n      </ng-container>\n      @for (groupColumns of config?.groupsColumns; track groupColumns) {\n      <div>\n        @if (groupColumns.columns && groupColumns.name) {\n        <ng-container [matColumnDef]=\"groupColumns.name\">\n          <th mat-header-cell *matHeaderCellDef [attr.colspan]=\"groupColumns.columns.length\">\n            <span [class]=\"'grid text-' + groupColumns?.align\">\n              {{ groupColumns.header }}\n            </span>\n          </th>\n        </ng-container>\n        }\n      </div>\n      } @if (isGroupColumnsQuery()) {\n      <div>\n        <tr mat-header-row *matHeaderRowDef=\"groupColumnsKey; sticky: true\" class=\"group-columns\"></tr>\n      </div>\n      }\n      <tr mat-header-row *matHeaderRowDef=\"columnKeys; sticky: true\"></tr>\n      <tr\n        mat-row\n        *matRowDef=\"let item; columns: columnKeys; when: isNotGroup\"\n        [ngClass]=\"'rowClass' | groupClass : { config: config, item: item, expandedRows: expandedRows }\"\n        (click)=\"onRowClick(item, $event)\"\n        cdkDragBoundary=\".cdk-table\"\n        cdkDrag\n        [cdkDragDisabled]=\"config.dragAndDrop?.disableDragOnItem ? config.dragAndDrop?.disableDragOnItem(item) : false\"\n        cdkDragPreviewContainer=\"parent\"\n        [cdkDragData]=\"item\"\n      ></tr>\n      @if (rowDetailQuery) {\n      <tr mat-row *matRowDef=\"let row; columns: ['table-expanded-detail']\" class=\"table-expanded-detail\"></tr>\n      } @if (total) {\n      <tr mat-footer-row *matFooterRowDef=\"columnKeys\"></tr>\n      }\n    </table>\n  </div>\n  @if (!data?.length && tableNoData && tableNoData.templateRef) {\n  <div class=\"table-empty\">\n    <ng-container *ngTemplateOutlet=\"tableNoData.templateRef\"></ng-container>\n  </div>\n  }\n</ng-template>\n<mat-menu #columnSelectorMenu=\"matMenu\" (closed)=\"onColumnSelectorClose()\">\n  <mat-list\n    micScrollBar\n    [formGroup]=\"columnForm\"\n    class=\"table-column-selector\"\n    [cdkDropListData]=\"orderedColumnKeys\"\n    cdkDropList\n    (cdkDropListDropped)=\"dropColumnKey($event)\"\n  >\n    @for (col of columnFormArray.controls; track col; let i = $index) {\n    <mat-list-item\n      class=\"table-column-selector-item {{ theme() }}\"\n      cdkDrag\n      (click)=\"$event.stopImmediatePropagation()\"\n      formArrayName=\"selected\"\n    >\n      <div class=\"flex flex-row items-center\">\n        <div class=\"table-column-selector-placeholder\" *cdkDragPlaceholder></div>\n        <mat-icon class=\"table-column-selector-icon\" cdkDragHandle>drag_indicator</mat-icon>\n        <mat-checkbox class=\"mx-2\" [formControlName]=\"i\"></mat-checkbox>\n        <span [micHeaderCell]=\"columns[orderedColumnKeys[i]]\" [templateFinder]=\"headerTemplateFinder\"></span>\n      </div>\n    </mat-list-item>\n    }\n  </mat-list>\n</mat-menu>\n", styles: [".mat-icon.mic-icon-link{vertical-align:sub;font-size:18px;width:auto;height:auto}.mic-elevation-1{box-shadow:0 4px 8px #6666661f}.mic-elevation-2{box-shadow:0 8px 16px #66666629}.mic-elevation-3{box-shadow:0 16px 32px #6663}.mic-elevation-4{box-shadow:0 32px 64px #66666652}.mat-column-table-menu{width:30px}.mat-column-table-actions{width:70px}.cdk-column-table-dragger{width:58px}.mat-mdc-table{margin-bottom:2px!important}table,.container-scroll{width:100%;min-width:100%}.table-filter-icon{font-size:18px;height:18px;width:18px;line-height:18px}.table-empty{padding:20px;flex:1;text-align:center}.table-expanded-detail{min-height:0;border-bottom:0;height:0}.mat-column-table-expanded-detail{overflow:hidden}.mat-mdc-header-cell{border-bottom-width:2px}.mat-mdc-cell:not(:first-of-type),.mat-mdc-header-cell:not(:first-of-type),.mat-mdc-footer-cell:not(:first-of-type){padding-left:10px;padding-right:14px}.mat-mdc-header-cell.align-left,.mat-mdc-cell.align-left,.mat-mdc-footer-cell.align-left{text-align:left;justify-content:flex-start}.mat-mdc-header-cell.align-center,.mat-mdc-cell.align-center,.mat-mdc-footer-cell.align-center{text-align:center;justify-content:center}.mat-mdc-header-cell.align-center[mat-sort-header]::ng-deep>*,.mat-mdc-cell.align-center[mat-sort-header]::ng-deep>*,.mat-mdc-footer-cell.align-center[mat-sort-header]::ng-deep>*{transform:translate(9px)}.mat-mdc-header-cell.align-center ::ng-deep .mat-sort-header-content,.mat-mdc-header-cell.align-center ::ng-deep .mat-sort-header-container,.mat-mdc-cell.align-center ::ng-deep .mat-sort-header-content,.mat-mdc-cell.align-center ::ng-deep .mat-sort-header-container,.mat-mdc-footer-cell.align-center ::ng-deep .mat-sort-header-content,.mat-mdc-footer-cell.align-center ::ng-deep .mat-sort-header-container{text-align:center;justify-content:center}.mat-mdc-header-cell.align-right,.mat-mdc-cell.align-right,.mat-mdc-footer-cell.align-right{text-align:right;justify-content:flex-end}.mat-mdc-header-cell.align-right ::ng-deep .mat-sort-header-content,.mat-mdc-header-cell.align-right ::ng-deep .mat-sort-header-container,.mat-mdc-cell.align-right ::ng-deep .mat-sort-header-content,.mat-mdc-cell.align-right ::ng-deep .mat-sort-header-container,.mat-mdc-footer-cell.align-right ::ng-deep .mat-sort-header-content,.mat-mdc-footer-cell.align-right ::ng-deep .mat-sort-header-container{text-align:right;justify-content:flex-end}.mat-column-table-selector{width:fit-content}.xs-actions{display:none}@media screen and (max-width: 800px){.mat-mdc-header-row,.mat-column-table-menu,.mat-column-table-actions,.mat-mdc-footer-cell:first-of-type{display:none!important}.mat-mdc-cell:not(:first-of-type),.mat-mdc-header-cell:not(:first-of-type),.mat-mdc-footer-cell:not(:first-of-type){padding-left:0}.mat-mdc-cell:first-of-type:not(.mat-column-table-selector),.mat-mdc-header-cell:first-of-type,.mat-mdc-footer-cell:first-of-type{padding-left:0}.mat-mdc-cell:last-of-type,.mat-mdc-header-cell:last-of-type{padding-right:0}.mat-column-table-selector{margin-right:15px!important}.mat-column-table-selector .mat-mdc-checkbox{margin-top:5px}.selector-cell{width:100%}.xs-actions{display:block;margin-left:10px;margin-bottom:5px;margin-top:10px}.mat-mdc-table{border:0;vertical-align:middle}.mat-mdc-table caption{font-size:1em}.mat-mdc-table .mat-mdc-cell{max-width:100%;font-size:1em;text-align:right;font-weight:700;min-height:30px;padding-right:4%;display:flex;line-height:35px}.mat-mdc-table .mat-mdc-cell:not(:last-of-type){border:none}.mat-mdc-table .mat-mdc-cell.mat-column-table-expanded-detail{min-height:0}.mat-mdc-table .mat-mdc-cell:before{flex:1;content:attr(data-label);text-align:left;margin-left:4%;font-weight:400}}.cdk-drag-preview{border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-preview:not(.mat-mdc-row){background-color:#fff;display:flex;flex-direction:row;align-items:center;justify-content:center;min-width:fit-content}.cdk-drag-preview:not(.mat-mdc-row).dark-mode{color:#fff;background-color:#1e1e1e}.cdk-drag-preview:not(.mat-mdc-row) .mat-mdc-checkbox{margin-left:30px;margin-right:10px;margin-bottom:5px}.cdk-drag-preview:not(.mat-mdc-row) .cdk-drag-handle{margin-right:-10px;position:absolute}.cdk-drag-preview.mat-mdc-row{display:table}tr.mat-mdc-row{z-index:0;position:relative}.table-column-selector.cdk-drop-list-dragging .table-column-selector-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.table-column-selector .cdk-drag-handle{cursor:move}.table-column-selector .table-column-selector-item{background:inherit}.table-column-selector .table-column-selector-item div{min-height:43px}.table-column-selector .table-column-selector-item span{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.table-column-selector .table-column-selector-icon{min-width:25px}.table-column-selector .cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.table-column-selector .table-column-selector-item:last-child{border:none}.table-column-selector .table-column-selector-placeholder{min-height:48px;transition:transform .25s cubic-bezier(0,0,.2,1)}.mat-icon.disabled{color:#bdbdbd}.group{transform:scale(1);-webkit-transform:scale(1);-moz-transform:scale(1);box-shadow:-2px 2px 9px #00000024;-webkit-box-shadow:-2px 2px 9px 0px rgba(0,0,0,.14);-moz-box-shadow:-2px 2px 9px 0px rgba(0,0,0,.14)}.group .toggle-group{cursor:pointer}.group td .mat-mdc-checkbox{margin-left:6px}.table-dragger{text-align:center}.table-dragger .drag-cursor{cursor:move}.overlay-input-text{box-shadow:0 4px 8px #6666661f;background-color:#fff}.overlay-input-text ::ng-deep .mat-mdc-form-field .mat-mdc-text-field-wrapper{max-height:50px}.overlay-input-text ::ng-deep .mat-mdc-form-field .mdc-text-field--no-label:not(.mdc-text-field--outlined):not(.mdc-text-field--textarea) .mat-mdc-form-field-infix{padding-top:14px}.overlay-input-text ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-icon-suffix>.mat-icon{padding-top:0}.overlay-input-text ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper{display:none}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i1.MatIconButton, selector: "button[mat-icon-button]", exportAs: ["matButton"] }, { kind: "directive", type: i5$1.MatBadge, selector: "[matBadge]", inputs: ["matBadgeColor", "matBadgeOverlap", "matBadgeDisabled", "matBadgePosition", "matBadge", "matBadgeDescription", "matBadgeSize", "matBadgeHidden"] }, { kind: "component", type: i8.MatCheckbox, selector: "mat-checkbox", inputs: ["aria-label", "aria-labelledby", "aria-describedby", "id", "required", "labelPosition", "name", "value", "disableRipple", "tabIndex", "color", "checked", "disabled", "indeterminate"], outputs: ["change", "indeterminateChange"], exportAs: ["matCheckbox"] }, { kind: "directive", type: i9.MatChipRemove, selector: "[matChipRemove]" }, { kind: "component", type: i9.MatChipRow, selector: "mat-chip-row, [mat-chip-row], mat-basic-chip-row, [mat-basic-chip-row]", inputs: ["editable"], outputs: ["edited"] }, { kind: "component", type: i10.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["for", "tabIndex", "aria-label", "disabled", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { kind: "component", type: i10.MatDateRangeInput, selector: "mat-date-range-input", inputs: ["rangePicker", "required", "dateFilter", "min", "max", "disabled", "separator", "comparisonStart", "comparisonEnd"], exportAs: ["matDateRangeInput"] }, { kind: "directive", type: i10.MatStartDate, selector: "input[matStartDate]", outputs: ["dateChange", "dateInput"] }, { kind: "directive", type: i10.MatEndDate, selector: "input[matEndDate]", outputs: ["dateChange", "dateInput"] }, { kind: "component", type: i10.MatDateRangePicker, selector: "mat-date-range-picker", exportAs: ["matDateRangePicker"] }, { kind: "component", type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i3$3.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i4$1.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i4$1.MatSuffix, selector: "[matSuffix], [matIconSuffix], [matTextSuffix]", inputs: ["matTextSuffix"] }, { kind: "component", type: i14.MatList, selector: "mat-list", exportAs: ["matList"] }, { kind: "component", type: i14.MatListItem, selector: "mat-list-item, a[mat-list-item], button[mat-list-item]", inputs: ["activated"], exportAs: ["matListItem"] }, { kind: "component", type: i4.MatMenu, selector: "mat-menu", inputs: ["backdropClass", "aria-label", "aria-labelledby", "aria-describedby", "xPosition", "yPosition", "overlapTrigger", "hasBackdrop", "class", "classList"], outputs: ["closed", "close"], exportAs: ["matMenu"] }, { kind: "directive", type: i4.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", inputs: ["mat-menu-trigger-for", "matMenuTriggerFor", "matMenuTriggerData", "matMenuTriggerRestoreFocus"], outputs: ["menuOpened", "onMenuOpen", "menuClosed", "onMenuClose"], exportAs: ["matMenuTrigger"] }, { kind: "directive", type: i16.MatTooltip, selector: "[matTooltip]", inputs: ["matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipDisabled", "matTooltipShowDelay", "matTooltipHideDelay", "matTooltipTouchGestures", "matTooltip", "matTooltipClass"], exportAs: ["matTooltip"] }, { kind: "directive", type: i17.MatSort, selector: "[matSort]", inputs: ["matSortActive", "matSortStart", "matSortDirection", "matSortDisableClear", "matSortDisabled"], outputs: ["matSortChange"], exportAs: ["matSort"] }, { kind: "component", type: i17.MatSortHeader, selector: "[mat-sort-header]", inputs: ["mat-sort-header", "arrowPosition", "start", "disabled", "sortActionDescription", "disableClear"], exportAs: ["matSortHeader"] }, { kind: "component", type: i18.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i18.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i18.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i18.MatColumnDef, selector: "[matColumnDef]", inputs: ["matColumnDef"] }, { kind: "directive", type: i18.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i18.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i18.MatFooterCellDef, selector: "[matFooterCellDef]" }, { kind: "directive", type: i18.MatFooterRowDef, selector: "[matFooterRowDef]", inputs: ["matFooterRowDef", "matFooterRowDefSticky"] }, { kind: "directive", type: i18.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i18.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "directive", type: i18.MatFooterCell, selector: "mat-footer-cell, td[mat-footer-cell]" }, { kind: "component", type: i18.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i18.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "component", type: i18.MatFooterRow, selector: "mat-footer-row, tr[mat-footer-row]", exportAs: ["matFooterRow"] }, { kind: "directive", type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i3$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i3$1.FormArrayName, selector: "[formArrayName]", inputs: ["formArrayName"] }, { kind: "directive", type: i19.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { kind: "directive", type: i19.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "directive", type: i19.CdkDragHandle, selector: "[cdkDragHandle]", inputs: ["cdkDragHandleDisabled"] }, { kind: "directive", type: i19.CdkDragPlaceholder, selector: "ng-template[cdkDragPlaceholder]", inputs: ["data"] }, { kind: "directive", type: i1$8.CdkConnectedOverlay, selector: "[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]", inputs: ["cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayPositionStrategy", "cdkConnectedOverlayOffsetX", "cdkConnectedOverlayOffsetY", "cdkConnectedOverlayWidth", "cdkConnectedOverlayHeight", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayMinHeight", "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayViewportMargin", "cdkConnectedOverlayScrollStrategy", "cdkConnectedOverlayOpen", "cdkConnectedOverlayDisableClose", "cdkConnectedOverlayTransformOriginOn", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayLockPosition", "cdkConnectedOverlayFlexibleDimensions", "cdkConnectedOverlayGrowAfterOpen", "cdkConnectedOverlayPush", "cdkConnectedOverlayDisposeOnNavigation"], outputs: ["backdropClick", "positionChange", "attach", "detach", "overlayKeydown", "overlayOutsideClick"], exportAs: ["cdkConnectedOverlay"] }, { kind: "directive", type: i1$8.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }, { kind: "component", type: PaginatorComponent, selector: "mic-paginator", inputs: ["fetcher", "config", "storage", "color"], outputs: ["dataChanged"] }, { kind: "directive", type: PaginatorContentDirective, selector: "[micPaginatorContent]" }, { kind: "component", type: DropdownComponent, selector: "mic-dropdown-search", inputs: ["data", "label", "appearance", "color", "loaderConfig", "virtualScroll", "floatLabel", "attribute", "placeholder", "emptyPlaceholder", "searchPlaceholder", "required", "requiredLabel", "nullLabel", "allLabel", "multiple", "limitSelection", "paginator", "filters", "fetcher", "subscriptSizing", "formControl", "formControlName", "compareWith"], outputs: ["openedChange"] }, { kind: "directive", type: ScrollBarDirective, selector: "[micScrollBar]", inputs: ["micScrollBar", "micScrollBarOptions"] }, { kind: "directive", type: TableCellDirective, selector: "[micCell]", inputs: ["micCell", "item", "templateFinder"] }, { kind: "directive", type: TableHeaderCellDirective, selector: "[micHeaderCell]", inputs: ["micHeaderCell", "templateFinder"] }, { kind: "pipe", type: i2.DecimalPipe, name: "number" }, { kind: "pipe", type: i2.CurrencyPipe, name: "currency" }, { kind: "pipe", type: TableRowCellClassPipe, name: "groupClass" }], animations: [
            trigger('detailExpand', [
                state('collapsed', style({ height: '0px', minHeight: '0' })),
                state('expanded', style({ height: '*' })),
                transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
            ])
        ], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-table', changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        trigger('detailExpand', [
                            state('collapsed', style({ height: '0px', minHeight: '0' })),
                            state('expanded', style({ height: '*' })),
                            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
                        ])
                    ], template: "@if (config.paginator && fetcher) {\n<mic-paginator\n  #paginator\n  [fetcher]=\"fetcher\"\n  [storage]=\"config.storage\"\n  [config]=\"config.paginator\"\n  (dataChanged)=\"selectionChanged(false)\"\n>\n  @if (config.paginator.position !== 'top' && !config.paginator.forceBottomAction) {\n  <ng-container *ngTemplateOutlet=\"actions\"></ng-container>\n  } @if (filtersConfig?.tags?.display) {\n  <ng-container *ngTemplateOutlet=\"tagsFilter\"></ng-container>\n  }\n  <ng-container *ngTemplateOutlet=\"table\"></ng-container>\n  @if (config.paginator.position === 'top' || config.paginator.forceBottomAction) {\n  <ng-container *micPaginatorContent>\n    <ng-container *ngTemplateOutlet=\"actions\"></ng-container>\n  </ng-container>\n  }\n</mic-paginator>\n} @if (!config.paginator && !fetcher) {\n<ng-container *ngTemplateOutlet=\"actions\"></ng-container>\n@if (filtersConfig?.tags?.display) {\n<ng-container *ngTemplateOutlet=\"tagsFilter\"></ng-container>\n}\n<ng-container *ngTemplateOutlet=\"table\"></ng-container>\n}\n<ng-template #actions>\n  @if (actionsQuery || columnSelectorQuery) {\n  <div class=\"flex flex-row flex-wrap gap-2 m-2\">\n    @if (columnSelectorQuery) {\n    <div [matMenuTriggerFor]=\"columnSelectorMenu\">\n      <ng-container *ngTemplateOutlet=\"columnSelectorQuery.templateRef\"></ng-container>\n    </div>\n    } @if (actionsQuery) {\n    <ng-container *ngTemplateOutlet=\"actionsQuery.templateRef; context: { $implicit: selection.selected }\"></ng-container>\n    }\n  </div>\n  }\n</ng-template>\n<ng-template #tagsFilter>\n  <div class=\"flex flex-row flex-wrap\">\n    @for (key of orderedColumnKeys; track key) { @if (filtersConfig?.tags?.display && filters && filters[key]) { @for (control of\n    filterControls[key].value; track control) {\n    <mat-chip-row class=\"m-1\" [color]=\"filtersConfig?.tags?.color || 'primary'\" (removed)=\"removeFilter(key, control)\">\n      {{ config.columns[key].header + ': ' + control }}\n      <button matChipRemove [attr.aria-label]=\"'remove ' + config.columns[key].header + ': ' + control.value\">\n        <mat-icon>cancel</mat-icon>\n      </button>\n    </mat-chip-row>\n    } } }\n  </div>\n</ng-template>\n<ng-template #table>\n  <div\n    [ngStyle]=\"{ 'max-height': config?.options?.maxHeight }\"\n    class=\"container-scroll\"\n    micScrollBar\n    [micScrollBarOptions]=\"config.options?.scrollOptions\"\n  >\n    <table\n      mat-table\n      matSort\n      multiTemplateDataRows\n      [matSortActive]=\"activeSort\"\n      [matSortDirection]=\"activeSortDirection\"\n      [dataSource]=\"ds\"\n      [@.disabled]=\"config?.rows?.disableExpandAnimation\"\n      cdkDropList\n      (cdkDropListDropped)=\"drop($event)\"\n      [cdkDropListSortPredicate]=\"sortGroupPredicate\"\n      [cdkDropListDisabled]=\"dragDisabled\"\n      role=\"table\"\n      aria-labelledby=\"mic-table\"\n      tabindex=\"0\"\n    >\n      <!-- Group header -->\n      <ng-container matColumnDef=\"groupHeader\">\n        <td tabindex=\"0\" mat-cell colspan=\"999\" *matCellDef=\"let group\">\n          <div [ngClass]=\"'flex flex-row items-center gap-2 mr-2 ml-' + 3 * group.level\">\n            @if (!groupHeaderQuery) {\n            <span [ngClass]=\"'mr-2 ml-' + 4 * group.level\">\n              @if (config.onSelectionChange) {\n              <mat-checkbox\n                (click)=\"$event.stopPropagation()\"\n                (change)=\"$event ? toggleGroup(group) : null\"\n                [checked]=\"isGroupSelected(group)\"\n              >\n              </mat-checkbox>\n              }\n              <strong> {{ group.field }} = {{ group.value }} ({{ group.totalCounts }}) </strong>\n            </span>\n            } @if (groupHeaderQuery) {\n            <ng-container *ngTemplateOutlet=\"groupHeaderQuery.templateRef; context: { $implicit: group }\"></ng-container>\n            } @if (group.totalCounts > 0) {\n            <button class=\"toggle-group\" mat-icon-button (click)=\"groupHeaderClick(group)\">\n              @if (isExpanded(group)) {\n              <mat-icon>expand_less</mat-icon>\n              } @if (!isExpanded(group)) {\n              <mat-icon>expand_more</mat-icon>\n              }\n            </button>\n            }\n          </div>\n        </td>\n      </ng-container>\n      <tr\n        mat-row\n        class=\"group\"\n        cdkDragBoundary=\".cdk-table\"\n        cdkDrag\n        [cdkDragDisabled]=\"true\"\n        cdkDragPreviewContainer=\"parent\"\n        *matRowDef=\"let row; columns: ['groupHeader']; when: isGroup\"\n      ></tr>\n      <!-- Drag and drop -->\n      <ng-container matColumnDef=\"table-dragger\">\n        <th id=\"table-dragger\" mat-header-cell *matHeaderCellDef disableClear=\"true\"></th>\n        <td tabindex=\"0\" mat-cell *matCellDef=\"let row\" class=\"table-dragger\">\n          <mat-icon\n            [ngClass]=\"{\n              'disabled': config.dragAndDrop?.disableDragOnItem ? config.dragAndDrop?.disableDragOnItem(row) : false,\n              'drag-cursor': config.dragAndDrop?.disableDragOnItem ? !config.dragAndDrop?.disableDragOnItem(row) : true\n            }\"\n            (mousedown)=\"dragDisabled = false\"\n            >drag_indicator</mat-icon\n          >\n        </td>\n        <td tabindex=\"0\" mat-footer-cell *matFooterCellDef></td>\n      </ng-container>\n      @for (key of orderedColumnKeys; track key; let isLast = $last) {\n      <ng-container [matColumnDef]=\"key\" [sticky]=\"columns[key].sticky\" [stickyEnd]=\"columns[key].stickyEnd\">\n        <th\n          mat-header-cell\n          *matHeaderCellDef\n          [id]=\"key\"\n          [mat-sort-header]=\"columns[key].sortKey\"\n          [disabled]=\"!columns[key].sortable\"\n          [style.width]=\"small ? undefined : columns[key]?.width\"\n          [ngClass]=\"'cellClass' | groupClass : { config: config, columns: columns, columnKey: key }\"\n        >\n          <div [micHeaderCell]=\"columns[key]\" [templateFinder]=\"headerTemplateFinder\"></div>\n          @if (filters && filters[key]) { @if ( ['text', 'date'].includes(filters[key].type)) {\n          <div class=\"w-14\">\n            <mat-icon\n              class=\"table-filter-icon\"\n              matBadge=\"1\"\n              [matBadgeHidden]=\"filterControls[key].value.length === 0\"\n              matBadgeColor=\"accent\"\n              matBadgeSize=\"small\"\n              aria-hidden=\"false\"\n              [matBadgeDescription]=\"'filter ' + key\"\n              (click)=\"openFilterOverlay($event, key)\"\n              type=\"button\"\n              cdkOverlayOrigin\n              #trigger=\"cdkOverlayOrigin\"\n              >filter_alt\n            </mat-icon>\n            <ng-template\n              cdkConnectedOverlay\n              [cdkConnectedOverlayHasBackdrop]=\"true\"\n              cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\"\n              [cdkConnectedOverlayOrigin]=\"trigger\"\n              [cdkConnectedOverlayOpen]=\"filters[key].open\"\n              (backdropClick)=\"closeFilterOverlay(key)\"\n            >\n              <div class=\"overlay-input-text py-2\">\n                <div class=\"flex flex-row\">\n                  <div class=\"flex flex-row w-1on6\">\n                    <div class=\"mat-select-checked flex flex-col ml-2 gap-1\">\n                      <button mat-icon-button class=\"mic-icon-button-medium\" type=\"button\" (click)=\"closeFilterOverlay(key)\">\n                        <mat-icon>clear</mat-icon>\n                      </button>\n                    </div>\n                  </div>\n                  @if (filters[key].type === 'text') {\n                  <mat-form-field class=\"flex-1\">\n                    <input matInput type=\"text\" autocomplete=\"off\" [formControl]=\"filterControls[key]\" />\n                    <mat-icon matSuffix>search</mat-icon>\n                  </mat-form-field>\n                  <div class=\"w-1on6\"></div>\n                  } @if (filters[key].type === 'date') {\n                  <mat-form-field class=\"flex-1\">\n                    <mat-date-range-input [rangePicker]=\"picker\">\n                      <input matStartDate [formControl]=\"filterDateControls[key + 'Start']\" placeholder=\"Start date\" />\n                      <input matEndDate [formControl]=\"filterDateControls[key + 'End']\" placeholder=\"End date\" />\n                    </mat-date-range-input>\n                    <mat-datepicker-toggle matIconSuffix [for]=\"picker\"></mat-datepicker-toggle>\n                    <mat-date-range-picker #picker></mat-date-range-picker>\n                  </mat-form-field>\n                  <div class=\"w-1on12\"></div>\n                  }\n                </div>\n              </div>\n            </ng-template>\n          </div>\n          } @else {\n          <mic-dropdown-search\n            class=\"w-14 min-w\"\n            color=\"accent\"\n            [multiple]=\"true\"\n            [formControl]=\"filterControls[key]\"\n            [filters]=\"filtersResetValue\"\n            [fetcher]=\"filters[key].fetcher\"\n            [limitSelection]=\"filters[key].limit\"\n            [attribute]=\"filters[key].attribute\"\n            (click)=\"$event.stopPropagation()\"\n            (openedChange)=\"applyFilterDropdownValues($event)\"\n          >\n            <mat-icon\n              class=\"table-filter-icon\"\n              [matBadge]=\"filterControls[key].value.length\"\n              [matBadgeHidden]=\"filterControls[key].value.length === 0\"\n              matBadgeColor=\"accent\"\n              matBadgeSize=\"small\"\n              aria-hidden=\"false\"\n              [matBadgeDescription]=\"'filter ' + key\"\n              >filter_alt</mat-icon\n            >\n          </mic-dropdown-search>\n          } }\n        </th>\n        <td\n          tabindex=\"0\"\n          mat-cell\n          *matCellDef=\"let item\"\n          [ngClass]=\"'cellClass' | groupClass : { config: config, columns: columns, columnKey: key, item: item }\"\n          [attr.data-label]=\"columns[key].header\"\n          [style.width]=\"small ? undefined : columns[key]?.width\"\n        >\n          <ng-container [micCell]=\"columns[key]\" [item]=\"item\" [templateFinder]=\"templateFinder\"></ng-container>\n        </td>\n        <td\n          tabindex=\"0\"\n          mat-footer-cell\n          *matFooterCellDef=\"let item\"\n          [ngClass]=\"'cellClass' | groupClass : { config: config, columns: columns, columnKey: key, item: item }\"\n          [style.width]=\"small ? undefined : columns[key]?.width\"\n        >\n          @if (!columns[key].totalFormat) {\n          {{ getTotal(key) | number }}\n          } @if (columns[key].totalFormat) { @if (columns[key].totalFormat === 'currency') {\n          {{ getTotal(key) | currency : 'EUR' : 'symbol' : '0.0-0' }}\n          } @if (columns[key].totalFormat !== 'currency') {\n          {{ getTotal(key) | number }} {{ columns[key].totalFormat }}\n          } }\n        </td>\n      </ng-container>\n      }\n      <ng-container matColumnDef=\"table-selector\" sticky>\n        <th id=\"table-selector\" mat-header-cell *matHeaderCellDef disableClear=\"true\">\n          @if (!config.selection?.disableHeaderCheckbox) {\n          <mat-checkbox\n            [ngStyle]=\"{ display: !data?.length ? 'none' : 'inline-block' }\"\n            (change)=\"$event ? toggleAll() : null\"\n            [checked]=\"selection.hasValue() && isAllSelected\"\n            [indeterminate]=\"selection.hasValue() && !isAllSelected\"\n            [matTooltip]=\"config?.selection?.allLabel\"\n          >\n          </mat-checkbox>\n          }\n        </th>\n        <td mat-cell *matCellDef=\"let row\" class=\"selector-cell\">\n          @if (config.onSelectionChange) {\n          <mat-checkbox\n            (click)=\"$event.stopPropagation()\"\n            (change)=\"$event ? selection.toggle(row) : null\"\n            [checked]=\"isSelected(row)\"\n            [matTooltip]=\"getCheckLabel(row)\"\n          >\n          </mat-checkbox>\n          } @if (rowMenuQuery) {\n          <div class=\"xs-actions\">\n            <button type=\"button\" mat-icon-button [matMenuTriggerFor]=\"menu\" [disabled]=\"isMenuDisplayed(row)\">\n              <mat-icon>more_horiz</mat-icon>\n            </button>\n            <mat-menu #menu=\"matMenu\">\n              <ng-container *ngTemplateOutlet=\"rowMenuQuery.templateRef; context: { $implicit: row }\"></ng-container>\n            </mat-menu>\n          </div>\n          } @if (rowActionsQuery) {\n          <div class=\"xs-actions\">\n            <ng-container *ngTemplateOutlet=\"rowActionsQuery.templateRef; context: { $implicit: row }\"></ng-container>\n          </div>\n          }\n        </td>\n        <td tabindex=\"0\" mat-footer-cell *matFooterCellDef></td>\n      </ng-container>\n      <ng-container matColumnDef=\"table-expander\">\n        <th id=\"table-expander\" mat-header-cell [style.minWidth]=\"'50px'\" *matHeaderCellDef></th>\n        <td mat-cell [style.minWidth]=\"'50px'\" *matCellDef=\"let row\">\n          @if (!row.disableExpansion) {\n          <button mat-icon-button (click)=\"onRowExpand(row)\">\n            <mat-icon>{{ expandedRows?.includes(row) ? 'expand_less' : 'expand_more' }}</mat-icon>\n          </button>\n          }\n        </td>\n        <td tabindex=\"0\" mat-footer-cell *matFooterCellDef></td>\n      </ng-container>\n      <ng-container matColumnDef=\"table-actions\" stickyEnd>\n        <th id=\"table-actions\" mat-header-cell *matHeaderCellDef></th>\n        <td mat-cell *matCellDef=\"let item\">\n          <ng-container *ngTemplateOutlet=\"rowActionsQuery.templateRef; context: { $implicit: item }\"></ng-container>\n        </td>\n        <td tabindex=\"0\" mat-footer-cell *matFooterCellDef></td>\n      </ng-container>\n      <ng-container matColumnDef=\"table-menu\" stickyEnd>\n        <th id=\"table-menu\" mat-header-cell *matHeaderCellDef></th>\n        <td mat-cell *matCellDef=\"let item\">\n          <button type=\"button\" mat-icon-button [matMenuTriggerFor]=\"menu\" aria-label=\"more_vert\" [disabled]=\"isMenuDisplayed(item)\">\n            <mat-icon aria-hidden=\"false\">more_vert</mat-icon>\n          </button>\n          <mat-menu #menu=\"matMenu\">\n            <ng-container *ngTemplateOutlet=\"rowMenuQuery.templateRef; context: { $implicit: item }\"></ng-container>\n          </mat-menu>\n        </td>\n        <td tabindex=\"0\" mat-footer-cell *matFooterCellDef></td>\n      </ng-container>\n      <ng-container matColumnDef=\"table-expanded-detail\">\n        @if (rowDetailQuery) {\n        <td tabindex=\"0\" mat-cell *matCellDef=\"let row\" [attr.colspan]=\"columnKeys.length\">\n          <div [@detailExpand]=\"expandedRows?.includes(row) ? 'expanded' : 'collapsed'\">\n            <ng-container *ngTemplateOutlet=\"rowDetailQuery.templateRef; context: { $implicit: row }\"></ng-container>\n          </div>\n        </td>\n        }\n      </ng-container>\n      @for (groupColumns of config?.groupsColumns; track groupColumns) {\n      <div>\n        @if (groupColumns.columns && groupColumns.name) {\n        <ng-container [matColumnDef]=\"groupColumns.name\">\n          <th mat-header-cell *matHeaderCellDef [attr.colspan]=\"groupColumns.columns.length\">\n            <span [class]=\"'grid text-' + groupColumns?.align\">\n              {{ groupColumns.header }}\n            </span>\n          </th>\n        </ng-container>\n        }\n      </div>\n      } @if (isGroupColumnsQuery()) {\n      <div>\n        <tr mat-header-row *matHeaderRowDef=\"groupColumnsKey; sticky: true\" class=\"group-columns\"></tr>\n      </div>\n      }\n      <tr mat-header-row *matHeaderRowDef=\"columnKeys; sticky: true\"></tr>\n      <tr\n        mat-row\n        *matRowDef=\"let item; columns: columnKeys; when: isNotGroup\"\n        [ngClass]=\"'rowClass' | groupClass : { config: config, item: item, expandedRows: expandedRows }\"\n        (click)=\"onRowClick(item, $event)\"\n        cdkDragBoundary=\".cdk-table\"\n        cdkDrag\n        [cdkDragDisabled]=\"config.dragAndDrop?.disableDragOnItem ? config.dragAndDrop?.disableDragOnItem(item) : false\"\n        cdkDragPreviewContainer=\"parent\"\n        [cdkDragData]=\"item\"\n      ></tr>\n      @if (rowDetailQuery) {\n      <tr mat-row *matRowDef=\"let row; columns: ['table-expanded-detail']\" class=\"table-expanded-detail\"></tr>\n      } @if (total) {\n      <tr mat-footer-row *matFooterRowDef=\"columnKeys\"></tr>\n      }\n    </table>\n  </div>\n  @if (!data?.length && tableNoData && tableNoData.templateRef) {\n  <div class=\"table-empty\">\n    <ng-container *ngTemplateOutlet=\"tableNoData.templateRef\"></ng-container>\n  </div>\n  }\n</ng-template>\n<mat-menu #columnSelectorMenu=\"matMenu\" (closed)=\"onColumnSelectorClose()\">\n  <mat-list\n    micScrollBar\n    [formGroup]=\"columnForm\"\n    class=\"table-column-selector\"\n    [cdkDropListData]=\"orderedColumnKeys\"\n    cdkDropList\n    (cdkDropListDropped)=\"dropColumnKey($event)\"\n  >\n    @for (col of columnFormArray.controls; track col; let i = $index) {\n    <mat-list-item\n      class=\"table-column-selector-item {{ theme() }}\"\n      cdkDrag\n      (click)=\"$event.stopImmediatePropagation()\"\n      formArrayName=\"selected\"\n    >\n      <div class=\"flex flex-row items-center\">\n        <div class=\"table-column-selector-placeholder\" *cdkDragPlaceholder></div>\n        <mat-icon class=\"table-column-selector-icon\" cdkDragHandle>drag_indicator</mat-icon>\n        <mat-checkbox class=\"mx-2\" [formControlName]=\"i\"></mat-checkbox>\n        <span [micHeaderCell]=\"columns[orderedColumnKeys[i]]\" [templateFinder]=\"headerTemplateFinder\"></span>\n      </div>\n    </mat-list-item>\n    }\n  </mat-list>\n</mat-menu>\n", styles: [".mat-icon.mic-icon-link{vertical-align:sub;font-size:18px;width:auto;height:auto}.mic-elevation-1{box-shadow:0 4px 8px #6666661f}.mic-elevation-2{box-shadow:0 8px 16px #66666629}.mic-elevation-3{box-shadow:0 16px 32px #6663}.mic-elevation-4{box-shadow:0 32px 64px #66666652}.mat-column-table-menu{width:30px}.mat-column-table-actions{width:70px}.cdk-column-table-dragger{width:58px}.mat-mdc-table{margin-bottom:2px!important}table,.container-scroll{width:100%;min-width:100%}.table-filter-icon{font-size:18px;height:18px;width:18px;line-height:18px}.table-empty{padding:20px;flex:1;text-align:center}.table-expanded-detail{min-height:0;border-bottom:0;height:0}.mat-column-table-expanded-detail{overflow:hidden}.mat-mdc-header-cell{border-bottom-width:2px}.mat-mdc-cell:not(:first-of-type),.mat-mdc-header-cell:not(:first-of-type),.mat-mdc-footer-cell:not(:first-of-type){padding-left:10px;padding-right:14px}.mat-mdc-header-cell.align-left,.mat-mdc-cell.align-left,.mat-mdc-footer-cell.align-left{text-align:left;justify-content:flex-start}.mat-mdc-header-cell.align-center,.mat-mdc-cell.align-center,.mat-mdc-footer-cell.align-center{text-align:center;justify-content:center}.mat-mdc-header-cell.align-center[mat-sort-header]::ng-deep>*,.mat-mdc-cell.align-center[mat-sort-header]::ng-deep>*,.mat-mdc-footer-cell.align-center[mat-sort-header]::ng-deep>*{transform:translate(9px)}.mat-mdc-header-cell.align-center ::ng-deep .mat-sort-header-content,.mat-mdc-header-cell.align-center ::ng-deep .mat-sort-header-container,.mat-mdc-cell.align-center ::ng-deep .mat-sort-header-content,.mat-mdc-cell.align-center ::ng-deep .mat-sort-header-container,.mat-mdc-footer-cell.align-center ::ng-deep .mat-sort-header-content,.mat-mdc-footer-cell.align-center ::ng-deep .mat-sort-header-container{text-align:center;justify-content:center}.mat-mdc-header-cell.align-right,.mat-mdc-cell.align-right,.mat-mdc-footer-cell.align-right{text-align:right;justify-content:flex-end}.mat-mdc-header-cell.align-right ::ng-deep .mat-sort-header-content,.mat-mdc-header-cell.align-right ::ng-deep .mat-sort-header-container,.mat-mdc-cell.align-right ::ng-deep .mat-sort-header-content,.mat-mdc-cell.align-right ::ng-deep .mat-sort-header-container,.mat-mdc-footer-cell.align-right ::ng-deep .mat-sort-header-content,.mat-mdc-footer-cell.align-right ::ng-deep .mat-sort-header-container{text-align:right;justify-content:flex-end}.mat-column-table-selector{width:fit-content}.xs-actions{display:none}@media screen and (max-width: 800px){.mat-mdc-header-row,.mat-column-table-menu,.mat-column-table-actions,.mat-mdc-footer-cell:first-of-type{display:none!important}.mat-mdc-cell:not(:first-of-type),.mat-mdc-header-cell:not(:first-of-type),.mat-mdc-footer-cell:not(:first-of-type){padding-left:0}.mat-mdc-cell:first-of-type:not(.mat-column-table-selector),.mat-mdc-header-cell:first-of-type,.mat-mdc-footer-cell:first-of-type{padding-left:0}.mat-mdc-cell:last-of-type,.mat-mdc-header-cell:last-of-type{padding-right:0}.mat-column-table-selector{margin-right:15px!important}.mat-column-table-selector .mat-mdc-checkbox{margin-top:5px}.selector-cell{width:100%}.xs-actions{display:block;margin-left:10px;margin-bottom:5px;margin-top:10px}.mat-mdc-table{border:0;vertical-align:middle}.mat-mdc-table caption{font-size:1em}.mat-mdc-table .mat-mdc-cell{max-width:100%;font-size:1em;text-align:right;font-weight:700;min-height:30px;padding-right:4%;display:flex;line-height:35px}.mat-mdc-table .mat-mdc-cell:not(:last-of-type){border:none}.mat-mdc-table .mat-mdc-cell.mat-column-table-expanded-detail{min-height:0}.mat-mdc-table .mat-mdc-cell:before{flex:1;content:attr(data-label);text-align:left;margin-left:4%;font-weight:400}}.cdk-drag-preview{border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-preview:not(.mat-mdc-row){background-color:#fff;display:flex;flex-direction:row;align-items:center;justify-content:center;min-width:fit-content}.cdk-drag-preview:not(.mat-mdc-row).dark-mode{color:#fff;background-color:#1e1e1e}.cdk-drag-preview:not(.mat-mdc-row) .mat-mdc-checkbox{margin-left:30px;margin-right:10px;margin-bottom:5px}.cdk-drag-preview:not(.mat-mdc-row) .cdk-drag-handle{margin-right:-10px;position:absolute}.cdk-drag-preview.mat-mdc-row{display:table}tr.mat-mdc-row{z-index:0;position:relative}.table-column-selector.cdk-drop-list-dragging .table-column-selector-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.table-column-selector .cdk-drag-handle{cursor:move}.table-column-selector .table-column-selector-item{background:inherit}.table-column-selector .table-column-selector-item div{min-height:43px}.table-column-selector .table-column-selector-item span{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.table-column-selector .table-column-selector-icon{min-width:25px}.table-column-selector .cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.table-column-selector .table-column-selector-item:last-child{border:none}.table-column-selector .table-column-selector-placeholder{min-height:48px;transition:transform .25s cubic-bezier(0,0,.2,1)}.mat-icon.disabled{color:#bdbdbd}.group{transform:scale(1);-webkit-transform:scale(1);-moz-transform:scale(1);box-shadow:-2px 2px 9px #00000024;-webkit-box-shadow:-2px 2px 9px 0px rgba(0,0,0,.14);-moz-box-shadow:-2px 2px 9px 0px rgba(0,0,0,.14)}.group .toggle-group{cursor:pointer}.group td .mat-mdc-checkbox{margin-left:6px}.table-dragger{text-align:center}.table-dragger .drag-cursor{cursor:move}.overlay-input-text{box-shadow:0 4px 8px #6666661f;background-color:#fff}.overlay-input-text ::ng-deep .mat-mdc-form-field .mat-mdc-text-field-wrapper{max-height:50px}.overlay-input-text ::ng-deep .mat-mdc-form-field .mdc-text-field--no-label:not(.mdc-text-field--outlined):not(.mdc-text-field--textarea) .mat-mdc-form-field-infix{padding-top:14px}.overlay-input-text ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-icon-suffix>.mat-icon{padding-top:0}.overlay-input-text ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper{display:none}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.ActivatedRoute }, { type: i1$1.Router }, { type: i0.ChangeDetectorRef }, { type: i2$5.BreakpointObserver }, { type: i3$1.FormBuilder }, { type: ThemingService }, { type: i0.KeyValueDiffers }, { type: i0.IterableDiffers }], propDecorators: { config: [{
                type: Input
            }], dataSource: [{
                type: Input
            }], fetcher: [{
                type: Input
            }], filtersConfig: [{
                type: Input
            }], compareWith: [{
                type: Input
            }], cellsQuery: [{
                type: ContentChildren,
                args: [TableCellTemplateDirective]
            }], headerCellsQuery: [{
                type: ContentChildren,
                args: [TableHeaderCellTemplateDirective]
            }], rowMenuQuery: [{
                type: ContentChild,
                args: [TableRowMenuDirective]
            }], rowActionsQuery: [{
                type: ContentChild,
                args: [TableRowActionsDirective]
            }], columnSelectorQuery: [{
                type: ContentChild,
                args: [TableColumnSelectorDirective, { static: true }]
            }], actionsQuery: [{
                type: ContentChild,
                args: [TableActionsDirective]
            }], rowDetailQuery: [{
                type: ContentChild,
                args: [TableRowDetailDirective, { static: true }]
            }], tableNoData: [{
                type: ContentChild,
                args: [TableNoDataTemplateDirective, { static: true }]
            }], groupHeaderQuery: [{
                type: ContentChild,
                args: [TableGroupHeaderDirective]
            }], table: [{
                type: ViewChild,
                args: [MatTable, { static: false }]
            }], sort: [{
                type: ViewChild,
                args: [MatSort, { static: false }]
            }], paginator: [{
                type: ViewChild,
                args: [PaginatorComponent, { static: false }]
            }] } });

const modules$1 = [CommonModule, MaterialModule, PaginatorModule, DropdownModule];
const declarations$1 = [
    TableComponent,
    TableCellDirective,
    TableRowActionsDirective,
    TableRowMenuDirective,
    TableCellTemplateDirective,
    TableRowDetailDirective,
    TableActionsDirective,
    TableColumnSelectorDirective,
    TableHeaderCellDirective,
    TableHeaderCellTemplateDirective,
    TableNoDataTemplateDirective,
    TableGroupHeaderDirective
];
/** <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { TableModule } from '@michelin/theme';</code>
 */
class TableModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: TableModule, declarations: [TableComponent,
            TableCellDirective,
            TableRowActionsDirective,
            TableRowMenuDirective,
            TableCellTemplateDirective,
            TableRowDetailDirective,
            TableActionsDirective,
            TableColumnSelectorDirective,
            TableHeaderCellDirective,
            TableHeaderCellTemplateDirective,
            TableNoDataTemplateDirective,
            TableGroupHeaderDirective, TableRowCellClassPipe], imports: [CommonModule, MaterialModule, PaginatorModule, DropdownModule], exports: [TableComponent,
            TableCellDirective,
            TableRowActionsDirective,
            TableRowMenuDirective,
            TableCellTemplateDirective,
            TableRowDetailDirective,
            TableActionsDirective,
            TableColumnSelectorDirective,
            TableHeaderCellDirective,
            TableHeaderCellTemplateDirective,
            TableNoDataTemplateDirective,
            TableGroupHeaderDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableModule, imports: [modules$1] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TableModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: modules$1,
                    declarations: [...declarations$1, TableRowCellClassPipe],
                    exports: declarations$1
                }]
        }] });

/**
 * Component to manage timeline content
 *
 */
class TimelineEntryContentComponent {
    constructor() {
        this.className = 'mic-timeline-entry-content';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimelineEntryContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: TimelineEntryContentComponent, selector: "mic-timeline-entry-content", host: { properties: { "class": "this.className" } }, ngImport: i0, template: "<div><ng-content></ng-content></div>\n", styles: [".mic-timeline-entry-content{position:relative;display:block;overflow:hidden;text-align:justify;padding-right:15px;padding-left:15px}.mic-timeline-entry-content>div{padding:10px 14px}.timeline-horizontal .mic-timeline-entry-content{padding-top:18px}@media screen and (max-width: 599px){.mic-timeline-entry-content{padding-right:5px;padding-left:5px}}\n"], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimelineEntryContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-timeline-entry-content', encapsulation: ViewEncapsulation.None, template: "<div><ng-content></ng-content></div>\n", styles: [".mic-timeline-entry-content{position:relative;display:block;overflow:hidden;text-align:justify;padding-right:15px;padding-left:15px}.mic-timeline-entry-content>div{padding:10px 14px}.timeline-horizontal .mic-timeline-entry-content{padding-top:18px}@media screen and (max-width: 599px){.mic-timeline-entry-content{padding-right:5px;padding-left:5px}}\n"] }]
        }], propDecorators: { className: [{
                type: HostBinding,
                args: ['class']
            }] } });

const defaultActualSize = 42;
/**
 * Component to manage timeline dots
 */
class TimelineEntryDotComponent {
    /**
     * Size of the dot
     */
    set size(size) {
        this.actualSize = size;
        this.setStyle();
    }
    get size() {
        return this.actualSize;
    }
    set alternate(alternate) {
        this.isAlternate = alternate;
        this.setStyle();
    }
    get alternate() {
        return this.isAlternate;
    }
    constructor(elementRef, renderer, document) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.document = document;
        this.isAlternate = false;
        this.actualSize = defaultActualSize;
        /**
         * Class used for the coloration (default: primary)
         */
        this.class = 'primary';
    }
    ngOnInit() {
        this.className = `mic-timeline-entry-dot ${this.class}`;
    }
    ngAfterViewInit() {
        this.initialStyle = this.document.defaultView.getComputedStyle(this.elementRef.nativeElement);
        this.setStyle();
    }
    getCollapsedStyle() {
        return {
            width: this.size + 'px',
            height: this.size + 'px',
            opacity: 1,
            transform: 'translateY(-50%) translateX(-50%)',
            boxShadow: this.initialStyle && this.initialStyle.boxShadow,
            borderRadius: '100px'
        };
    }
    setStyle() {
        const baseStyle = this.getCollapsedStyle();
        Object.keys(baseStyle).forEach((property) => {
            this.renderer.setStyle(this.elementRef.nativeElement, property, baseStyle[property]);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimelineEntryDotComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: TimelineEntryDotComponent, selector: "mic-timeline-entry-dot", inputs: { class: "class", size: "size" }, host: { properties: { "class": "this.className" } }, ngImport: i0, template: "<ng-content></ng-content>\n", styles: [".mic-timeline-entry-dot{top:50%;display:block;position:absolute}.mic-timeline-entry .mic-timeline-entry-dot{left:calc(100% + 4px)}.mic-timeline-entry.alternate .mic-timeline-entry-dot{left:-4px}.timeline-horizontal .mic-timeline-entry .mic-timeline-entry-dot{top:-4px;left:150px}.timeline-horizontal .mic-timeline-entry.alternate .mic-timeline-entry-dot{left:150px}.timeline-horizontal-list .mic-timeline-entry-dot{z-index:1}@media screen and (max-width: 599px){.mic-timeline-entry .mic-timeline-entry-dot{top:0%;left:calc(100% - 35px)}.mic-timeline-entry.alternate .mic-timeline-entry-dot{left:calc(100% - 35px)}}\n"], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimelineEntryDotComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-timeline-entry-dot', encapsulation: ViewEncapsulation.None, template: "<ng-content></ng-content>\n", styles: [".mic-timeline-entry-dot{top:50%;display:block;position:absolute}.mic-timeline-entry .mic-timeline-entry-dot{left:calc(100% + 4px)}.mic-timeline-entry.alternate .mic-timeline-entry-dot{left:-4px}.timeline-horizontal .mic-timeline-entry .mic-timeline-entry-dot{top:-4px;left:150px}.timeline-horizontal .mic-timeline-entry.alternate .mic-timeline-entry-dot{left:150px}.timeline-horizontal-list .mic-timeline-entry-dot{z-index:1}@media screen and (max-width: 599px){.mic-timeline-entry .mic-timeline-entry-dot{top:0%;left:calc(100% - 35px)}.mic-timeline-entry.alternate .mic-timeline-entry-dot{left:calc(100% - 35px)}}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { class: [{
                type: Input
            }], className: [{
                type: HostBinding,
                args: ['class']
            }], size: [{
                type: Input
            }] } });

/**
 * Component to manage timeline sides
 */
class TimelineEntrySideComponent {
    set alternate(value) {
        this.elementRef.nativeElement.classList.toggle('alternate', value);
    }
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.className = 'mic-timeline-entry-side';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimelineEntrySideComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: TimelineEntrySideComponent, selector: "mic-timeline-entry-side", host: { properties: { "class": "this.className" } }, ngImport: i0, template: "<ng-content></ng-content>\n", styles: [".mic-timeline-entry-side{position:absolute;left:100%;text-align:left;margin-left:40px;width:calc(100% - 45px);top:50%;margin-top:-12px;color:#cfcfcf}.mic-timeline-entry-side.alternate{text-align:right;width:100%;margin-left:-40px;left:-100%}.timeline-horizontal .mic-timeline-entry-side{margin-left:0;left:0;width:300px;top:-45px;text-align:center}.timeline-horizontal .mic-timeline-entry-side.alternate{text-align:center;margin-left:0}.timeline-horizontal-list .mic-timeline-entry-side{width:200px;position:relative;margin-left:-42px;left:0;top:-42px;text-align:center}@media screen and (max-width: 599px){.mic-timeline-entry-side{width:100%;margin-left:0;left:0;text-align:right;top:-50px}.mic-timeline-entry-side.alternate{left:0;margin-left:0}}\n"], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimelineEntrySideComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-timeline-entry-side', encapsulation: ViewEncapsulation.None, template: "<ng-content></ng-content>\n", styles: [".mic-timeline-entry-side{position:absolute;left:100%;text-align:left;margin-left:40px;width:calc(100% - 45px);top:50%;margin-top:-12px;color:#cfcfcf}.mic-timeline-entry-side.alternate{text-align:right;width:100%;margin-left:-40px;left:-100%}.timeline-horizontal .mic-timeline-entry-side{margin-left:0;left:0;width:300px;top:-45px;text-align:center}.timeline-horizontal .mic-timeline-entry-side.alternate{text-align:center;margin-left:0}.timeline-horizontal-list .mic-timeline-entry-side{width:200px;position:relative;margin-left:-42px;left:0;top:-42px;text-align:center}@media screen and (max-width: 599px){.mic-timeline-entry-side{width:100%;margin-left:0;left:0;text-align:right;top:-50px}.mic-timeline-entry-side.alternate{left:0;margin-left:0}}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { className: [{
                type: HostBinding,
                args: ['class']
            }] } });

/**
 * Component to manage timeline entries
 */
class TimelineEntryComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.className = 'mic-timeline-entry';
        this.focusOnOpen = false;
    }
    set alternate(value) {
        this.elementRef.nativeElement.classList.toggle('alternate', value);
        if (this.dot) {
            this.dot.alternate = value;
        }
        if (this.side) {
            this.side.alternate = value;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimelineEntryComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: TimelineEntryComponent, selector: "mic-timeline-entry", host: { properties: { "class": "this.className" } }, queries: [{ propertyName: "content", first: true, predicate: TimelineEntryContentComponent, descendants: true }, { propertyName: "dot", first: true, predicate: TimelineEntryDotComponent, descendants: true }, { propertyName: "side", first: true, predicate: TimelineEntrySideComponent, descendants: true }], ngImport: i0, template: "<ng-content select=\"mic-timeline-entry-side\"></ng-content>\n<div class=\"timeline-entry-card\" tabindex=\"0\">\n  <ng-content select=\"mic-timeline-entry-dot\"></ng-content>\n  <ng-content select=\"mic-timeline-entry-content\"></ng-content>\n</div>\n", styles: [".mic-timeline-entry{display:block;position:relative;margin-bottom:25px;width:calc(50% - 4px)}.mic-timeline-entry.alternate{margin-left:calc(50% + 4px)}.mic-timeline-entry.alternate .timeline-entry-card{border-radius:0 5px 5px 0}.mic-timeline-entry .timeline-entry-card{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f;border-radius:5px 0 0 5px}.timeline-horizontal .mic-timeline-entry{width:300px;float:left;margin-bottom:0;margin-left:25px;top:8px}.timeline-horizontal .mic-timeline-entry.alternate .timeline-entry-card,.timeline-horizontal .mic-timeline-entry .timeline-entry-card{border-radius:0 0 5px 5px}@media screen and (max-width: 599px){.mic-timeline-entry{margin-top:100px;margin-bottom:25px;width:100%}.mic-timeline-entry.alternate{width:100%;margin-left:0}.mic-timeline-entry .timeline-entry-card{border-radius:5px}}\n"], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimelineEntryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-timeline-entry', encapsulation: ViewEncapsulation.None, template: "<ng-content select=\"mic-timeline-entry-side\"></ng-content>\n<div class=\"timeline-entry-card\" tabindex=\"0\">\n  <ng-content select=\"mic-timeline-entry-dot\"></ng-content>\n  <ng-content select=\"mic-timeline-entry-content\"></ng-content>\n</div>\n", styles: [".mic-timeline-entry{display:block;position:relative;margin-bottom:25px;width:calc(50% - 4px)}.mic-timeline-entry.alternate{margin-left:calc(50% + 4px)}.mic-timeline-entry.alternate .timeline-entry-card{border-radius:0 5px 5px 0}.mic-timeline-entry .timeline-entry-card{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f;border-radius:5px 0 0 5px}.timeline-horizontal .mic-timeline-entry{width:300px;float:left;margin-bottom:0;margin-left:25px;top:8px}.timeline-horizontal .mic-timeline-entry.alternate .timeline-entry-card,.timeline-horizontal .mic-timeline-entry .timeline-entry-card{border-radius:0 0 5px 5px}@media screen and (max-width: 599px){.mic-timeline-entry{margin-top:100px;margin-bottom:25px;width:100%}.mic-timeline-entry.alternate{width:100%;margin-left:0}.mic-timeline-entry .timeline-entry-card{border-radius:5px}}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { className: [{
                type: HostBinding,
                args: ['class']
            }], content: [{
                type: ContentChild,
                args: [TimelineEntryContentComponent]
            }], dot: [{
                type: ContentChild,
                args: [TimelineEntryDotComponent]
            }], side: [{
                type: ContentChild,
                args: [TimelineEntrySideComponent]
            }] } });

var TimelineMode;
(function (TimelineMode) {
    TimelineMode["HORIZONTAL"] = "horizontal";
    TimelineMode["VERTICAL"] = "vertical";
    TimelineMode["HORIZONTALLIST"] = "horizontal-list";
})(TimelineMode || (TimelineMode = {}));

/**
 * Component to manage timeline
 */
class TimelineComponent {
    constructor() {
        /**
         * Timeline mode : vertical or horizontal
         */
        this.mode = TimelineMode.VERTICAL;
        /**
         * Alternate timeline entry position from left to right
         */
        this.alternate = true;
        /**
         * First entry position
         */
        this.side = 'left';
    }
    get class() {
        return 'mic-timeline timeline-' + this.mode;
    }
    ngOnChanges() {
        this.updateContent();
    }
    ngAfterViewInit() {
        setTimeout(() => this.updateContent());
        this.content.changes.subscribe(() => {
            this.updateContent();
        });
    }
    /**
     * Alternate position of timeline entries
     */
    updateContent() {
        if (this.content) {
            this.content.forEach((entry, index) => {
                entry.alternate = this.alternate ? index % 2 !== 0 : this.side === 'right';
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimelineComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: TimelineComponent, selector: "mic-timeline", inputs: { mode: "mode", alternate: "alternate", side: "side" }, host: { properties: { "class": "this.class" } }, queries: [{ propertyName: "content", predicate: TimelineEntryComponent }], usesOnChanges: true, ngImport: i0, template: "<div class=\"timeline-container\">\n  <div class=\"timeline-line\"></div>\n  <div class=\"timeline\">\n    <ng-content></ng-content>\n  </div>\n</div>\n", styles: [".mic-timeline.timeline-vertical{width:100%;position:relative;display:block;padding:50px 0 25px}.mic-timeline.timeline-vertical .timeline-line{position:absolute;top:0;height:100%;left:50%;width:8px;transform:translate(-50%);border-radius:5px}.mic-timeline.timeline-horizontal{padding-bottom:20px}.mic-timeline.timeline-horizontal .timeline-container{width:max-content;position:relative;display:block;padding:55px 50px 55px 25px}.mic-timeline.timeline-horizontal .timeline-line{position:absolute;top:50%;height:8px;left:0;width:100%;border-radius:5px}.mic-timeline.timeline-horizontal-list .timeline-container{width:max-content;position:relative;display:block;padding:50px 50px 55px 25px}.mic-timeline.timeline-horizontal-list .timeline-line{position:absolute;height:8px;left:0;width:100%;border-radius:5px}@media screen and (max-width: 599px){.mic-timeline.timeline-vertical{padding:0 0 25px}}\n"], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimelineComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-timeline', encapsulation: ViewEncapsulation.None, template: "<div class=\"timeline-container\">\n  <div class=\"timeline-line\"></div>\n  <div class=\"timeline\">\n    <ng-content></ng-content>\n  </div>\n</div>\n", styles: [".mic-timeline.timeline-vertical{width:100%;position:relative;display:block;padding:50px 0 25px}.mic-timeline.timeline-vertical .timeline-line{position:absolute;top:0;height:100%;left:50%;width:8px;transform:translate(-50%);border-radius:5px}.mic-timeline.timeline-horizontal{padding-bottom:20px}.mic-timeline.timeline-horizontal .timeline-container{width:max-content;position:relative;display:block;padding:55px 50px 55px 25px}.mic-timeline.timeline-horizontal .timeline-line{position:absolute;top:50%;height:8px;left:0;width:100%;border-radius:5px}.mic-timeline.timeline-horizontal-list .timeline-container{width:max-content;position:relative;display:block;padding:50px 50px 55px 25px}.mic-timeline.timeline-horizontal-list .timeline-line{position:absolute;height:8px;left:0;width:100%;border-radius:5px}@media screen and (max-width: 599px){.mic-timeline.timeline-vertical{padding:0 0 25px}}\n"] }]
        }], propDecorators: { mode: [{
                type: Input
            }], alternate: [{
                type: Input
            }], side: [{
                type: Input
            }], content: [{
                type: ContentChildren,
                args: [TimelineEntryComponent]
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });

class TimelineEntryContentListComponent {
    constructor() {
        this.className = 'mic-timeline-entry-list';
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.list.nativeElement.parentElement.parentElement.style.height = `${this.list.nativeElement.offsetHeight + 40}px`;
        }, 0);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimelineEntryContentListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: TimelineEntryContentListComponent, selector: "mic-timeline-entry-list", host: { properties: { "class": "this.className" } }, viewQueries: [{ propertyName: "list", first: true, predicate: ["list"], descendants: true }], ngImport: i0, template: "<ng-content select=\"mic-timeline-entry-side\"></ng-content>\n<ng-content select=\"mic-timeline-entry-dot\"></ng-content>\n<div class=\"timeline-list\" #list>\n  <ng-content select=\"mic-timeline-entry-content\"></ng-content>\n</div>\n", styles: [".timeline-horizontal-list .mic-timeline-entry-list{position:relative;width:300px;float:left;margin-bottom:0;top:0;display:flex;justify-content:center}.timeline-horizontal-list .mic-timeline-entry-content{text-align:center;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f;border-radius:5px;display:block;position:relative;width:200px;top:60px;margin-bottom:50px;left:-9%}.timeline-horizontal-list .mic-timeline-entry-content>div{padding:15px 14px}.timeline-horizontal-list .timeline-list{position:absolute}.timeline-horizontal-list .timeline-list:before{content:\"\";position:absolute;width:6px;top:0;bottom:0;left:40%}\n"], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimelineEntryContentListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-timeline-entry-list', encapsulation: ViewEncapsulation.None, template: "<ng-content select=\"mic-timeline-entry-side\"></ng-content>\n<ng-content select=\"mic-timeline-entry-dot\"></ng-content>\n<div class=\"timeline-list\" #list>\n  <ng-content select=\"mic-timeline-entry-content\"></ng-content>\n</div>\n", styles: [".timeline-horizontal-list .mic-timeline-entry-list{position:relative;width:300px;float:left;margin-bottom:0;top:0;display:flex;justify-content:center}.timeline-horizontal-list .mic-timeline-entry-content{text-align:center;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f;border-radius:5px;display:block;position:relative;width:200px;top:60px;margin-bottom:50px;left:-9%}.timeline-horizontal-list .mic-timeline-entry-content>div{padding:15px 14px}.timeline-horizontal-list .timeline-list{position:absolute}.timeline-horizontal-list .timeline-list:before{content:\"\";position:absolute;width:6px;top:0;bottom:0;left:40%}\n"] }]
        }], propDecorators: { className: [{
                type: HostBinding,
                args: ['class']
            }], list: [{
                type: ViewChild,
                args: ['list']
            }] } });

const modules = [CommonModule];
const components$3 = [
    TimelineComponent,
    TimelineEntryComponent,
    TimelineEntrySideComponent,
    TimelineEntryContentComponent,
    TimelineEntryDotComponent,
    TimelineEntryContentListComponent
];
/**
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { TimelineModule } from '@michelin/theme';</code>
 */
class TimelineModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimelineModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: TimelineModule, declarations: [TimelineComponent,
            TimelineEntryComponent,
            TimelineEntrySideComponent,
            TimelineEntryContentComponent,
            TimelineEntryDotComponent,
            TimelineEntryContentListComponent], imports: [CommonModule], exports: [TimelineComponent,
            TimelineEntryComponent,
            TimelineEntrySideComponent,
            TimelineEntryContentComponent,
            TimelineEntryDotComponent,
            TimelineEntryContentListComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimelineModule, imports: [modules] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimelineModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: modules,
                    declarations: components$3,
                    exports: components$3
                }]
        }] });

/**
 * Component to display a file drop zone
 *
 */
class UploadDropZoneComponent {
    constructor() {
        /**
         * Method to detect file dropped
         */
        this.fileDropped = new EventEmitter();
    }
    onDragOver(event) {
        event.preventDefault();
        event.stopPropagation();
        this.fileOver = true;
    }
    onDragLeave(event) {
        event.preventDefault();
        event.stopPropagation();
        this.fileOver = false;
    }
    onDrop(event) {
        event.preventDefault();
        event.stopPropagation();
        this.fileOver = false;
        const files = event.dataTransfer.files;
        if (files.length > 0) {
            this.fileDropped.emit(files);
        }
    }
    ngAfterViewInit() {
        // Apply accept attribute to the file input
        if (this.accept) {
            this.fileDropRef.nativeElement.accept = this.accept;
        }
    }
    /**
     * Handler to manage file input click
     *
     * @param event
     */
    fileInputClick(event) {
        event.target.value = '';
    }
    /**
     * Handler to manage file upload with button
     *
     * @param event
     */
    fileBrowseHandler(event) {
        this.fileDropped.emit(event.target.files);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: UploadDropZoneComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: UploadDropZoneComponent, selector: "mic-upload-dropzone", inputs: { required: "required", accept: "accept", multiple: "multiple", label: "label", button: "button", or: "or" }, outputs: { fileDropped: "fileDropped" }, host: { listeners: { "dragover": "onDragOver($event)", "dragleave": "onDragLeave($event)", "drop": "onDrop($event)" } }, viewQueries: [{ propertyName: "fileDropRef", first: true, predicate: ["fileDropRef"], descendants: true }], ngImport: i0, template: "<div class=\"mic-dropzone flex flex-col items-center\" [ngClass]=\"{ fileover: fileOver === true }\">\n  <input\n    type=\"file\"\n    #fileDropRef\n    id=\"fileDropRef\"\n    [multiple]=\"multiple\"\n    (click)=\"fileInputClick($event)\"\n    (change)=\"fileBrowseHandler($event)\"\n    autocomplete=\"off\"\n  />\n  <mat-icon>upload_file</mat-icon>\n  <h3>{{ label }} {{ required ? '*' : '' }}</h3>\n  <h3>{{ or }}</h3>\n  <label for=\"fileDropRef\">{{ button }}</label>\n</div>\n", styles: [".mic-dropzone{width:100%;height:250px;position:relative;margin:0}.mic-dropzone.fileover{border-width:3px}.mic-dropzone input{opacity:0;z-index:2;width:100%;top:0;left:0}.mic-dropzone h3{font-size:20px}.mic-dropzone label{margin-top:1em;border-radius:5px;padding:5px 15px;font-weight:700;cursor:pointer}.mic-dropzone .mat-icon{transform:scale(2)}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: UploadDropZoneComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-upload-dropzone', template: "<div class=\"mic-dropzone flex flex-col items-center\" [ngClass]=\"{ fileover: fileOver === true }\">\n  <input\n    type=\"file\"\n    #fileDropRef\n    id=\"fileDropRef\"\n    [multiple]=\"multiple\"\n    (click)=\"fileInputClick($event)\"\n    (change)=\"fileBrowseHandler($event)\"\n    autocomplete=\"off\"\n  />\n  <mat-icon>upload_file</mat-icon>\n  <h3>{{ label }} {{ required ? '*' : '' }}</h3>\n  <h3>{{ or }}</h3>\n  <label for=\"fileDropRef\">{{ button }}</label>\n</div>\n", styles: [".mic-dropzone{width:100%;height:250px;position:relative;margin:0}.mic-dropzone.fileover{border-width:3px}.mic-dropzone input{opacity:0;z-index:2;width:100%;top:0;left:0}.mic-dropzone h3{font-size:20px}.mic-dropzone label{margin-top:1em;border-radius:5px;padding:5px 15px;font-weight:700;cursor:pointer}.mic-dropzone .mat-icon{transform:scale(2)}\n"] }]
        }], propDecorators: { fileDropRef: [{
                type: ViewChild,
                args: ['fileDropRef']
            }], fileDropped: [{
                type: Output
            }], required: [{
                type: Input
            }], accept: [{
                type: Input
            }], multiple: [{
                type: Input
            }], label: [{
                type: Input
            }], button: [{
                type: Input
            }], or: [{
                type: Input
            }], onDragOver: [{
                type: HostListener,
                args: ['dragover', ['$event']]
            }], onDragLeave: [{
                type: HostListener,
                args: ['dragleave', ['$event']]
            }], onDrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }] } });

const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
class FileSizePipe {
    transform(sizeInBytes) {
        let power = Math.round(Math.log(sizeInBytes) / Math.log(1024));
        power = Math.min(power, units.length - 1);
        const size = sizeInBytes / Math.pow(1024, power); // size in new units
        const formattedSize = Math.round(size * 100) / 100; // keep up to 2 decimals
        const unit = units[power];
        return `${formattedSize} ${unit}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: FileSizePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: FileSizePipe, name: "fileSize" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: FileSizePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fileSize'
                }]
        }] });

/**
 * Component to display an uploaded file
 *
 */
class FileComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: FileComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: FileComponent, selector: "mic-file", inputs: { file: "file", config: "config" }, ngImport: i0, template: "<mat-card appearance=\"outlined\">\n  <mat-card-header>\n    <mat-card-title>\n      <span>{{ file.name }}</span>\n      @if (config.onFileDeleted) {\n      <button mat-icon-button (click)=\"config.onFileDeleted(file)\">\n        <mat-icon>delete</mat-icon>\n      </button>\n      }\n    </mat-card-title>\n    <mat-card-subtitle>\n      <span>{{ file.size | fileSize }}</span>\n      @if (config.progress?.value) {\n      <span>{{ config.progress.value }} %</span>\n      }\n    </mat-card-subtitle>\n  </mat-card-header>\n  @if (config.progress) {\n  <mat-card-footer>\n    <mat-progress-bar [mode]=\"config.progress.mode\" [value]=\"config.progress.value\"></mat-progress-bar>\n  </mat-card-footer>\n  }\n</mat-card>\n", styles: [":host{display:block;margin-top:10px;width:100%}:host .mat-mdc-card{padding:2px}:host .mat-mdc-card-footer{margin:0 -3px -5px}:host .mat-mdc-card-header{width:calc(100% - 32px)}:host .mat-mdc-card-header ::ng-deep .mat-mdc-card-header-text{width:100%}:host .mat-mdc-card-header .mat-mdc-card-subtitle{font-size:12px;display:flex;flex-direction:row;justify-content:space-between;margin-bottom:5px}:host .mat-mdc-card-header .mat-mdc-card-title{font-size:12px;display:flex;flex-direction:row;justify-content:space-between;margin-bottom:-15px}\n"], dependencies: [{ kind: "component", type: i1.MatIconButton, selector: "button[mat-icon-button]", exportAs: ["matButton"] }, { kind: "component", type: i2$1.MatCard, selector: "mat-card", inputs: ["appearance"], exportAs: ["matCard"] }, { kind: "directive", type: i2$1.MatCardFooter, selector: "mat-card-footer" }, { kind: "component", type: i2$1.MatCardHeader, selector: "mat-card-header" }, { kind: "directive", type: i2$1.MatCardSubtitle, selector: "mat-card-subtitle, [mat-card-subtitle], [matCardSubtitle]" }, { kind: "directive", type: i2$1.MatCardTitle, selector: "mat-card-title, [mat-card-title], [matCardTitle]" }, { kind: "component", type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i1$2.MatProgressBar, selector: "mat-progress-bar", inputs: ["color", "value", "bufferValue", "mode"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }, { kind: "pipe", type: FileSizePipe, name: "fileSize" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: FileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-file', template: "<mat-card appearance=\"outlined\">\n  <mat-card-header>\n    <mat-card-title>\n      <span>{{ file.name }}</span>\n      @if (config.onFileDeleted) {\n      <button mat-icon-button (click)=\"config.onFileDeleted(file)\">\n        <mat-icon>delete</mat-icon>\n      </button>\n      }\n    </mat-card-title>\n    <mat-card-subtitle>\n      <span>{{ file.size | fileSize }}</span>\n      @if (config.progress?.value) {\n      <span>{{ config.progress.value }} %</span>\n      }\n    </mat-card-subtitle>\n  </mat-card-header>\n  @if (config.progress) {\n  <mat-card-footer>\n    <mat-progress-bar [mode]=\"config.progress.mode\" [value]=\"config.progress.value\"></mat-progress-bar>\n  </mat-card-footer>\n  }\n</mat-card>\n", styles: [":host{display:block;margin-top:10px;width:100%}:host .mat-mdc-card{padding:2px}:host .mat-mdc-card-footer{margin:0 -3px -5px}:host .mat-mdc-card-header{width:calc(100% - 32px)}:host .mat-mdc-card-header ::ng-deep .mat-mdc-card-header-text{width:100%}:host .mat-mdc-card-header .mat-mdc-card-subtitle{font-size:12px;display:flex;flex-direction:row;justify-content:space-between;margin-bottom:5px}:host .mat-mdc-card-header .mat-mdc-card-title{font-size:12px;display:flex;flex-direction:row;justify-content:space-between;margin-bottom:-15px}\n"] }]
        }], propDecorators: { file: [{
                type: Input
            }], config: [{
                type: Input
            }] } });

const imports$3 = [CommonModule, MaterialModule];
const declarations = [UploadDropZoneComponent, FileComponent, FileSizePipe];
/** <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { UploadModule } from '@michelin/theme';</code>
 */
class UploadModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: UploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: UploadModule, declarations: [UploadDropZoneComponent, FileComponent, FileSizePipe], imports: [CommonModule, MaterialModule], exports: [UploadDropZoneComponent, FileComponent, FileSizePipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: UploadModule, imports: [imports$3] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: UploadModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$3,
                    declarations,
                    exports: [...declarations]
                }]
        }] });

/**
 * Progress bar configuration
 */
class FileProgressConfig {
}
/**
 * Main configuration class for file component
 */
class FileConfig {
}

/**
 * This directive manage the zone with scrolling content
 */
class ScrollingContentDirective extends ScrollBarDirective {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ScrollingContentDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: ScrollingContentDirective, selector: "[micScrollingContent]", usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ScrollingContentDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[micScrollingContent]'
                }]
        }] });

/**
 * This directive manage the zone with sections and links
 */
class ContentsDirective {
    constructor(element) {
        this.element = element;
        this.activeSection = new BehaviorSubject(null);
    }
    ngAfterContentInit() {
        (this.scrollingView ? this.scrollingView.element.nativeElement : window).addEventListener('scroll', this.scroll.bind(this), true);
    }
    ngOnDestroy() {
        (this.scrollingView ? this.scrollingView.element.nativeElement : window).removeEventListener('scroll', this.scroll, true);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.sections = Array.from(this.element.nativeElement.querySelectorAll('h2'));
            this.setCurrentActive(this.sections[0]);
            this.initTop = this.getOffsetTop(this.element.nativeElement);
        }, 0);
    }
    scroll() {
        if (this.sections) {
            let active;
            const mainTop = (this.scrollingView ? this.getOffsetTop(this.scrollingView.element.nativeElement) : this.initTop) + 1;
            this.sections.forEach((section) => {
                if (this.getOffsetTop(section) < mainTop) {
                    active = section;
                }
            });
            this.setCurrentActive(active);
        }
    }
    setCurrentActive(active) {
        if (this.currentActive !== active) {
            this.activeSection.next(active);
            this.currentActive = active;
        }
    }
    getOffsetTop(element) {
        return element.getBoundingClientRect().top;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ContentsDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.4", type: ContentsDirective, selector: "[micContents]", queries: [{ propertyName: "scrollingView", first: true, predicate: ScrollingContentDirective, descendants: true }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ContentsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[micContents]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { scrollingView: [{
                type: ContentChild,
                args: [ScrollingContentDirective]
            }] } });

class CompareNodePipe {
    transform(node1, node2) {
        return node1.isEqualNode(node2);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: CompareNodePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: CompareNodePipe, name: "compareNode" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: CompareNodePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'compareNode' }]
        }] });

/**
 * Component to build the content table
 */
class ContentTableComponent {
    constructor(contents) {
        this.contents = contents;
    }
    ngOnInit() {
        this.contents.activeSection.subscribe((active) => {
            this.activeElement = active;
        });
    }
    clickLink($event, element) {
        $event.preventDefault();
        if (this.contents.scrollingView) {
            const top = element.getBoundingClientRect().top - this.contents.scrollingView.element.nativeElement.getBoundingClientRect().top;
            const osViewport = this.contents.scrollingView.scroll.getElements().viewport;
            const osTop = top + osViewport.scrollTop;
            osViewport.scrollTo({ top: osTop });
        }
        else {
            element.scrollIntoView(true);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ContentTableComponent, deps: [{ token: ContentsDirective, host: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: ContentTableComponent, selector: "mic-content-table", ngImport: i0, template: "<div class=\"content-table\" [ngClass]=\"{ fixed: !contents.scrollingView }\">\n  <ul>\n    @for (item of contents.sections; track item) {\n    <li class=\"flex\">\n      <mic-link\n        href=\"#\"\n        [label]=\"item.getAttribute('data-alt-title') || item.innerText\"\n        icon=\"keyboard_arrow_right\"\n        iconPosition=\"left\"\n        [active]=\"item | compareNode : activeElement\"\n        (click)=\"clickLink($event, item)\"\n      ></mic-link>\n    </li>\n    }\n  </ul>\n  <ng-content></ng-content>\n</div>\n", dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: LinkComponent, selector: "mic-link", inputs: ["id", "href", "target", "label", "ariaLabel", "color", "icon", "iconPosition", "rel", "routerLink", "disabled", "active", "titleNewWindow"] }, { kind: "pipe", type: CompareNodePipe, name: "compareNode" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ContentTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-content-table', template: "<div class=\"content-table\" [ngClass]=\"{ fixed: !contents.scrollingView }\">\n  <ul>\n    @for (item of contents.sections; track item) {\n    <li class=\"flex\">\n      <mic-link\n        href=\"#\"\n        [label]=\"item.getAttribute('data-alt-title') || item.innerText\"\n        icon=\"keyboard_arrow_right\"\n        iconPosition=\"left\"\n        [active]=\"item | compareNode : activeElement\"\n        (click)=\"clickLink($event, item)\"\n      ></mic-link>\n    </li>\n    }\n  </ul>\n  <ng-content></ng-content>\n</div>\n" }]
        }], ctorParameters: () => [{ type: ContentsDirective, decorators: [{
                    type: Host
                }] }] });

const imports$2 = [CommonModule, LinkModule];
const components$2 = [ContentTableComponent];
const directives = [ContentsDirective, ScrollingContentDirective];
const pipes = [CompareNodePipe];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { ContentTableModule } from '@michelin/theme';</code>
 */
class ContentTableModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ContentTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: ContentTableModule, declarations: [ContentTableComponent, ContentsDirective, ScrollingContentDirective, CompareNodePipe], imports: [CommonModule, LinkModule], exports: [ContentTableComponent, ContentsDirective, ScrollingContentDirective, CommonModule, LinkModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ContentTableModule, imports: [imports$2, CommonModule, LinkModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: ContentTableModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$2,
                    declarations: [...components$2, ...directives, ...pipes],
                    exports: [...components$2, ...directives, ...imports$2]
                }]
        }] });

const maxHour = 12;
const timeRegexPattern = '[0-9]{2}';
const maxMinutes = 59;
class TimepickerComponent {
    constructor() {
        this.hour = new FormControl('', [Validators.maxLength(2)]);
        this.minutes = new FormControl('', [Validators.maxLength(2)]);
        this.period = new FormControl('');
        this.onChangeCallback = () => { };
        this.onTouchedCallback = () => { };
    }
    ngOnInit() {
        this.updateValue();
        this.hourSubscription = this.hour.valueChanges.subscribe((hour) => {
            this.validateManualTime(hour, this.hour);
        });
        this.minuteSubscription = this.minutes.valueChanges.subscribe((minutes) => {
            this.validateManualTime(minutes, this.minutes);
        });
    }
    // validate manually enter time
    validateManualTime(time, value) {
        if (time && time.toString().length > 2) {
            value.setValue(time.toString().substring(0, 2));
        }
        else {
            this.onChangeCallback(this.getSelectedTime());
        }
    }
    // validate hour
    validateHour(hour) {
        const regexp = new RegExp(timeRegexPattern);
        if (!regexp.test(hour)) {
            this.hour.patchValue('01');
        }
        this.onChange();
    }
    // validate minutes
    validateMinutes(minutes) {
        const regexp = new RegExp(timeRegexPattern);
        if (!regexp.test(minutes)) {
            this.hour.patchValue('00');
        }
        this.onChange();
    }
    addLeadingZero() {
        if (this.hour.value.toString().length > 0 && this.hour.value.toString().length < 2) {
            this.hour.patchValue(`0${this.hour.value}`);
        }
        if (this.minutes.value.toString().length > 0 && this.minutes.value.toString().length < 2) {
            this.minutes.patchValue(`0${this.minutes.value}`);
        }
    }
    // increment  hour or decrement hour
    chnageHour(flag) {
        if (+this.hour.value < maxHour && flag) {
            this.hour.setValue((+this.hour.value + 1).toString());
            this.addLeadingZero();
            this.validateHour(this.hour.value);
        }
        else if (+this.hour.value > 1 && !flag) {
            this.hour.setValue((+this.hour.value - 1).toString());
            this.addLeadingZero();
            this.validateHour(this.hour.value);
        }
    }
    // increment  minutes or decrement minutes
    changeMinutes(flag) {
        if (+this.minutes.value < maxMinutes && flag) {
            this.minutes.setValue((+this.minutes.value + 1).toString());
            this.addLeadingZero();
            this.validateMinutes(this.minutes.value);
        }
        else if (+this.minutes.value > 0 && !flag) {
            this.minutes.setValue((+this.minutes.value - 1).toString());
            this.addLeadingZero();
            this.validateMinutes(this.minutes.value);
        }
    }
    ngOnDestroy() {
        this.onChangeCallback = () => { };
        this.onTouchedCallback = () => { };
        this.hourSubscription.unsubscribe();
        this.minuteSubscription.unsubscribe();
    }
    //the callback function to register on UI change
    onChange() {
        this.updateValue();
        this.onChangeCallback(this.getSelectedTime());
    }
    //this will write the value to the view if the value changes occur on the model programmatically
    writeValue(value) {
        if (value) {
            const timeParts = value.split(' ');
            const time = timeParts[0].split(':');
            this.hour.setValue(time[0]);
            this.minutes.setValue(time[1]);
            this.period.setValue(timeParts[1]);
            this.updateValue();
        }
    }
    // When the value in the UI is changed, this method will invoke a callback function
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    //When the element is touched, this method will get called
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    //the callback function to register on element touch
    updateValue() {
        this.onTouchedCallback();
    }
    // returns selected time
    getSelectedTime() {
        return `${this.hour.value ? this.hour.value : '00'}:${this.minutes.value ? this.minutes.value : '00'} ${this.period.value}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimepickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: TimepickerComponent, selector: "mic-timepicker", inputs: { label: "label" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => TimepickerComponent),
                multi: true
            }
        ], ngImport: i0, template: "<div class=\"flex timepicker-container\">\n  <div class=\"flex flex-row\">\n    <div class=\"flex flex-col justify-center mt-2 timepicker-max-size\">\n      <mat-form-field subscriptSizing=\"dynamic\" class=\"hours-form\">\n        @if (label) {\n        <mat-label>{{ label }}</mat-label>\n        }\n        <input\n          [formControl]=\"hour\"\n          required\n          type=\"number\"\n          min=\"00\"\n          max=\"12\"\n          maxlength=\"2\"\n          pattern=\"[0-9]{2}\"\n          autocomplete=\"off\"\n          matInput\n          class=\"no-spinner\"\n          autocomplete=\"off\"\n        />\n        <mat-icon (click)=\"chnageHour(true)\" matSuffix>arrow_drop_up</mat-icon>\n        <mat-icon (click)=\"chnageHour(false)\" matSuffix>arrow_drop_down</mat-icon>\n      </mat-form-field>\n    </div>\n  </div>\n  <div class=\"flex flex-row\">\n    <div class=\"flex flex-col justify-center mt-2 timepicker-max-size\">\n      <mat-form-field subscriptSizing=\"dynamic\" class=\"minutes-form\">\n        @if (label) {\n        <mat-label></mat-label>\n        }\n        <input\n          [formControl]=\"minutes\"\n          required\n          maxlength=\"2\"\n          type=\"number\"\n          min=\"00\"\n          max=\"59\"\n          pattern=\"[0-9]{2}\"\n          matInput\n          class=\"no-spinner\"\n          autocomplete=\"off\"\n        />\n        <mat-icon (click)=\"changeMinutes(true)\" matSuffix>arrow_drop_up</mat-icon>\n        <mat-icon (click)=\"changeMinutes(false)\" matSuffix>arrow_drop_down</mat-icon>\n      </mat-form-field>\n    </div>\n  </div>\n  <div class=\"flex flex-row meridian mt-2\">\n    <mat-form-field subscriptSizing=\"dynamic\" class=\"pr-2\">\n      @if (label) {\n      <mat-label></mat-label>\n      }\n      <mat-select [formControl]=\"period\" (selectionChange)=\"onChange()\">\n        <mat-option class=\"timepicker-meridian\" value=\"AM\">AM</mat-option>\n        <mat-option class=\"timepicker-meridian\" value=\"PM\">PM</mat-option>\n      </mat-select>\n    </mat-form-field>\n  </div>\n</div>\n", styles: [".timepicker-max-size{width:60px;min-width:60px}.meridian{width:70px}.hours-form{position:initial;z-index:1}::ng-deep .timepicker-container input[type=number]::-webkit-inner-spin-button{display:none}::ng-deep .timepicker-container .mat-mdc-form-field-subscript-wrapper{display:none}::ng-deep .timepicker-container .mdc-text-field--filled:not(.mdc-text-field--disabled),::ng-deep .timepicker-container .mdc-text-field--filled:hover{padding-right:0;border-radius:0;overflow:visible}::ng-deep .timepicker-container .mat-mdc-form-field-icon-suffix>.mat-icon{padding:0;box-sizing:content-box}::ng-deep .timepicker-container .minutes-form .mdc-floating-label--required:not(.mdc-floating-label--hide-required-marker):after{content:\"\"}::ng-deep .timepicker-container .mat-mdc-form-field-icon-suffix,::ng-deep .timepicker-container .mat-mdc-form-field-icon-prefix{padding:14px 0 0 4px}::ng-deep .timepicker-container .mat-mdc-select-arrow-wrapper{transform:translateY(0)!important}::ng-deep .timepicker-container .mdc-text-field--no-label .mat-mdc-form-field-icon-suffix,::ng-deep .timepicker-container .mdc-text-field--no-label .mat-mdc-form-field-icon-prefix{padding:0 0 0 4px}::ng-deep .timepicker-container .mat-icon{height:20px;width:20px;color:#0000008a}::ng-deep .timepicker-container .mat-mdc-select-trigger{padding-right:4px}::ng-deep .dark-mode .timepicker-container .mat-icon{color:#ffffff8a}::ng-deep .mat-mdc-option.timepicker-meridian .mat-pseudo-checkbox-minimal{display:none}\n"], dependencies: [{ kind: "component", type: i3$2.MatOption, selector: "mat-option", inputs: ["value", "id", "disabled"], outputs: ["onSelectionChange"], exportAs: ["matOption"] }, { kind: "component", type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i3$3.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i4$1.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i4$1.MatLabel, selector: "mat-label" }, { kind: "directive", type: i4$1.MatSuffix, selector: "[matSuffix], [matIconSuffix], [matTextSuffix]", inputs: ["matTextSuffix"] }, { kind: "component", type: i5.MatSelect, selector: "mat-select", inputs: ["aria-describedby", "panelClass", "disabled", "disableRipple", "tabIndex", "hideSingleSelectionIndicator", "placeholder", "required", "multiple", "disableOptionCentering", "compareWith", "value", "aria-label", "aria-labelledby", "errorStateMatcher", "typeaheadDebounceInterval", "sortComparator", "id", "panelWidth"], outputs: ["openedChange", "opened", "closed", "selectionChange", "valueChange"], exportAs: ["matSelect"] }, { kind: "directive", type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3$1.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i3$1.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i3$1.PatternValidator, selector: "[pattern][formControlName],[pattern][formControl],[pattern][ngModel]", inputs: ["pattern"] }, { kind: "directive", type: i3$1.MinValidator, selector: "input[type=number][min][formControlName],input[type=number][min][formControl],input[type=number][min][ngModel]", inputs: ["min"] }, { kind: "directive", type: i3$1.MaxValidator, selector: "input[type=number][max][formControlName],input[type=number][max][formControl],input[type=number][max][ngModel]", inputs: ["max"] }, { kind: "directive", type: i3$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimepickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-timepicker', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => TimepickerComponent),
                            multi: true
                        }
                    ], template: "<div class=\"flex timepicker-container\">\n  <div class=\"flex flex-row\">\n    <div class=\"flex flex-col justify-center mt-2 timepicker-max-size\">\n      <mat-form-field subscriptSizing=\"dynamic\" class=\"hours-form\">\n        @if (label) {\n        <mat-label>{{ label }}</mat-label>\n        }\n        <input\n          [formControl]=\"hour\"\n          required\n          type=\"number\"\n          min=\"00\"\n          max=\"12\"\n          maxlength=\"2\"\n          pattern=\"[0-9]{2}\"\n          autocomplete=\"off\"\n          matInput\n          class=\"no-spinner\"\n          autocomplete=\"off\"\n        />\n        <mat-icon (click)=\"chnageHour(true)\" matSuffix>arrow_drop_up</mat-icon>\n        <mat-icon (click)=\"chnageHour(false)\" matSuffix>arrow_drop_down</mat-icon>\n      </mat-form-field>\n    </div>\n  </div>\n  <div class=\"flex flex-row\">\n    <div class=\"flex flex-col justify-center mt-2 timepicker-max-size\">\n      <mat-form-field subscriptSizing=\"dynamic\" class=\"minutes-form\">\n        @if (label) {\n        <mat-label></mat-label>\n        }\n        <input\n          [formControl]=\"minutes\"\n          required\n          maxlength=\"2\"\n          type=\"number\"\n          min=\"00\"\n          max=\"59\"\n          pattern=\"[0-9]{2}\"\n          matInput\n          class=\"no-spinner\"\n          autocomplete=\"off\"\n        />\n        <mat-icon (click)=\"changeMinutes(true)\" matSuffix>arrow_drop_up</mat-icon>\n        <mat-icon (click)=\"changeMinutes(false)\" matSuffix>arrow_drop_down</mat-icon>\n      </mat-form-field>\n    </div>\n  </div>\n  <div class=\"flex flex-row meridian mt-2\">\n    <mat-form-field subscriptSizing=\"dynamic\" class=\"pr-2\">\n      @if (label) {\n      <mat-label></mat-label>\n      }\n      <mat-select [formControl]=\"period\" (selectionChange)=\"onChange()\">\n        <mat-option class=\"timepicker-meridian\" value=\"AM\">AM</mat-option>\n        <mat-option class=\"timepicker-meridian\" value=\"PM\">PM</mat-option>\n      </mat-select>\n    </mat-form-field>\n  </div>\n</div>\n", styles: [".timepicker-max-size{width:60px;min-width:60px}.meridian{width:70px}.hours-form{position:initial;z-index:1}::ng-deep .timepicker-container input[type=number]::-webkit-inner-spin-button{display:none}::ng-deep .timepicker-container .mat-mdc-form-field-subscript-wrapper{display:none}::ng-deep .timepicker-container .mdc-text-field--filled:not(.mdc-text-field--disabled),::ng-deep .timepicker-container .mdc-text-field--filled:hover{padding-right:0;border-radius:0;overflow:visible}::ng-deep .timepicker-container .mat-mdc-form-field-icon-suffix>.mat-icon{padding:0;box-sizing:content-box}::ng-deep .timepicker-container .minutes-form .mdc-floating-label--required:not(.mdc-floating-label--hide-required-marker):after{content:\"\"}::ng-deep .timepicker-container .mat-mdc-form-field-icon-suffix,::ng-deep .timepicker-container .mat-mdc-form-field-icon-prefix{padding:14px 0 0 4px}::ng-deep .timepicker-container .mat-mdc-select-arrow-wrapper{transform:translateY(0)!important}::ng-deep .timepicker-container .mdc-text-field--no-label .mat-mdc-form-field-icon-suffix,::ng-deep .timepicker-container .mdc-text-field--no-label .mat-mdc-form-field-icon-prefix{padding:0 0 0 4px}::ng-deep .timepicker-container .mat-icon{height:20px;width:20px;color:#0000008a}::ng-deep .timepicker-container .mat-mdc-select-trigger{padding-right:4px}::ng-deep .dark-mode .timepicker-container .mat-icon{color:#ffffff8a}::ng-deep .mat-mdc-option.timepicker-meridian .mat-pseudo-checkbox-minimal{display:none}\n"] }]
        }], ctorParameters: () => [], propDecorators: { label: [{
                type: Input
            }] } });

const imports$1 = [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule];
const components$1 = [TimepickerComponent];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { TimepickerModule } from '@michelin/theme';</code>
 */
class TimepickerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimepickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: TimepickerModule, declarations: [TimepickerComponent], imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule], exports: [TimepickerComponent, CommonModule, MaterialModule, FormsModule, ReactiveFormsModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimepickerModule, imports: [imports$1, CommonModule, MaterialModule, FormsModule, ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: TimepickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: imports$1,
                    declarations: [...components$1],
                    exports: [...components$1, ...imports$1]
                }]
        }] });

/**
 * List of all country iso
 */
var CountryISO;
(function (CountryISO) {
    CountryISO["Afghanistan"] = "af";
    CountryISO["Albania"] = "al";
    CountryISO["Algeria"] = "dz";
    CountryISO["AmericanSamoa"] = "as";
    CountryISO["Andorra"] = "ad";
    CountryISO["Angola"] = "ao";
    CountryISO["Anguilla"] = "ai";
    CountryISO["AntiguaAndBarbuda"] = "ag";
    CountryISO["Argentina"] = "ar";
    CountryISO["Armenia"] = "am";
    CountryISO["Aruba"] = "aw";
    CountryISO["Australia"] = "au";
    CountryISO["Austria"] = "at";
    CountryISO["Azerbaijan"] = "az";
    CountryISO["Bahamas"] = "bs";
    CountryISO["Bahrain"] = "bh";
    CountryISO["Bangladesh"] = "bd";
    CountryISO["Barbados"] = "bb";
    CountryISO["Belarus"] = "by";
    CountryISO["Belgium"] = "be";
    CountryISO["Belize"] = "bz";
    CountryISO["Benin"] = "bj";
    CountryISO["Bermuda"] = "bm";
    CountryISO["Bhutan"] = "bt";
    CountryISO["Bolivia"] = "bo";
    CountryISO["BosniaAndHerzegovina"] = "ba";
    CountryISO["Botswana"] = "bw";
    CountryISO["Brazil"] = "br";
    CountryISO["BritishIndianOceanTerritory"] = "io";
    CountryISO["BritishVirginIslands"] = "vg";
    CountryISO["Brunei"] = "bn";
    CountryISO["Bulgaria"] = "bg";
    CountryISO["BurkinaFaso"] = "bf";
    CountryISO["Burundi"] = "bi";
    CountryISO["Cambodia"] = "kh";
    CountryISO["Cameroon"] = "cm";
    CountryISO["Canada"] = "ca";
    CountryISO["CapeVerde"] = "cv";
    CountryISO["CaribbeanNetherlands"] = "bq";
    CountryISO["CaymanIslands"] = "ky";
    CountryISO["CentralAfricanRepublic"] = "cf";
    CountryISO["Chad"] = "td";
    CountryISO["Chile"] = "cl";
    CountryISO["China"] = "cn";
    CountryISO["ChristmasIsland"] = "cx";
    CountryISO["Cocos"] = "cc";
    CountryISO["Colombia"] = "co";
    CountryISO["Comoros"] = "km";
    CountryISO["CongoDRCJamhuriYaKidemokrasiaYaKongo"] = "cd";
    CountryISO["CongoRepublicCongoBrazzaville"] = "cg";
    CountryISO["CookIslands"] = "ck";
    CountryISO["CostaRica"] = "cr";
    CountryISO["C\u00F4teDIvoire"] = "ci";
    CountryISO["Croatia"] = "hr";
    CountryISO["Cuba"] = "cu";
    CountryISO["Cura\u00E7ao"] = "cw";
    CountryISO["Cyprus"] = "cy";
    CountryISO["CzechRepublic"] = "cz";
    CountryISO["Denmark"] = "dk";
    CountryISO["Djibouti"] = "dj";
    CountryISO["Dominica"] = "dm";
    CountryISO["DominicanRepublic"] = "do";
    CountryISO["Ecuador"] = "ec";
    CountryISO["Egypt"] = "eg";
    CountryISO["ElSalvador"] = "sv";
    CountryISO["EquatorialGuinea"] = "gq";
    CountryISO["Eritrea"] = "er";
    CountryISO["Estonia"] = "ee";
    CountryISO["Ethiopia"] = "et";
    CountryISO["FalklandIslands"] = "fk";
    CountryISO["FaroeIslands"] = "fo";
    CountryISO["Fiji"] = "fj";
    CountryISO["Finland"] = "fi";
    CountryISO["France"] = "fr";
    CountryISO["FrenchGuiana"] = "gf";
    CountryISO["FrenchPolynesia"] = "pf";
    CountryISO["Gabon"] = "ga";
    CountryISO["Gambia"] = "gm";
    CountryISO["Georgia"] = "ge";
    CountryISO["Germany"] = "de";
    CountryISO["Ghana"] = "gh";
    CountryISO["Gibraltar"] = "gi";
    CountryISO["Greece"] = "gr";
    CountryISO["Greenland"] = "gl";
    CountryISO["Grenada"] = "gd";
    CountryISO["Guadeloupe"] = "gp";
    CountryISO["Guam"] = "gu";
    CountryISO["Guatemala"] = "gt";
    CountryISO["Guernsey"] = "gg";
    CountryISO["Guinea"] = "gn";
    CountryISO["GuineaBissau"] = "gw";
    CountryISO["Guyana"] = "gy";
    CountryISO["Haiti"] = "ht";
    CountryISO["Honduras"] = "hn";
    CountryISO["HongKong"] = "hk";
    CountryISO["Hungary"] = "hu";
    CountryISO["Iceland"] = "is";
    CountryISO["India"] = "in";
    CountryISO["Indonesia"] = "id";
    CountryISO["Iran"] = "ir";
    CountryISO["Iraq"] = "iq";
    CountryISO["Ireland"] = "ie";
    CountryISO["IsleOfMan"] = "im";
    CountryISO["Israel"] = "il";
    CountryISO["Italy"] = "it";
    CountryISO["Jamaica"] = "jm";
    CountryISO["Japan"] = "jp";
    CountryISO["Jersey"] = "je";
    CountryISO["Jordan"] = "jo";
    CountryISO["Kazakhstan"] = "kz";
    CountryISO["Kenya"] = "ke";
    CountryISO["Kiribati"] = "ki";
    CountryISO["Kosovo"] = "xk";
    CountryISO["Kuwait"] = "kw";
    CountryISO["Kyrgyzstan"] = "kg";
    CountryISO["Laos"] = "la";
    CountryISO["Latvia"] = "lv";
    CountryISO["Lebanon"] = "lb";
    CountryISO["Lesotho"] = "ls";
    CountryISO["Liberia"] = "lr";
    CountryISO["Libya"] = "ly";
    CountryISO["Liechtenstein"] = "li";
    CountryISO["Lithuania"] = "lt";
    CountryISO["Luxembourg"] = "lu";
    CountryISO["Macau"] = "mo";
    CountryISO["Macedonia"] = "mk";
    CountryISO["Madagascar"] = "mg";
    CountryISO["Malawi"] = "mw";
    CountryISO["Malaysia"] = "my";
    CountryISO["Maldives"] = "mv";
    CountryISO["Mali"] = "ml";
    CountryISO["Malta"] = "mt";
    CountryISO["MarshallIslands"] = "mh";
    CountryISO["Martinique"] = "mq";
    CountryISO["Mauritania"] = "mr";
    CountryISO["Mauritius"] = "mu";
    CountryISO["Mayotte"] = "yt";
    CountryISO["Mexico"] = "mx";
    CountryISO["Micronesia"] = "fm";
    CountryISO["Moldova"] = "md";
    CountryISO["Monaco"] = "mc";
    CountryISO["Mongolia"] = "mn";
    CountryISO["Montenegro"] = "me";
    CountryISO["Montserrat"] = "ms";
    CountryISO["Morocco"] = "ma";
    CountryISO["Mozambique"] = "mz";
    CountryISO["Myanmar"] = "mm";
    CountryISO["Namibia"] = "na";
    CountryISO["Nauru"] = "nr";
    CountryISO["Nepal"] = "np";
    CountryISO["Netherlands"] = "nl";
    CountryISO["NewCaledonia"] = "nc";
    CountryISO["NewZealand"] = "nz";
    CountryISO["Nicaragua"] = "ni";
    CountryISO["Niger"] = "ne";
    CountryISO["Nigeria"] = "ng";
    CountryISO["Niue"] = "nu";
    CountryISO["NorfolkIsland"] = "nf";
    CountryISO["NorthKorea"] = "kp";
    CountryISO["NorthernMarianaIslands"] = "mp";
    CountryISO["Norway"] = "no";
    CountryISO["Oman"] = "om";
    CountryISO["Pakistan"] = "pk";
    CountryISO["Palau"] = "pw";
    CountryISO["Palestine"] = "ps";
    CountryISO["Panama"] = "pa";
    CountryISO["PapuaNewGuinea"] = "pg";
    CountryISO["Paraguay"] = "py";
    CountryISO["Peru"] = "pe";
    CountryISO["Philippines"] = "ph";
    CountryISO["Poland"] = "pl";
    CountryISO["Portugal"] = "pt";
    CountryISO["PuertoRico"] = "pr";
    CountryISO["Qatar"] = "qa";
    CountryISO["R\u00E9union"] = "re";
    CountryISO["Romania"] = "ro";
    CountryISO["Russia"] = "ru";
    CountryISO["Rwanda"] = "rw";
    CountryISO["SaintBarth\u00E9lemy"] = "bl";
    CountryISO["SaintHelena"] = "sh";
    CountryISO["SaintKittsAndNevis"] = "kn";
    CountryISO["SaintLucia"] = "lc";
    CountryISO["SaintMartin"] = "mf";
    CountryISO["SaintPierreAndMiquelon"] = "pm";
    CountryISO["SaintVincentAndTheGrenadines"] = "vc";
    CountryISO["Samoa"] = "ws";
    CountryISO["SanMarino"] = "sm";
    CountryISO["S\u00E3oTom\u00E9AndPr\u00EDncipe"] = "st";
    CountryISO["SaudiArabia"] = "sa";
    CountryISO["Senegal"] = "sn";
    CountryISO["Serbia"] = "rs";
    CountryISO["Seychelles"] = "sc";
    CountryISO["SierraLeone"] = "sl";
    CountryISO["Singapore"] = "sg";
    CountryISO["SintMaarten"] = "sx";
    CountryISO["Slovakia"] = "sk";
    CountryISO["Slovenia"] = "si";
    CountryISO["SolomonIslands"] = "sb";
    CountryISO["Somalia"] = "so";
    CountryISO["SouthAfrica"] = "za";
    CountryISO["SouthKorea"] = "kr";
    CountryISO["SouthSudan"] = "ss";
    CountryISO["Spain"] = "es";
    CountryISO["SriLanka"] = "lk";
    CountryISO["Sudan"] = "sd";
    CountryISO["Suriname"] = "sr";
    CountryISO["SvalbardAndJanMayen"] = "sj";
    CountryISO["Swaziland"] = "sz";
    CountryISO["Sweden"] = "se";
    CountryISO["Switzerland"] = "ch";
    CountryISO["Syria"] = "sy";
    CountryISO["Taiwan"] = "tw";
    CountryISO["Tajikistan"] = "tj";
    CountryISO["Tanzania"] = "tz";
    CountryISO["Thailand"] = "th";
    CountryISO["TimorLeste"] = "tl";
    CountryISO["Togo"] = "tg";
    CountryISO["Tokelau"] = "tk";
    CountryISO["Tonga"] = "to";
    CountryISO["TrinidadAndTobago"] = "tt";
    CountryISO["Tunisia"] = "tn";
    CountryISO["Turkey"] = "tr";
    CountryISO["Turkmenistan"] = "tm";
    CountryISO["TurksAndCaicosIslands"] = "tc";
    CountryISO["Tuvalu"] = "tv";
    CountryISO["USVirginIslands"] = "vi";
    CountryISO["Uganda"] = "ug";
    CountryISO["Ukraine"] = "ua";
    CountryISO["UnitedArabEmirates"] = "ae";
    CountryISO["UnitedKingdom"] = "gb";
    CountryISO["UnitedStates"] = "us";
    CountryISO["Uruguay"] = "uy";
    CountryISO["Uzbekistan"] = "uz";
    CountryISO["Vanuatu"] = "vu";
    CountryISO["VaticanCity"] = "va";
    CountryISO["Venezuela"] = "ve";
    CountryISO["Vietnam"] = "vn";
    CountryISO["WallisAndFutuna"] = "wf";
    CountryISO["WesternSahara"] = "eh";
    CountryISO["Yemen"] = "ye";
    CountryISO["Zambia"] = "zm";
    CountryISO["Zimbabwe"] = "zw";
    CountryISO["\u00C5landIslands"] = "ax";
})(CountryISO || (CountryISO = {}));
class CountryData {
}
const allCountries = [
    {
        name: 'Afghanistan (‫افغانستان‬‎)',
        iso: CountryISO.Afghanistan,
        indicator: '93'
    },
    {
        name: 'Albania (Shqipëri)',
        iso: CountryISO.Albania,
        indicator: '355'
    },
    {
        name: 'Algeria (‫الجزائر‬‎)',
        iso: CountryISO.Algeria,
        indicator: '213'
    },
    {
        name: 'American Samoa',
        iso: 'as',
        indicator: '1'
    },
    {
        name: 'Andorra',
        iso: CountryISO.Andorra,
        indicator: '376'
    },
    {
        name: 'Angola',
        iso: CountryISO.Angola,
        indicator: '244'
    },
    {
        name: 'Anguilla',
        iso: 'ai',
        indicator: '1'
    },
    {
        name: 'Antigua and Barbuda',
        iso: 'ag',
        indicator: '1'
    },
    {
        name: 'Argentina',
        iso: CountryISO.Argentina,
        indicator: '54'
    },
    {
        name: 'Armenia (Հայաստան)',
        iso: CountryISO.Armenia,
        indicator: '374'
    },
    {
        name: 'Aruba',
        iso: CountryISO.Aruba,
        indicator: '297'
    },
    {
        name: 'Australia',
        iso: CountryISO.Australia,
        indicator: '61'
    },
    {
        name: 'Austria (Österreich)',
        iso: CountryISO.Austria,
        indicator: '43'
    },
    {
        name: 'Azerbaijan (Azərbaycan)',
        iso: CountryISO.Azerbaijan,
        indicator: '994'
    },
    {
        name: 'Bahamas',
        iso: 'bs',
        indicator: '1'
    },
    {
        name: 'Bahrain (‫البحرين‬‎)',
        iso: CountryISO.Bahrain,
        indicator: '973'
    },
    {
        name: 'Bangladesh (বাংলাদেশ)',
        iso: CountryISO.Bangladesh,
        indicator: '880'
    },
    {
        name: 'Barbados',
        iso: 'bb',
        indicator: '1'
    },
    {
        name: 'Belarus (Беларусь)',
        iso: CountryISO.Belarus,
        indicator: '375'
    },
    {
        name: 'Belgium (België)',
        iso: CountryISO.Belgium,
        indicator: '32'
    },
    {
        name: 'Belize',
        iso: CountryISO.Belize,
        indicator: '501'
    },
    {
        name: 'Benin (Bénin)',
        iso: CountryISO.Benin,
        indicator: '229'
    },
    {
        name: 'Bermuda',
        iso: 'bm',
        indicator: '1'
    },
    {
        name: 'Bhutan (འབྲུག)',
        iso: CountryISO.Bhutan,
        indicator: '975'
    },
    {
        name: 'Bolivia',
        iso: CountryISO.Bolivia,
        indicator: '591'
    },
    {
        name: 'Bosnia and Herzegovina (Босна и Херцеговина)',
        iso: CountryISO.BosniaAndHerzegovina,
        indicator: '387'
    },
    {
        name: 'Botswana',
        iso: CountryISO.Botswana,
        indicator: '267'
    },
    {
        name: 'Brazil (Brasil)',
        iso: CountryISO.Brazil,
        indicator: '55'
    },
    {
        name: 'British Indian Ocean Territory',
        iso: CountryISO.BritishIndianOceanTerritory,
        indicator: '246'
    },
    {
        name: 'British Virgin Islands',
        iso: 'vg',
        indicator: '1'
    },
    {
        name: 'Brunei',
        iso: CountryISO.Brunei,
        indicator: '673'
    },
    {
        name: 'Bulgaria (България)',
        iso: CountryISO.Bulgaria,
        indicator: '359'
    },
    {
        name: 'Burkina Faso',
        iso: CountryISO.BurkinaFaso,
        indicator: '226'
    },
    {
        name: 'Burundi (Uburundi)',
        iso: CountryISO.Burundi,
        indicator: '257'
    },
    {
        name: 'Cambodia (កម្ពុជា)',
        iso: CountryISO.Cambodia,
        indicator: '855'
    },
    {
        name: 'Cameroon (Cameroun)',
        iso: CountryISO.Cameroon,
        indicator: '237'
    },
    {
        name: 'Canada',
        iso: CountryISO.Canada,
        indicator: '1'
    },
    {
        name: 'Cape Verde (Kabu Verdi)',
        iso: CountryISO.CapeVerde,
        indicator: '238'
    },
    {
        name: 'Caribbean Netherlands',
        iso: CountryISO.CaribbeanNetherlands,
        indicator: '599'
    },
    {
        name: 'Cayman Islands',
        iso: 'ky',
        indicator: '1'
    },
    {
        name: 'Central African Republic (République centrafricaine)',
        iso: CountryISO.CentralAfricanRepublic,
        indicator: '236'
    },
    {
        name: 'Chad (Tchad)',
        iso: CountryISO.Chad,
        indicator: '235'
    },
    {
        name: 'Chile',
        iso: CountryISO.Chile,
        indicator: '56'
    },
    {
        name: 'China (中国)',
        iso: CountryISO.China,
        indicator: '86'
    },
    {
        name: 'Christmas Island',
        iso: CountryISO.ChristmasIsland,
        indicator: '61'
    },
    {
        name: 'Cocos (Keeling) Islands',
        iso: CountryISO.Cocos,
        indicator: '61'
    },
    {
        name: 'Colombia',
        iso: CountryISO.Colombia,
        indicator: '57'
    },
    {
        name: 'Comoros (‫جزر القمر‬‎)',
        iso: CountryISO.Comoros,
        indicator: '269'
    },
    {
        name: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
        iso: CountryISO.CongoDRCJamhuriYaKidemokrasiaYaKongo,
        indicator: '243'
    },
    {
        name: 'Congo (Republic) (Congo-Brazzaville)',
        iso: CountryISO.CongoRepublicCongoBrazzaville,
        indicator: '242'
    },
    {
        name: 'Cook Islands',
        iso: CountryISO.CookIslands,
        indicator: '682'
    },
    {
        name: 'Costa Rica',
        iso: CountryISO.CostaRica,
        indicator: '506'
    },
    {
        name: 'Côte d’Ivoire',
        iso: CountryISO.CôteDIvoire,
        indicator: '225'
    },
    {
        name: 'Croatia (Hrvatska)',
        iso: CountryISO.Croatia,
        indicator: '385'
    },
    {
        name: 'Cuba',
        iso: CountryISO.Cuba,
        indicator: '53'
    },
    {
        name: 'Curaçao',
        iso: CountryISO.Curaçao,
        indicator: '599'
    },
    {
        name: 'Cyprus (Κύπρος)',
        iso: CountryISO.Cyprus,
        indicator: '357'
    },
    {
        name: 'Czech Republic (Česká republika)',
        iso: CountryISO.CzechRepublic,
        indicator: '420'
    },
    {
        name: 'Denmark (Danmark)',
        iso: CountryISO.Denmark,
        indicator: '45'
    },
    {
        name: 'Djibouti',
        iso: CountryISO.Djibouti,
        indicator: '253'
    },
    {
        name: 'Dominica',
        iso: CountryISO.Dominica,
        indicator: '1767'
    },
    {
        name: 'Dominican Republic (República Dominicana)',
        iso: CountryISO.DominicanRepublic,
        indicator: '1'
    },
    {
        name: 'Ecuador',
        iso: CountryISO.Ecuador,
        indicator: '593'
    },
    {
        name: 'Egypt (‫مصر‬‎)',
        iso: CountryISO.Egypt,
        indicator: '20'
    },
    {
        name: 'El Salvador',
        iso: CountryISO.ElSalvador,
        indicator: '503'
    },
    {
        name: 'Equatorial Guinea (Guinea Ecuatorial)',
        iso: CountryISO.EquatorialGuinea,
        indicator: '240'
    },
    {
        name: 'Eritrea',
        iso: CountryISO.Eritrea,
        indicator: '291'
    },
    {
        name: 'Estonia (Eesti)',
        iso: CountryISO.Estonia,
        indicator: '372'
    },
    {
        name: 'Ethiopia',
        iso: CountryISO.Ethiopia,
        indicator: '251'
    },
    {
        name: 'Falkland Islands (Islas Malvinas)',
        iso: CountryISO.FalklandIslands,
        indicator: '500'
    },
    {
        name: 'Faroe Islands (Føroyar)',
        iso: CountryISO.FaroeIslands,
        indicator: '298'
    },
    {
        name: 'Fiji',
        iso: CountryISO.Fiji,
        indicator: '679'
    },
    {
        name: 'Finland (Suomi)',
        iso: CountryISO.Finland,
        indicator: '358'
    },
    {
        name: 'France',
        iso: CountryISO.France,
        indicator: '33'
    },
    {
        name: 'French Guiana (Guyane française)',
        iso: CountryISO.FrenchGuiana,
        indicator: '594'
    },
    {
        name: 'French Polynesia (Polynésie française)',
        iso: CountryISO.FrenchPolynesia,
        indicator: '689'
    },
    {
        name: 'Gabon',
        iso: CountryISO.Gabon,
        indicator: '241'
    },
    {
        name: 'Gambia',
        iso: CountryISO.Gambia,
        indicator: '220'
    },
    {
        name: 'Georgia (საქართველო)',
        iso: CountryISO.Georgia,
        indicator: '995'
    },
    {
        name: 'Germany (Deutschland)',
        iso: CountryISO.Germany,
        indicator: '49'
    },
    {
        name: 'Ghana (Gaana)',
        iso: CountryISO.Ghana,
        indicator: '233'
    },
    {
        name: 'Gibraltar',
        iso: CountryISO.Gibraltar,
        indicator: '350'
    },
    {
        name: 'Greece (Ελλάδα)',
        iso: CountryISO.Greece,
        indicator: '30'
    },
    {
        name: 'Greenland (Kalaallit Nunaat)',
        iso: CountryISO.Greenland,
        indicator: '299'
    },
    {
        name: 'Grenada',
        iso: CountryISO.Grenada,
        indicator: '1473'
    },
    {
        name: 'Guadeloupe',
        iso: CountryISO.Guadeloupe,
        indicator: '590'
    },
    {
        name: 'Guam',
        iso: 'gu',
        indicator: '1'
    },
    {
        name: 'Guatemala',
        iso: CountryISO.Guatemala,
        indicator: '502'
    },
    {
        name: 'Guernsey',
        iso: CountryISO.Guernsey,
        indicator: '44'
    },
    {
        name: 'Guinea (Guinée)',
        iso: CountryISO.Guinea,
        indicator: '224'
    },
    {
        name: 'Guinea-Bissau (Guiné Bissau)',
        iso: CountryISO.GuineaBissau,
        indicator: '245'
    },
    {
        name: 'Guyana',
        iso: CountryISO.Guyana,
        indicator: '592'
    },
    {
        name: 'Haiti',
        iso: CountryISO.Haiti,
        indicator: '509'
    },
    {
        name: 'Honduras',
        iso: CountryISO.Honduras,
        indicator: '504'
    },
    {
        name: 'Hong Kong (香港)',
        iso: CountryISO.HongKong,
        indicator: '852'
    },
    {
        name: 'Hungary (Magyarország)',
        iso: CountryISO.Hungary,
        indicator: '36'
    },
    {
        name: 'Iceland (Ísland)',
        iso: CountryISO.Iceland,
        indicator: '354'
    },
    {
        name: 'India (भारत)',
        iso: CountryISO.India,
        indicator: '91'
    },
    {
        name: 'Indonesia',
        iso: CountryISO.Indonesia,
        indicator: '62'
    },
    {
        name: 'Iran (‫ایران‬‎)',
        iso: CountryISO.Iran,
        indicator: '98'
    },
    {
        name: 'Iraq (‫العراق‬‎)',
        iso: CountryISO.Iraq,
        indicator: '964'
    },
    {
        name: 'Ireland',
        iso: CountryISO.Ireland,
        indicator: '353'
    },
    {
        name: 'Isle of Man',
        iso: CountryISO.IsleOfMan,
        indicator: '44'
    },
    {
        name: 'Israel (‫ישראל‬‎)',
        iso: CountryISO.Israel,
        indicator: '972'
    },
    {
        name: 'Italy (Italia)',
        iso: CountryISO.Italy,
        indicator: '39'
    },
    {
        name: 'Jamaica',
        iso: 'jm',
        indicator: '1'
    },
    {
        name: 'Japan (日本)',
        iso: CountryISO.Japan,
        indicator: '81'
    },
    {
        name: 'Jersey',
        iso: CountryISO.Jersey,
        indicator: '44'
    },
    {
        name: 'Jordan (‫الأردن‬‎)',
        iso: CountryISO.Jordan,
        indicator: '962'
    },
    {
        name: 'Kazakhstan (Казахстан)',
        iso: CountryISO.Kazakhstan,
        indicator: '7'
    },
    {
        name: 'Kenya',
        iso: CountryISO.Kenya,
        indicator: '254'
    },
    {
        name: 'Kiribati',
        iso: CountryISO.Kiribati,
        indicator: '686'
    },
    {
        name: 'Kosovo',
        iso: CountryISO.Kosovo,
        indicator: '383'
    },
    {
        name: 'Kuwait (‫الكويت‬‎)',
        iso: CountryISO.Kuwait,
        indicator: '965'
    },
    {
        name: 'Kyrgyzstan (Кыргызстан)',
        iso: CountryISO.Kyrgyzstan,
        indicator: '996'
    },
    {
        name: 'Laos (ລາວ)',
        iso: CountryISO.Laos,
        indicator: '856'
    },
    {
        name: 'Latvia (Latvija)',
        iso: CountryISO.Latvia,
        indicator: '371'
    },
    {
        name: 'Lebanon (‫لبنان‬‎)',
        iso: CountryISO.Lebanon,
        indicator: '961'
    },
    {
        name: 'Lesotho',
        iso: CountryISO.Lesotho,
        indicator: '266'
    },
    {
        name: 'Liberia',
        iso: CountryISO.Liberia,
        indicator: '231'
    },
    {
        name: 'Libya (‫ليبيا‬‎)',
        iso: CountryISO.Libya,
        indicator: '218'
    },
    {
        name: 'Liechtenstein',
        iso: CountryISO.Liechtenstein,
        indicator: '423'
    },
    {
        name: 'Lithuania (Lietuva)',
        iso: CountryISO.Lithuania,
        indicator: '370'
    },
    {
        name: 'Luxembourg',
        iso: CountryISO.Luxembourg,
        indicator: '352'
    },
    {
        name: 'Macau (澳門)',
        iso: CountryISO.Macau,
        indicator: '853'
    },
    {
        name: 'Macedonia (FYROM) (Македонија)',
        iso: CountryISO.Macedonia,
        indicator: '389'
    },
    {
        name: 'Madagascar (Madagasikara)',
        iso: CountryISO.Madagascar,
        indicator: '261'
    },
    {
        name: 'Malawi',
        iso: CountryISO.Malawi,
        indicator: '265'
    },
    {
        name: 'Malaysia',
        iso: CountryISO.Malaysia,
        indicator: '60'
    },
    {
        name: 'Maldives',
        iso: CountryISO.Maldives,
        indicator: '960'
    },
    {
        name: 'Mali',
        iso: CountryISO.Mali,
        indicator: '223'
    },
    {
        name: 'Malta',
        iso: CountryISO.Malta,
        indicator: '356'
    },
    {
        name: 'Marshall Islands',
        iso: CountryISO.MarshallIslands,
        indicator: '692'
    },
    {
        name: 'Martinique',
        iso: CountryISO.Martinique,
        indicator: '596'
    },
    {
        name: 'Mauritania (‫موريتانيا‬‎)',
        iso: CountryISO.Mauritania,
        indicator: '222'
    },
    {
        name: 'Mauritius (Moris)',
        iso: CountryISO.Mauritius,
        indicator: '230'
    },
    {
        name: 'Mayotte',
        iso: CountryISO.Mayotte,
        indicator: '262'
    },
    {
        name: 'Mexico (México)',
        iso: CountryISO.Mexico,
        indicator: '52'
    },
    {
        name: 'Micronesia',
        iso: CountryISO.Micronesia,
        indicator: '691'
    },
    {
        name: 'Moldova (Republica Moldova)',
        iso: CountryISO.Moldova,
        indicator: '373'
    },
    {
        name: 'Monaco',
        iso: CountryISO.Monaco,
        indicator: '377'
    },
    {
        name: 'Mongolia (Монгол)',
        iso: CountryISO.Mongolia,
        indicator: '976'
    },
    {
        name: 'Montenegro (Crna Gora)',
        iso: CountryISO.Montenegro,
        indicator: '382'
    },
    {
        name: 'Montserrat',
        iso: 'ms',
        indicator: '1'
    },
    {
        name: 'Morocco (‫المغرب‬‎)',
        iso: CountryISO.Morocco,
        indicator: '212'
    },
    {
        name: 'Mozambique (Moçambique)',
        iso: CountryISO.Mozambique,
        indicator: '258'
    },
    {
        name: 'Myanmar (Burma) (မြန်မာ)',
        iso: CountryISO.Myanmar,
        indicator: '95'
    },
    {
        name: 'Namibia (Namibië)',
        iso: CountryISO.Namibia,
        indicator: '264'
    },
    {
        name: 'Nauru',
        iso: CountryISO.Nauru,
        indicator: '674'
    },
    {
        name: 'Nepal (नेपाल)',
        iso: CountryISO.Nepal,
        indicator: '977'
    },
    {
        name: 'Netherlands (Nederland)',
        iso: CountryISO.Netherlands,
        indicator: '31'
    },
    {
        name: 'New Caledonia (Nouvelle-Calédonie)',
        iso: CountryISO.NewCaledonia,
        indicator: '687'
    },
    {
        name: 'New Zealand',
        iso: CountryISO.NewZealand,
        indicator: '64'
    },
    {
        name: 'Nicaragua',
        iso: CountryISO.Nicaragua,
        indicator: '505'
    },
    {
        name: 'Niger (Nijar)',
        iso: CountryISO.Niger,
        indicator: '227'
    },
    {
        name: 'Nigeria',
        iso: CountryISO.Nigeria,
        indicator: '234'
    },
    {
        name: 'Niue',
        iso: CountryISO.Niue,
        indicator: '683'
    },
    {
        name: 'Norfolk Island',
        iso: CountryISO.NorfolkIsland,
        indicator: '672'
    },
    {
        name: 'North Korea (조선 민주주의 인민 공화국)',
        iso: CountryISO.NorthKorea,
        indicator: '850'
    },
    {
        name: 'Northern Mariana Islands',
        iso: CountryISO.NorthernMarianaIslands,
        indicator: '1670'
    },
    {
        name: 'Norway (Norge)',
        iso: CountryISO.Norway,
        indicator: '47'
    },
    {
        name: 'Oman (‫عُمان‬‎)',
        iso: CountryISO.Oman,
        indicator: '968'
    },
    {
        name: 'Pakistan (‫پاکستان‬‎)',
        iso: CountryISO.Pakistan,
        indicator: '92'
    },
    {
        name: 'Palau',
        iso: CountryISO.Palau,
        indicator: '680'
    },
    {
        name: 'Palestine (‫فلسطين‬‎)',
        iso: CountryISO.Palestine,
        indicator: '970'
    },
    {
        name: 'Panama (Panamá)',
        iso: CountryISO.Panama,
        indicator: '507'
    },
    {
        name: 'Papua New Guinea',
        iso: CountryISO.PapuaNewGuinea,
        indicator: '675'
    },
    {
        name: 'Paraguay',
        iso: CountryISO.Paraguay,
        indicator: '595'
    },
    {
        name: 'Peru (Perú)',
        iso: CountryISO.Peru,
        indicator: '51'
    },
    {
        name: 'Philippines',
        iso: CountryISO.Philippines,
        indicator: '63'
    },
    {
        name: 'Poland (Polska)',
        iso: CountryISO.Poland,
        indicator: '48'
    },
    {
        name: 'Portugal',
        iso: CountryISO.Portugal,
        indicator: '351'
    },
    {
        name: 'Puerto Rico',
        iso: CountryISO.PuertoRico,
        indicator: '1'
    },
    {
        name: 'Qatar (‫قطر‬‎)',
        iso: CountryISO.Qatar,
        indicator: '974'
    },
    {
        name: 'Réunion (La Réunion)',
        iso: CountryISO.Réunion,
        indicator: '262'
    },
    {
        name: 'Romania (România)',
        iso: CountryISO.Romania,
        indicator: '40'
    },
    {
        name: 'Russia (Россия)',
        iso: CountryISO.Russia,
        indicator: '7'
    },
    {
        name: 'Rwanda',
        iso: CountryISO.Rwanda,
        indicator: '250'
    },
    {
        name: 'Saint Barthélemy (Saint-Barthélemy)',
        iso: CountryISO.SaintBarthélemy,
        indicator: '590'
    },
    {
        name: 'Saint Helena',
        iso: CountryISO.SaintHelena,
        indicator: '290'
    },
    {
        name: 'Saint Kitts and Nevis',
        iso: CountryISO.SaintKittsAndNevis,
        indicator: '1869'
    },
    {
        name: 'Saint Lucia',
        iso: 'lc',
        indicator: '1'
    },
    {
        name: 'Saint Martin (Saint-Martin (partie française))',
        iso: CountryISO.SaintMartin,
        indicator: '590'
    },
    {
        name: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
        iso: CountryISO.SaintPierreAndMiquelon,
        indicator: '508'
    },
    {
        name: 'Saint Vincent and the Grenadines',
        iso: 'vc',
        indicator: '1'
    },
    {
        name: 'Samoa',
        iso: CountryISO.Samoa,
        indicator: '685'
    },
    {
        name: 'San Marino',
        iso: CountryISO.SanMarino,
        indicator: '378'
    },
    {
        name: 'São Tomé and Príncipe (São Tomé e Príncipe)',
        iso: CountryISO.SãoToméAndPríncipe,
        indicator: '239'
    },
    {
        name: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
        iso: CountryISO.SaudiArabia,
        indicator: '966'
    },
    {
        name: 'Senegal (Sénégal)',
        iso: CountryISO.Senegal,
        indicator: '221'
    },
    {
        name: 'Serbia (Србија)',
        iso: CountryISO.Serbia,
        indicator: '381'
    },
    {
        name: 'Seychelles',
        iso: CountryISO.Seychelles,
        indicator: '248'
    },
    {
        name: 'Sierra Leone',
        iso: CountryISO.SierraLeone,
        indicator: '232'
    },
    {
        name: 'Singapore',
        iso: CountryISO.Singapore,
        indicator: '65'
    },
    {
        name: 'Sint Maarten',
        iso: 'sx',
        indicator: '1'
    },
    {
        name: 'Slovakia (Slovensko)',
        iso: CountryISO.Slovakia,
        indicator: '421'
    },
    {
        name: 'Slovenia (Slovenija)',
        iso: CountryISO.Slovenia,
        indicator: '386'
    },
    {
        name: 'Solomon Islands',
        iso: CountryISO.SolomonIslands,
        indicator: '677'
    },
    {
        name: 'Somalia (Soomaaliya)',
        iso: CountryISO.Somalia,
        indicator: '252'
    },
    {
        name: 'South Africa',
        iso: CountryISO.SouthAfrica,
        indicator: '27'
    },
    {
        name: 'South Korea (대한민국)',
        iso: CountryISO.SouthKorea,
        indicator: '82'
    },
    {
        name: 'South Sudan (‫جنوب السودان‬‎)',
        iso: CountryISO.SouthSudan,
        indicator: '211'
    },
    {
        name: 'Spain (España)',
        iso: CountryISO.Spain,
        indicator: '34'
    },
    {
        name: 'Sri Lanka (ශ්‍රී ලංකාව)',
        iso: CountryISO.SriLanka,
        indicator: '94'
    },
    {
        name: 'Sudan (‫السودان‬‎)',
        iso: CountryISO.Sudan,
        indicator: '249'
    },
    {
        name: 'Suriname',
        iso: CountryISO.Suriname,
        indicator: '597'
    },
    {
        name: 'Svalbard and Jan Mayen',
        iso: CountryISO.SvalbardAndJanMayen,
        indicator: '47'
    },
    {
        name: 'Swaziland',
        iso: CountryISO.Swaziland,
        indicator: '268'
    },
    {
        name: 'Sweden (Sverige)',
        iso: CountryISO.Sweden,
        indicator: '46'
    },
    {
        name: 'Switzerland (Schweiz)',
        iso: CountryISO.Switzerland,
        indicator: '41'
    },
    {
        name: 'Syria (‫سوريا‬‎)',
        iso: CountryISO.Syria,
        indicator: '963'
    },
    {
        name: 'Taiwan (台灣)',
        iso: CountryISO.Taiwan,
        indicator: '886'
    },
    {
        name: 'Tajikistan',
        iso: CountryISO.Tajikistan,
        indicator: '992'
    },
    {
        name: 'Tanzania',
        iso: CountryISO.Tanzania,
        indicator: '255'
    },
    {
        name: 'Thailand (ไทย)',
        iso: CountryISO.Thailand,
        indicator: '66'
    },
    {
        name: 'Timor-Leste',
        iso: CountryISO.TimorLeste,
        indicator: '670'
    },
    {
        name: 'Togo',
        iso: CountryISO.Togo,
        indicator: '228'
    },
    {
        name: 'Tokelau',
        iso: CountryISO.Tokelau,
        indicator: '690'
    },
    {
        name: 'Tonga',
        iso: CountryISO.Tonga,
        indicator: '676'
    },
    {
        name: 'Trinidad and Tobago',
        iso: 'tt',
        indicator: '1'
    },
    {
        name: 'Tunisia (‫تونس‬‎)',
        iso: CountryISO.Tunisia,
        indicator: '216'
    },
    {
        name: 'Turkey (Türkiye)',
        iso: CountryISO.Turkey,
        indicator: '90'
    },
    {
        name: 'Turkmenistan',
        iso: CountryISO.Turkmenistan,
        indicator: '993'
    },
    {
        name: 'Turks and Caicos Islands',
        iso: CountryISO.TurksAndCaicosIslands,
        indicator: '1649'
    },
    {
        name: 'Tuvalu',
        iso: CountryISO.Tuvalu,
        indicator: '688'
    },
    {
        name: 'U.S. Virgin Islands',
        iso: 'vi',
        indicator: '1'
    },
    {
        name: 'Uganda',
        iso: CountryISO.Uganda,
        indicator: '256'
    },
    {
        name: 'Ukraine (Україна)',
        iso: CountryISO.Ukraine,
        indicator: '380'
    },
    {
        name: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
        iso: CountryISO.UnitedArabEmirates,
        indicator: '971'
    },
    {
        name: 'United Kingdom',
        iso: CountryISO.UnitedKingdom,
        indicator: '44'
    },
    {
        name: 'United States',
        iso: CountryISO.UnitedStates,
        indicator: '1'
    },
    {
        name: 'Uruguay',
        iso: CountryISO.Uruguay,
        indicator: '598'
    },
    {
        name: 'Uzbekistan (Oʻzbekiston)',
        iso: CountryISO.Uzbekistan,
        indicator: '998'
    },
    {
        name: 'Vanuatu',
        iso: CountryISO.Vanuatu,
        indicator: '678'
    },
    {
        name: 'Vatican City (Città del Vaticano)',
        iso: CountryISO.VaticanCity,
        indicator: '39'
    },
    {
        name: 'Venezuela',
        iso: CountryISO.Venezuela,
        indicator: '58'
    },
    {
        name: 'Vietnam (Việt Nam)',
        iso: CountryISO.Vietnam,
        indicator: '84'
    },
    {
        name: 'Wallis and Futuna',
        iso: CountryISO.WallisAndFutuna,
        indicator: '681'
    },
    {
        name: 'Western Sahara (‫الصحراء الغربية‬‎)',
        iso: CountryISO.WesternSahara,
        indicator: '212'
    },
    {
        name: 'Yemen (‫اليمن‬‎)',
        iso: CountryISO.Yemen,
        indicator: '967'
    },
    {
        name: 'Zambia',
        iso: CountryISO.Zambia,
        indicator: '260'
    },
    {
        name: 'Zimbabwe',
        iso: CountryISO.Zimbabwe,
        indicator: '263'
    },
    {
        name: 'Åland Islands',
        iso: CountryISO.ÅlandIslands,
        indicator: '358'
    }
];

/**
 * Phone number component
 */
class PhoneNumberComponent {
    constructor(
    // required parameters should be placed first
    controlContainer) {
        this.controlContainer = controlContainer;
        /**
         * Material appearance for the input
         * Default value is fill
         */
        this.appearance = 'fill';
        this.countryIndicatorForm = new FormControl(null);
        this.phoneNumberForm = new FormControl(null);
        /**
         * Css classes to focus
         */
        this.textFieldFocusedClass = 'mdc-text-field--focused';
        this.lineRippleDeactivatingClass = 'mdc-line-ripple--deactivating';
        this.lineRippleActiveClass = 'mdc-line-ripple--active';
        this.lineRippleInvalidClass = 'mdc-text-field--invalid';
        // @typescript-eslint/explicit-function-return-type
        this.onChange = (_) => {
            /*onChange*/
        };
        this.onTouch = () => {
            /*onTouch */
        };
    }
    /**
     * Get the parent control using input or control container
     */
    // @typescript-eslint/explicit-function-return-type
    get parentControl() {
        if (this.controlContainer !== undefined && this.formControlName !== undefined && this.formControl === undefined) {
            return this.controlContainer.control?.get(this.formControlName);
        }
        return this.formControl;
    }
    ngOnInit() {
        if (this.countriesList) {
            this.countriesData = this.retrieveCountriesByIso(this.countriesList);
        }
        else {
            this.countriesData = allCountries;
        }
        /**
         * Sort countriesData by alphabetics order
         */
        this.countriesData.sort((a, b) => (a.iso > b.iso ? 1 : -1));
        // Inherit required validators from parent control
        if (this.parentControl?.hasValidator(Validators.required)) {
            this.countryIndicatorForm.addValidators(Validators.required);
            this.phoneNumberForm.addValidators(Validators.required);
        }
    }
    ngAfterViewInit() {
        this.selectIndicatorBorderDiv = this.indicator.nativeElement.querySelector('.mat-mdc-text-field-wrapper');
        this.inputNumberBorderDiv = this.number.nativeElement.querySelector('.mat-mdc-text-field-wrapper');
        this.selectIndicatorBottomLine = this.indicator.nativeElement.querySelector('.mdc-line-ripple');
        this.inputNumberBottomLine = this.number.nativeElement.querySelector('.mdc-line-ripple');
    }
    /**
     * Do check
     * Detect touched on the formControl
     *
     * @returns
     */
    ngDoCheck() {
        if (this.phoneNumberForm.touched) {
            return;
        }
        if (this.countryIndicatorForm.touched) {
            return;
        }
        if (this.parentControl && this.parentControl.touched) {
            this.phoneNumberForm.markAsTouched();
            this.countryIndicatorForm.markAsTouched();
        }
    }
    /**
     * Apply onFocus css on both mat-form-field when one is focus
     */
    onFocusEvent() {
        this.selectIndicatorBorderDiv.classList.add(this.textFieldFocusedClass);
        this.inputNumberBorderDiv.classList.add(this.textFieldFocusedClass);
        if (this.appearance === 'fill') {
            this.selectIndicatorBottomLine.classList.remove(this.lineRippleDeactivatingClass);
            this.selectIndicatorBottomLine.classList.add(this.lineRippleActiveClass);
            this.inputNumberBottomLine.classList.remove(this.lineRippleDeactivatingClass);
            this.inputNumberBottomLine.classList.add(this.lineRippleActiveClass);
        }
    }
    /**
     * Remove onFocus css on both mat-form-field when no one is focus
     */
    onFocusOutEvent() {
        this.selectIndicatorBorderDiv.classList.remove(this.textFieldFocusedClass);
        this.inputNumberBorderDiv.classList.remove(this.textFieldFocusedClass);
        if (this.appearance === 'fill') {
            this.selectIndicatorBottomLine.classList.remove(this.lineRippleActiveClass);
            this.selectIndicatorBottomLine.classList.add(this.lineRippleDeactivatingClass);
            this.inputNumberBottomLine.classList.remove(this.lineRippleActiveClass);
            this.inputNumberBottomLine.classList.add(this.lineRippleDeactivatingClass);
        }
        this.addValidatorStyle();
    }
    /**
     * Retrieve list of countries by iso list
     * @param isoList CountryIso list
     */
    retrieveCountriesByIso(isoList) {
        const countries = [];
        isoList.forEach((iso) => {
            countries.push(allCountries.find((country) => country.iso === iso));
        });
        return countries;
    }
    /**
     * If control has validators, apply invalid style on both forms when a value is missing
     */
    addValidatorStyle() {
        if (this.parentControl?.hasValidator(Validators.required)) {
            if (!this.phoneNumberForm.value || !this.countryIndicatorForm.value) {
                this.selectIndicatorBorderDiv.classList.add(this.lineRippleInvalidClass);
                this.inputNumberBorderDiv.classList.add(this.lineRippleInvalidClass);
            }
            else {
                this.selectIndicatorBorderDiv.classList.remove(this.lineRippleInvalidClass);
                this.inputNumberBorderDiv.classList.remove(this.lineRippleInvalidClass);
            }
        }
    }
    /**
     * Trigger the change detection on formcontrol with the phone number value
     */
    onPhoneNumberChange() {
        this.formatNumber();
        this.addValidatorStyle();
        const value = {
            countryIndicator: this.countryIndicatorForm?.value && this.countryIndicatorForm.value.indicator
                ? '+' + this.countryIndicatorForm.value.indicator
                : null,
            phoneNumber: this.phoneNumberForm?.value
        };
        this.onChange(value);
    }
    /**
     * When the user first interacts with the form control, the control is considered to have the status touched, which is useful for styling.
     * In order to report to the parent form that the control was touched, we need to use a callback registered using the registerOnToched method
     */
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    /**
     * When a form value changes due to user input, we need to report the value back to the parent form.
     * This is done by calling a callback, that was initially registered with the control using the registerOnChange method
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * This method is called by the Forms module to write a value into a form control
     */
    writeValue(value) {
        if (!value || !value?.countryIndicator || value.countryIndicator === null) {
            this.countryIndicatorForm.setValue(null);
        }
        else {
            this.countryIndicatorForm.setValue(this.findCountryData(value.countryIndicator));
        }
        if (!value || !value?.phoneNumber || value.phoneNumber === null) {
            this.phoneNumberForm.setValue(null);
        }
        else {
            this.phoneNumberForm.setValue(value.phoneNumber);
        }
    }
    /**
     * Form controls can be enabled and disabled using the Forms API.
     * This state can be transmitted to the form control via the setDisabledState method
     */
    setDisabledState(disabled) {
        if (disabled) {
            this.countryIndicatorForm.disable();
            this.phoneNumberForm.disable();
        }
        else {
            this.countryIndicatorForm.enable();
            this.phoneNumberForm.enable();
        }
    }
    /**
     * Find country data by indicator
     * @param indicator
     * @returns
     */
    findCountryData(indicator) {
        if (!indicator) {
            return;
        }
        return this.countriesData.find((val) => val.indicator === indicator.replace('+', ''));
    }
    /**
     * Return a string containing only numeric values from the
     * phone.number form field.
     */
    get phoneNumberDigits() {
        return this.phoneNumberForm.value?.replace(/\D/g, '');
    }
    /**
     * Formats the phone number digits
     */
    formatNumber() {
        this.phoneNumberForm.setValue(this.phoneNumberDigits);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: PhoneNumberComponent, deps: [{ token: i3$1.ControlContainer, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: PhoneNumberComponent, selector: "mic-phone-number", inputs: { label: "label", placeholder: "placeholder", appearance: "appearance", color: "color", formControl: "formControl", formControlName: "formControlName", countriesList: "countriesList" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => PhoneNumberComponent),
                multi: true
            }
        ], viewQueries: [{ propertyName: "indicator", first: true, predicate: ["indicator"], descendants: true, read: ElementRef, static: true }, { propertyName: "number", first: true, predicate: ["number"], descendants: true, read: ElementRef, static: true }], ngImport: i0, template: "<div class=\"flex flex-row phone-number\">\n  <mat-form-field #indicator class=\"select-country\" [appearance]=\"appearance\" [color]=\"color\" subscriptSizing=\"dynamic\">\n    @if (label) {\n    <mat-label>{{ label }}</mat-label>\n    }\n    <mat-select\n      placeholder=\"+...\"\n      [formControl]=\"countryIndicatorForm\"\n      (focus)=\"onFocusEvent()\"\n      (focusout)=\"onFocusOutEvent()\"\n      disableOptionCentering\n      panelWidth=\"260px\"\n      autocomplete=\"tel-country-code\"\n    >\n      <mat-select-trigger class=\"flex flex-row align-middle\">\n        <div [class]=\"'flag-' + countryIndicatorForm?.value?.iso\"></div>\n        {{ '+' + countryIndicatorForm?.value?.indicator }}\n      </mat-select-trigger>\n      @for (item of countriesData; track item) {\n      <mat-option\n        (click)=\"onPhoneNumberChange()\"\n        [value]=\"item\"\n        [matTooltip]=\"item.iso.toUpperCase()\"\n        matTooltipPosition=\"before\"\n        autocomplete=\"tel-country-code\"\n      >\n        <div class=\"flex flex-row align-middle\">\n          <div [class]=\"item?.iso\"></div>\n          <div [class]=\"'flag-' + item?.iso\"></div>\n          <span [innerHTML]=\"'<strong>+' + item?.indicator + '</strong> ' + item?.name\"></span>\n        </div>\n      </mat-option>\n      }\n    </mat-select>\n  </mat-form-field>\n  <mat-form-field #number [appearance]=\"appearance\" [color]=\"color\" class=\"number-form\" subscriptSizing=\"dynamic\">\n    @if (label && appearance === 'fill') {\n    <mat-label></mat-label>\n    }\n    <input\n      class=\"number-input\"\n      [formControl]=\"phoneNumberForm\"\n      (focus)=\"onFocusEvent()\"\n      (focusout)=\"onFocusOutEvent()\"\n      (keyup)=\"onPhoneNumberChange()\"\n      [placeholder]=\"placeholder\"\n      type=\"tel\"\n      matInput\n      autocomplete=\"tel\"\n    />\n  </mat-form-field>\n</div>\n", styles: [".select-country{min-width:110px;width:110px}.select-country .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__trailing{border-top-right-radius:0;border-bottom-right-radius:0;border-right:none}.select-country .mdc-notched-outline__notch{max-width:100%!important}.select-country .mdc-floating-label--float-above{max-width:fit-content!important}.select-country .mdc-text-field{border-top-right-radius:0}.select-country .mdc-text-field--focused{outline:none!important}.text-bold{font-weight:700}.mat-mdc-text-field-wrapper.mdc-text-field--outlined .mat-mdc-form-field-infix{padding-top:12px;padding-bottom:8px}.mat-mdc-form-field-infix{min-height:50px}.mat-mdc-text-field-wrapper:not(.mdc-text-field--outlined) .mat-mdc-form-field-infix{height:56px}.mat-mdc-select-arrow-wrapper{transform:none!important}.number-form{min-width:150px}.number-form .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading{border-top-left-radius:0;border-bottom-left-radius:0;border-left:none}.number-form .mdc-floating-label--required:not(.mdc-floating-label--hide-required-marker):after{content:\"\"}.number-form .mdc-text-field{border-top-left-radius:0}.number-form .mdc-text-field--focused{outline:none!important}\n"], dependencies: [{ kind: "component", type: i3$2.MatOption, selector: "mat-option", inputs: ["value", "id", "disabled"], outputs: ["onSelectionChange"], exportAs: ["matOption"] }, { kind: "directive", type: i3$3.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i4$1.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i4$1.MatLabel, selector: "mat-label" }, { kind: "component", type: i5.MatSelect, selector: "mat-select", inputs: ["aria-describedby", "panelClass", "disabled", "disableRipple", "tabIndex", "hideSingleSelectionIndicator", "placeholder", "required", "multiple", "disableOptionCentering", "compareWith", "value", "aria-label", "aria-labelledby", "errorStateMatcher", "typeaheadDebounceInterval", "sortComparator", "id", "panelWidth"], outputs: ["openedChange", "opened", "closed", "selectionChange", "valueChange"], exportAs: ["matSelect"] }, { kind: "directive", type: i5.MatSelectTrigger, selector: "mat-select-trigger" }, { kind: "directive", type: i16.MatTooltip, selector: "[matTooltip]", inputs: ["matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipDisabled", "matTooltipShowDelay", "matTooltipHideDelay", "matTooltipTouchGestures", "matTooltip", "matTooltipClass"], exportAs: ["matTooltip"] }, { kind: "directive", type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: ScrollBarSelectDirective, selector: "mat-select" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: PhoneNumberComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mic-phone-number', encapsulation: ViewEncapsulation.None, providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => PhoneNumberComponent),
                            multi: true
                        }
                    ], template: "<div class=\"flex flex-row phone-number\">\n  <mat-form-field #indicator class=\"select-country\" [appearance]=\"appearance\" [color]=\"color\" subscriptSizing=\"dynamic\">\n    @if (label) {\n    <mat-label>{{ label }}</mat-label>\n    }\n    <mat-select\n      placeholder=\"+...\"\n      [formControl]=\"countryIndicatorForm\"\n      (focus)=\"onFocusEvent()\"\n      (focusout)=\"onFocusOutEvent()\"\n      disableOptionCentering\n      panelWidth=\"260px\"\n      autocomplete=\"tel-country-code\"\n    >\n      <mat-select-trigger class=\"flex flex-row align-middle\">\n        <div [class]=\"'flag-' + countryIndicatorForm?.value?.iso\"></div>\n        {{ '+' + countryIndicatorForm?.value?.indicator }}\n      </mat-select-trigger>\n      @for (item of countriesData; track item) {\n      <mat-option\n        (click)=\"onPhoneNumberChange()\"\n        [value]=\"item\"\n        [matTooltip]=\"item.iso.toUpperCase()\"\n        matTooltipPosition=\"before\"\n        autocomplete=\"tel-country-code\"\n      >\n        <div class=\"flex flex-row align-middle\">\n          <div [class]=\"item?.iso\"></div>\n          <div [class]=\"'flag-' + item?.iso\"></div>\n          <span [innerHTML]=\"'<strong>+' + item?.indicator + '</strong> ' + item?.name\"></span>\n        </div>\n      </mat-option>\n      }\n    </mat-select>\n  </mat-form-field>\n  <mat-form-field #number [appearance]=\"appearance\" [color]=\"color\" class=\"number-form\" subscriptSizing=\"dynamic\">\n    @if (label && appearance === 'fill') {\n    <mat-label></mat-label>\n    }\n    <input\n      class=\"number-input\"\n      [formControl]=\"phoneNumberForm\"\n      (focus)=\"onFocusEvent()\"\n      (focusout)=\"onFocusOutEvent()\"\n      (keyup)=\"onPhoneNumberChange()\"\n      [placeholder]=\"placeholder\"\n      type=\"tel\"\n      matInput\n      autocomplete=\"tel\"\n    />\n  </mat-form-field>\n</div>\n", styles: [".select-country{min-width:110px;width:110px}.select-country .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__trailing{border-top-right-radius:0;border-bottom-right-radius:0;border-right:none}.select-country .mdc-notched-outline__notch{max-width:100%!important}.select-country .mdc-floating-label--float-above{max-width:fit-content!important}.select-country .mdc-text-field{border-top-right-radius:0}.select-country .mdc-text-field--focused{outline:none!important}.text-bold{font-weight:700}.mat-mdc-text-field-wrapper.mdc-text-field--outlined .mat-mdc-form-field-infix{padding-top:12px;padding-bottom:8px}.mat-mdc-form-field-infix{min-height:50px}.mat-mdc-text-field-wrapper:not(.mdc-text-field--outlined) .mat-mdc-form-field-infix{height:56px}.mat-mdc-select-arrow-wrapper{transform:none!important}.number-form{min-width:150px}.number-form .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading{border-top-left-radius:0;border-bottom-left-radius:0;border-left:none}.number-form .mdc-floating-label--required:not(.mdc-floating-label--hide-required-marker):after{content:\"\"}.number-form .mdc-text-field{border-top-left-radius:0}.number-form .mdc-text-field--focused{outline:none!important}\n"] }]
        }], ctorParameters: () => [{ type: i3$1.ControlContainer, decorators: [{
                    type: Optional
                }] }], propDecorators: { label: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], appearance: [{
                type: Input
            }], color: [{
                type: Input
            }], formControl: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], countriesList: [{
                type: Input
            }], indicator: [{
                type: ViewChild,
                args: ['indicator', { read: ElementRef, static: true }]
            }], number: [{
                type: ViewChild,
                args: ['number', { read: ElementRef, static: true }]
            }] } });

const imports = [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, ScrollbarModule, LoaderModule];
const components = [PhoneNumberComponent];
/**
 *
 * <b>Requirements: </b>
 *
 * Import the following module :
 *
 * <code>import { PhoneNumberModule } from '@michelin/theme';</code>
 */
class PhoneNumberModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: PhoneNumberModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.4", ngImport: i0, type: PhoneNumberModule, declarations: [PhoneNumberComponent], imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, ScrollbarModule, LoaderModule], exports: [PhoneNumberComponent, CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, ScrollbarModule, LoaderModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: PhoneNumberModule, imports: [imports, CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, ScrollbarModule, LoaderModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: PhoneNumberModule, decorators: [{
            type: NgModule,
            args: [{
                    imports,
                    declarations: [...components],
                    exports: [...components, ...imports]
                }]
        }] });

/*
 * Public API Surface of theme library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AlertCenterComponent, AlertComponent, AlertModule, AlertService, AlertType, BreadcrumbComponent, BreadcrumbLinkComponent, BreadcrumbModule, CarouselComponent, CarouselModule, CellRowConfig, ContentTableComponent, ContentTableModule, ContentsDirective, CountryData, CountryISO, DEFAULT_PAGESIZE, DEFAULT_PAGESIZE_OPTIONS, DropdownComponent, DropdownModule, EmptyStateComponent, EmptyStateModule, ExpandableItem, FileComponent, FileConfig, FileProgressConfig, FileSizePipe, FilterConfig, FilterFetcher, FiltersConfig, FooterComponent, FooterModule, Group, GroupColumn, HeaderComponent, HeaderModule, Icon, IconComponent, IconModule, Image, LinkComponent, LinkDirective, LinkModule, LoaderDirective, LoaderModule, LogoComponent, LogoModule, MATERIAL_ICONS_DEFAULT_FONT, MainContentComponent, MainContentModule, MaterialIconFonts, MaterialModule, MicCustomPaginatorDirective, ModalButton, ModalComponent, ModalContentComponent, ModalModule, NavbarComponent, NavbarIconComponent, NavbarLinkComponent, NavbarLinksComponent, NavbarModule, NavbarProfileComponent, NavbarSpacerComponent, PaginationOption, PaginatorComponent, PaginatorConfig, PaginatorContentDirective, PaginatorFilters, PaginatorFormGroup, PaginatorModule, PhoneNumberComponent, PhoneNumberModule, ProgressbarComponent, SafeHtmlDirective, ScrollBarAutocompleteDirective, ScrollBarBacktotopDirective, ScrollBarDirective, ScrollBarSelectDirective, ScrollbarModule, ScrollingContentDirective, SidebarComponent, SidebarContainerComponent, SidebarItemComponent, SidebarModule, SidebarParameter, SidebarSpacerComponent, SidebarTogglerComponent, SkeletonComponent, SpinnerButtonDirective, SpinnerComponent, SpinnerOverlayComponent, StatusComponent, StatusModule, StorageConfig, StorageOption, TableActionsDirective, TableCellDirective, TableCellTemplateDirective, TableColumnSelectorDirective, TableComponent, TableConfig, TableGroupHeaderDirective, TableHeaderCellDirective, TableHeaderCellTemplateDirective, TableModule, TableNoDataTemplateDirective, TableOption, TableRowActionsDirective, TableRowDetailDirective, TableRowMenuDirective, TableRowSpecification, TableSelection, Tag, ThemingModule, ThemingService, TimelineComponent, TimelineEntryComponent, TimelineEntryContentComponent, TimelineEntryContentListComponent, TimelineEntryDotComponent, TimelineEntrySideComponent, TimelineModule, TimepickerComponent, TimepickerModule, UploadDropZoneComponent, UploadModule, UtilitiesModule, allCountries, getAttributeForObject };
